var BoostPFS = (function (t) {
  function e(e) {
    for (
      var i, a, s = e[0], l = e[1], c = e[2], p = 0, f = [];
      p < s.length;
      p++
    )
      (a = s[p]),
        Object.prototype.hasOwnProperty.call(r, a) && r[a] && f.push(r[a][0]),
        (r[a] = 0);
    for (i in l) Object.prototype.hasOwnProperty.call(l, i) && (t[i] = l[i]);
    for (u && u(e); f.length; ) f.shift()();
    return o.push.apply(o, c || []), n();
  }
  function n() {
    for (var t, e = 0; e < o.length; e++) {
      for (var n = o[e], i = !0, s = 1; s < n.length; s++)
        0 !== r[n[s]] && (i = !1);
      i && (o.splice(e--, 1), (t = a((a.s = n[0]))));
    }
    return t;
  }
  var i = {},
    r = { 0: 0 },
    o = [];
  function a(e) {
    if (i[e]) return i[e].exports;
    var n = (i[e] = { i: e, l: !1, exports: {} });
    return t[e].call(n.exports, n, n.exports, a), (n.l = !0), n.exports;
  }
  (a.m = t),
    (a.c = i),
    (a.d = function (t, e, n) {
      a.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
    }),
    (a.r = function (t) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(t, "__esModule", { value: !0 });
    }),
    (a.t = function (t, e) {
      if (
        (1 & e && (t = a(t)),
        8 & e || (4 & e && "object" == typeof t && t && t.__esModule))
      )
        return t;
      var n = Object.create(null);
      if (
        (a.r(n),
        Object.defineProperty(n, "default", { enumerable: !0, value: t }),
        2 & e && "string" != typeof t)
      )
        for (var i in t)
          a.d(
            n,
            i,
            function (e) {
              return t[e];
            }.bind(null, i)
          );
      return n;
    }),
    (a.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return a.d(e, "a", e), e;
    }),
    (a.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (a.p = "");
  var s = (window.webpackJsonpBoostPFS = window.webpackJsonpBoostPFS || []),
    l = s.push.bind(s);
  (s.push = e), (s = s.slice());
  for (var c = 0; c < s.length; c++) e(s[c]);
  var u = l;
  return o.push([189, 1]), n();
})({
  0: function (t, e, n) {
    "use strict";
    n(22),
      n(23),
      n(80),
      n(38),
      n(24),
      n(9),
      n(25),
      n(170),
      n(97),
      n(115),
      n(48),
      n(21),
      n(30),
      n(34),
      n(41),
      n(54),
      n(149),
      n(81),
      n(98),
      n(47),
      n(82),
      n(116),
      n(40),
      n(66),
      n(83),
      n(27),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(2),
      a = n(3),
      s = n(4),
      l = n(5),
      c = {
        isFullWidthMobile: function () {
          return (
            O.isMobile() &&
            "style1" == o.a.getSettingValue("search.suggestionMobileStyle")
          );
        },
        isStyle2: function () {
          return (
            !O.isMobile() &&
            "style2" === o.a.getSettingValue("search.suggestionStyle")
          );
        },
        isStyle3: function () {
          return (
            (!O.isMobile() &&
              "style3" === o.a.getSettingValue("search.suggestionStyle")) ||
            "2-overlay-fullwidth" ===
              o.a.getSettingValue("search.suggestionColumn")
          );
        },
        getListSuggestionType: function () {
          var t = o.a.getSettingValue("search.suggestionBlocks"),
            e = [];
          return (
            t.forEach(function (t) {
              ["products", "suggestions", "collections", "pages"].includes(
                t.type
              ) &&
                "active" == t.status &&
                e.push(t.type);
            }),
            4 == e.length ? [] : e
          );
        },
      },
      u = {
        checkExistFilterOptionParam: function () {
          for (var t in Globals.queryParams)
            if (t.indexOf("pf_") > -1) return !0;
          return !1;
        },
        encodeURIParamValue: function (t) {
          return encodeURIComponent(t)
            .replace(/&/g, "%26")
            .replace(/'/g, "%27")
            .replace(/\*/g, "%2A");
        },
        showFilterTree: function () {
          r()("." + s.a.filterTree).css({ display: "" }),
            r()(".boost-pfs-filter-tree-mobile-button").css({ display: "" }),
            r()(".boost-pfs-filter-left-col").css({ display: "" }),
            r()(".boost-pfs-filter-right-col, .boost-pfs-filter-right").css({
              width: "",
            }),
            r()(".boost-pfs-filter-tree-desktop-button").css({ display: "" });
        },
        hideFilterTree: function () {
          r()("." + s.a.filterTree).css({ display: "none" }),
            r()(".boost-pfs-filter-tree-mobile-button").css({
              display: "none",
            }),
            r()(".boost-pfs-filter-left-col").css({ display: "none" }),
            r()(".boost-pfs-filter-right-col, .boost-pfs-filter-right").css({
              width: "100%",
            }),
            r()(".boost-pfs-filter-tree-desktop-button").css({
              display: "none",
            });
        },
      },
      p = (n(204), n(7));
    function f(t) {
      return (f =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    var h = function () {
        return o.a.getSettingValue("general.paginationTypeAdvanced");
      },
      d = function () {
        return "load_more" == o.a.getSettingValue("general.paginationType");
      },
      g = function () {
        return "infinite" == o.a.getSettingValue("general.paginationType");
      },
      y = {
        getSortingList: function () {
          var t = o.a.getSettingValue("general.sortingList"),
            e = o.a.getSettingValue("general.customSortingList");
          if ("" != e)
            for (var n = (t = e.trim().split("|")).length - 1; n >= 0; n--)
              "" == t[n] && t.splice(n, 1);
          var i = o.a.getSettingValue("general.extraSortingList");
          if ((i && (t = t.concat(i.split("|"))), O.isSearchPage())) {
            var r = O.findIndexArray("manual", t);
            r >= 0 && t.splice(r, 1);
          } else if (
            !O.isCollectionPage() ||
            (O.isCollectionPage() &&
              !o.a.getSettingValue("general.enableCollectionSearch"))
          ) {
            var a = O.findIndexArray("relevance", t);
            a >= 0 && t.splice(a, 1);
          }
          for (var s = {}, l = 0; l < t.length; l++) {
            var c = p.a.sortingList[t[l]];
            if (i.length > 0 && i.indexOf(t[l]) > -1) {
              var u = t[l].replace(/-/g, "_");
              c = p.a[u];
            }
            if (((s[t[l]] = c), p.a.sortByOptions)) {
              var f = p.a.sortByOptions[t[l]];
              f && f.length > 0 && (s[t[l]] = f);
            }
          }
          return s;
        },
        getDefaultSorting: function (t) {
          var e = o.a.getSettingValue("default_sort_order"),
            n = "";
          return (
            void 0 === t &&
              (t = O.isSearchPage()
                ? "search"
                : O.isCollectionPage()
                ? boostPFSConfig.general.collection_id
                : void 0),
            "object" == f(e) &&
              void 0 !== t &&
              ((n = e[(t = t.toString())]) ||
                (n = "search" == t ? "relevance" : e.all)),
            n
          );
        },
        getProductMetafield: function (t, e, n) {
          if (t.hasOwnProperty("metafields")) {
            var i = t.metafields.filter(function (t) {
              return t.namespace == e && t.key == n;
            });
            if (void 0 !== i[0]) return i[0].value;
          }
          return null;
        },
        isAdvancedPaginationType: h,
        buildProductItemUrl: function (t, e) {
          var n = O.getWindowLocation().search.substring(1),
            i = window.location.pathname,
            r = i.split("/"),
            a = "",
            s = Shopify && Shopify.routes && void 0 !== Shopify.routes.root;
          o.a.getSettingValue("general.useShopifyRouteForMultiLanguageURL") && s
            ? (a = Shopify.routes.root.replace(/\/$/, ""))
            : r.indexOf(boostPFSAppConfig.general.current_locale) > -1 &&
              (a = "/" + boostPFSAppConfig.general.current_locale);
          var l =
            "object" === f(t) && t.hasOwnProperty("handle") ? t.handle : t;
          if (
            (e =
              void 0 !== e
                ? e
                : o.a.getSettingValue("general.addCollectionToProductUrl"))
          ) {
            if (
              "/" == i ||
              O.isSearchPage() ||
              O.isVendorPage() ||
              O.isTypePage()
            )
              return (c = a + "/collections/all/products/") + l;
            if (O.isTagPage()) {
              var c = a + "/collections/",
                u = r.indexOf("collections") + 1;
              return r.length >= 4
                ? c + r[u] + "/products/" + l
                : "/collections/all/products/" + l;
            }
            if (n.indexOf("cache:") > -1) {
              var p = "all",
                h = n.split("&")[0].split("?")[0].split("collections/");
              return (
                h.length > 1 &&
                  (p = h[1].indexOf("/") > -1 ? h[1].split("/")[0] : h[1]),
                "/collections/" +
                  (p = p.replace(
                    /[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g,
                    ""
                  )) +
                  "/products/" +
                  l
              );
            }
            return (
              (u = r.indexOf("collections") + 1),
              (c = a + "/collections/"),
              void 0 !== r[2]
                ? c + r[u] + "/products/" + l
                : window.location.pathname + "/products/" + l
            );
          }
          return a + "/products/" + l;
        },
        buildProductItemUrlWithVariant: function (t) {
          var e =
            t.split_product && t.variant_id ? "?variant=" + t.variant_id : "";
          return O.buildProductItemUrl(t) + e;
        },
        buildProductItemVendorUrl: function (t) {
          return (
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/collections/vendors?q=" +
            u.encodeURIParamValue(t)
          );
        },
        removePageParamFromUrl: function (t) {
          if (a.a.queryParams.hasOwnProperty("page")) {
            var e =
              a.a.queryParams.page && !isNaN(a.a.queryParams.page)
                ? a.a.queryParams.page
                : 1;
            t = t
              .replace("&page=" + e, "")
              .replace("?page=" + e + "&", "?")
              .replace("?page=" + e, "");
          }
          return O.isBadUrl(t) ? "" : t;
        },
        removeCollectionScopeParamFromUrl: function (t) {
          if (a.a.queryParams.hasOwnProperty("collection_scope")) {
            var e =
              a.a.queryParams.collection_scope &&
              !isNaN(a.a.queryParams.collection_scope)
                ? a.a.queryParams.collection_scope
                : 0;
            t = t.replace("&collection_scope=" + e, "");
          }
          return O.isBadUrl(t) ? "" : t;
        },
        buildToolbarLink: function (t, e, n) {
          var i = window.location.origin + window.location.pathname;
          switch (t) {
            case "page":
            case "limit":
            case "sort":
            case "display":
              if ("page" == t && 1 == n) break;
              i += "?" + t + "=" + n;
          }
          return i;
        },
        isDefaultPaginationType: function () {
          return "default" == o.a.getSettingValue("general.paginationType");
        },
        isLoadMorePaginationType: d,
        isInfiniteLoadingPaginationType: g,
        isLoadPreviousPagePaginationType: function () {
          return (
            (d() || g()) &&
            h() &&
            o.a.getSettingValue("general.activeLoadPreviousPage")
          );
        },
        isNoFilterResult: function (t, e) {
          return (
            t <= 0 &&
            !(
              "init" === e &&
              o.a.getSettingValue("general.productAndVariantAvailable") &&
              o.a.getSettingValue("general.availableAfterFiltering")
            )
          );
        },
        compileShopifyProductVariables: function (t, e) {
          return (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e =
            (e = (e = (e = (e = (e = e.replace(
              /{{product.title}}/g,
              t.title
            )).replace(/{{product.vendor}}/g, t.vendor)).replace(
              /{{product.url}}/g,
              O.buildProductItemUrl(t)
            )).replace(/{{product.available}}/g, t.available)).replace(
              /{{product.compare_at_price}}/g,
              O.formatMoney(t.compare_at_price_min)
            )).replace(
              /{{product.compare_at_price_min}}/g,
              O.formatMoney(t.compare_at_price_min)
            )).replace(
            /{{product.compare_at_price_max}}/g,
            O.formatMoney(t.compare_at_price_max)
          )).replace(
            /{{product.description}}/g,
            void 0 !== t.body_html && null != t.body_html ? t.body_html : ""
          )).replace(/{{product.handle}}/g, t.handle)).replace(
            /{{product.id}}/g,
            t.id
          )).replace(/{{product.price}}/g, O.formatMoney(t.price_min))).replace(
            /{{product.price_max}}/g,
            O.formatMoney(t.price_max)
          )).replace(
            /{{product.price_min}}/g,
            O.formatMoney(t.price_min)
          )).replace(
            /{{product.template_suffix}}/g,
            void 0 !== t.template_suffix && null != t.template_suffix
              ? t.template_suffix
              : ""
          )).replace(
            /{{product.percent_sale_min}}/g,
            t.percent_sale_min > 0 ? t.percent_sale_min : ""
          )).replace(/{{product.type}}/g, t.product_type)).replace(
            /{{product.sku}}/g,
            void 0 !== t.skus && null != t.skus && t.skus.length > 0
              ? t.skus[0]
              : ""
          ));
        },
        compileShopifyProductMetafield: function (t, e) {
          if (-1 != e.indexOf("product.metafields")) {
            var n = e.match(/\{\{product.metafields(.*?)\}\}/g),
              i = 0,
              r = "",
              o = "",
              a = "",
              s = "";
            if (n.length > 0) {
              i = n.length;
              for (var l = 0; l < i; l++)
                4 ==
                  (o = n[l]
                    .replace(/\{\{/g, "")
                    .replace(/\}\}/g, "")
                    .split(".")).length &&
                  ((r = o[2]),
                  (a = o[3]),
                  (s = O.getProductMetafield(t, r, a) || ""),
                  (e = e.replaceAll(n[l], s)));
            }
          }
          return e;
        },
      };
    function m(t) {
      return (m =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    var v = function (t, e) {
        t || (t = boostPFSConfig.general.no_image_url),
          (e = void 0 !== e ? e : "large");
        for (
          var n = o.a.getSettingValue("general.imageExtension"), i = 0;
          i < n.length;
          i++
        )
          t = t.replace("." + n[i] + "?", "_" + e + "." + n[i] + "?");
        return t;
      },
      b = function () {
        return r()("<p>" + boostPFSConfig.shop.money_format + "</p>")
          .text()
          .replace(/{{[^}]*}}/g, "");
      },
      S = null,
      $ = function (t, e) {
        e || (e = k.getWindowLocation().href);
        var n = RegExp(
          "[?&]" + (t = t.replace(/[\[\]]/g, "\\$&")) + "(=([^&#]*)|&|#|$)"
        ).exec(e);
        return n
          ? n[2]
            ? decodeURIComponent(n[2].replace(/\+/g, " "))
            : ""
          : null;
      },
      T = function (t) {
        for (var e in t)
          if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
        return JSON.stringify(t) === JSON.stringify({});
      },
      P = function (t, e, n, i) {
        if (null != n) {
          for (var r = 0; r < e.length; r++)
            if (
              (void 0 !== i &&
                0 == i &&
                ((e[r][n] = e[r][n].toLowerCase()), (t = t.toLowerCase())),
              e[r][n] == t)
            )
              return r;
        } else
          for (r = 0; r < e.length; r++)
            if (
              (void 0 !== i &&
                0 == i &&
                ((e[r] = e[r].toLowerCase()), (t = t.toLowerCase())),
              e[r] == t)
            )
              return r;
        return -1;
      },
      _ = function (t) {
        if (t && "string" == typeof t) {
          var e;
          return t
            .replace(/<.*?>/g, "")
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&#x27;/g, "'")
            .replace(/&#36;/g, "$")
            .replace(/&#x2F;/g, "/")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#x27;")
            .replace(/\$/g, "&#36;")
            .replace(/\//g, "&#x2F;");
        }
        return void 0 === t || "undefined" == t ? "" : t;
      },
      k = {
        escape: function (t, e) {
          return (
            (e = e ? "&#13;" : "\n"),
            ("" + t)
              .replace(/&/g, "&amp;")
              .replace(/'/g, "&apos;")
              .replace(/"/g, "&quot;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/\r\n/g, e)
              .replace(/[\r\n]/g, e)
          );
        },
        unescape: function (t) {
          return ("" + t)
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&#x27;/g, "'")
            .replace(/&#36;/g, "$")
            .replace(/&#x2F;/g, "/");
        },
        findIndexArray: P,
        getParam: $,
        getSearchTerm: function () {
          return k.stripHtml($(a.a.searchTermKey));
        },
        getValueInObjectArray: function (t, e, n, i) {
          void 0 === n && (n = "key"), void 0 === i && (i = "values");
          var r = P(t, e, n);
          return r > -1 && e[r].hasOwnProperty(i) ? e[r][i] : "";
        },
        getFilePath: function (t, e, n) {
          var i;
          return (
            (e = void 0 !== e ? e : "png"),
            (n = void 0 !== n ? n : ""),
            a.a.fileUrl.split("?")[0] + (t + "." + e) + (n ? "?v=" + n : "")
          );
        },
        getNumberDecimals: function (t) {
          var e = t.toString().split(".");
          return e.length > 1 ? e[1].length : 0;
        },
        isMobile: function () {
          return (
            S ||
              ((S = r()(window).width()),
              r()(window).on("resize", function () {
                S = r()(window).width();
              })),
            S <= o.a.getSettingValue("general.breakpointMobile")
          );
        },
        isMobileDevice: function () {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          );
        },
        isTablet: function () {
          return (
            S ||
              ((S = r()(window).width()),
              r()(window).on("resize", function () {
                S = r()(window).width();
              })),
            S <= o.a.getSettingValue("general.breakpointTablet") &&
              S > o.a.getSettingValue("general.breakpointMobile")
          );
        },
        isiOS: function () {
          return (
            /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
          );
        },
        isSafari: function () {
          return (
            /Safari/.test(navigator.userAgent) &&
            !/Chrome/.test(navigator.userAgent)
          );
        },
        isBackButton: function () {
          return (
            window.performance &&
            window.performance.navigation &&
            2 == window.performance.navigation.type
          );
        },
        isCartPage: function () {
          return window.location.pathname.indexOf("/cart") > -1;
        },
        isProductPage: function () {
          return window.location.pathname.indexOf("/products") > -1;
        },
        isCollectionPage: function () {
          return window.location.pathname.includes("/collections");
        },
        isSearchPage: function () {
          return k
            .getWindowLocation()
            .href.includes("webcache.googleusercontent.com")
            ? k.getWindowLocation().search.indexOf("search?") > -1
            : window.location.pathname.indexOf("/search") > -1;
        },
        isVendorPage: function () {
          return window.location.pathname.indexOf("/collections/vendors") > -1;
        },
        isTagPage: function () {
          return (
            void 0 !== a.a.currentTags &&
            null !== a.a.currentTags &&
            a.a.currentTags.length > 0
          );
        },
        isTypePage: function () {
          return window.location.pathname.indexOf("/collections/types") > -1;
        },
        isGLHMobile: function () {
          return (
            navigator &&
            navigator.userAgent &&
            navigator.userAgent.includes(atob("TGlnaHRob3VzZQ==")) &&
            k.isMobile() &&
            !k.isSearchPage()
          );
        },
        mergeObject: function t(e, n) {
          for (var i in n)
            try {
              e[i] =
                n[i].constructor == Object
                  ? T(n[i])
                    ? e[i] || {}
                    : t(e[i], n[i])
                  : n[i];
            } catch (r) {
              e[i] = n[i];
            }
          return e;
        },
        optimizeImage: v,
        getFeaturedImage: function (t, e) {
          e = void 0 !== e ? e : "large";
          var n = v(boostPFSConfig.general.no_image_url, e);
          return (
            t.length > 0 &&
              (n = "object" === m(t[0]) ? v(t[0].src, e) : v(t[0], e)),
            n
          );
        },
        getFilterTagImage: function (t) {
          var e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            n =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : {},
            i = e.widthUrl,
            r = void 0 === i ? 530 : i,
            o = n.width,
            a = void 0 === o ? r : o,
            s = n.widths,
            l = void 0 === s ? "352, 832, 1200, 1920" : s,
            c = n.sizes,
            u = void 0 === c ? "" : c,
            p = n.srcset,
            f = void 0 === p ? "" : p,
            h = n.alt,
            d = void 0 === h ? "" : h,
            g = n.classes,
            y = void 0 === g ? "" : g,
            m = n.loading,
            v = void 0 === m ? "" : m,
            b = "";
          if (!t || "string" != typeof t) return b;
          if (
            ((b += "<img "),
            (b += 'src="'
              .concat(k.optimizeImage(t, r), "&amp;width=")
              .concat(r, '" ')),
            "string" == typeof d &&
              "nil" != d &&
              (b += 'alt="'.concat(d, '" ')),
            y &&
              "string" == typeof y &&
              "nil" != y &&
              (b += "class=".concat(y, " ")),
            a && "nil" != a && (b += 'width="'.concat(a, '" ')),
            v &&
              "string" == typeof v &&
              ("eager" === v || "lazy" === v) &&
              (b += 'loading="'.concat(v, '" ')),
            "nil" !== f && l && "string" == typeof l)
          ) {
            b += 'srcset="';
            var S = l.split(", ");
            Array.isArray(S) &&
              S.length > 0 &&
              (S.forEach(function (e, n) {
                (b += ""
                  .concat(k.optimizeImage(t, e + "x"), " ")
                  .concat(e, "w")),
                  n < S.length - 1 && (b += ", ");
              }),
              (b += '" '));
          }
          return (
            u && "string" == typeof u && (b += 'sizes="'.concat(u, '"')),
            (b += "/>")
          );
        },
        slugify: function (t) {
          if (null == t || "object" == m(t)) return "";
          if ("string" != typeof t) {
            if ("function" != typeof t.toString) return "";
            t = t.toString();
          }
          t = t.toLowerCase();
          for (
            var e =
                "\xe0\xe1\xe4\xe2\xe3\xe8\xe9\xeb\xeaẽ\xec\xed\xef\xeeĩ\xf2\xf3\xf6\xf4\xf5\xf9\xfa\xfc\xfbũ\xf1\xe7\xb7/_,:;",
              n = 0,
              i = e.length;
            n < i;
            n++
          )
            t = t.replace(
              RegExp(e.charAt(n), "g"),
              "aaaaaeeeeeiiiiiooooouuuuunc--_---".charAt(n)
            );
          for (var r = 32, o = 0; o < r; o++)
            t = t.replace(
              RegExp(
                "\xc1\xe1\xc4\xe4ČčĎď\xc9\xe9ě\xcd\xedŇň\xd3\xf3\xd6\xf6ŘřŠšŤť\xda\xfaů\xdd\xfdŽž".charAt(
                  o
                ),
                "g"
              ),
              "AaAaCcDdEeeIiNnOoOoRrSsTtUuuYyZz".charAt(o)
            );
          for (
            var a = ["AE", "ae", "O", "o", "A", "a"], s = 6, l = 0;
            l < s;
            l++
          )
            t = t.replace(
              RegExp("\xc6\xe6\xd8\xf8\xc5\xe5".charAt(l), "g"),
              a[l]
            );
          return (t = t.replace(/'/g, "").replace(/"/g, ""))
            .replace(/[\s\/]+/g, "-")
            .replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/g, "-")
            .replace(/\-\-+/g, "-")
            .replace(/^-+/, "")
            .replace(/-+$/, "");
        },
        capitalize: function (t, e, n) {
          return (
            (n = void 0 !== n && n),
            (e = void 0 !== e && e) && (t = t.toLowerCase()),
            n
              ? t.charAt(0).toUpperCase() + t.slice(1)
              : t.replace(/(?:^|\s)\S/g, function (t) {
                  return t.toUpperCase();
                })
          );
        },
        textify: function (t, e) {
          e = void 0 !== e ? e : "-";
          for (var n = t.split(e), i = "", r = 0; r < n.length; r++)
            (i += n[r].charAt(0).toUpperCase() + n[r].slice(1)),
              r < n.length - 1 && (i += " ");
          return i;
        },
        stripHtml: _,
        stripScriptTag: function (t) {
          if (t) return t.replace(/<script[^>]*>.*?<\/script>/gi, "");
        },
        truncateByWord: function (t, e, n) {
          return (
            void 0 === n && (n = "..."),
            (t =
              t.split(" ").length > e
                ? t.split(" ").splice(0, e).join(" ") + n
                : t.split(" ").splice(0, e).join(" "))
          );
        },
        removeDecimal: function (t, e) {
          var n = RegExp(
            "(\\" +
              (e =
                void 0 !== e
                  ? e
                  : o.a.getSettingValue("general.decimalDelimiter")) +
              "\\d+)+",
            "gi"
          );
          return t.replace(n, "");
        },
        formatMoney: function (t, e, n) {
          void 0 === e && (e = a.a.moneyFormat),
            ("money_with_currency" == e ||
              o.a.getSettingValue("general.moneyFormatWithCurrency")) &&
              (e = a.a.moneyFormatWithCurrency),
            void 0 === n && (n = !1),
            "string" == typeof t && (t = t.replace(".", ""));
          var i = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            s = e || "${{amount}}";
          function l(t, e) {
            return void 0 === t ? e : t;
          }
          function c(t, e, i, r) {
            if (
              ((e = l(e, 2)),
              (i = l(i, ",")),
              (r = l(r, ".")),
              isNaN(t) || null == t)
            )
              return 0;
            var o = (t = parseFloat(t).toFixed(e)).split("."),
              a = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
              s = o[1] ? r + o[1] : "";
            return 1 == n ? (a + s).replace(/((\,00)|(\.00))$/g, "") : a + s;
          }
          var u = s.match(r);
          switch (u && u.length > 1 ? u[1] : "") {
            case "amount":
            case "amount_with_space_separator_no_comma":
            default:
              i = c(t, 2);
              break;
            case "amount_no_decimals":
              i = c(t, 0);
              break;
            case "amount_with_comma_separator":
              i = c(t, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              i = c(t, 0, ".", ",");
              break;
            case "amount_no_decimals_with_space_separator":
              i = c(t, 0, " ", ".");
          }
          return (
            (s = s.replace(r, i)),
            o.a.getSettingValue("general.enable3rdCurrencySupport")
              ? k.moneyWrapper(s)
              : s
          );
        },
        moneyWrapper: function (t) {
          return '<span class="money">{{money}}</span>'.replace(
            /{{money}}/g,
            _(t)
          );
        },
        formatNumberWithSeparator: function (t, e, n, i, r) {
          isNaN(t) && (t = 0),
            isNaN(e) && (e = 0),
            i || (i = "." == n ? "," : ".");
          var o = (t = parseFloat(t).toFixed(e)).toString().split("."),
            a = o[0],
            s = o[1] ? o[1] : "";
          return (
            n && (a = a.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n)),
            i && s && (s = r && /0+/.test(s) ? "" : i + s),
            a + s
          );
        },
        getCurrency: b,
        removeCurrencySymbol: function (t) {
          t = r()("<p>" + t + "</p>").text();
          for (var e = b().split(" "), n = 0; n < e.length; n++)
            t = t.replace(e[n].trim(), "");
          return t.trim();
        },
        isShopifyActiveCurrency: function () {
          return (
            "undefined" != typeof Shopify &&
            Shopify.hasOwnProperty("currency") &&
            Shopify.currency.hasOwnProperty("rate") &&
            1 != Shopify.currency.rate
          );
        },
        isEnableShopifyMultipleCurrencies: function () {
          return (
            o.a.hasOwnProperty("general") &&
            o.a.general.hasOwnProperty("currencies") &&
            o.a.general.currencies.length > 1 &&
            k.isShopifyActiveCurrency()
          );
        },
        isConvertCurrenciesOnFrontEnd: function () {
          var t = o.a.getSettingValue("currencyRoundingRules");
          return t && "object" == m(t);
        },
        roundedPrice: function (t) {
          t = parseFloat(t).toFixed(2);
          var e = boostPFSAppConfig.general.current_currency
              .toLowerCase()
              .trim(),
            n = o.a.getSettingValue("currencyRoundingRules"),
            i = n && e && n.hasOwnProperty(e) ? n[e] : 0,
            r = k.getRoundingRange(!0);
          if (r) {
            var a = parseFloat(i);
            (t /= r), 1 == (a /= r) && (a = 0);
            var s = Math.floor(t);
            (t = (t - s).toFixed(2) > a ? s + 1 : s),
              (t *= r),
              0 == a && (i = 0),
              (t += parseFloat(i));
          }
          return t;
        },
        getRoundingRange: function (t) {
          void 0 === t && (t = !1);
          var e = boostPFSAppConfig.general.current_currency
              .toLowerCase()
              .trim(),
            n = o.a.getSettingValue("currencyRoundingRules"),
            i = n && e && n.hasOwnProperty(e) ? parseFloat(n[e]) : 0,
            r = !1;
          return (
            i > 0 &&
              -1 !=
                [
                  0.25, 0.5, 0.75, 0.9, 0.95, 0.99, 1, 25, 50, 75, 90, 95, 99,
                  100, 250, 500, 750, 900, 950, 999, 1e3,
                ].indexOf(i) &&
              ((r = 0.99),
              i > 100 ? (r = 999) : i > 10 ? (r = 99) : i > 1 && (r = 9),
              t && (r = i > 1 ? r + 1 : r + 0.01)),
            r
          );
        },
        convertPriceBasedOnActiveCurrency: function (t, e) {
          if ((void 0 === e && (e = !0), !t || 0 == t)) return t;
          if (k.isEnableShopifyMultipleCurrencies()) {
            var n = t * Shopify.currency.rate;
            t = e ? k.roundedPrice(n) : n;
          }
          return parseFloat(t);
        },
        convertPriceBasedOnPresentmentPrice: function (t) {
          var e = o.a.getSettingValue("general.currencies");
          if (void 0 !== e && e.length > 1) {
            var n = o.a
              .getSettingValue("general.current_currency")
              .toLowerCase()
              .trim();
            [
              "price_min",
              "price_max",
              "compare_at_price_min",
              "compare_at_price_max",
            ].forEach(function (e) {
              var i = e + "_" + n;
              void 0 !== t[i] && (t[e] = t[i]);
            });
          }
        },
        revertPriceToDefaultCurrency: function (t, e) {
          if (!t || 0 == t) return t;
          if (k.isEnableShopifyMultipleCurrencies()) {
            if (((t = k.roundedPrice(t)), e)) {
              var n = k.getRoundingRange();
              n && (t -= n);
            }
            return (t /= Shopify.currency.rate).toFixed(8);
          }
          return t;
        },
        reBuildUrlBaseOnLocale: function (t) {
          t = t.replace("https://", "").replace("http://", "");
          var e = Shopify && Shopify.routes && void 0 !== Shopify.routes.root;
          if (
            o.a.getSettingValue("general.useShopifyRouteForMultiLanguageURL") &&
            e
          )
            return Shopify.routes.root.replace(/\/$/, "") + t;
          var n = o.a.getSettingValue("general.current_locale"),
            i = o.a.getSettingValue("general.published_locales"),
            r = Object.keys(i);
          if (0 > r.indexOf(n) || 1 == i[n]) return t;
          var a = t.split("/");
          return (
            a.length > 1 &&
              r.length &&
              n.length &&
              (r.indexOf(a[1]) > -1 ? (a[1] = n) : a.splice(1, 0, n)),
            a.join("/")
          );
        },
        getWindowLocation: function () {
          for (
            var t = window.location.href
                .replace(/%3C/g, "&lt;")
                .replace(/%3E/g, "&gt;"),
              e = [],
              n = 0;
            n < t.length;
            n++
          )
            e.push(t.charAt(n));
          var i = e
              .join("")
              .split("&lt;")
              .join("%3C")
              .split("&gt;")
              .join("%3E"),
            r = "",
            o = i.replace(/#.*$/, "");
          return (
            o.split("?").length > 1 &&
              (r = o.split("?")[1]).length > 0 &&
              (r = "?" + r),
            { pathname: window.location.pathname, href: i, search: r }
          );
        },
        setWindowLocation: function (t) {
          window.location.href = t;
        },
        isBadUrl: function (t) {
          try {
            t || (t = k.getWindowLocation().search);
            var e = decodeURIComponent(t).split("&"),
              n = !1;
            if (e.length > 0)
              for (var i = 0; i < e.length; i++) {
                var r = e[i];
                if ((n = k.isBadSearchTerm(r))) break;
              }
            return n;
          } catch (o) {
            return !0;
          }
        },
        isBadSearchTerm: function (t) {
          if ("string" == typeof t) {
            var e = RegExp(
                "onabort=|onpopstate=|onafterprint=|onbeforeprint=|onbeforeunload=|onblur=|oncanplay=|oncanplaythrough=|onchange=|onclick=|oncontextmenu=|oncopy=|oncut=|ondblclick=|ondrag=|ondragend=|ondragenter=|ondragleave=|ondragover=|ondragstart=|ondrop=|ondurationchange=|onended=|onerror=|onfocus=|onfocusin=|onfocusout=|onfullscreenchange=|onfullscreenerror=|onhashchange=|oninput=|oninvalid=|onkeydown=|onkeypress=|onkeyup=|onload=|onloadeddata=|onloadedmetadata=|onloadstart=|onmousedown=|onmouseenter=|onmouseleave=|onmousemove=|onmouseover=|onmouseout=|onmouseout=|onmouseup=|onoffline=|ononline=|onpagehide=|onpageshow=|onpaste=|onpause=|onplay=|onplaying=|onprogress=|onratechange=|onresize=|onreset=|onscroll=|onsearch=|onseeked=|onseeking=|onselect=|onshow=|onstalled=|onsubmit=|onsuspend=|ontimeupdate=|ontoggle=|ontouchcancel=|ontouchend=|ontouchmove=|ontouchstart=|onunload=|onvolumechange=|onwaiting=|onwheel"
              ),
              n = (t.match(/</g) || []).length,
              i = (t.match(/>/g) || []).length,
              r = (t.match(/alert\(/g) || []).length,
              o = (t.match(/console\.log\(/g) || []).length,
              a = (t.match(/execCommand/g) || []).length,
              s = (t.match(/document\.cookie/g) || []).length,
              l = (t.match(/j.*a.*v.*a.*s.*c.*r.*i.*p.*t/g) || []).length,
              c = e.test(t);
            if (
              (n > 0 && i > 0) ||
              n > 1 ||
              i > 1 ||
              r ||
              o ||
              a ||
              s ||
              l ||
              c
            )
              return !0;
          }
          return !1;
        },
        debounce: function (t, e) {
          var n;
          return function () {
            var i = this,
              r = arguments,
              o = function () {
                t.apply(i, r);
              };
            clearTimeout(n), (n = setTimeout(o, e));
          };
        },
        iterateObject: function (t, e) {
          t &&
            "object" == m(t) &&
            Object.keys(t).forEach(function (n) {
              "object" == m(t[n])
                ? k.iterateObject(t[n])
                : "function" == typeof e && (t[n] = e(t[n]));
            });
        },
        sticky: function (t, e, n) {
          if (null == t.attr("data-offset-top")) {
            var i = t.offset().top;
            t.attr("data-offset-top", i);
          }
          var a = function () {
            var i = !!(
                t.hasClass(s.a.filterTreeVertical) ||
                t.find(l.a.filterTreeVertical).length > 0
              ),
              a = t.outerWidth(),
              c = i ? t[0].scrollHeight : t.outerHeight(),
              u = window.innerHeight,
              p = Number(t.attr("data-offset-top")),
              f = r()(e).position().top + r()(e).outerHeight(),
              h = r()(e).offset().top + r()(e).outerHeight(),
              d =
                "boost-pfs-filter-tree" == t[0].classList[0] ||
                "boost-pfs-filter-tree-h-wrapper" == t[0].classList[0]
                  ? t[0].classList[0] + "-stick-body"
                  : "boost-pfs-filter-tree-button-stick-wrapper-body",
              g = r()(e).height() <= u + 100,
              y = 0,
              m = r()(n);
            if (
              (m.length > 0 &&
                m.each(function (t, e) {
                  var n = e.getBoundingClientRect();
                  n.y >= 0 && n.height > 0
                    ? (y += n.height)
                    : r()(e)
                        .children()
                        .each(function (t, e) {
                          var n = e.getBoundingClientRect();
                          n.y >= 0 && n.height > 0 && (y += n.height);
                        });
                }),
              window.scrollY < p || h - p <= c || g)
            )
              t.removeClass("boost-pfs-filter-stick"),
                t.removeClass("boost-pfs-filter-absolute"),
                r()("body").removeClass("boost-pfs-filter-stick-body"),
                r()("body").removeClass(d),
                t.css({
                  position: "initial",
                  width: "",
                  maxHeight: "none",
                  overflow: "visible",
                  visibility: "visible",
                });
            else if (window.scrollY + c <= h) {
              t.addClass("boost-pfs-filter-stick"),
                t.removeClass("boost-pfs-filter-absolute"),
                r()("body").addClass("boost-pfs-filter-stick-body"),
                r()("body").addClass(d),
                t.css({
                  position: "fixed",
                  width: i ? a : "",
                  maxHeight: window.innerHeight - y + "px",
                  overflow: i ? "auto" : "visible",
                  visibility: "visible",
                  top: y + "px",
                });
              var v = o.a.getSettingValue("general.stickyChangeTopTimeout");
              "number" != typeof v && (v = 0),
                setTimeout(function () {
                  t.css({ top: y + "px" });
                }, v);
            } else {
              t.removeClass("boost-pfs-filter-stick"),
                t.addClass("boost-pfs-filter-absolute"),
                r()("body").removeClass("boost-pfs-filter-stick-body"),
                r()("body").removeClass(d);
              var b = o.a.getSettingValue("general.stickyFixTopPos")
                ? f - p - c
                : f - c - y;
              t.css({
                position: "absolute",
                top: b + "px",
                width: i ? a : "",
                maxHeight: "none",
                visibility: i ? "visible" : "hidden",
              });
            }
          };
          r()(window).off("scroll", a), r()(window).on("scroll", a), a();
        },
        addClassToBody: function () {
          var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          if (t && "string" == typeof t) {
            var e = {
              enableApp: s.a.enableApp,
              enableFilter: s.a.enableFilter,
              enableInstantSearch: s.a.enableInstantSearch,
              variantsDisplay: s.a.variantsDisplay,
            }[t];
            e && r()("body").addClass(e);
          }
        },
        InstantSearch: c,
        isFullWidthMobile: c.isFullWidthMobile,
        isStyle2: c.isStyle2,
        isStyle3: c.isStyle3,
        getListSuggestionType: c.getListSuggestionType,
        FilterTree: u,
        checkExistFilterOptionParam: u.checkExistFilterOptionParam,
        encodeURIParamValue: u.encodeURIParamValue,
        showFilterTree: u.showFilterTree,
        hideFilterTree: u.hideFilterTree,
        FilterResult: y,
        buildProductItemUrl: y.buildProductItemUrl,
        buildProductItemUrlWithVariant: y.buildProductItemUrlWithVariant,
        buildProductItemVendorUrl: y.buildProductItemVendorUrl,
        removePageParamFromUrl: y.removePageParamFromUrl,
        removeCollectionScopeParamFromUrl: y.removeCollectionScopeParamFromUrl,
        buildToolbarLink: y.buildToolbarLink,
        isDefaultPaginationType: y.isDefaultPaginationType,
        isLoadMorePaginationType: y.isLoadMorePaginationType,
        isInfiniteLoadingPaginationType: y.isInfiniteLoadingPaginationType,
        isLoadPreviousPagePaginationType: y.isLoadPreviousPagePaginationType,
        getSortingList: y.getSortingList,
        getDefaultSorting: y.getDefaultSorting,
        getProductMetafield: y.getProductMetafield,
        isNoFilterResult: y.isNoFilterResult,
        compileShopifyProductVariables: y.compileShopifyProductVariables,
        compileShopifyProductMetafield: y.compileShopifyProductMetafield,
      },
      O = (e.a = k);
  },
  10: function (t, e, n) {
    "use strict";
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    n(30), n(83), n(24), n(9), n(25);
    var r = (function () {
      var t, e, n;
      function r() {
        !(function (t, e) {
          if (!(t instanceof e))
            throw TypeError("Cannot call a class as a function");
        })(this, r),
          (this.isInit = !1),
          (this.isRendered = !1),
          (this.isBoundEvent = !1),
          (this.children = []),
          (this.parent = null),
          (this.$element = null);
      }
      return (
        (t = r),
        (e = [
          {
            key: "refresh",
            value: function () {
              this._callAllInit(),
                this._callAllRender(),
                this._callAllBindEvents();
            },
          },
          { key: "beforeInit", value: function () {} },
          { key: "init", value: function () {} },
          { key: "afterInit", value: function () {} },
          {
            key: "isLoopThroughChild",
            value: function () {
              return !0;
            },
          },
          {
            key: "isRender",
            value: function () {
              return !0;
            },
          },
          { key: "beforeRender", value: function () {} },
          { key: "render", value: function () {} },
          { key: "afterRender", value: function () {} },
          {
            key: "isBindEvents",
            value: function () {
              return !0;
            },
          },
          { key: "beforeBindEvents", value: function () {} },
          { key: "bindEvents", value: function () {} },
          { key: "afterBindEvents", value: function () {} },
          {
            key: "addComponent",
            value: function (t) {
              (t.parent = this), this.children.push(t);
            },
          },
          {
            key: "removeComponent",
            value: function (t) {
              if (this.children && this.children.length > 0) {
                var e = this.children.indexOf(t);
                -1 !== e && this.children.splice(e, 1);
              }
            },
          },
          {
            key: "_callAllInit",
            value: function () {
              this.isInit || (this.beforeInit(), this.init()),
                this.children &&
                  this.children.length > 0 &&
                  this.isLoopThroughChild() &&
                  this.children.forEach(function (t) {
                    t._callAllInit();
                  }),
                this.isInit || (this.afterInit(), (this.isInit = !0));
            },
          },
          {
            key: "_callAllRender",
            value: function () {
              this.isRender() && this.beforeRender(),
                this.children &&
                  this.children.length > 0 &&
                  this.isLoopThroughChild() &&
                  this.children.forEach(function (t) {
                    t._callAllRender();
                  }),
                this.isRender() &&
                  (this.render(), this.afterRender(), (this.isRendered = !0));
            },
          },
          {
            key: "_callAllBindEvents",
            value: function () {
              this.isBindEvents() && this.beforeBindEvents(),
                this.children &&
                  this.children.length > 0 &&
                  this.isLoopThroughChild() &&
                  this.children.forEach(function (t) {
                    t._callAllBindEvents();
                  }),
                this.isBindEvents() &&
                  (this.bindEvents(),
                  this.afterBindEvents(),
                  (this.isBoundEvent = !0));
            },
          },
        ]),
        i(t.prototype, e),
        n && i(t, n),
        r
      );
    })();
    e.a = r;
  },
  100: function (t, e, n) {
    "use strict";
    n(9), n(48), n(21), n(24), n(25), n(11), n(12), n(22), n(23);
    var i = n(3),
      r = n(0),
      o = function () {
        "string" != typeof i.a.currentTerm &&
          (i.a.currentTerm = r.a.stripHtml(i.a.currentTerm.toString())),
          (i.a.currentTerm = r.a.stripHtml(i.a.currentTerm.trim()));
        var t = "";
        return (
          i.a.suggestionCache.hasOwnProperty(r.a.unescape(i.a.currentTerm)) &&
            i.a.suggestionCache[r.a.unescape(i.a.currentTerm)].forEach(
              function (e) {
                "redirect" == e.key &&
                  e.values &&
                  (t = (t = (t = e.values).replace(
                    "https://" + i.a.shopDomain,
                    ""
                  )).replace("http://" + i.a.shopDomain, ""));
              }
            ),
          t
        );
      },
      a = {
        getSearchRedirectUrl: o,
        checkForSearchRedirect: function (t) {
          if (t.data("search-submit")) {
            t.removeAttr("data-search-submit");
            var e = o();
            e
              ? r.a.setWindowLocation(e)
              : t.closest("form").trigger("submit", [!0]);
          }
        },
      };
    e.a = a;
  },
  121: function (t, e, n) {
    "use strict";
    n(21),
      n(22),
      n(23),
      n(27),
      n(9),
      n(24),
      n(25),
      n(17),
      n(18),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(10),
      a = n(4),
      s = n(122),
      l = n(86),
      c = n(123),
      u = n(124),
      p = n(20),
      f = n(125),
      h = n(2),
      d = n(0),
      g = n(7);
    function y(t) {
      return (y =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function m(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function v(t, e) {
      return (v =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function b(t, e) {
      return e && ("object" === y(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function S(t) {
      return (S = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var $ = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && v(t, e);
      })(y, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = S(t);
            if (e()) {
              var r = S(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return b(this, n);
          };
        })(y);
      function y(t) {
        var e;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, y),
          ((e = o.call(this)).type = t.type),
          (e.status = t.status),
          (e.maxSuggesionItems = t.number),
          (e.label = d.a.stripHtml(t.label)),
          (e.isShow = !1),
          (e.isShowDYM = !1),
          e.type &&
            e.type === p.a.ResultType.PRODUCTS &&
            (e.blockDym = new f.a()),
          (e.settings = {
            suggesionMaxItems: h.a.getSettingValue("search.suggesionMaxItems"),
          }),
          e
        );
      }
      return (
        (e = y),
        (n = [
          {
            key: "init",
            value: function () {
              switch (this.type) {
                case p.a.ResultType.SUGGESTIONS:
                case p.a.ResultType.DEFAULT_SUGGESTIONS:
                case p.a.ResultType.RECENT_SEARCHES:
                case p.a.ResultType.NO_RESULT_SUGGESTIONS:
                  this.maxSuggesionItems = this.settings.suggesionMaxItems;
                  for (var t = 0; t < this.maxSuggesionItems; t++)
                    this.addComponent(new s.a());
                  break;
                case p.a.ResultType.PRODUCTS:
                case p.a.ResultType.DEFAULT_PRODUCTS:
                case p.a.ResultType.NO_RESULT_PRODUCTS:
                  for (
                    this.maxSuggesionItems = this.settings.suggesionMaxItems,
                      t = 0;
                    t < this.maxSuggesionItems;
                    t++
                  )
                    this.addComponent(new l.a());
                  break;
                case p.a.ResultType.COLLECTIONS:
                  for (t = 0; t < this.maxSuggesionItems; t++)
                    this.addComponent(new c.a());
                  break;
                case p.a.ResultType.PAGES:
                  for (t = 0; t < this.maxSuggesionItems; t++)
                    this.addComponent(new u.a());
              }
            },
          },
          {
            key: "getTemplate",
            value: function (t) {
              return "dym" === t
                ? '\n					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestion}}-dym" aria-label="Did you mean">{{dymContent}}</li>\n				'.trim()
                : '\n					<div class="{{class.searchSuggestionGroup}}" data-group="{{type}}" aria-label="{{label}}">\n						<ul>\n							<li class="{{class.searchSuggestionHeader}}-{{type}} {{class.searchSuggestionHeader}}" aria-label="{{label}}">{{label}}</li>\n							{{resultItems}}\n						</ul>\n					</div>\n				'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t;
              if (
                !(("active" == this.status && this.isShow) || this._isShowDYM())
              )
                return "";
              switch (this.type) {
                case p.a.ResultType.SUGGESTIONS:
                  t = h.a.getSettingValue(
                    "label.suggestion.instantSearchSuggestionsLabel"
                  );
                  break;
                case p.a.ResultType.COLLECTIONS:
                  t = h.a.getSettingValue(
                    "label.suggestion.instantSearchCollectionsLabel"
                  );
                  break;
                case p.a.ResultType.PRODUCTS:
                  t = h.a.getSettingValue(
                    "label.suggestion.instantSearchProductsLabel"
                  );
                  break;
                case p.a.ResultType.PAGES:
                  t = h.a.getSettingValue(
                    "label.suggestion.instantSearchPagesLabel"
                  );
                  break;
                case p.a.ResultType.NO_RESULT_SUGGESTIONS:
                  t = g.a.suggestion.noSearchResultSearchTermLabel;
                  break;
                case p.a.ResultType.NO_RESULT_PRODUCTS:
                  t = g.a.suggestion.noSearchResultProductsLabel;
                  break;
                case p.a.ResultType.RECENT_SEARCHES:
                  t = g.a.suggestion.searchBoxOnclickRecentSearchLabel;
                  break;
                case p.a.ResultType.DEFAULT_SUGGESTIONS:
                  t = g.a.suggestion.searchBoxOnclickSearchTermLabel;
                  break;
                case p.a.ResultType.DEFAULT_PRODUCTS:
                  t = g.a.suggestion.searchBoxOnclickProductsLabel;
                  break;
                default:
                  t = this.label;
              }
              return (
                t || (t = this.label),
                this.getTemplate()
                  .replace(/{{type}}/g, this.type)
                  .replace(/{{label}}/g, d.a.stripHtml(t))
                  .replace(
                    /{{class.searchSuggestionHeader}}/g,
                    a.a.searchSuggestionHeader
                  )
                  .replace(
                    /{{class.searchSuggestionGroup}}/g,
                    a.a.searchSuggestionGroup
                  )
                  .replace(/{{resultItems}}/g, "")
              );
            },
          },
          {
            key: "render",
            value: function () {
              var t = this;
              (this.$element = r()(this.compileTemplate())),
                this.type &&
                  this.type === p.a.ResultType.PRODUCTS &&
                  (this.blockDym.render(),
                  this.blockDym.bindEvents(),
                  this.blockDym.$element &&
                    ((this.$element = r()(this.compileTemplate())),
                    this.$element.find(" ul").prepend(this.blockDym.$element))),
                this.children.forEach(function (e) {
                  e.$element && t.$element.find(" ul").append(e.$element);
                });
            },
          },
          {
            key: "_isShowDYM",
            value: function () {
              return this.isShowDYM && this.type == p.a.ResultType.PRODUCTS;
            },
          },
          {
            key: "setData",
            value: function (t, e) {
              (this.data = t),
                (this.isAllEmpty = e),
                this.children.forEach(function (e, n) {
                  t && t.length > n ? e.setData(t[n]) : e.setData(null);
                }),
                this.blockDym &&
                  (this.blockDym.setData(this.parent.data),
                  (this.isShowDYM = this.blockDym.isShow)),
                (this.isShow = t && t.length > 0);
            },
          },
        ]),
        m(e.prototype, n),
        i && m(e, i),
        y
      );
    })(o.a);
    e.a = $;
  },
  122: function (t, e, n) {
    "use strict";
    n(21),
      n(22),
      n(23),
      n(17),
      n(18),
      n(9),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(0),
      a = n(3),
      s = n(4),
      l = n(43),
      c = n(59),
      u = n(20);
    function p(t) {
      return (p =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function f(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function h(t, e) {
      return (h =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function d(t, e) {
      return e && ("object" === p(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function g(t) {
      return (g = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var y = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && h(t, e);
      })(p, t);
      var e,
        n,
        i,
        c = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = g(t);
            if (e()) {
              var r = g(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return d(this, n);
          };
        })(p);
      function p() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, p),
          ((t = c.call(this)).data = ""),
          t
        );
      }
      return (
        (e = p),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedData}}" role="option">\n				<a tabindex="-1" href="{{searchLink}}">{{highlightedSuggestionResult}}</a>\n			</li>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              if (!this.isShow) return "";
              var t = o.a.stripHtml(a.a.currentTerm),
                e = this.data;
              return (
                this.parent.type == u.a.ResultType.SUGGESTIONS &&
                  (e = this._highlightSuggestionResult(this.data, t)),
                this.getTemplate()
                  .replace(
                    /{{escapedBlockType}}/g,
                    o.a.stripHtml(this.parent.type)
                  )
                  .replace(/{{escapedData}}/g, o.a.stripHtml(this.data))
                  .replace(
                    /{{class.searchSuggestionItem}}/g,
                    s.a.searchSuggestionItem
                  )
                  .replace(
                    /{{class.searchUiAutocompleteItem}}/g,
                    s.a.searchUiAutocompleteItem
                  )
                  .replace(/{{searchLink}}/g, this.searchLink)
                  .replace(/{{highlightedSuggestionResult}}/g, e)
              );
            },
          },
          {
            key: "checkForRedirectData",
            value: function () {
              var t = this.parent.parent;
              if (
                t.hasRedirectData &&
                t.redirectData &&
                t.searchQuery == this.data
              )
                return t.redirectData;
              var e = o.a.getValueInObjectArray(
                u.a.ResultType.SUGGESTIONS_REDIRECT,
                t.data
              );
              return e && e[this.data] ? e[this.data] : "";
            },
          },
          {
            key: "render",
            value: function () {
              this.data
                ? ((this.$element = r()(this.compileTemplate())),
                  this.$element.attr("data-title", o.a.stripHtml(this.data)))
                : (this.$element = null);
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                !this.redirectLink &&
                this.$element.on("click", this.saveRecentSearch.bind(this));
            },
          },
          {
            key: "saveRecentSearch",
            value: function () {
              l.a.setOnClickRecentSearches(this.data);
            },
          },
          {
            key: "setData",
            value: function (t) {
              (this.data = t),
                (this.isShow = !!this.data),
                (this.redirectLink = this.checkForRedirectData()),
                this.redirectLink
                  ? (this.searchLink = this.redirectLink)
                  : (this.searchLink = o.a.reBuildUrlBaseOnLocale(
                      "/search?" +
                        a.a.searchTermKey +
                        "=" +
                        o.a.encodeURIParamValue(this.data)
                    ));
            },
          },
        ]),
        f(e.prototype, n),
        i && f(e, i),
        p
      );
    })(c.a);
    e.a = y;
  },
  123: function (t, e, n) {
    "use strict";
    n(21),
      n(22),
      n(23),
      n(17),
      n(18),
      n(9),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(0),
      a = n(3),
      s = n(4);
    function l(t) {
      return (l =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function c(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function u(t, e) {
      return (u =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function p(t, e) {
      return e && ("object" === l(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function f(t) {
      return (f = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var h = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && u(t, e);
      })(h, t);
      var e,
        n,
        i,
        l = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = f(t);
            if (e()) {
              var r = f(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return p(this, n);
          };
        })(h);
      function h() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, h),
          ((t = l.call(this)).data = ""),
          t
        );
      }
      return (
        (e = h),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedDataTitle}}" role="option">\n				<a tabindex="-1" href="{{searchLink}}">{{highlightedSuggestionResult}}</a>\n			</li>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              if (!this.isShow) return "";
              this.searchTerm = o.a.stripHtml(a.a.currentTerm);
              var t = o.a.reBuildUrlBaseOnLocale(
                  "/collections/" + this.data.handle
                ),
                e = this._highlightSuggestionResult(
                  this.data.title,
                  this.searchTerm
                );
              return this.getTemplate()
                .replace(
                  /{{escapedBlockType}}/g,
                  o.a.stripHtml(this.parent.type)
                )
                .replace(
                  /{{escapedDataTitle}}/g,
                  o.a.stripHtml(this.data.title)
                )
                .replace(/{{escapedDataId}}/g, o.a.stripHtml(this.data.id))
                .replace(
                  /{{class.searchSuggestionItem}}/g,
                  s.a.searchSuggestionItem
                )
                .replace(
                  /{{class.searchUiAutocompleteItem}}/g,
                  s.a.searchUiAutocompleteItem
                )
                .replace(/{{searchLink}}/g, t)
                .replace(/{{highlightedSuggestionResult}}/g, e);
            },
          },
          {
            key: "render",
            value: function () {
              this.data
                ? ((this.$element = r()(this.compileTemplate())),
                  this.$element.attr(
                    "data-title",
                    o.a.stripHtml(this.data.title)
                  ))
                : (this.$element = null);
            },
          },
          {
            key: "setData",
            value: function (t) {
              (this.data = t), (this.isShow = !!this.data);
            },
          },
        ]),
        c(e.prototype, n),
        i && c(e, i),
        h
      );
    })(n(59).a);
    e.a = h;
  },
  124: function (t, e, n) {
    "use strict";
    n(21),
      n(22),
      n(23),
      n(17),
      n(18),
      n(9),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(0),
      a = n(3),
      s = n(4);
    function l(t) {
      return (l =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function c(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function u(t, e) {
      return (u =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function p(t, e) {
      return e && ("object" === l(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function f(t) {
      return (f = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var h = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && u(t, e);
      })(h, t);
      var e,
        n,
        i,
        l = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = f(t);
            if (e()) {
              var r = f(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return p(this, n);
          };
        })(h);
      function h() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, h),
          ((t = l.call(this)).data = ""),
          t
        );
      }
      return (
        (e = h),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedDataTitle}}" role="option">\n				<a tabindex="-1" href="{{searchLink}}">{{highlightedSuggestionResult}}</a>\n			</li>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              if (!this.isShow) return "";
              var t = o.a.stripHtml(a.a.currentTerm),
                e = o.a.reBuildUrlBaseOnLocale(this.data.url),
                n = this._highlightSuggestionResult(this.data.title, t);
              return this.getTemplate()
                .replace(
                  /{{escapedBlockType}}/g,
                  o.a.stripHtml(this.parent.type)
                )
                .replace(
                  /{{escapedDataTitle}}/g,
                  o.a.stripHtml(this.data.title)
                )
                .replace(
                  /{{class.searchSuggestionItem}}/g,
                  s.a.searchSuggestionItem
                )
                .replace(
                  /{{class.searchUiAutocompleteItem}}/g,
                  s.a.searchUiAutocompleteItem
                )
                .replace(/{{searchLink}}/g, e)
                .replace(/{{highlightedSuggestionResult}}/g, n);
            },
          },
          {
            key: "render",
            value: function () {
              this.data
                ? ((this.$element = r()(this.compileTemplate())),
                  this.$element.attr(
                    "data-title",
                    o.a.stripHtml(this.data.title)
                  ))
                : (this.$element = null);
            },
          },
          {
            key: "setData",
            value: function (t) {
              (this.data = t), (this.isShow = !!this.data);
            },
          },
        ]),
        c(e.prototype, n),
        i && c(e, i),
        h
      );
    })(n(59).a);
    e.a = h;
  },
  125: function (t, e, n) {
    "use strict";
    n(21),
      n(24),
      n(9),
      n(25),
      n(22),
      n(23),
      n(27),
      n(17),
      n(18),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(10),
      a = n(4),
      s = n(0),
      l = n(20),
      c = n(3),
      u = n(7),
      p = n(43);
    function f(t) {
      return (f =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function h(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function d(t, e) {
      return (d =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function g(t, e) {
      return e && ("object" === f(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function y(t) {
      return (y = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var m = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && d(t, e);
      })(f, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = y(t);
            if (e()) {
              var r = y(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return g(this, n);
          };
        })(f);
      function f() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, f),
          ((t = o.call(this)).data = ""),
          (t.$element = null),
          t
        );
      }
      return (
        (e = f),
        (i = [
          {
            key: "tempType",
            get: function () {
              return {
                LINK: "link",
                SEPARATOR: "separator",
                STRONG: "strong",
                P: "p",
              };
            },
          },
        ]),
        (n = [
          {
            key: "getTemplate",
            value: function (t) {
              switch (t) {
                case f.tempType.LINK:
                  return '\n					<a class="{{class.searchSuggestion}}-dym-suggest-query" href="{{url}}">{{content}}</a>\n				'.trim();
                case f.tempType.SEPARATOR:
                  return '\n					<span class="{{class.searchSuggestion}}-dym-suggest-query-separator">&nbsp</span>\n				'.trim();
                case f.tempType.STRONG:
                  return "\n					<strong>{{content}}</strong>\n				".trim();
                case f.tempType.P:
                  return '\n					<p class="{{class.searchSuggestion}}-{{classType}}">{{content}}</p>\n				'.trim();
                default:
                  return '\n					<div class="{{class.searchSuggestionItem}} {{class.searchSuggestion}}-dym" aria-label="Did you mean">{{dymContent}}</div>\n				'.trim();
              }
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t = this;
              if (this.isShow) {
                var e = "";
                "" != this.dymList &&
                  this.dymList.length > 0 &&
                  this.dymList.forEach(function (n, i) {
                    var r =
                      "/search?" +
                      c.a.searchTermKey +
                      "=" +
                      s.a.encodeURIParamValue(n);
                    (e += t
                      .getTemplate(f.tempType.LINK)
                      .replace(/{{url}}/g, r)
                      .replace(/{{content}}/g, n)),
                      i < t.dymList.length - 1 &&
                        (e += t.getTemplate(f.tempType.SEPARATOR));
                  });
                var n = "";
                if (this.suggestQuery != s.a.stripHtml(c.a.currentTerm)) {
                  if (0 == this.totalProduct) {
                    var i = this.getTemplate(f.tempType.STRONG).replace(
                        /{{content}}/g,
                        s.a.stripHtml(c.a.currentTerm)
                      ),
                      r =
                        u.a.error.noSuggestionProducts.replace(
                          /{{ terms }}/g,
                          i
                        ) + " ";
                    n += this.getTemplate(f.tempType.P)
                      .replace(/{{content}}/g, r)
                      .replace(/{{classType}}/g, "dym-notfound");
                  }
                  if ("" != this.suggestQuery) {
                    var o = this.getTemplate(f.tempType.STRONG).replace(
                        /{{content}}/g,
                        this.suggestQuery
                      ),
                      l = this.getTemplate(f.tempType.STRONG).replace(
                        /{{content}}/g,
                        this.totalProductFromSuggestedQuery
                          ? this.totalProductFromSuggestedQuery
                          : ""
                      ),
                      p = u.a.suggestion.suggestQuery
                        .replace(/{{ count }}/g, l)
                        .replace(/{{ terms }}/g, o);
                    n += this.getTemplate(f.tempType.P)
                      .replace(/{{content}}/g, p)
                      .replace(/{{classType}}/g, "dym-showing-result-for");
                  }
                  "" != e &&
                    (n += this.getTemplate(f.tempType.P)
                      .replace(
                        /{{content}}/g,
                        u.a.suggestion.didYouMean.replace(/{{ terms }}/g, e)
                      )
                      .replace(/{{classType}}/g, "dym-suggest-query-list"));
                }
                return this.getTemplate()
                  .replace(/{{dymContent}}/g, n)
                  .replace(/{{class.searchSuggestion}}/g, a.a.searchSuggestion)
                  .replace(
                    /{{class.searchSuggestionItem}}/g,
                    a.a.searchSuggestionItem
                  );
              }
              return "";
            },
          },
          {
            key: "render",
            value: function () {
              this.isShow
                ? (this.$element = r()(this.compileTemplate()))
                : (this.$element = null);
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                this.$element
                  .find("a")
                  .on("click", this.saveRecentSearch.bind(this));
            },
          },
          {
            key: "saveRecentSearch",
            value: function (t) {
              if (t && t.target) {
                var e = r()(t.target).text();
                e && p.a.setOnClickRecentSearches(e);
              }
            },
          },
          {
            key: "setData",
            value: function (t) {
              (this.data = t),
                (this.isShow = !1),
                t &&
                  (s.a.getValueInObjectArray(
                    l.a.ResultType.LOCAL_CACHE,
                    this.data
                  )
                    ? ((this.totalProduct = s.a.getValueInObjectArray(
                        l.a.ResultType.TOTAL_PRODUCT,
                        this.data
                      )),
                      (this.totalProductFromSuggestedQuery =
                        s.a.getValueInObjectArray(
                          l.a.ResultType.SUGGEST_TOTAL_PRODUCT,
                          this.data
                        )),
                      (this.dymList = s.a.getValueInObjectArray(
                        l.a.ResultType.DID_YOU_MEAN,
                        this.data
                      )),
                      (this.suggestQuery = s.a.getValueInObjectArray(
                        l.a.ResultType.SUGGEST_QUERY,
                        this.data
                      )),
                      (this.isShow = this.totalProductFromSuggestedQuery > 0))
                    : s.a.getValueInObjectArray(
                        l.a.ResultType.PREV_QUERY,
                        this.data
                      )
                    ? ((this.totalProduct = s.a.getValueInObjectArray(
                        l.a.ResultType.PREV_TOTAL_PRODUCT,
                        this.data
                      )),
                      (this.totalProductFromSuggestedQuery =
                        s.a.getValueInObjectArray(
                          l.a.ResultType.TOTAL_PRODUCT,
                          this.data
                        )),
                      (this.isShow = this.totalProductFromSuggestedQuery > 0))
                    : ((this.totalProduct = s.a.getValueInObjectArray(
                        l.a.ResultType.TOTAL_PRODUCT,
                        this.data
                      )),
                      (this.totalProductFromSuggestedQuery = 0),
                      (this.dymList = s.a.getValueInObjectArray(
                        l.a.ResultType.DID_YOU_MEAN,
                        this.data
                      )),
                      (this.suggestQuery = s.a.getValueInObjectArray(
                        l.a.ResultType.SUGGEST_QUERY,
                        this.data
                      )),
                      (this.isShow =
                        (this.dymList && this.dymList.length > 0) ||
                        this.suggestQuery)));
            },
          },
        ]),
        h(e.prototype, n),
        i && h(e, i),
        f
      );
    })(o.a);
    e.a = m;
  },
  126: function (t, e, n) {
    "use strict";
    n(21),
      n(22),
      n(23),
      n(17),
      n(18),
      n(9),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(10),
      a = n(4),
      s = n(0),
      l = n(3),
      c = n(2),
      u = n(7),
      p = n(20),
      f = n(43);
    function h(t) {
      return (h =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function d(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function g(t, e) {
      return (g =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function y(t, e) {
      return e && ("object" === h(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function m(t) {
      return (m = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var v = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && g(t, e);
      })(h, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = m(t);
            if (e()) {
              var r = m(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return y(this, n);
          };
        })(h);
      function h() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, h),
          ((t = o.call(this)).data = ""),
          (t.$element = null),
          t
        );
      }
      return (
        (e = h),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<div class="{{class.searchSuggestionHeader}}-view-all {{class.searchSuggestionHeader}}" data-group="view-all" aria-label="View All">\n				<a href="{{viewAllUrl}}"><span>{{label.suggestion.viewAll}}{{iconViewAll}}</span></a>\n			</div>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t = s.a.getValueInObjectArray("total_product", this.data),
                e = s.a.getValueInObjectArray(
                  "suggest_total_product",
                  this.data
                );
              "" !== e && (t = e);
              var n = c.a.getSettingValue("search.suggestionBlocks"),
                i = s.a.getValueInObjectArray("products", n, "type", "number");
              if (0 == t || t <= i) return "";
              var r = c.a.getSettingValue("search.iconViewAll");
              (this.viewAllTerm = s.a.getValueInObjectArray(
                p.a.ResultType.SUGGEST_QUERY,
                this.data
              )),
                this.viewAllTerm ||
                  (this.viewAllTerm = s.a.getValueInObjectArray(
                    p.a.ResultType.QUERY,
                    this.data
                  ));
              var o = s.a.reBuildUrlBaseOnLocale(
                "/search?" +
                  l.a.searchTermKey +
                  "=" +
                  s.a.encodeURIParamValue(this.viewAllTerm)
              );
              return this.getTemplate()
                .replace(
                  /{{class.searchSuggestionHeader}}/g,
                  a.a.searchSuggestionHeader
                )
                .replace(
                  /{{label.suggestion.viewAll}}/g,
                  u.a.suggestion.viewAll
                )
                .replace(/{{iconViewAll}}/g, r)
                .replace(/{{ count }}/g, t)
                .replace(/{{viewAllUrl}}/g, o);
            },
          },
          {
            key: "render",
            value: function () {
              this.$element = r()(this.compileTemplate());
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                this.$element.on("click", this.saveRecentSearch.bind(this));
            },
          },
          {
            key: "saveRecentSearch",
            value: function (t) {
              this.viewAllTerm &&
                f.a.setOnClickRecentSearches(this.viewAllTerm);
            },
          },
          {
            key: "setData",
            value: function (t) {
              this.data = t || null;
            },
          },
        ]),
        d(e.prototype, n),
        i && d(e, i),
        h
      );
    })(o.a);
    e.a = v;
  },
  127: function (t, e, n) {
    "use strict";
    n(21),
      n(22),
      n(23),
      n(17),
      n(18),
      n(9),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(10),
      a = n(4),
      s = n(2);
    function l(t) {
      return (l =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function c(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function u(t, e) {
      return (u =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function p(t, e) {
      return e && ("object" === l(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function f(t) {
      return (f = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var h = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && u(t, e);
      })(l, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = f(t);
            if (e()) {
              var r = f(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return p(this, n);
          };
        })(l);
      function l() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, l),
          ((t = o.call(this)).$element = null),
          t
        );
      }
      return (
        (e = l),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<div class="{{class.searchSuggestionLoading}}">\n				<ul>\n					<li>\n						<div class="{{class.searchSuggestionLoading}}-img"></div>\n					</li>\n					<li>\n						<div class="{{class.searchSuggestionLoading}}-img"></div>\n					</li>\n					<li>\n						<div class="{{class.searchSuggestionLoading}}-img"></div>\n					</li>\n				</ul>\n			</div>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate().replace(
                /{{class.searchSuggestionLoading}}/g,
                a.a.searchSuggestionLoading
              );
            },
          },
          {
            key: "isRender",
            value: function () {
              return s.a.getSettingValue("search.showSuggestionLoading");
            },
          },
          {
            key: "render",
            value: function () {
              this.$element = r()(this.compileTemplate());
            },
          },
        ]),
        c(e.prototype, n),
        i && c(e, i),
        l
      );
    })(o.a);
    e.a = h;
  },
  128: function (t, e, n) {
    "use strict";
    n(21),
      n(22),
      n(54),
      n(23),
      n(17),
      n(18),
      n(9),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(4),
      a = n(7),
      s = n(0),
      l = n(3),
      c = n(20),
      u = n(70);
    function p(t) {
      return (p =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function f(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function h(t, e) {
      return (h =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function d(t, e) {
      return e && ("object" === p(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function g(t) {
      return (g = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var y = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && h(t, e);
      })(y, t);
      var e,
        n,
        i,
        p = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = g(t);
            if (e()) {
              var r = g(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return d(this, n);
          };
        })(y);
      function y() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, y),
          ((t = p.call(this)).$element = null),
          t
        );
      }
      return (
        (e = y),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<div class="{{class.searchSuggestion}}-no-result" data-group="empty" data-label="No Results: {{searchTerm}}" data-value="{{searchTerm}}" aria-label="No Results">\n				<p>{{noResultLabel}}</p>\n			</div>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t = s.a.stripHtml(l.a.currentTerm),
                e = this.isEmptyWithSuggestion
                  ? a.a.search.resultEmptyWithSuggestion
                  : a.a.error.noSuggestionResult;
              return (
                (e = e.replace(/{{ terms }}/g, "<strong>" + t + "</strong>")),
                this.getTemplate()
                  .replace(/{{class.searchSuggestion}}/g, o.a.searchSuggestion)
                  .replace(
                    /{{class.searchSuggestionItem}}/g,
                    o.a.searchSuggestionItem
                  )
                  .replace(/{{searchTerm}}/g, t)
                  .replace(/{{noResultLabel}}/g, e)
              );
            },
          },
          {
            key: "render",
            value: function () {
              this.hasRedirect
                ? (this.$element = null)
                : (this.$element = r()(this.compileTemplate()));
            },
          },
          {
            key: "setData",
            value: function (t) {
              var e = u.a.getNoResultData();
              (this.isEmptyWithSuggestion = e && !e.isAllEmpty),
                t
                  ? ((this.data = t),
                    (this.hasRedirect = s.a.getValueInObjectArray(
                      c.a.ResultType.REDIRECT,
                      this.data
                    )))
                  : ((this.data = null), (this.hasRedirect = !1));
            },
          },
        ]),
        f(e.prototype, n),
        i && f(e, i),
        y
      );
    })(n(10).a);
    e.a = y;
  },
  129: function (t, e, n) {
    "use strict";
    n(17), n(18), n(9), n(19), n(14), n(15), n(16), n(11), n(13), n(12);
    var i = n(1),
      r = n.n(i),
      o = n(0),
      a = n(2),
      s = n(4);
    function l(t) {
      return (l =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function c(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function u(t, e) {
      return (u =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function p(t, e) {
      return e && ("object" === l(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function f(t) {
      return (f = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    n(20);
    var h = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && u(t, e);
      })(h, t);
      var e,
        n,
        i,
        l = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = f(t);
            if (e()) {
              var r = f(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return p(this, n);
          };
        })(h);
      function h(t, e) {
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, h),
          l.call(this, t, e)
        );
      }
      return (
        (e = h),
        (i = [
          {
            key: "isActive",
            value: function () {
              return (
                !o.a.isMobile() &&
                "style2" === a.a.getSettingValue("search.suggestionStyle")
              );
            },
          },
        ]),
        (n = [
          {
            key: "_applyFilterAutocompleteAppendElement",
            value: function (t) {
              this.appendToSelector = a.a.getSettingValue(
                "search.suggestionStyle2MainContainerSelector"
              );
            },
          },
          {
            key: "_renderWrapper",
            value: function () {
              var t = o.a.InstantSearch.isFullWidthMobile()
                ? s.a.searchSuggestionMobile
                : "";
              "" !== t && this.$wrapper.addClass(t);
              var e = this._setSuggestionPosition();
              e.setSuggetionPosition(),
                e.setSuggetionPopoverPosition(),
                r()(window).resize(function () {
                  e.setSuggetionPopoverPosition();
                });
            },
          },
        ]),
        c(e.prototype, n),
        i && c(e, i),
        h
      );
    })(n(85).a);
    e.a = h;
  },
  130: function (t, e, n) {
    "use strict";
    n(21),
      n(27),
      n(9),
      n(34),
      n(41),
      n(17),
      n(18),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(10),
      a = n(4),
      s = n(0),
      l = n(3),
      c = n(20),
      u = n(43);
    function p(t) {
      return (p =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function f(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function h(t, e) {
      return (h =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function d(t, e) {
      return e && ("object" === p(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function g(t) {
      return (g = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var y = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && h(t, e);
      })(p, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = g(t);
            if (e()) {
              var r = g(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return d(this, n);
          };
        })(p);
      function p(t, e) {
        var n;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, p),
          ((n = o.call(this)).id = t),
          (n.$inputElement = e),
          (n.$element = null),
          (n.isOpen = !1),
          (n.keyboardNavIndex = -1),
          n
        );
      }
      return (
        (e = p),
        (n = [
          {
            key: "init",
            value: function () {
              (this.searchInput = this.parent),
                (this.searchResult = this.parent.instantSearchResult),
                (this.appendTo = this.searchResult.selector.wrapper),
                (this.minLength = Settings.getSettingValue(
                  "search.suggestionMinLength"
                )),
                (this.delay = Settings.getSettingValue(
                  "search.suggestionDelay"
                ));
              var t = Settings.getSettingValue("search.searchBoxOnclick"),
                e = u.a.getOnClickRecentSearches();
              this.enableOnClickSearchBox = !!(
                (t &&
                  t.recentSearch &&
                  t.recentSearch.status &&
                  e.length > 0) ||
                (t.searchTermSuggestion &&
                  t.searchTermSuggestion.status &&
                  t.searchTermSuggestion.data.length > 0) ||
                (t.productSuggestion &&
                  t.productSuggestion.status &&
                  t.productSuggestion.data.length > 0)
              );
            },
          },
          {
            key: "getTemplate",
            value: function () {
              return '\n			<div tabindex="0" class="boost-pfs-search-suggestion" style="display: none;"></div>\n		'.trim();
            },
          },
          {
            key: "render",
            value: function () {
              this.$element ||
                ((this.$element = r()(this.getTemplate())),
                (this.searchResult.$instantSearchResult = this.$element));
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvent;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                this.parent.instantSearchResult.$wrapper &&
                this.$inputElement &&
                ((this.currentTerm = s.a.stripHtml(this.$inputElement.val())),
                this.searchResult.$wrapper.append(this.$element),
                this.$inputElement.on(
                  "keydown",
                  this._onKeyboardEnter.bind(this)
                ),
                this.$inputElement.on(
                  "keyup",
                  this._onKeyboardNavigation.bind(this)
                ),
                this.$element.on(
                  "focus",
                  this.searchInput.onFocusAutocomplete.bind(this.searchInput)
                ),
                this.$element.on(
                  "click",
                  this.searchInput.onSelectAutocomplete.bind(this.searchInput)
                ),
                document.addEventListener(
                  "click",
                  this._onClose.bind(this),
                  !0
                ),
                this.$inputElement.on("click", this._onOpen.bind(this)),
                this.$inputElement.on(
                  "keyup",
                  s.a.debounce(this._onKeyUp.bind(this), this.delay)
                ));
            },
          },
          {
            key: "_onOpen",
            value: function (t) {
              this._isXSSSearchTerm(t) ||
                ((this.isOpen = !0),
                (this.keyboardNavIndex = -1),
                (this.$keyboardSelectedItem = null),
                (this.currentTerm = s.a.stripHtml(this.$inputElement.val())),
                this.$element.show(),
                this.searchInput.onOpenAutocomplete(),
                this._source());
            },
          },
          {
            key: "_onClose",
            value: function (t) {
              if (!this._isXSSSearchTerm(t)) {
                var e = !1;
                if (this.isOpen && t && t.target) {
                  var n = r()(t.target),
                    i = n.closest("." + a.a.searchSuggestionWrapper).length > 0,
                    o = n.closest("#" + this.$inputElement.id).length > 0,
                    s = n.closest(".boost-pfs-search-btn").length > 0;
                  i || o || s || (e = !0);
                } else t || (e = !0);
                e &&
                  (this.$element.hide(),
                  this.searchInput.onCloseAutocomplete(),
                  (this.isOpen = !1),
                  (this.keyboardNavIndex = -1),
                  (this.$keyboardSelectedItem = null));
              }
            },
          },
          {
            key: "_onKeyUp",
            value: function (t) {
              if (!this._isXSSSearchTerm(t)) {
                this.isOpen = !0;
                var e = s.a.stripHtml(this.$inputElement.val().trim());
                this.currentTerm != e &&
                  ((this.currentTerm = e),
                  (this.currentEvent = t),
                  this._source());
              }
            },
          },
          {
            key: "_onKeyboardNavigation",
            value: function (t) {
              var e = this;
              if (
                !this._isXSSSearchTerm(t) &&
                this.isOpen &&
                this.$element &&
                t &&
                t.key
              ) {
                var n = this.$element.find("." + a.a.searchSuggestionItem);
                if (!(n.length <= 0)) {
                  var i = this.$element.find("[data-group=view-all]"),
                    o = n.length + i.length,
                    c = !1;
                  if (t.key.includes("Down") || t.key.includes("Up")) {
                    if (
                      ((c = !0),
                      t.key.includes("Up")
                        ? (this.keyboardNavIndex--,
                          this.keyboardNavIndex < -1 &&
                            (this.keyboardNavIndex = o - 1))
                        : t.key.includes("Down") &&
                          (this.keyboardNavIndex++,
                          this.keyboardNavIndex > o - 1 &&
                            (this.keyboardNavIndex = -1)),
                      this.$inputElement.focus(),
                      -1 == this.keyboardNavIndex)
                    ) {
                      this.$keyboardSelectedItem = null;
                      var u = s.a.unescape(s.a.stripHtml(l.a.currentTerm));
                      this.$inputElement.val(u), n.removeClass("selected");
                    } else
                      this.keyboardNavIndex > n.length - 1
                        ? ((this.$keyboardSelectedItem = null),
                          (u = s.a.unescape(s.a.stripHtml(l.a.currentTerm))),
                          this.$inputElement.val(u),
                          n.removeClass("selected"),
                          i.addClass("selected"))
                        : n.each(function (t, n) {
                            var o = r()(n);
                            if ((console.log(n), t == e.keyboardNavIndex)) {
                              var a = s.a.unescape(
                                s.a.stripHtml(o.attr("data-title"))
                              );
                              e.$inputElement.val(a),
                                o.addClass("selected"),
                                i.removeClass("selected"),
                                (e.$keyboardSelectedItem = o);
                            } else o.removeClass("selected");
                          });
                  } else
                    (t.key.includes("Left") || t.key.includes("Right")) &&
                      -1 != this.keyboardNavIndex &&
                      (c = !0);
                  c &&
                    (t.stopImmediatePropagation(),
                    t.stopPropagation(),
                    t.preventDefault());
                }
              }
            },
          },
          {
            key: "_onKeyboardEnter",
            value: function (t) {
              if (
                !this._isXSSSearchTerm() &&
                this.isOpen &&
                this.$element &&
                t &&
                t.key
              ) {
                var e = !1;
                if ("Enter" == t.key || "Space" == t.key) {
                  if (
                    -1 != this.keyboardNavIndex &&
                    this.$keyboardSelectedItem
                  ) {
                    var n = this.$keyboardSelectedItem.find("a").attr("href");
                    n &&
                      !s.a.isBadUrl(n) &&
                      ((e = !0), (window.location.href = n));
                  }
                } else
                  "Tab" == t.key
                    ? document.activeElement &&
                      (document.activeElement.id != this.searchInput.id
                        ? this._onClose()
                        : this._onOpen())
                    : "Escape" == t.key && this._onClose();
                e &&
                  (t.stopImmediatePropagation(),
                  t.stopPropagation(),
                  t.preventDefault());
              }
            },
          },
          {
            key: "_source",
            value: function () {
              if (!this._isXSSSearchTerm()) {
                if (
                  (this.$element.html(""),
                  (this.keyboardNavIndex = -1),
                  (this.$keyboardSelectedItem = null),
                  this.currentTerm.length > 0)
                ) {
                  var t = { term: this.currentTerm },
                    e = this._response.bind(this);
                  this.searchInput._bindAutoCompleteSource(t, e);
                } else
                  this.enableOnClickSearchBox
                    ? this.showOnClickSuggestion()
                    : (this.searchResult.$wrapper.hide(),
                      this.searchInput.$element.attr("aria-expanded", !1));
              }
            },
          },
          {
            key: "_response",
            value: function (t) {
              if (!this._isXSSSearchTerm()) {
                var e = s.a.stripHtml(this.$inputElement.val()),
                  n = s.a.getValueInObjectArray(c.a.ResultType.EVENT_TYPE, t),
                  i = s.a.getValueInObjectArray(c.a.ResultType.QUERY, t);
                if ("suggest_dym" == n || ("" != e && "" != i)) {
                  this.$element.html(""),
                    (this.keyboardNavIndex = -1),
                    (this.$keyboardSelectedItem = null),
                    this.searchInput._bindAutoCompleteRenderMenu(
                      this.$element[0],
                      t
                    );
                  var r = { content: t };
                  this.searchInput._bindAutoCompleteResponse(
                    this.currentEvent,
                    r
                  ),
                    0 ==
                    this.searchResult.$wrapper.find(
                      '[data-group]:not([data-group="view-all"]'
                    ).length
                      ? (this.searchResult.$wrapper.hide(),
                        this.searchInput.$element.attr("aria-expanded", !1))
                      : (this.searchResult.$wrapper.show(),
                        this.searchInput.$element.attr("aria-expanded", !0));
                }
              }
            },
          },
          {
            key: "showOnClickSuggestion",
            value: function () {
              if (!this._isXSSSearchTerm()) {
                this.$element.html(""),
                  (this.keyboardNavIndex = -1),
                  (this.$keyboardSelectedItem = null);
                var t = u.a.getOnClickData();
                this.searchResult.setData(this.$element, t, !1),
                  this.searchResult.refresh(),
                  this.searchResult.$wrapper.show(),
                  this.searchInput.$element.attr("aria-expanded", !0),
                  0 ==
                    this.$element.find("." + a.a.searchSuggestionItem).length &&
                    (this.searchResult.$wrapper.hide(),
                    this.searchInput.$element.attr("aria-expanded", !1));
              }
            },
          },
          {
            key: "_isXSSSearchTerm",
            value: function (t) {
              var e = s.a.stripHtml(this.$inputElement.val());
              return (
                !!s.a.isBadSearchTerm(e) &&
                ((this.isOpen = !1),
                this.$element.html(""),
                this.$element.hide(),
                this.searchResult.$wrapper.hide(),
                t &&
                  "function" == typeof t.stopPropagation &&
                  (t.stopImmediatePropagation(),
                  t.stopPropagation(),
                  t.preventDefault()),
                !0)
              );
            },
          },
        ]),
        f(e.prototype, n),
        i && f(e, i),
        p
      );
    })(o.a);
    e.a = y;
  },
  189: function (t, e, n) {
    var i = n(62).default;
    (window.BoostPFSFilterCallback = n(8).default.BoostPFSFilterCallback),
      (window.BoostPFSInstantSearchCallback =
        n(84).default.BoostPFSInstantSearchCallback),
      (t.exports = i);
  },
  2: function (t, e, n) {
    "use strict";
    n(47), n(30), n(22), n(38);
    var i = n(0),
      r = {
        general: {
          enableFilter: !0,
          filterTreeEnableRenderPartially: !0,
          filterTreeNumberResultEnable: !0,
          filterTreeIcon:
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z" fill="#222222"/><mask id="mask0_8095:39389" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z" fill="white"/></mask><g mask="url(#mask0_8095:39389)"></g></svg>',
          filterTreeIconClose:
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.13062 8.00003L12.565 4.56563C12.8778 4.25283 12.8778 3.74723 12.565 3.43443C12.2522 3.12163 11.7466 3.12163 11.4338 3.43443L7.99942 6.86883L4.56502 3.43443C4.25222 3.12163 3.74662 3.12163 3.43382 3.43443C3.12102 3.74723 3.12102 4.25283 3.43382 4.56563L6.86822 8.00003L3.43382 11.4344C3.12102 11.7472 3.12102 12.2528 3.43382 12.5656C3.58982 12.7216 3.79462 12.8 3.99942 12.8C4.20422 12.8 4.40902 12.7216 4.56502 12.5656L7.99942 9.13123L11.4338 12.5656C11.5898 12.7216 11.7946 12.8 11.9994 12.8C12.2042 12.8 12.409 12.7216 12.565 12.5656C12.8778 12.2528 12.8778 11.7472 12.565 11.4344L9.13062 8.00003Z" fill="#222222"/><mask id="mask0_33:1711" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="10" height="10"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.13062 8.00003L12.565 4.56563C12.8778 4.25283 12.8778 3.74723 12.565 3.43443C12.2522 3.12163 11.7466 3.12163 11.4338 3.43443L7.99942 6.86883L4.56502 3.43443C4.25222 3.12163 3.74662 3.12163 3.43382 3.43443C3.12102 3.74723 3.12102 4.25283 3.43382 4.56563L6.86822 8.00003L3.43382 11.4344C3.12102 11.7472 3.12102 12.2528 3.43382 12.5656C3.58982 12.7216 3.79462 12.8 3.99942 12.8C4.20422 12.8 4.40902 12.7216 4.56502 12.5656L7.99942 9.13123L11.4338 12.5656C11.5898 12.7216 11.7946 12.8 11.9994 12.8C12.2042 12.8 12.409 12.7216 12.565 12.5656C12.8778 12.2528 12.8778 11.7472 12.565 11.4344L9.13062 8.00003Z" fill="white"/></mask><g mask="url(#mask0_33:1711)"></g></svg>',
          filterTreeMobileStyle: "style2",
          filterTreeMobileStyleFullWidth: !1,
          filterTreeMobileIcon: "",
          filterTreeHorizontalStyle: "style1",
          filterHorizontalColumn: "1",
          filterHorizontalOptionsAlign: "left",
          filterTreeVerticalStyle: "style-default",
          stickyFilterOnDesktop: !1,
          stickyFilterOnMobile: !1,
          stickyProductHeightLimitParam: 300,
          showRefineBy: !0,
          separateRefineByFromFilter: !1,
          refineByHorizontalPosition: "bottom",
          changeMobileButtonLabel: !1,
          breakpointMobile: "1024",
          breakpointTablet: "1199",
          changeDesktopButtonLabel: !1,
          changeDesktopButtonIcon: !0,
          showLoading: !1,
          showMobileLoading: !1,
          showLoadMoreLoading: !0,
          positionShowInfiniteLoading: 700,
          activeScrollToTop: !1,
          styleScrollToTop: "style1",
          showSingleOption: !0,
          showOutOfStockOption: !1,
          showFilterOptionCount: !0,
          requestInstantly: !1,
          capitalizeFilterOptionValues: !0,
          forceCapitalizeFilterOptionValues: !1,
          capitalizeFirstLetterFilterOptionValues: !1,
          collapseOnPCByDefault: !1,
          collapseOnMobileByDefault: !1,
          keepScrollState: !0,
          keepToggleState: !0,
          keepTabOpenState: !1,
          activeFilterScrollbarPC: !0,
          activeFilterScrollbarMobile: !0,
          scrollFirstLoadLength: 24,
          startViewMore: { list: 5, box: 3, swatch: 10 },
          startViewMoreH: { list: 10, box: 20, swatch: 10 },
          removePriceDecimal: !0,
          rangeSliderMoneyFormat: "",
          oneValueRangeSlider: !1,
          rangeSlidersStyle3: [],
          rangeSlidersSingleHandle: [],
          advancedRangeSliders: [],
          shortenPipsRange: !1,
          formatPipsRange: [
            { node: 1e3, symbol: "K", fix: 0, suffix: !1 },
            { node: 1e6, symbol: "M", fix: 2, suffix: !1 },
          ],
          enable3rdCurrencySupport: !1,
          imageExtension: [
            "jpg",
            "JPG",
            "png",
            "PNG",
            "jpeg",
            "JPEG",
            "gif",
            "GIF",
            "webp",
            "WEBP",
          ],
          swatchStyle: "",
          swatchImageVersion: "1111111",
          removePrefixFromSwatchFile: !0,
          enableFilterOptionBoxStyle: !0,
          filterOptionBoxCharWidth: 14,
          openMultiLevelByDefault: [],
          multiLevelCollectionSelectType: "single",
          filterPrefixParam: "pf_",
          limit: 16,
          vendorParam: "pf_v_vendor",
          typeParam: "pf_pt_product_type",
          priceMode: "",
          tagMode: "",
          location: "",
          urlScheme: 1,
          isShortenUrlParam: !1,
          shortenUrlParamList: [],
          productAvailable: !1,
          variantAvailable: !1,
          availableAfterFiltering: !1,
          loadProductFirst: !0,
          loadProductFirstBestSelling: !1,
          addCollectionToProductUrl: !0,
          showVariantImageBasedOnSelectedFilter: "",
          paginationType: "default",
          paginationTypeAdvanced: !0,
          activeLoadPreviousPage: !0,
          loadPreviousType: "load_more",
          sessionStorageCurrentPreviousPage: "boostPFSCurrentPreviousPage",
          sessionStorageCurrentPage: "boostPFSCurrentPage",
          sessionStorageCurrentNextPage: "boostPFSCurrentNextPage",
          sessionStoragePreviousPageEvent: "boostPFSPreviousPageEvent",
          enableKeepScrollbackPosition: !0,
          keepScrollbackPositionType: "sessionStorage",
          sessionStorageScrollbackPosition: "boostPFSScrollbackPostion",
          sortingList: [
            "relevance",
            "best-selling",
            "manual",
            "price-ascending",
            "price-descending",
            "title-ascending",
            "title-descending",
            "created-descending",
            "created-ascending",
          ],
          customSortingList: "",
          extraSortingList: "",
          sortingAvailableFirst: !1,
          showLimitList: "4,8,12,16",
          defaultDisplay: "grid",
          collageNumber: 3,
          enableCollectionSearch: !0,
          showVariantsAsProduct: !1,
          enableVariantsDisplay: !1,
          showPlaceholderProductList: !1,
          placeholderImageRatio: 1.4,
          placeholderProductGridItemClass: "",
          placeholderProductPerRow: 3,
          loadProductFromLiquid: !1,
          loadProductFromLiquidType: "ajax",
          otpProductItemClass: "",
          enableAjaxCart: !0,
          enableAjaxCartOnProductPage: !1,
          ajaxCartStyle: "slide",
          showAjaxCartOnAdd: !0,
          autoCloseMiniCart: !1,
          autoCloseMiniCartDuration: 2e3,
          selectOptionInProductItem: !1,
          selectOptionContainer: "",
          icoQuickView:
            '<svg width="40" height="40" viewBox="0 0 40 40"><g id="boost-pfs-icon-quick-view" transform="scale(0.03125 0.03125)"><path d="M1009.004 493.256c-2.256-2.82-56.254-69.828-143.786-137.492-51.696-39.962-104.462-71.87-156.832-94.834-66.48-29.152-132.556-43.932-196.386-43.932-63.832 0-129.904 14.782-196.386 43.932-52.37 22.962-105.136 54.87-156.834 94.834-87.53 67.666-141.528 134.674-143.784 137.494l-14.996 18.742 14.998 18.744c2.256 2.82 56.252 69.828 143.784 137.492 51.696 39.962 104.462 71.87 156.834 94.834 66.48 29.152 132.554 43.932 196.386 43.932 63.83 0 129.904-14.782 196.386-43.932 52.37-22.962 105.136-54.87 156.832-94.834 87.53-67.666 141.53-134.674 143.786-137.492l14.994-18.744-14.996-18.744zM827.402 621.624c-74.24 57.196-189.226 125.374-315.402 125.374-126.18 0-241.162-68.178-315.402-125.374-55.36-42.65-97.042-85.794-118.512-109.612 52.994-58.698 229.246-235.006 433.916-235.006 126.178 0 241.162 68.178 315.402 125.374 55.366 42.654 97.050 85.8 118.522 109.622-21.474 23.82-63.158 66.968-118.524 109.622z"></path><path d="M512 309.976c-111.396 0-202.024 90.63-202.024 202.024s90.63 202.024 202.024 202.024 202.026-90.628 202.026-202.024-90.63-202.024-202.026-202.024zM512 654.018c-78.308 0-142.018-63.71-142.018-142.018s63.71-142.018 142.018-142.018 142.018 63.71 142.018 142.018c0 78.308-63.71 142.018-142.018 142.018z"></path><path d="M512 419.322c-51.102 0-92.678 41.576-92.678 92.678s41.576 92.68 92.678 92.68 92.678-41.576 92.678-92.68c0-51.104-41.574-92.678-92.678-92.678zM512 544.672c-18.014 0-32.67-14.656-32.67-32.672s14.656-32.67 32.67-32.67 32.67 14.656 32.67 32.67c0.002 18.014-14.654 32.672-32.67 32.672z"></path></g></svg>',
          icoQuickViewLink:
            '<svg width="40" height="40" viewBox="0 0 40 40"><use xlink:href="#boost-pfs-icon-quick-view"></use></svg>',
          icoCart:
            '<svg width="40" height="40" viewBox="0 0 40 40"><g id="boost-pfs-icon-cart" transform="scale(0.03125 0.03125)"><path d="M448.217 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256s102.256-45.879 102.256-102.256c0-56.379-45.857-102.256-102.256-102.256zM448.217 977.908c-31.312 0-56.807-25.472-56.807-56.807 0-31.312 25.495-56.807 56.807-56.807s56.807 25.495 56.807 56.807c0.003 31.335-25.472 56.807-56.807 56.807z"></path><path d="M768.66 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256 56.354 0 102.256-45.879 102.256-102.256 0-56.379-45.902-102.256-102.256-102.256zM768.66 977.908c-31.335 0-56.807-25.472-56.807-56.807 0-31.312 25.472-56.807 56.807-56.807 31.29 0 56.807 25.495 56.807 56.807 0.003 31.335-25.517 56.807-56.807 56.807z"></path><path d="M1019.164 259.373c-4.294-5.499-10.886-8.702-17.883-8.702h-768.3l-63.329-233.255c-0.137-0.5-0.5-0.886-0.682-1.364-0.5-1.476-1.25-2.773-2.046-4.090-0.749-1.25-1.431-2.477-2.385-3.545-0.931-1.068-2.021-1.865-3.159-2.726-1.182-0.909-2.317-1.795-3.659-2.454-1.25-0.637-2.591-0.953-3.975-1.364-1.476-0.431-2.907-0.794-4.476-0.909-0.545-0.022-1.001-0.319-1.568-0.319h-124.978c-12.543 0-22.724 10.181-22.724 22.724s10.181 22.724 22.724 22.724h107.595l63.239 232.959 113.572 460.078c2.499 10.156 11.612 17.293 22.065 17.293h558.448c10.452 0 19.543-7.112 22.065-17.293l113.617-460.282c1.7-6.796 0.154-13.955-4.162-19.476zM869.871 710.976h-522.865l-102.39-414.858h727.667l-102.413 414.858z"></path></g></svg>',
          icoCartLink:
            '<svg width="40" height="40" viewBox="0 0 40 40"><use xlink:href="#boost-pfs-icon-cart"></use></svg>',
          enableTrackingOrderRevenue: !0,
          filterEverywhereCollectionId: 0,
          filterEverywhereDefaultSorting: "best-selling",
          filterEverywhereUrlScheme: 0,
          enableSeo: !0,
          boostCollection: "boost-all",
          moneyFormatWithCurrency: !1,
          useShopifyRouteForMultiLanguageURL: !0,
          enableBackToOriginal: !0,
        },
        search: {
          enableSearch: !0,
          enableSuggestion: !0,
          suggestionBlocks: [
            {
              type: "suggestions",
              label: "Suggestions",
              status: "active",
              number: 3,
            },
            {
              type: "collections",
              label: "Collections",
              status: "active",
              number: 2,
            },
            { type: "pages", label: "Pages", status: "active", number: 2 },
            {
              type: "products",
              label: "Products",
              status: "active",
              number: 6,
            },
          ],
          suggesionMaxItems: 10,
          suggestionDymLimit: 2,
          suggestionMinLength: 1,
          suggestionPosition: "",
          suggestionDelay: 50,
          suggestionWidth: "auto",
          suggestionTypes: [],
          suggestionStyle: "style2",
          suggestionColumn: "1",
          suggestionProductPosition: "none",
          suggestionProductItemPerRow: "1",
          suggestionProductItemType: "list",
          suggestionMaxHeight: "",
          suggestionMaxWidth: "",
          suggestionStyle2MainContainerSelector: "body",
          suggestionStyle1ProductItemType: "list",
          suggestionStyle1ProductPosition: "none",
          suggestionStyle1ProductPerRow: "1",
          suggestionStyle2ProductItemType: "list",
          suggestionStyle2ProductPosition: "right",
          suggestionStyle2ProductPerRow: 2,
          suggestionStyle3ProductItemType: "list",
          suggestionStyle3ProductPosition: "right",
          suggestionStyle3ProductPerRow: 3,
          suggestionMobileStyle: "style1",
          showSuggestionLoading: !0,
          showSuggestionProductVendor: !0,
          showSuggestionProductPrice: !0,
          showSuggestionProductSalePrice: !0,
          showSuggestionProductImage: !0,
          showSuggestionProductSku: !1,
          showSearchBtnMobile: !1,
          showSearchBtnStyle3: !0,
          enableDefaultResult: !0,
          enableFuzzy: !0,
          productAvailable: !1,
          removePriceDecimal: !1,
          highlightSuggestionResult: !0,
          openProductNewTab: !1,
          suggestionMode: "prod",
          termKey: "q",
          skipFields: [],
          reduceMinMatch: !1,
          fullMinMatch: !1,
          enablePlusCharacterSearch: !1,
          collectionDescLimitCharacter: 264,
          pageExcerptLimitCharacter: 264,
          fontSizeSuggestionHeader: "",
          bgSuggestionHeader: "",
          colorSuggestionHeader: "",
          enableFixHeadTitle: !0,
          searchPanelList: ["products", "collections", "pages"],
          searchPanelDefault: "products",
          searchPanelBlocks: {
            products: { label: "Products", pageSize: 25, active: !0 },
            collections: { label: "Collections", pageSize: 25, active: !1 },
            pages: { label: "Pages", pageSize: 25, active: !1 },
          },
          suggestionNoResult: {
            search_terms: {
              label: '"Popular suggestions',
              status: !0,
              data: [],
            },
            products: { label: "Products", status: !0, data: [] },
          },
          searchBoxOnclick: {
            recentSearch: { label: "Recent searches", status: !1, number: 3 },
            searchTermSuggestion: {
              label: "Popular searches",
              status: !1,
              data: [],
            },
            productSuggestion: {
              label: "Trending products",
              status: !1,
              data: [],
            },
          },
          iconViewAll:
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.1657 7.43443L10.1657 3.43443C9.8529 3.12163 9.3473 3.12163 9.0345 3.43443C8.7217 3.74723 8.7217 4.25283 9.0345 4.56563L11.6689 7.20003H2.4001C1.9577 7.20003 1.6001 7.55843 1.6001 8.00003C1.6001 8.44163 1.9577 8.80003 2.4001 8.80003H11.6689L9.0345 11.4344C8.7217 11.7472 8.7217 12.2528 9.0345 12.5656C9.1905 12.7216 9.3953 12.8 9.6001 12.8C9.8049 12.8 10.0097 12.7216 10.1657 12.5656L14.1657 8.56563C14.4785 8.25283 14.4785 7.74723 14.1657 7.43443" fill="#5C5F62"/></svg>',
        },
        init: function () {
          var t = r;
          if (
            ("undefined" != typeof boostPFSConfig &&
              boostPFSConfig.hasOwnProperty("settings") &&
              null !== boostPFSConfig.settings &&
              (t = i.a.mergeObject(t, boostPFSConfig.settings)),
            "undefined" != typeof boostPFSAppConfig &&
              Object.keys(boostPFSAppConfig).length > 0 &&
              (t = i.a.mergeObject(t, boostPFSAppConfig)),
            "undefined" != typeof boostPFSThemeConfig &&
              Object.keys(boostPFSThemeConfig).length > 0 &&
              (t = i.a.mergeObject(t, boostPFSThemeConfig)),
            "undefined" != typeof boostPFSFilterConfig &&
              Object.keys(boostPFSFilterConfig).length > 0 &&
              (t = i.a.mergeObject(t, boostPFSFilterConfig)),
            "undefined" != typeof boostPFSInstantSearchConfig &&
              Object.keys(boostPFSInstantSearchConfig).length > 0 &&
              (t = i.a.mergeObject(t, boostPFSInstantSearchConfig)),
            "undefined" != typeof Shopify &&
              Shopify.hasOwnProperty("locale") &&
              t.hasOwnProperty("label") &&
              t.hasOwnProperty("labelTranslations") &&
              void 0 !== t.labelTranslations &&
              t.labelTranslations.hasOwnProperty(Shopify.locale))
          ) {
            var e = t.labelTranslations[Shopify.locale];
            t.label = i.a.mergeObject(t.label || {}, e);
          }
          r = t;
        },
        getSettingValue: function (t) {
          var e = "";
          if (r.hasOwnProperty(t)) return r[t];
          if (t.indexOf(".") > -1)
            for (var n = t.split("."), i = 0; i < n.length; i++)
              if ("" == e) {
                if (!r.hasOwnProperty(n[i])) return "";
                e = r[n[i]];
              } else {
                if (!e.hasOwnProperty(n[i])) return "";
                e = e[n[i]];
              }
          return e;
        },
      };
    e.a = r;
  },
  20: function (t, e, n) {
    "use strict";
    e.a = {
      ResultType: {
        ALL_EMPTY: "all_empty",
        TOTAL_PRODUCT: "total_product",
        SUGGESTIONS: "suggestions",
        COLLECTIONS: "collections",
        PRODUCTS: "products",
        PAGES: "pages",
        DID_YOU_MEAN: "did_you_mean",
        REDIRECT: "redirect",
        SUGGESTIONS_REDIRECT: "suggestions_redirect",
        QUERY: "query",
        PREV_QUERY: "prev_query",
        SUGGEST_QUERY: "suggest_query",
        EVENT_TYPE: "event_type",
        PREV_TOTAL_PRODUCT: "prev_total_product",
        SUGGEST_TOTAL_PRODUCT: "suggest_total_product",
        LOCAL_CACHE: "local_cache",
        RECENT_SEARCHES: "recent_searches",
        DEFAULT_SUGGESTIONS: "default_suggestions",
        DEFAULT_PRODUCTS: "default_products",
        NO_RESULT_PRODUCTS: "no_result_products",
        NO_RESULT_SUGGESTIONS: "no_result_suggestions",
      },
      Mobile: { SuggestionType: { FULL_SCREEN: "style1", STYLE_2: "style2" } },
    };
  },
  3: function (t, e, n) {
    "use strict";
    n(99), n(21);
    var i = n(2),
      r = n(0),
      o = {
        prefix: "pf",
        queryParams: {},
        instantSearchQueryParams: {},
        internalClick: !1,
        imutableFilterTree: ["page", "sort", "limit", "display", "_", "tab"],
        otherParams: ["page", "sort", "limit", "display", "tab"],
        hasFilterOptionParam: !1,
        hasFilterByLocation: !1,
        scrollData: [],
        shopName: "",
        shopDomain: "",
        fileUrl: "",
        defaultCurrency: "",
        moneyFormat: "",
        moneyFormatWithCurrency: "",
        collectionId: "",
        collectionTags: "",
        currentTags: "",
        defaultSorting: "",
        swatchExtension: "",
        productAvailable: !0,
        variantAvailable: !0,
        loadProductFirst: !1,
        searchTermKey: "q",
        suggestionCache: {},
        currentTerm: "",
        inventoryBaseSelectedLocations: !1,
        hasIntegration: !1,
        init: function () {
          var t = boostPFSConfig.shop,
            e = boostPFSConfig.general;
          (o.shopName = t.name),
            (o.shopDomain = t.domain),
            (o.defaultCurrency = t.currency),
            (o.moneyFormat = t.money_format),
            (o.moneyFormatWithCurrency = t.money_format_with_currency),
            (o.fileUrl = e.file_url),
            (o.collectionId =
              r.a.isCollectionPage() || r.a.isSearchPage()
                ? e.collection_id
                : null),
            (o.collectionTags = e.collection_tags),
            (o.collectionCount = e.collection_count),
            (o.currentTags = e.current_tags),
            (o.defaultSorting = e.default_sort_by.trim()),
            (o.swatchExtension = e.swatch_extension),
            (o.productAvailable = i.a.getSettingValue(
              "general.productAvailable"
            )),
            (o.variantAvailable = i.a.getSettingValue(
              "general.variantAvailable"
            )),
            i.a.getSettingValue("general.productAndVariantAvailable") &&
              ((o.productAvailable = !0), (o.variantAvailable = !0)),
            (o.loadProductFirst = i.a.getSettingValue(
              "general.loadProductFirst"
            )),
            (o.searchTermKey = i.a.getSettingValue("search.termKey")),
            (o.mobileStyle = i.a.getSettingValue(
              "general.filterTreeMobileStyle"
            )),
            (o.suggestionTypes = i.a.getSettingValue("search.suggestionTypes"));
        },
      };
    e.a = o;
  },
  36: function (t, e, n) {
    "use strict";
    n(11),
      n(58),
      n(9),
      n(13),
      n(12),
      n(40),
      n(34),
      n(41),
      n(22),
      n(38),
      n(24),
      n(25),
      n(115),
      n(81),
      n(54),
      n(67),
      n(47),
      n(45),
      n(82),
      n(48),
      n(23);
    var i = n(1),
      r = n.n(i),
      o = n(0),
      a = n(3),
      s = n(2),
      l = n(8),
      c = n(62),
      u = {},
      p = {},
      f = window.location.pathname,
      h = document.title,
      d = "",
      g = new Map(),
      y = new Map(),
      m = {
        init: function () {
          (d = o.a.getWindowLocation().href),
            (p = {
              page: 1,
              limit: s.a.getSettingValue("general.limit"),
              sort: o.a.isSearchPage() ? "relevance" : a.a.defaultSorting,
              display: s.a.getSettingValue("general.defaultDisplay"),
              tab: s.a.getSettingValue("general.searchPanelDefault"),
            }),
            window.addEventListener("popstate", m.onPopState),
            m.initShortenUrl();
        },
        initShortenUrl: function () {
          var t = s.a.getSettingValue("general.shortenUrlParamList");
          s.a.getSettingValue("general.isShortenUrlParam") &&
            Array.isArray(t) &&
            t.forEach(function (t) {
              if ("string" == typeof t) {
                var e = t.match(/[^:]:[^:]/).index;
                if (e) {
                  var n = t.slice(0, e + 1),
                    i = t.slice(e + 2);
                  n && i && (g.set(n, i), y.set(i, n));
                }
              }
            });
        },
        updateAddressBar: function () {
          if (
            0 !=
              (o.a.isCollectionPage() || o.a.isSearchPage()
                ? s.a.getSettingValue("general.urlScheme")
                : s.a.getSettingValue("general.filterEverywhereUrlScheme")) &&
            window.history &&
            "function" == typeof window.history.pushState
          ) {
            var t = m.buildAddressBarUrl(),
              e = JSON.parse(JSON.stringify(a.a.queryParams));
            (a.a.queryParams = e),
              history.pushState({ param: a.a.queryParams }, h, t),
              (d = t);
            var n = new Event("boost-pfs-change-address-bar");
            window.dispatchEvent(n);
          }
        },
        buildAddressBarUrl: function (t) {
          var e = t || a.a.queryParams,
            n = window.location.protocol + "//" + window.location.hostname + f,
            i = o.a.getWindowLocation().search,
            r = new URLSearchParams(i),
            l = !1,
            c =
              o.a.isCollectionPage() || o.a.isSearchPage()
                ? s.a.getSettingValue("general.urlScheme")
                : s.a.getSettingValue("general.filterEverywhereUrlScheme");
          Object.keys(e).forEach(function (t) {
            var n = e[t];
            if (t.startsWith(a.a.prefix)) {
              var i = g.get(t);
              if ((i || (i = t), r.delete(i), Array.isArray(n))) {
                switch (c) {
                  case 0:
                    break;
                  case 2:
                    r.set(i, n);
                    break;
                  default:
                    n.forEach(function (t) {
                      r.append(i, t);
                    });
                }
                l = !0;
              } else null != n && (r.set(i, n), (l = !0));
            } else t == a.a.searchTermKey && "string" == typeof n ? (o.a.isCollectionPage() && "" === n ? r.delete(t) : r.set(t, n)) : a.a.otherParams.includes(t) && (n == p[t] || ("sort" == t && n == a.a.defaultSorting) ? r.delete(t) : r.set(t, n));
          });
          var u = [];
          r.forEach(function (t, n) {
            var i = y.get(n);
            i || (i = n),
              (i.startsWith(a.a.prefix) ||
                a.a.imutableFilterTree.includes(i) ||
                i == a.a.searchTermKey) &&
                (e.hasOwnProperty(i) || u.push(n));
          }),
            u.forEach(function (t) {
              r.delete(t);
            }),
            (a.a.hasFilterOptionParam = l),
            r.sort();
          var h = n,
            d = r.toString();
          return (
            d && (2 == c && (d = d.replace(/%2C/g, ",")), (h += "?" + d)), h
          );
        },
        setAddressBarPathAfterFilter: function (t) {
          (f =
            "string" == typeof t && t.startsWith("/")
              ? t
              : window.location.pathname),
            (f = o.a.reBuildUrlBaseOnLocale(f));
        },
        setWindowTitleAfterFilter: function (t) {
          h =
            "string" != typeof t ||
            "" == t ||
            t.includes("undefined") ||
            t.includes("null")
              ? document.title
              : t;
        },
        getHistoryState: function () {
          return u;
        },
        onPopState: function (t) {
          u = t.state;
          var e = c.default.instance.filter,
            n = o.a.getWindowLocation().href,
            i = (n.includes("#") || d.includes("#")) && n.split("#")[0] == d;
          e &&
            !i &&
            (o.a.isSearchPage() &&
              r()("." + Class.searchResultPanelItem).length > 0 &&
              r()("." + Class.searchResultPanelItem)
                .first()
                .trigger("click"),
            e.filterLoadingIcon.setShow(!0),
            l.default.updateParamsFromUrl(),
            s.a.getSettingValue("general.enableKeepScrollbackPosition") ||
              l.default.getFilterData("history", e.setData.bind(e)));
        },
        shortParamsMap: g,
        longParamMap: y,
      };
    e.a = m;
  },
  39: function (t, e, n) {
    "use strict";
    n(47), n(21);
    var i = n(0),
      r = {
        getApiUrl: function (t) {
          var e = boostPFSConfig.api.filterUrl;
          switch (t) {
            case "search":
              e = boostPFSConfig.api.searchUrl;
              break;
            case "suggestion":
              e = boostPFSConfig.api.suggestionUrl;
              break;
            case "analytics":
              e = boostPFSConfig.api.analyticsUrl;
              break;
            case "filter":
              e = boostPFSConfig.api.filterUrl;
              break;
            case "products":
              e = boostPFSConfig.api.productsUrl;
          }
          return e;
        },
        setApiLocaleParams: function (t) {
          return (
            Settings.general.hasOwnProperty("published_locales") &&
              Object.keys(Settings.general.published_locales).length >= 1 &&
              void 0 !== Settings.general.current_locale &&
              (t.locale = Settings.getSettingValue("general.current_locale")),
            t
          );
        },
        setShopifyMultiCurrencyParams: function (t) {
          return (
            i.a.isEnableShopifyMultipleCurrencies() &&
              (i.a.isConvertCurrenciesOnFrontEnd() ||
                (boostPFSConfig &&
                  boostPFSConfig.general &&
                  "string" == typeof boostPFSConfig.general.current_currency &&
                  (t.currency = boostPFSConfig.general.current_currency
                    .toLowerCase()
                    .trim()),
                Shopify &&
                  Shopify.country &&
                  "string" == typeof Shopify.country &&
                  (t.country = Shopify.country.toLowerCase().trim()))),
            t
          );
        },
      };
    e.a = r;
  },
  4: function (t, e, n) {
    "use strict";
    e.a = {
      filterTree: "boost-pfs-filter-tree",
      filterTreeVertical: "boost-pfs-filter-tree-v",
      filterTreeHorizontal: "boost-pfs-filter-tree-h",
      filterTreeOpenBody: "boost-pfs-filter-tree-open-body",
      filterTreeMobileButton: "boost-pfs-filter-tree-mobile-button",
      filterTreeMobileOpen: "boost-pfs-filter-tree-mobile-open",
      filterTreeDesktopButton: "boost-pfs-filter-tree-desktop-button",
      filterTreeDesktopOpen: "boost-pfs-filter-tree-desktop-open",
      filterOptionsWrapper: "boost-pfs-filter-options-wrapper",
      filterOption: "boost-pfs-filter-option",
      filterOptionTitle: "boost-pfs-filter-option-title",
      filterOptionContent: "boost-pfs-filter-option-content",
      filterOptionContentInner: "boost-pfs-filter-option-content-inner",
      filterOptionItem: "boost-pfs-filter-option-item",
      filterOptionLabel: "boost-pfs-filter-option-label",
      filterOptionRange: "boost-pfs-filter-option-range",
      filterRefineByWrapper: "boost-pfs-filter-refine-by-wrapper",
      filterRefineBy: "boost-pfs-filter-refine-by",
      filterSelectedItems: "boost-pfs-filter-refine-by-items",
      filterSelectedItemsMobile: "boost-pfs-filter-refine-by-items-mobile",
      filterOptionHidden: "boost-pfs-filter-option-hidden",
      filterOptionOpenList: "boost-pfs-filter-option-open-list",
      filterOptionCloseList: "boost-pfs-filter-option-close-list",
      filterOptionItemList: "boost-pfs-filter-option-item-list",
      filterOptionItemListSingleList:
        "boost-pfs-filter-option-item-list-single-list",
      filterOptionItemListMultipleList:
        "boost-pfs-filter-option-item-list-multiple-list",
      filterOptionItemListBox: "boost-pfs-filter-option-item-list-box",
      filterOptionItemListSwatch: "boost-pfs-filter-option-item-list-swatch",
      filterOptionItemListRating: "boost-pfs-filter-option-item-list-rating",
      filterOptionItemListMultiLevelTag:
        "boost-pfs-filter-option-item-list-multi-level-tag",
      filterOptiontemListMultiLevelCollections:
        "boost-pfs-filter-option-item-list-multi-level-collections",
      filterOptionItemStar: "boost-pfs-filter-icon-star",
      filterOptionItemStarActive: "boost-pfs-filter-icon-star-active",
      filterHasViewMore: "boost-pfs-filter-has-view-more",
      filterOptionViewMore: "boost-pfs-filter-option-view-more-action",
      filterOptionViewLess: "boost-pfs-filter-option-view-less-action",
      filterOptionViewMoreList: "boost-pfs-filter-view-more-list-action",
      filterHasSearchBox: "boost-pfs-filter-has-searchbox",
      filterOptionShowSearchBox: "boost-pfs-filter-option-show-search-box",
      filterHasScrollbar: "boost-pfs-filter-has-scrollbar",
      filterNoScrollbar: "boost-pfs-filter-no-scrollbar",
      button: "boost-pfs-filter-button",
      clearButton: "boost-pfs-filter-clear",
      clearAllButton: "boost-pfs-filter-clear-all",
      applyButton: "boost-pfs-filter-apply-button",
      applyAllButton: "boost-pfs-filter-apply-all-button",
      closeFilterButton: "boost-pfs-filter-close",
      showResultFilterButton: "boost-pfs-filter-show-result",
      numberResult: "boost-pfs-filter-number-result",
      collectionHeader: "boost-pfs-filter-collection-header",
      collectionDescription: "boost-pfs-filter-collection-description",
      collectionImage: "boost-pfs-filter-collection-image",
      collectionHasImage: "boost-pfs-filter-collection-has-image",
      collectionNoImage: "boost-pfs-filter-collection-no-image",
      filterOptionTooltip: "boost-pfs-filter-option-tooltip",
      searchBox: "boost-pfs-search-box",
      searchResultHeader: "boost-pfs-search-result-header",
      searchResultNumber: "boost-pfs-search-result-number",
      searchResultPanels: "boost-pfs-search-result-panel-controls",
      searchResultPanelItem: "boost-pfs-search-result-panel-item",
      searchSuggestion: "boost-pfs-search-suggestion",
      searchSuggestionWrapper: "boost-pfs-search-suggestion-wrapper",
      searchSuggestionHeader: "boost-pfs-search-suggestion-header",
      searchSuggestionGroup: "boost-pfs-search-suggestion-group",
      searchSuggestionItem: "boost-pfs-search-suggestion-item",
      searchSuggestionMobile: "boost-pfs-search-suggestion-mobile",
      searchSuggestionLoading: "boost-pfs-search-suggestion-loading",
      searchSuggestionOpen: "boost-pfs-search-suggestion-open",
      searchSuggestionOpenBody: "boost-pfs-search-suggestion-open-body",
      searchSuggestionMobileOpen: "boost-pfs-search-suggestion-mobile-open",
      searchSuggestionStyle3Open: "boost-pfs-search-suggestion-style3-open",
      searchUiAutocompleteItem: "boost-pfs-ui-item",
      searchSuggestionBtnSubmitMobile: "boost-pfs-search-submit-mobile",
      searchSuggestionBtnCloseMobile: "boost-pfs-search-btn-close-suggestion",
      searchSuggestionBtnClearMobile: "boost-pfs-search-btn-clear-suggestion",
      searchSuggestionNoTabIndex: "boost-pfs-search-no-tabindex",
      searchSuggestionBtnSubmitStyle3: "boost-pfs-search-submit-style3",
      searchSuggestionBtnCloseStyle3: "boost-pfs-search-btn-close-suggestion",
      searchSuggestionBtnClearStyle3: "boost-pfs-search-btn-clear-suggestion",
      productLoadMore: "boost-pfs-filter-load-more",
      productWrapLoading: "boost-pfs-filter-product-loading",
      buttonLoadPreviousPageSelector: "boost-pfs-filter-btn-load-previous-page",
      buttonLoadPreviousPageWrapper:
        "boost-pfs-filter-btn-load-previous-page-wrapper",
      productDisplayType: "boost-pfs-filter-display",
      filterResultItem: "boost-pfs-search-result-list-item",
      filterSkeleton: "boost-pfs-filter-skeleton",
      filterProductSkeleton: "boost-pfs-filter-product-skeleton",
      filterSkeletonText: "boost-pfs-filter-skeleton-text",
      filterSkeletonButton: "boost-pfs-filter-skeleton-button",
      atcForm: "boost-pfs-addtocart-product-form",
      atcAvailable: "boost-pfs-addtocart-available",
      atcSelectOptions: "boost-pfs-addtocart-select-options",
      atcSoldOut: "boost-pfs-addtocart-sold-out",
      variantsDisplay: "boost-pfs-variants-display",
      adaWrapper: "boost-pfs-ada",
      mobileButtonOpen: "boost-pfs-filter-tree-mobile-button-open",
      desktopButtonOpen: "boost-pfs-filter-tree-desktop-button-open",
      mobileDetectiOS: "boost-pfs-filter-mobile-detect-ios",
      hidden: "boost-hidden",
      enableApp: "boost-pfs-enable-app",
      enableFilter: "boost-pfs-enable-filter",
      enableInstantSearch: "boost-pfs-enable-instant-search",
    };
  },
  42: function (t, e, n) {
    "use strict";
    n(22),
      n(23),
      n(21),
      n(47),
      n(27),
      n(9),
      n(17),
      n(18),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(2),
      a = n(0),
      s = n(3),
      l = n(4),
      c = n(7),
      u = n(10),
      p = n(84),
      f = n(75),
      h = n(100),
      d = n(130),
      g = n(43);
    function y(t) {
      return (y =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function m(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function v(t, e) {
      return (v =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function b(t, e) {
      return e && ("object" === y(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function S(t) {
      return (S = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var $ = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && v(t, e);
        })(y, t);
        var e,
          n,
          i,
          u = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = S(t);
              if (e()) {
                var r = S(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return b(this, n);
            };
          })(y);
        function y(t, e) {
          var n;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, y),
            ((n = u.call(this)).id = t),
            (n.autocomplete = null),
            (n.instantSearchResult = null),
            (n.isRendered = !1),
            (n.isBoundEvents = !1),
            (n.$element = e || r()("#" + n.id)),
            (n.$searchForm = n.$element.closest("form")),
            (n.$uiMenuElement = null),
            n
          );
        }
        return (
          (e = y),
          (i = [
            {
              key: "disableInstantSearch",
              value: function () {
                (T = !0),
                  r()("." + l.a.searchSuggestionWrapper).css({
                    visibility: "hidden",
                    opacity: 0,
                    display: "none",
                  });
              },
            },
          ]),
          (n = [
            {
              key: "init",
              value: function () {
                (this.instantSearchResult = f.a.instantSearchResult(
                  this.id,
                  this.$element
                )),
                  this.addComponent(this.instantSearchResult),
                  (this.searchAutoComplete = new d.a(this.id, this.$element)),
                  this.addComponent(this.searchAutoComplete);
              },
            },
            {
              key: "isRender",
              value: function () {
                return !this.isRendered;
              },
            },
            {
              key: "render",
              value: function () {
                var t = a.a.getParam(s.a.searchTermKey);
                this.$element
                  .val(t)
                  .addClass(l.a.searchBox)
                  .attr("autocomplete", "off")
                  .attr("id", a.a.stripHtml(this.id))
                  .attr("data-search-box", a.a.stripHtml(this.id))
                  .attr("role", "combobox")
                  .attr("placeholder", c.a.suggestion.searchBoxPlaceholder)
                  .attr("aria-expanded", !1)
                  .attr("aria-autocomplete", "list")
                  .attr("aria-label", c.a.ada.searchAutoComplete)
                  .attr(
                    "aria-owns",
                    a.a.stripHtml(
                      this.id.replace(l.a.searchBox, l.a.searchSuggestion)
                    )
                  )
                  .attr("data-already-init", !0),
                  (this.isRendered = !0);
              },
            },
            {
              key: "isBindEvents",
              value: function () {
                return !this.isBoundEvents;
              },
            },
            {
              key: "bindEvents",
              value: function () {
                this.$element
                  .on("click", this._onClickSearchBox.bind(this))
                  .on("focus", this._onFocusSearchBox.bind(this))
                  .on("keyup", this._onTypeSearchBoxEvent.bind(this)),
                  this.$searchForm.length &&
                    this.$searchForm.on("submit", this._onSubmit.bind(this)),
                  (this.isBoundEvents = !0);
              },
            },
            {
              key: "_bindAutoCompleteSource",
              value: function (t, e) {
                (window.suggestionCallback = e),
                  (s.a.currentTerm = a.a.stripHtml(t.term));
                var n = t.term.trim().replace(/\s+/g, " ");
                if ("" != n) {
                  var i = this.searchAutoComplete.$element;
                  if (
                    (this.instantSearchResult.setData(i, null, !0),
                    this.instantSearchResult.refresh(),
                    s.a.suggestionCache.hasOwnProperty(n))
                  )
                    return void window.suggestionCallback(
                      s.a.suggestionCache[n]
                    );
                  (n = encodeURIComponent(n)),
                    p.default.getSuggestionData(n, 0, "suggest");
                }
              },
            },
            {
              key: "_bindAutoCompleteResponse",
              value: function (t, e) {
                var n = e.content,
                  i = a.a.getValueInObjectArray("query", n),
                  r = a.a.getValueInObjectArray("event_type", n),
                  o = a.a.getValueInObjectArray("suggest_query", n),
                  l = a.a.getValueInObjectArray("local_cache", n);
                a.a.getValueInObjectArray("redirect", n),
                  25 == Object.keys(s.a.suggestionCache).length &&
                    (s.a.suggestionCache = {}),
                  s.a.suggestionCache.hasOwnProperty(i) ||
                    "suggest_dym" == r ||
                    (s.a.suggestionCache[i] = n),
                  "" == o ||
                    "suggest" != r ||
                    l ||
                    p.default.getSuggestionData(o, 0, "suggest_dym", i),
                  h.a.checkForSearchRedirect(this.$element);
              },
            },
            {
              key: "_bindAutoCompleteRenderMenu",
              value: function (t, e) {
                this.instantSearchResult.setData(r()(t), e, !1),
                  this.instantSearchResult.refresh();
              },
            },
            {
              key: "_bindAutoCompleteResizeMenu",
              value: function () {
                this.customizeInstantSearch();
              },
            },
            { key: "customizeInstantSearch", value: function () {} },
            {
              key: "onFocusAutocomplete",
              value: function (t, e) {
                return !(!e || !e.item || void 0 === e.item.label);
              },
            },
            {
              key: "onOpenAutocomplete",
              value: function (t) {
                var e = this;
                a.a.isiOS() &&
                  r()("." + l.a.searchSuggestionItem + " a")
                    .on("touchstart", function () {
                      e.isScrolling = !1;
                    })
                    .on("touchmove", function () {
                      e.isScrolling = !0;
                    })
                    .on("touchend", function (t) {
                      if (!e.isScrolling) {
                        var n = r()(t.currentTarget).attr("href");
                        a.a.isBadUrl(n) || (window.location.href = n);
                      }
                    }),
                  a.a.InstantSearch.isFullWidthMobile() &&
                    !r()("body").hasClass(l.a.searchSuggestionMobileOpen) &&
                    r()("body").addClass(l.a.searchSuggestionMobileOpen),
                  a.a.InstantSearch.isStyle3() &&
                    !r()("body").hasClass(l.a.searchSuggestionStyle3Open) &&
                    r()("body").addClass(l.a.searchSuggestionStyle3Open),
                  this.instantSearchResult.$wrapper.addClass(
                    l.a.searchSuggestionOpen
                  ),
                  r()("body").hasClass(l.a.searchSuggestionOpenBody) ||
                    r()("body").addClass(l.a.searchSuggestionOpenBody);
              },
            },
            {
              key: "onCloseAutocomplete",
              value: function (t, e) {
                this.instantSearchResult &&
                  this.instantSearchResult.$instantSearchResult &&
                  this.instantSearchResult.$wrapper &&
                  ("test" == o.a.getSettingValue("search.suggestionMode") ||
                  a.a.InstantSearch.isFullWidthMobile()
                    ? this.instantSearchResult.$instantSearchResult.show()
                    : this.instantSearchResult.$instantSearchResult
                        .siblings()
                        .hide(),
                  a.a.isiOS() ||
                    this.instantSearchResult.$wrapper.removeClass(
                      l.a.searchSuggestionOpen
                    ),
                  r()("body").removeClass(l.a.searchSuggestionOpenBody));
              },
            },
            {
              key: "onSelectAutocomplete",
              value: function (t) {
                if (this.autocomplete) {
                  var e = this.autocomplete.$element.find(
                    "." + l.a.searchSuggestionItem + ".selected"
                  );
                  if (e.length) {
                    var n = e.find("> a");
                    if (n.length) {
                      var i = n[0].attr("href");
                      a.a.isBadUrl(i) || a.a.setWindowLocation(i);
                    }
                  }
                  return !1;
                }
              },
            },
            { key: "_onClickSearchBox", value: function (t) {} },
            { key: "_onFocusSearchBox", value: function (t) {} },
            {
              key: "_onTypeSearchBoxEvent",
              value: function (t) {
                s.a.currentTerm = a.a.stripHtml(t.target.value);
              },
            },
            {
              key: "_onSubmit",
              value: function (t, e) {
                if (
                  !T &&
                  (void 0 === e && (e = this.isChangePage),
                  (this.isChangePage = !1),
                  !e)
                ) {
                  t.stopImmediatePropagation(),
                    t.stopPropagation(),
                    t.preventDefault(),
                    (s.a.currentTerm = a.a.stripHtml(this.$element.val())),
                    !s.a.currentTerm &&
                      t &&
                      t.target &&
                      (s.a.searchTerm = a.a.stripHtml(t.target.value));
                  var n = h.a.getSearchRedirectUrl(),
                    i = a.a.unescape(s.a.currentTerm);
                  i = i.trim().replace(/\s+/g, " ");
                  var r = s.a.suggestionCache.hasOwnProperty(i);
                  g.a.setOnClickRecentSearches(i),
                    r
                      ? n && !a.a.isBadUrl(n)
                        ? a.a.setWindowLocation(n)
                        : ((this.isChangePage = !0),
                          this.$searchForm[0].submit())
                      : s.a.currentTerm
                      ? this.$element.data("search-submit", !0)
                      : ((this.isChangePage = !0),
                        this.$searchForm[0].submit());
                }
              },
            },
          ]),
          m(e.prototype, n),
          i && m(e, i),
          y
        );
      })(u.a),
      T = !1;
    e.a = $;
  },
  43: function (t, e, n) {
    "use strict";
    n(21),
      n(30),
      n(83),
      n(81),
      n(24),
      n(9),
      n(25),
      n(11),
      n(13),
      n(12),
      n(67),
      n(48);
    var i = n(1),
      r = n.n(i),
      o = n(20),
      a = n(2),
      s = n(3),
      l = n(39),
      c = n(0),
      u = n(7),
      p = "boostPFSRecentSearches",
      f = null,
      h = {
        getOnClickBlockSettings: function () {
          var t = {
              type: o.a.ResultType.RECENT_SEARCHES,
              label: u.a.suggestion.searchBoxOnClickRecentSearchLabel,
              status: a.a.getSettingValue(
                "search.searchBoxOnclick.recentSearch.status"
              )
                ? "active"
                : "inactive",
              number: a.a.getSettingValue(
                "search.searchBoxOnclick.recentSearch.number"
              ),
            },
            e = a.a.getSettingValue(
              "search.searchBoxOnclick.searchTermSuggestion.data"
            ),
            n = {
              type: o.a.ResultType.DEFAULT_SUGGESTIONS,
              label: u.a.suggestion.searchBoxOnClickSearchTermLabel,
              status: a.a.getSettingValue(
                "search.searchBoxOnclick.searchTermSuggestion.status"
              )
                ? "active"
                : "inactive",
              number: e && e.length ? e.length : 0,
            },
            i = a.a.getSettingValue(
              "search.searchBoxOnclick.productSuggestion.data"
            );
          return [
            t,
            n,
            {
              type: o.a.ResultType.DEFAULT_PRODUCTS,
              label: u.a.suggestion.searchBoxOnClickProductsLabel,
              status: a.a.getSettingValue(
                "search.searchBoxOnclick.productSuggestion.status"
              )
                ? "active"
                : "inactive",
              number: i && i.length ? i.length : 0,
            },
          ];
        },
        getOnClickData: function () {
          var t = a.a.getSettingValue("search.searchBoxOnclick");
          if (f) return (f.recent_searches = h.getOnClickRecentSearches()), f;
          var e = [];
          return (
            a.a.getSettingValue(
              "search.searchBoxOnclick.recentSearch.status"
            ) &&
              e.push({
                key: o.a.ResultType.RECENT_SEARCHES,
                values: h.getOnClickRecentSearches(),
              }),
            a.a.getSettingValue(
              "search.searchBoxOnclick.searchTermSuggestion.status"
            ) &&
              e.push({
                key: o.a.ResultType.DEFAULT_SUGGESTIONS,
                values: Array.isArray(t.searchTermSuggestion.data)
                  ? t.searchTermSuggestion.data
                  : [],
              }),
            a.a.getSettingValue(
              "search.searchBoxOnclick.productSuggestion.status"
            ) && h.getOnClickProducts(t.productSuggestion.data),
            (f = e)
          );
        },
        getOnClickRecentSearches: function (t) {
          try {
            n = JSON.parse(localStorage.getItem(p));
          } catch (e) {
            n = [];
          }
          if (Array.isArray(n)) {
            if (!t) {
              var n,
                i = a.a.getSettingValue(
                  "search.searchBoxOnclick.recentSearch.number"
                );
              i > 0 && (n = n.slice(0, i));
            }
          } else n = [];
          var r = [];
          n.forEach(function (t) {
            "" == t || c.a.isBadUrl(t) || r.push(t);
          });
          try {
            localStorage.setItem(p, JSON.stringify(r));
          } catch (o) {}
          return r;
        },
        setOnClickRecentSearches: function (t) {
          if ("string" == typeof t && "" != t.trim() && !c.a.isBadUrl(t)) {
            t = t.trim();
            var e = h.getOnClickRecentSearches(!0),
              n = e.indexOf(t);
            n >= 0
              ? (e.splice(n, 1), e.unshift(t))
              : (e.unshift(t), (e = e.slice(0, 10)));
            try {
              localStorage.setItem(p, JSON.stringify(e));
            } catch (i) {}
          }
        },
        getOnClickProducts: function (t) {
          if (Array.isArray(t) && 0 != t.length) {
            var e = new URLSearchParams();
            e.append("shop", s.a.shopDomain),
              t.forEach(function (t) {
                return e.append("ids", t);
              });
            var n = e.toString();
            r.a.ajax({
              method: "GET",
              url: l.a.getApiUrl("products") + "?" + n,
              dataType: "json",
              success: function (t) {
                f.push({ key: o.a.ResultType.DEFAULT_PRODUCTS, values: t });
              },
            });
          }
        },
        onClickData: f,
      };
    e.a = h;
  },
  5: function (t, e, n) {
    "use strict";
    var i = {
      filterTree: ".boost-pfs-filter-tree",
      filterTreeVertical: ".boost-pfs-filter-tree-v",
      filterTreeHorizontal: ".boost-pfs-filter-tree-h",
      filterTreeHorizontalWrapper: ".boost-pfs-filter-tree-h-wrapper",
      filterTreeMobileButton: ".boost-pfs-filter-tree-mobile-button",
      filterTreeDesktopButton: ".boost-pfs-filter-tree-desktop-button",
      filterTreeWrapper: ".boost-pfs-filter-wrapper",
      stickyElementDesktop: ".boost-pfs-filter-tree",
      stickyElementMobile: ".boost-pfs-filter-tree-mobile-button",
      stickyFilterTreeDesktopButtonWrapper:
        ".boost-pfs-filter-tree-desktop-button-sticky-wrapper",
      stickyFilterTreeMobileButtonWrapper:
        ".boost-pfs-filter-tree-mobile-button-stick-wrapper",
      endStickyDesktop: ".boost-pfs-filter-products",
      endStickyMobile: ".boost-pfs-filter-products",
      avoidStickyHeader:
        "#shopify-section-announcement-bar, #shopify-section-header,.site-header--opening, .js-navigation, .js-mobile-header-wrapper, .mobile-nav-bar-wrapper, mobile_nav-fixed--true, .site-header--sticky, .site-header-wrapper .action-bar-wrapper",
      filterRefineByVertical: ".boost-pfs-filter-refine-by-wrapper-v",
      filterRefineByHorizontal: ".boost-pfs-filter-refine-by-wrapper-h",
      products: ".boost-pfs-filter-products",
      collections: ".boost-pfs-search-result-collections",
      pages: ".boost-pfs-search-result-pages",
      searchBoxMobile: "#boost-pfs-search-box-mobile",
      searchBoxStyle3: "#boost-pfs-search-box-style3",
      searchTopPanels: ".boost-pfs-search-result-panel-controls",
      searchCollectionPagination:
        ".boost-pfs-search-result-collection-pagination",
      searchPagePagination: ".boost-pfs-search-result-page-pagination",
      searchPanelsProductShow: ".boost-pfs-search-panel-product-show",
      searchPanelsCollectionShow: ".boost-pfs-search-panel-collection-show",
      searchPanelsPageShow: ".boost-pfs-search-panel-page-show",
      searchTotalResult: ".boost-pfs-search-total-result",
      searchNoResultJson: "#boost-pfs-instant-search-products-not-found-json",
      inCollectionSearch: ".boost-pfs-in-collection-search",
      topShowLimit: ".boost-pfs-filter-top-show-limit",
      topSorting: ".boost-pfs-filter-top-sorting",
      topDisplayType: ".boost-pfs-filter-top-display-type",
      pagination:
        ".boost-pfs-filter-bottom-pagination,.boost-pfs-filter-top-pagination",
      bottomPagination: ".boost-pfs-filter-bottom-pagination",
      loadMore: ".boost-pfs-filter-load-more",
      loadMoreButtonContainer: ".boost-pfs-filter-load-more-button-container",
      btnLoadPreviousPageWrapperSelector:
        ".boost-pfs-filter-btn-load-previous-page-wrapper",
      btnLoadPreviousPageSelector: ".boost-pfs-filter-btn-load-previous-page",
      loadMoreLoading: ".boost-pfs-filter-load-more-loading",
      topNotification: ".boost-pfs-filter-top-notification",
      breadcrumb: ".boost-pfs-filter-breadcrumb",
      scrollToTop: ".boost-pfs-filter-scroll-to-top",
      otpProductItem: "",
      otpButtons: "",
      otpTopCartWrapper: "#cart-icon-bubble",
      otpTopCartLink:
        'header a[href="/cart"], a[href="/cart"].site-header__cart, .cart-page-link',
      otpTopCartCount: "#CartCount, .cart-count-bubble, .cart-count",
      otpTopCartSubtotal: "",
      productPageAtcButton:
        'form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] *[name="add"]',
      productPageAtcForm: 'form[action="/cart/add"]',
      mostPopular: ".boost-pfs-most-popular",
      recentlyViewed: ".boost-pfs-recently-viewed",
      trackingProduct: ".boost-pfs-filter-products > *",
      trackingQuickView: ".boost-pfs-quickview-btn",
      trackingAddToCart:
        'form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] *[name="add"]',
      trackingBuyNow: ".shopify-payment-button, #dynamic-checkout-cart",
      init: function () {
        var t = i;
        "undefined" != typeof boostPFSConfig &&
          boostPFSConfig.hasOwnProperty("selector") &&
          null !== boostPFSConfig.selector &&
          (t = Utils.mergeObject(t, boostPFSConfig.selector)),
          "undefined" != typeof boostPFSFilterConfig &&
            boostPFSFilterConfig.hasOwnProperty("selector") &&
            null !== boostPFSFilterConfig.selector &&
            (t = Utils.mergeObject(t, boostPFSFilterConfig.selector)),
          "undefined" != typeof boostPFSInstantSearchConfig &&
            boostPFSInstantSearchConfig.hasOwnProperty("selector") &&
            null !== boostPFSInstantSearchConfig.selector &&
            (t = Utils.mergeObject(t, boostPFSInstantSearchConfig.selector)),
          (i = t);
      },
    };
    e.a = i;
  },
  51: function (module, __webpack_exports__, __webpack_require__) {
    "use strict";
    var compileTemplate,
      call3rdAppFunction,
      compileIntegrationTemplate,
      call3rdIntegrationFunc,
      core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ =
        __webpack_require__(22),
      core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default =
        __webpack_require__.n(
          core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__
        ),
      core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__ =
        __webpack_require__(23),
      core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1___default =
        __webpack_require__.n(
          core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__
        ),
      _helpers_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2),
      _helpers_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0),
      _helpers_globals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3),
      hascompileTemplate = function (t, e) {
        var n =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : "compileTemplate",
          i = {};
        return (
          !!_helpers_globals__WEBPACK_IMPORTED_MODULE_4__.a.hasIntegration ||
          !(
            void 0 ===
              (i = e
                ? "undefined" != typeof boostPFSIntegrationCustomTemplate
                  ? boostPFSIntegrationCustomTemplate
                  : {}
                : "undefined" != typeof boostPFSIntegrationTemplate
                ? boostPFSIntegrationTemplate
                : {}) ||
            !i.hasOwnProperty(n) ||
            !i[n].hasOwnProperty(t) ||
            "" === i[n][t]
          )
        );
      },
      Integration = {
        compileTemplate: function compileTemplate(itemHtml, data) {
          if (
            "undefined" != typeof boostPFSIntegrationTemplate &&
            boostPFSIntegrationTemplate.hasOwnProperty("compileTemplate")
          ) {
            var _compileTemplate = "";
            for (var i in boostPFSIntegrationTemplate.compileTemplate)
              hascompileTemplate(i, !0)
                ? (_compileTemplate +=
                    boostPFSIntegrationCustomTemplate.compileTemplate[i])
                : (_compileTemplate +=
                    boostPFSIntegrationTemplate.compileTemplate[i]);
            try {
              eval(_compileTemplate);
            } catch (t) {
              console.log("Error when parsing 3rd app template code");
            }
          }
          return itemHtml;
        },
        call3rdAppFunction: function call3rdAppFunction(data) {
          if (
            "undefined" != typeof boostPFSIntegrationTemplate &&
            boostPFSIntegrationTemplate.hasOwnProperty("call3rdFunction")
          ) {
            var call3rdFunction = "";
            for (var i in boostPFSIntegrationTemplate.call3rdFunction)
              hascompileTemplate(i, !0, "call3rdFunction")
                ? (call3rdFunction +=
                    boostPFSIntegrationCustomTemplate.call3rdFunction[i])
                : (call3rdFunction +=
                    boostPFSIntegrationTemplate.call3rdFunction[i]);
            try {
              eval(call3rdFunction);
            } catch (t) {
              console.log("Error when parsing 3rd app integration code");
            }
          }
        },
        hascompileTemplate: hascompileTemplate,
        compileIntegrationTemplate: function (t, e) {
          return (e = e.replace(/{{itemReviews}}/g, ""));
        },
        call3rdIntegrationFunc: function (t) {},
      };
    __webpack_exports__.a = Integration;
  },
  59: function (t, e, n) {
    "use strict";
    n(149),
      n(22),
      n(48),
      n(23),
      n(38),
      n(115),
      n(40),
      n(9),
      n(30),
      n(17),
      n(18),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(10),
      r = n(2);
    function o(t) {
      return (o =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function a(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function s(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function l(t, e) {
      return (l =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function c(t, e) {
      return e && ("object" === o(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function u(t) {
      return (u = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var p = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && l(t, e);
      })(p, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = u(t);
            if (e()) {
              var r = u(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return c(this, n);
          };
        })(p);
      function p() {
        return a(this, p), o.apply(this, arguments);
      }
      return (
        (e = p),
        (n = [
          {
            key: "_highlightSuggestionResult",
            value: function (t, e) {
              if (
                r.a.getSettingValue("search.highlightSuggestionResult") &&
                e &&
                e.length > 1 &&
                t
              ) {
                var n,
                  i = function (t, e) {
                    return RegExp(
                      t.replace(/([\(\)\{\}\[\]\.\+\-\=\\\/])/g, "\\$&"),
                      e ? "g" : "ig"
                    );
                  },
                  o = e.split(" "),
                  a = o.length;
                for (n = 0; n < a; n++) {
                  var s = i(o[n]),
                    l = t.match(s);
                  if (null !== l && l.length > 0) {
                    var c,
                      u = (l = l.filter(function (t, e) {
                        return l.indexOf(t) == e && "" != t;
                      })).length;
                    for (c = 0; c < u; c++)
                      l[c].length > 1 &&
                        ((s = i(l[c], !0)),
                        (t = t.replace(s, "<b>" + l[c] + "</b>")));
                  }
                }
              }
              return t;
            },
          },
        ]),
        s(e.prototype, n),
        i && s(e, i),
        p
      );
    })(i.a);
    e.a = p;
  },
  6: function (t, e, n) {
    "use strict";
    e.a = {
      Status: { ACTIVE: "active", DISABLED: "disabled" },
      FilterType: {
        COLLECTION: "collection",
        VENDOR: "vendor",
        PRODUCT_TYPE: "product_type",
        TITLE: "title",
        PRICE: "price",
        VARIANTS_PRICE: "variants_price",
        PERCENT_SALE: "percent_sale",
        REVIEW_RATINGS: "review_ratings",
        WEIGHT: "weight",
        STOCK: "stock",
        TAG: "tag",
        MULTI_LEVEL_TAG: "multi_level_tag",
        LOCATION: "location",
      },
      SelectType: { SINGLE: "single", MULTIPLE: "multiple" },
      DisplayType: {
        LIST: "list",
        BOX: "box",
        RANGE: "range",
        SWATCH: "swatch",
        RATING: "rating",
        SUB_CATEGORY: "sub_category",
        MULTI_LEVEL_COLLECTIONS: "multi_level_collections",
        MULTI_LEVEL_TAG: "multi_level_tag",
      },
      ValueType: { ALL: "all", SPECIFIC: "specific" },
      SortType: {
        KEY_ASCENDING: "key-asc",
        KEY_DESCENDING: "key-desc",
        DOC_COUNT_ASCENDING: "doc_count-asc",
        DOC_COUNT_DESCENDING: "doc_count-desc",
      },
      ShowMoreType: {
        NONE: "none",
        SCROLLBAR: "scrollbar",
        VIEWMORE: "viewmore",
        VIEWMORE_SCROLLBAR: "viewmore_scrollbar",
      },
    };
  },
  61: function (t, e, n) {
    "use strict";
    n(21),
      n(22),
      n(23),
      n(17),
      n(18),
      n(9),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(10),
      a = n(42),
      s = n(4),
      l = n(2),
      c = n(7),
      u = n(5),
      p = n(0),
      f = n(3);
    function h(t) {
      return (h =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function d(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function g(t, e) {
      return (g =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function y(t, e) {
      return e && ("object" === h(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function m(t) {
      return (m = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var v = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && g(t, e);
      })(h, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = m(t);
            if (e()) {
              var r = m(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return y(this, n);
          };
        })(h);
      function h() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, h),
          ((t = o.call(this)).data = ""),
          (t.isBoundEvents = !1),
          (t.isOpen = !1),
          (t.inputMobileId = u.a.searchBoxMobile.substr(1)),
          (t.searchBox = null),
          (t.selector = {
            searchInput: u.a.searchBoxMobile,
            clearButton: "." + s.a.searchSuggestionBtnClearMobile,
            closebutton: "." + s.a.searchSuggestionBtnCloseMobile,
            submitButton: "." + s.a.searchSuggestionBtnSubmitMobile,
            topPanel: "." + s.a.searchSuggestion + "-mobile-top-panel",
            overlay: "." + s.a.searchSuggestion + "-mobile-overlay",
            searchInputs:
              'input[name="' + l.a.getSettingValue("search.termKey") + '"]',
          }),
          t
        );
      }
      return (
        (e = h),
        (i = [
          {
            key: "tempType",
            get: function () {
              return { SEARCH_BTN: "search_btn", DEFAULT: "default" };
            },
          },
          {
            key: "isActive",
            value: function () {
              return !0;
            },
          },
        ]),
        (n = [
          {
            key: "getTemplate",
            value: function (t) {
              return t === h.tempType.SEARCH_BTN
                ? '\n					<span class="{{class.searchSuggestionBtnSubmitMobile}}"><span>Submit</span></span>\n				'.trim()
                : '\n					<div class="{{class.searchSuggestion}}-mobile-overlay"></div>\n					<div class="{{class.searchSuggestion}}-mobile-top-panel">\n						<form action="/search" method="get">\n							<button type="button" class="{{class.searchSuggestionBtnCloseMobile}}"><-</button>\n							{{btnSearch}}\n							<input role="textbox" type="text" name="{{searchTermKey}}" placeholder="{{searchBoxPlaceholder}}" id="{{searchId}}" />\n							<button role="textbox" type="button" class="{{class.searchSuggestionBtnClearMobile}}">X</button>\n						</form>\n					</div>\n				'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t = "";
              return (
                l.a.getSettingValue("search.showSearchBtnMobile") &&
                  (t = this.getTemplate(h.tempType.SEARCH_BTN)),
                this.getTemplate()
                  .replace(/{{btnSearch}}/g, t)
                  .replace(
                    /{{searchTermKey}}/g,
                    l.a.getSettingValue("search.termKey")
                  )
                  .replace(
                    /{{searchBoxPlaceholder}}/g,
                    c.a.suggestion.searchBoxPlaceholder
                  )
                  .replace(/{{searchId}}/g, this.inputMobileId)
                  .replace(/{{class.searchSuggestion}}/g, s.a.searchSuggestion)
                  .replace(
                    /{{class.searchSuggestionBtnSubmitMobile}}/g,
                    s.a.searchSuggestionBtnSubmitMobile
                  )
                  .replace(
                    /{{class.searchSuggestionBtnCloseMobile}}/g,
                    s.a.searchSuggestionBtnCloseMobile
                  )
                  .replace(
                    /{{class.searchSuggestionBtnClearMobile}}/g,
                    s.a.searchSuggestionBtnClearMobile
                  )
              );
            },
          },
          {
            key: "render",
            value: function () {
              r()("body").append(this.compileTemplate());
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvents;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              (this.$searchInput = r()(this.selector.searchInput)),
                (this.$clearButtonElement = r()(this.selector.clearButton)),
                (this.$closebuttonElement = r()(this.selector.closebutton)),
                (this.$submitButtonElement = r()(this.selector.submitButton)),
                (this.$topPanelElement = r()(this.selector.topPanel)),
                (this.$overlayElement = r()(this.selector.overlay)),
                (this.searchBox = new a.a(
                  this.inputMobileId,
                  this.$searchInput
                )),
                this.searchBox.refresh(),
                this.$closebuttonElement.on(
                  "click",
                  this.closeInstantSearchMobile.bind(this, !0)
                ),
                this.$clearButtonElement.on(
                  "click",
                  this.clearInstantSearchMobile.bind(this)
                ),
                (this.$searchInputs = r()(this.selector.searchInputs)),
                this.$searchInputs
                  .on("click", this._onClickSearchBox.bind(this))
                  .on("focus", this._onFocusSearchBox.bind(this))
                  .on("keyup", this._onTypeSearchBoxEvent.bind(this)),
                this.$searchInput.on(
                  "focus",
                  this._onFocusMobileInput.bind(this)
                ),
                this.$searchInput.on(
                  "keyup",
                  this._onKeyupSearchBox.bind(this)
                ),
                (this.$targetInput = null),
                (this.isBoundEvents = !0);
            },
          },
          {
            key: "_onClickSearchBox",
            value: function (t) {
              if (p.a.isFullWidthMobile()) {
                var e =
                  this.$targetInput && p.a.stripHtml(this.$targetInput.val());
                e && this.$searchInputs.val(e),
                  this.$searchInput &&
                    (this.$searchInput.length > 0 &&
                    "" != p.a.stripHtml(this.$searchInput.val())
                      ? this.openSuggestionMobile()
                      : this.searchBox &&
                        this.searchBox.searchAutoComplete &&
                        this.searchBox.searchAutoComplete
                          .enableOnClickSearchBox &&
                        (this.openSuggestionMobile(),
                        this.searchBox.searchAutoComplete.showOnClickSuggestion()));
              }
            },
          },
          {
            key: "_onKeyupSearchBox",
            value: function (t) {
              var e;
              this.$targetInput.val(
                p.a.stripHtml(
                  null == t || null === (e = t.currentTarget) || void 0 === e
                    ? void 0
                    : e.value
                )
              );
            },
          },
          {
            key: "_onFocusSearchBox",
            value: function (t) {
              if (p.a.isFullWidthMobile()) {
                var e = t && t.target ? t.target.id : "",
                  n = this.$searchInput ? this.$searchInput.attr("id") : "";
                "" != e &&
                  "" != n &&
                  e != n &&
                  ((this.$targetInput = r()("#" + e)),
                  this.showSearchBoxMobile(),
                  this.$searchInput.trigger("click"));
              }
            },
          },
          {
            key: "_onFocusMobileInput",
            value: function (t) {
              var e = this;
              this.isReFocus
                ? (t &&
                    (t.stopImmediatePropagation(),
                    t.stopPropagation(),
                    t.preventDefault()),
                  (this.isReFocus = !1),
                  this._onFocusSearchBox(t))
                : setTimeout(function () {
                    (document.activeElement && document.activeElement.id
                      ? "#" + document.activeElement.id
                      : "") != u.a.searchBoxMobile &&
                      ((e.isReFocus = !0), e.$searchInput.focus());
                  }, 0);
            },
          },
          {
            key: "_onTypeSearchBoxEvent",
            value: function (t) {
              p.a.InstantSearch.isFullWidthMobile() &&
                (this.searchBox.instantSearchResult.$wrapper.show(),
                "" == p.a.stripHtml(t.target.value)
                  ? (this.searchBox &&
                    this.searchBox.searchAutoComplete &&
                    this.searchBox.searchAutoComplete.enableOnClickSearchBox
                      ? this.searchBox.searchAutoComplete.showOnClickSuggestion()
                      : this.closeInstantSearchMobile(),
                    this.$clearButtonElement.hide())
                  : this.$clearButtonElement.show());
            },
          },
          {
            key: "showSearchBoxMobile",
            value: function () {
              var t = this;
              (this.isOpen = !0),
                this.onClickOutsideSuggestionMobileEvent(),
                this.scrollSuggestionMobileEvent(),
                "" == p.a.stripHtml(this.$searchInput.val())
                  ? this.$clearButtonElement.hide()
                  : this.$clearButtonElement.show(),
                this.$searchInput.is(":focus") ||
                  (this.$topPanelElement.show(),
                  this.$overlayElement.show(),
                  r()('[tabindex="-1"]')
                    .removeAttr("tabindex")
                    .addClass(s.a.searchSuggestionNoTabIndex),
                  p.a.isMobile() &&
                    r()("[data-open=true]").length > 0 &&
                    r()("[data-open=true]").attr("data-open", !1),
                  setTimeout(function () {
                    t.$searchInput.focus();
                  }, 100),
                  this.afterShowSearchBoxMobile());
            },
          },
          {
            key: "closeInstantSearchMobile",
            value: function (t) {
              this.searchBox.instantSearchResult.$wrapper.hide(),
                (t = void 0 !== t && t) &&
                  (this.$topPanelElement.hide(), this.$overlayElement.hide()),
                this._setValueAllSearchBoxes(),
                r()("." + s.a.searchSuggestionNoTabIndex).attr("tabindex", -1),
                r()("body").hasClass(s.a.searchSuggestionMobileOpen) &&
                  r()("body").removeClass(s.a.searchSuggestionMobileOpen),
                this.afterCloseInstantSearchMobile(t);
            },
          },
          {
            key: "clearInstantSearchMobile",
            value: function () {
              this.$clearButtonElement.hide(),
                (f.a.currentTerm = ""),
                this._setValueAllSearchBoxes(""),
                this.searchBox &&
                this.searchBox.searchAutoComplete &&
                this.searchBox.searchAutoComplete.enableOnClickSearchBox
                  ? this.searchBox.searchAutoComplete.showOnClickSuggestion()
                  : this.closeInstantSearchMobile(),
                this.$searchInput.focus();
            },
          },
          { key: "afterCloseInstantSearchMobile", value: function (t) {} },
          {
            key: "_setValueAllSearchBoxes",
            value: function (t) {
              void 0 === t && (t = p.a.stripHtml(f.a.currentTerm)),
                (f.a.currentTerm = p.a.stripHtml(t)),
                this.$searchInputs.val(p.a.stripHtml(t));
            },
          },
          {
            key: "onClickOutsideSuggestionMobileEvent",
            value: function () {
              var t = this;
              r()(document).on("touchstart", function (e) {
                if (e.target) {
                  var n = r()(e.target),
                    i =
                      n.closest(
                        "." + s.a.searchSuggestion + "-mobile-top-panel"
                      ).length > 0,
                    o =
                      n.closest("." + s.a.searchSuggestionWrapper + " div")
                        .length > 0;
                  i || o || t.closeInstantSearchMobile(!0);
                }
              });
            },
          },
          {
            key: "scrollSuggestionMobileEvent",
            value: function () {
              var t = this;
              r()(document).on("touchmove", function (e) {
                t.$searchInput.is(":focus") && t.$searchInput.blur();
              });
            },
          },
          { key: "afterShowSearchBoxMobile", value: function () {} },
          {
            key: "openSuggestionMobile",
            value: function () {
              this.beforeOpenSuggestionMobile(),
                r()("body").hasClass(s.a.searchSuggestionMobileOpen) ||
                  r()("body").addClass(s.a.searchSuggestionMobileOpen),
                this.showSearchBoxMobile(),
                this.searchBox.instantSearchResult.$wrapper.show(),
                this.afterOpenSuggestionMobile();
            },
          },
          { key: "beforeOpenSuggestionMobile", value: function () {} },
          { key: "afterOpenSuggestionMobile", value: function () {} },
        ]),
        d(e.prototype, n),
        i && d(e, i),
        h
      );
    })(o.a);
    e.a = v;
  },
  62: function (t, e, n) {
    "use strict";
    n.r(e),
      n(22),
      n(54),
      n(40),
      n(9),
      n(17),
      n(18),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(2),
      a = n(7),
      s = n(3),
      l = n(5),
      c = n(36),
      u = (n(30), n(68), n(80), n(24), n(25), n(99), n(0)),
      p = n(42),
      f = n(61),
      h = n(76),
      d = n(86),
      g = (n(21), n(10)),
      y = n(51);
    function m(t) {
      return (m =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function v(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function b(t, e) {
      return (b =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function S(t, e) {
      return e && ("object" === m(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function $(t) {
      return ($ = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var T = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && b(t, e);
      })(p, t);
      var e,
        n,
        i,
        a = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = $(t);
            if (e()) {
              var r = $(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return S(this, n);
          };
        })(p);
      function p() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, p),
          ((t = a.call(this)).data = null),
          (t.id = null),
          (t.totalProduct = null),
          (t.$element = null),
          (t.$productList = r()(l.a.products)),
          (t.settings = {
            enableKeepScrollbackPosition: o.a.getSettingValue(
              "general.enableKeepScrollbackPosition"
            ),
            keepScrollbackPositionType: o.a.getSettingValue(
              "general.keepScrollbackPositionType"
            ),
            sessionStorageScrollbackPosition: o.a.getSettingValue(
              "general.sessionStorageScrollbackPosition"
            ),
          }),
          t
        );
      }
      return (
        (e = p),
        (n = [
          {
            key: "init",
            value: function () {
              window.BoostOTP && BoostOTP.OTPButtons.init(this);
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return "";
            },
          },
          {
            key: "render",
            value: function () {
              if (!this.$element || 0 == this.$element.length) {
                if (this.parent.isRender()) {
                  var t = this.compileTemplate();
                  "function" == typeof u.a.compileShopifyProductVariables &&
                    (t = u.a.compileShopifyProductVariables(this.data, t)),
                    "function" == typeof u.a.compileShopifyProductMetafield &&
                      (t = u.a.compileShopifyProductMetafield(this.data, t)),
                    (t = y.a.compileTemplate(t, this.data)),
                    (t = y.a.compileIntegrationTemplate(this.data, t)) &&
                      "string" == typeof t &&
                      (this.$element = r()(t.trim()));
                } else {
                  var e = o.a.getSettingValue("general.otpProductItemClass");
                  this.$element = e
                    ? this.$productList.children(e).eq(this.index)
                    : this.$productList.children().eq(this.index);
                }
              }
              if (this.$element) {
                this.$element.attr("data-id", u.a.stripHtml(this.id));
                var n = u.a.stripHtml(this.$element.attr("data-page")),
                  i =
                    s.a.queryParams.page && !isNaN(s.a.queryParams.page)
                      ? s.a.queryParams.page
                      : 1;
                (n && !isNaN(n)) ||
                  this.$element.attr("data-page", u.a.stripHtml(i)),
                  window.BoostOTP && BoostOTP.OTPButtons.render(this);                
              }
            },
          },
          {
            key: "bindEvents",
            value: function () {
              var t = u.a.isSearchPage() || u.a.isCollectionPage(),
                e =
                  u.a.isiOS() &&
                  o.a.getSettingValue("general.paginationType") ==
                    ProductPagination.Type.DEFAULT;
              t &&
                !e &&
                this.settings.enableKeepScrollbackPosition &&
                this._bindKeepScrollbackPositionEvent(),
                window.BoostOTP && BoostOTP.OTPButtons.bindEvents(this);
              setTimeout(()=>{ window.fixAddToCartButtons() },500);
            },
          },
          {
            key: "_bindKeepScrollbackPositionEvent",
            value: function () {
              if (this.$element) {
                if (u.a.isMobileDevice()) {
                  var t = !1;
                  this.$element
                    .on("touchstart", function () {
                      t = !1;
                    })
                    .on("touchmove", function () {
                      t = !0;
                    })
                    .on(
                      "touchend",
                      this._onClickKeepPositionEvent.bind(this, t)
                    );
                } else
                  this.$element.on(
                    "click",
                    this._onClickKeepPositionEvent.bind(this, !1)
                  );
              }
            },
          },
          {
            key: "_onClickKeepPositionEvent",
            value: function (t, e) {
              if (!t && this.id) {
                var n = JSON.parse(JSON.stringify(s.a.queryParams)),
                  i = u.a.stripHtml(this.$element.attr("data-page"));
                n.page = i && !isNaN(i) ? i : 1;
                var r = c.a.buildAddressBarUrl(n),
                  o = {
                    productId: this.id,
                    page: i,
                    position: window.pageYOffset,
                    offset: this.$element.offset().top - window.pageYOffset,
                    url: r,
                  };
                if (
                  "sessionStorage" == this.settings.keepScrollbackPositionType
                )
                  sessionStorage.setItem(
                    this.settings.sessionStorageScrollbackPosition,
                    JSON.stringify(o)
                  );
                else {
                  var a = c.a.getHistoryState();
                  a && a.param && (o.param = a.param);
                }
                window.history.replaceState(o, document.title, r);
              }
            },
          },
          {
            key: "setData",
            value: function (t, e) {
              (this.data = t),
                (this.id = t.id),
                (this.index = e),
                (this.totalProduct = this.parent.totalProduct);
            },
          },
        ]),
        v(e.prototype, n),
        i && v(e, i),
        p
      );
    })(g.a);
    function P(t) {
      return (P =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function _(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function k(t, e) {
      return (k =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function O(t, e) {
      return e && ("object" === P(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function C(t) {
      return (C = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var w = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && k(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = C(t);
            if (e()) {
              var r = C(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return O(this, n);
          };
        })(o);
      function o() {
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, o),
          r.call(this)
        );
      }
      return (
        (e = o),
        (n = [
          {
            key: "compileTemplate",
            value: function () {
              console.warn(
                "Missing buildProductGridItem function in theme lib"
              );
            },
          },
        ]),
        _(e.prototype, n),
        i && _(e, i),
        o
      );
    })(T);
    function I(t) {
      return (I =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function E(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function L(t, e) {
      return (L =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function A(t, e) {
      return e && ("object" === I(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function x(t) {
      return (x = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var B = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && L(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = x(t);
            if (e()) {
              var r = x(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return A(this, n);
          };
        })(o);
      function o() {
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, o),
          r.call(this)
        );
      }
      return (
        (e = o),
        (n = [
          {
            key: "compileTemplate",
            value: function () {
              console.warn(
                "Missing buildProductListItem function in theme lib"
              );
            },
          },
        ]),
        E(e.prototype, n),
        i && E(e, i),
        o
      );
    })(T);
    function R(t) {
      return (R =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function F(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function V(t, e) {
      return (V =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function D(t, e) {
      return e && ("object" === R(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function M(t) {
      return (M = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var H = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && V(t, e);
        })(o, t);
        var e,
          n,
          i,
          r = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = M(t);
              if (e()) {
                var r = M(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return D(this, n);
            };
          })(o);
        function o() {
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, o),
            r.call(this)
          );
        }
        return (
          (e = o),
          (n = [
            {
              key: "compileTemplate",
              value: function () {
                console.warn(
                  "Missing buildProductCollageItem function in theme lib"
                );
              },
            },
          ]),
          F(e.prototype, n),
          i && F(e, i),
          o
        );
      })(T),
      N =
        (n(45),
        n(38),
        n(97),
        n(23),
        n(34),
        n(41),
        n(82),
        n(186),
        n(66),
        n(120),
        n(67),
        n(48),
        n(27),
        n(4));
    function U(t) {
      return (U =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function W(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function j(t, e) {
      return (j =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function q(t, e) {
      return e && ("object" === U(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function G(t) {
      return (G = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    n(187);
    var z = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && j(t, e);
        })(s, t);
        var e,
          n,
          i,
          a = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = G(t);
              if (e()) {
                var r = G(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return q(this, n);
            };
          })(s);
        function s() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, s),
            ((t = a.call(this)).$element = r()(l.a.searchTopPanels)),
            (t.data = null),
            (t.panelItems = []),
            (t.eventType = "init"),
            (t.selector = {
              products: l.a.products,
              collections: l.a.collections,
              pages: l.a.pages,
              filterTree: l.a.filterTree,
              filterTreeMobileButton: l.a.filterTreeMobileButton,
              pagination: l.a.pagination,
              loadMore: l.a.loadMore,
              btnLoadPreviousPageWrapperSelector:
                l.a.btnLoadPreviousPageWrapperSelector,
              searchPanelsProductShow: l.a.searchPanelsProductShow,
              searchPanelsCollectionShow: l.a.searchPanelsCollectionShow,
              searchPanelsPageShow: l.a.searchPanelsPageShow,
            }),
            (t.settings = {
              searchPanelDefault: o.a.getSettingValue(
                "search.searchPanelDefault"
              ),
              searchPanelList: o.a.getSettingValue("search.searchPanelList"),
              searchPanelBlocks: o.a.getSettingValue(
                "search.searchPanelBlocks"
              ),
            }),
            (t.isFetchedFilterData = !1),
            t
          );
        }
        return (
          (e = s),
          (i = [
            {
              key: "isPanelActive",
              value: function (t) {
                return !u.a.isSearchPage() || s.getPanelActive() == t;
              },
            },
            {
              key: "getPanelActive",
              value: function () {
                return Globals.hasOwnProperty("searchDisplay") &&
                  Object.values(tt.Enum).indexOf(Globals.searchDisplay) > -1
                  ? Globals.searchDisplay
                  : o.a.getSettingValue("search.searchPanelDefault");
              },
            },
          ]),
          (n = [
            {
              key: "init",
              value: function () {
                var t = this;
                (this.panelItems = []),
                  this.settings.searchPanelList.forEach(function (e) {
                    var n = t.settings.searchPanelBlocks[e],
                      i = new tt(n, e);
                    t.addComponent(i), t.panelItems.push(i);
                  });
              },
            },
            {
              key: "isRender",
              value: function () {
                return u.a.isSearchPage() && this.isFetchedFilterData;
              },
            },
            {
              key: "render",
              value: function () {
                var t = this,
                  e = 0;
                switch (
                  (this.$element.empty(),
                  this.panelItems.forEach(function (n) {
                    t.$element.append(n.$element), n.isRendered && e++;
                  }),
                  s.getPanelActive())
                ) {
                  case tt.Enum.COLLECTION:
                    this.showPanelCollection();
                    break;
                  case tt.Enum.PAGE:
                    this.showPanelPage();
                    break;
                  default:
                    this.showPanelProduct();
                }
                this.$element.addClass("boost-pfs-search-panel-items-" + e);
              },
            },
            {
              key: "hidePanelProduct",
              value: function () {
                r()(this.selector.products).addClass(N.a.hidden),
                  r()(this.selector.filterTreeMobileButton).addClass(
                    N.a.hidden
                  ),
                  r()(this.selector.filterTree).addClass(N.a.hidden),
                  r()(this.selector.pagination).addClass(N.a.hidden),
                  r()(this.selector.loadMore).addClass(N.a.hidden),
                  r()(
                    this.selector.btnLoadPreviousPageWrapperSelector
                  ).addClass(N.a.hidden),
                  r()(this.selector.searchPanelsProductShow).addClass(
                    N.a.hidden
                  );
              },
            },
            {
              key: "hidePanelCollection",
              value: function () {
                r()(this.selector.collections).parent().addClass(N.a.hidden),
                  r()(this.selector.searchPanelsCollectionShow).addClass(
                    N.a.hidden
                  );
              },
            },
            {
              key: "hidePanelPage",
              value: function () {
                r()(this.selector.pages).parent().addClass(N.a.hidden),
                  r()(this.selector.searchPanelsPageShow).addClass(N.a.hidden);
              },
            },
            {
              key: "showPanelProduct",
              value: function () {
                this.hidePanelCollection(),
                  this.hidePanelPage(),
                  r()(this.selector.products).removeClass(N.a.hidden),
                  r()(this.selector.filterTree).removeClass(N.a.hidden),
                  r()(this.selector.filterTreeMobileButton).removeClass(
                    N.a.hidden
                  ),
                  r()(this.selector.pagination).removeClass(N.a.hidden),
                  r()(this.selector.loadMore).removeClass(N.a.hidden),
                  r()(
                    this.selector.btnLoadPreviousPageWrapperSelector
                  ).removeClass(N.a.hidden),
                  r()(this.selector.searchPanelsProductShow).removeClass(
                    N.a.hidden
                  );
              },
            },
            {
              key: "showPanelCollection",
              value: function () {
                this.hidePanelProduct(),
                  this.hidePanelPage(),
                  r()(this.selector.collections)
                    .parent()
                    .removeClass(N.a.hidden),
                  r()(this.selector.searchPanelsCollectionShow).removeClass(
                    N.a.hidden
                  );
              },
            },
            {
              key: "showPanelPage",
              value: function () {
                this.hidePanelProduct(),
                  this.hidePanelCollection(),
                  r()(this.selector.pages).parent().removeClass(N.a.hidden),
                  r()(this.selector.searchPanelsPageShow).removeClass(
                    N.a.hidden
                  );
              },
            },
            {
              key: "setData",
              value: function (t, e) {
                (this.isFetchedFilterData = !0),
                  t && (this.data = t),
                  (this.eventType = e),
                  this.panelItems.forEach(function (n) {
                    n.setData(t, e);
                  });
              },
            },
          ]),
          W(e.prototype, n),
          i && W(e, i),
          s
        );
      })(g.a),
      K = n(8);
    function Y(t) {
      return (Y =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function Q(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function X(t, e) {
      return (X =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function Z(t, e) {
      return e && ("object" === Y(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function J(t) {
      return (J = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var tt = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && X(t, e);
      })(l, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = J(t);
            if (e()) {
              var r = J(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return Z(this, n);
          };
        })(l);
      function l(t, e) {
        var n;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, l),
          ((n = o.call(this)).$element = null),
          (n.data = t),
          (n.type = e),
          (n.eventType = "init"),
          (n.isRenderPanelContent = !1),
          (n.limit = 25),
          (n.page = 1),
          (n.active = t.active),
          n.type == l.Enum.PRODUCT
            ? ((n.limit = Settings.getSettingValue("general.limit")),
              (n.page = s.a.queryParams.page))
            : t.hasOwnProperty("pageSize") && (n.limit = parseInt(t.pageSize)),
          n
        );
      }
      return (
        (e = l),
        (i = [
          {
            key: "Enum",
            get: function () {
              return {
                COLLECTION: "collections",
                PRODUCT: "products",
                PAGE: "pages",
              };
            },
          },
        ]),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<li class="{{class.searchResultPanelItem}}">\n				<button>{{panelItemLabel}} ({{panelItemCount}})</button>\n			</li>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(/{{panelItemLabel}}/g, u.a.stripHtml(this.data.label))
                .replace(/{{panelItemCount}}/g, u.a.stripHtml(this.totalResult))
                .replace(
                  /{{class.searchResultPanelItem}}/g,
                  N.a.searchResultPanelItem
                );
            },
          },
          {
            key: "isActive",
            value: function () {
              return z.isPanelActive(this.type);
            },
          },
          {
            key: "isRender",
            value: function () {
              return (
                this.type == l.Enum.PRODUCT ||
                (this.active && this.totalResult && "init" == this.eventType)
              );
            },
          },
          {
            key: "render",
            value: function () {
              (this.$element = r()(this.compileTemplate())),
                this.isActive() && this.$element.addClass("boost-active");
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                this.$element.on("click", this._onClickPanelItem.bind(this));
            },
          },
          {
            key: "setData",
            value: function (t, e) {
              var n = 0,
                i = "",
                r = this.data.hasOwnProperty("label") ? this.data.label : "";
              switch (this.type) {
                case l.Enum.COLLECTION:
                  (n = t.total_collection),
                    (i = a.a.search.searchPanelCollection
                      ? a.a.search.searchPanelCollection
                      : r);
                  break;
                case l.Enum.PAGE:
                  (n = t.total_page),
                    (i = a.a.search.searchPanelPage
                      ? a.a.search.searchPanelPage
                      : r);
                  break;
                default:
                  (n = t.total_product),
                    (i = a.a.search.searchPanelProduct
                      ? a.a.search.searchPanelProduct
                      : r);
              }
              (this.eventType = e),
                (this.totalResult = n),
                (this.data.label = i),
                this.type == l.Enum.PRODUCT &&
                  (this.page = s.a.queryParams.page);
            },
          },
          {
            key: "_onClickPanelItem",
            value: function (t) {
              t.preventDefault(),
                (s.a.searchDisplay = this.type),
                K.default.setParam("limit", this.limit),
                K.default.setParam("page", this.page);
              var e = this.parent,
                n = e.parent.searchResultTotal;
              switch (
                (this.isRenderPanelContent ||
                  this.type === l.Enum.PRODUCT ||
                  K.default.getFilterData(
                    "search",
                    this._searchPanelCallback.bind(this)
                  ),
                this.$element.addClass("boost-active"),
                this.$element.siblings().removeClass("boost-active"),
                this.type)
              ) {
                case l.Enum.COLLECTION:
                  e.showPanelCollection();
                  break;
                case l.Enum.PAGE:
                  e.showPanelPage();
                  break;
                default:
                  e.showPanelProduct();
              }
              n.setData(this.totalResult, this.type),
                n.refresh(),
                (this.isRenderPanelContent = !0);
            },
          },
          {
            key: "_searchPanelCallback",
            value: function (t) {
              var e = this.parent.parent.collectionList,
                n = this.parent.parent.collectionListPagination,
                i =
                  !!t.hasOwnProperty("total_collection") && t.total_collection;
              s.a.searchDisplay === l.Enum.PAGE &&
                ((e = this.parent.parent.pageList),
                (n = this.parent.parent.pageListPagination),
                (i = !!t.hasOwnProperty("total_page") && t.total_page)),
                e.setData(t),
                e.refresh(),
                n.setData(t, i, this.limit, this.page),
                n.refresh();
            },
          },
        ]),
        Q(e.prototype, n),
        i && Q(e, i),
        l
      );
    })(g.a);
    function te(t) {
      return (te =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function tn(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ti(t, e) {
      return (ti =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function tr(t, e) {
      return e && ("object" === te(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function to(t) {
      return (to = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ta = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && ti(t, e);
      })(s, t);
      var e,
        n,
        i,
        a = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = to(t);
            if (e()) {
              var r = to(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return tr(this, n);
          };
        })(s);
      function s() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, s),
          ((t = a.call(this)).data = null),
          (t.totalProduct = null),
          (t.paginationType = ""),
          (t.$loadMore = r()(l.a.loadMore)),
          (t.settings = {
            limit: o.a.getSettingValue("general.limit"),
            showLoading: o.a.getSettingValue("general.showLoading"),
            showLoadMoreLoading: o.a.getSettingValue(
              "general.showLoadMoreLoading"
            ),
          }),
          (t.settings.limit <= 0 || t.settings.limit > 70) &&
            (t.settings.limit = 24),
          t
        );
      }
      return (
        (e = s),
        (i = [
          {
            key: "Type",
            get: function () {
              return {
                DEFAULT: "default",
                LOAD_MORE: "load_more",
                INFINITE: "infinite",
              };
            },
          },
        ]),
        (n = [
          {
            key: "isRender",
            value: function () {
              return null !== this.data;
            },
          },
          {
            key: "setData",
            value: function (t) {
              t && (this.data = t),
                (this.totalProduct = this.parent.totalProduct),
                (this.paginationType = o.a.getSettingValue(
                  "general.paginationType"
                ));
            },
          },
          {
            key: "showLoading",
            value: function () {
              this.settings.showLoadMoreLoading &&
                !1 === this.settings.showLoading &&
                this.$loadMore.find(l.a.loadMoreLoading).show();
            },
          },
          {
            key: "hideLoading",
            value: function () {
              this.settings.showLoadMoreLoading &&
                this.$loadMore.find(l.a.loadMoreLoading).hide();
            },
          },
        ]),
        tn(e.prototype, n),
        i && tn(e, i),
        s
      );
    })(g.a);
    function ts(t) {
      return (ts =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function tl(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function tc(t, e) {
      return (tc =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function tu(t, e) {
      return e && ("object" === ts(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function tp(t) {
      return (tp = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var tf = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && tc(t, e);
      })(p, t);
      var e,
        n,
        i,
        c = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = tp(t);
            if (e()) {
              var r = tp(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return tu(this, n);
          };
        })(p);
      function p() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, p),
          ((t = c.call(this)).data = null),
          (t.totalProduct = null),
          (t.$element = r()(l.a.products)),
          (t.settings = {
            loadProductFromLiquid: o.a.getSettingValue(
              "general.loadProductFromLiquid"
            ),
            loadProductFromLiquidType: o.a.getSettingValue(
              "general.loadProductFromLiquidType"
            ),
            sessionStoragePreviousPageEvent: o.a.getSettingValue(
              "general.sessionStoragePreviousPageEvent"
            ),
            themeId: o.a.getSettingValue("general.theme_id"),
            productAndVariantAvailable: o.a.getSettingValue(
              "general.productAndVariantAvailable"
            ),
            sortingAvailableFirst: o.a.getSettingValue(
              "general.sortingAvailableFirst"
            ),
            enableKeepScrollbackPosition: o.a.getSettingValue(
              "general.enableKeepScrollbackPosition"
            ),
            keepScrollbackPositionType: o.a.getSettingValue(
              "general.keepScrollbackPositionType"
            ),
            sessionStorageScrollbackPosition: o.a.getSettingValue(
              "general.sessionStorageScrollbackPosition"
            ),
          }),
          t
        );
      }
      return (
        (e = p),
        (i = [
          {
            key: "Enum",
            get: function () {
              return {
                itemStyle: { GRID: "grid", LIST: "list", COLLAGE: "collage" },
                loadProductType: { JS: "js", AJAX: "ajax", SYNC: "sync" },
              };
            },
          },
        ]),
        (n = [
          {
            key: "isRender",
            value: function () {
              var t = u.a.getDefaultSorting();
              return (
                null != this.data &&
                z.isPanelActive(tt.Enum.PRODUCT) &&
                (!s.a.loadProductFirst ||
                  !u.a.isCollectionPage() ||
                  u.a.isVendorPage() ||
                  u.a.isTagPage() ||
                  u.a.isTypePage() ||
                  ("" != t &&
                    t != o.a.getSettingValue("general.default_sort_by")) ||
                  ("best-selling" === s.a.defaultSorting &&
                    !o.a.getSettingValue(
                      "general.loadProductFirstBestSelling"
                    )) ||
                  s.a.defaultSorting.startsWith("extra") ||
                  this.settings.productAndVariantAvailable ||
                  this.settings.sortingAvailableFirst ||
                  s.a.hasFilterByLocation ||
                  (s.a.loadProductFirst &&
                    (s.a.hasFilterOptionParam || "init" != this.eventType)) ||
                  o.a.getSettingValue("general.enableVariantsDisplay"))
              );
            },
          },
          {
            key: "getNoResultTemplate",
            value: function () {
              return '\n			<div class="boost-pfs-filter-message"><p><em>{{content}}</em></p></div>\n		'.trim();
            },
          },
          {
            key: "getNoResultSearchTemplate",
            value: function () {
              return '\n			<div class="boost-pfs-filter-message result-empty-search">\n				<p>{{content}}</p>\n				<p><a href="{{link}}">{{label.seeAllProducts}}</a></p>\n			</div>\n		'.trim();
            },
          },
          {
            key: "render",
            value: function () {
              this._catchError(),
                this.totalProduct > 0 &&
                  ("incollection_search" === s.a.queryParams.event_type &&
                    u.a.showFilterTree(),
                  this.settings.loadProductFromLiquid
                    ? this.buildProductListDataFromLiquid()
                    : this.buildProductList()),
                o.a.getSettingValue("mostPopular.mostPopularEnable") &&
                  r()(l.a.mostPopular).length > 0 &&
                  new MostPopular().refresh();
            },
          },
          {
            key: "bindEvents",
            value: function () {
              var t = u.a.isSearchPage() || u.a.isCollectionPage(),
                e =
                  u.a.isiOS() &&
                  o.a.getSettingValue("general.paginationType") ==
                    ta.Type.DEFAULT;
              t &&
                !e &&
                this.settings.enableKeepScrollbackPosition &&
                this._bindKeepScrollbackPositionEvent();
            },
          },
          {
            key: "setData",
            value: function (t) {
              var e = this;
              if (
                ((this.data = t),
                (this.totalProduct = this.parent.totalProduct),
                this.prepareProductData(),
                (this.eventType = this.parent.eventType),
                (this.eventInfo = this.parent.eventInfo),
                (this.children = []),
                (this.productItems = []),
                (this.ajaxPage = 0),
                this.totalProduct > 0)
              ) {
                var n = this._getProductItemClass();
                t.forEach(function (t, i) {
                  var r = new n();
                  e.addComponent(r), r.setData(t, i), e.productItems.push(r);
                });
              }
            },
          },
          {
            key: "_getProductItemClass",
            value: function () {
              switch (s.a.queryParams.display) {
                case p.Enum.itemStyle.LIST:
                  return B;
                case p.Enum.itemStyle.COLLAGE:
                  return H;
                default:
                  return w;
              }
            },
          },
          {
            key: "buildProductListDataFromLiquid",
            value: function () {
              u.a.isDefaultPaginationType() ||
                "page" != this.eventType ||
                r()(window).off("scroll"),
                this.settings.loadProductFromLiquidType ==
                p.Enum.loadProductType.SYNC
                  ? this._getProductListHtmlBySync()
                  : this._getProductListHtmlByAjax();
            },
          },
          {
            key: "prepareProductData",
            value: function () {
              var t = this,
                e = this.data;
              return Array.isArray(e)
                ? (e.forEach(function (e) {
                    var n = [];
                    e.options_with_values.forEach(function (t) {
                      n.push(t.name);
                    }),
                      (e.options = n);
                    var i = !0;
                    if (e.variants && e.variants.length > 0) {
                      var r = e.variants[0];
                      r.hasOwnProperty("fulfillment_service") &&
                        "gift_card" == r.fulfillment_service &&
                        (i = !1);
                    }
                    u.a.isEnableShopifyMultipleCurrencies() &&
                      (u.a.isConvertCurrenciesOnFrontEnd()
                        ? ((e.price_min = u.a.convertPriceBasedOnActiveCurrency(
                            e.price_min,
                            i
                          )),
                          (e.price_max = u.a.convertPriceBasedOnActiveCurrency(
                            e.price_max,
                            i
                          )),
                          (e.compare_at_price_min =
                            u.a.convertPriceBasedOnActiveCurrency(
                              e.compare_at_price_min,
                              i
                            )),
                          (e.compare_at_price_max =
                            u.a.convertPriceBasedOnActiveCurrency(
                              e.compare_at_price_max,
                              i
                            )))
                        : u.a.convertPriceBasedOnPresentmentPrice(e)),
                      e.variants.forEach(function (t) {
                        var e = [],
                          n = t.merged_options;
                        if (Array.isArray(n)) {
                          for (var r = 0; r < n.length; r++) {
                            var o = n[r].split(":");
                            (t["option" + (parseInt(r) + 1)] = o[1]),
                              (t["option_" + o[0]] = o[1]),
                              e.push(o[1]);
                          }
                          t.options = e;
                        }
                        if (null != t.compare_at_price) {
                          var a = parseFloat(t.compare_at_price);
                          (a = u.a.convertPriceBasedOnActiveCurrency(a, i)),
                            (t.compare_at_price = a);
                        }
                        var s = parseFloat(t.price);
                        (s = u.a.convertPriceBasedOnActiveCurrency(s, i)),
                          (t.price = s);
                      }),
                      (e.description = e.body_html),
                      (e.featured_image =
                        Array.isArray(e.images) && e.images.length > 0
                          ? e.images[0]
                          : boostPFSConfig.general.no_image_url),
                      (e = t.showVariantImageBasedOnSelectedFilter(e));
                  }),
                  e)
                : [];
            },
          },
          {
            key: "showVariantImageBasedOnSelectedFilter",
            value: function (t) {
              var e = o.a.getSettingValue(
                "general.showVariantImageBasedOnSelectedFilter"
              );
              if (
                e &&
                "string" == typeof e &&
                Array.isArray(t.variants) &&
                t.variants.length > 1 &&
                s.a.queryParams &&
                Array.isArray(s.a.queryParams[e]) &&
                s.a.queryParams[e].length > 0
              )
                for (var n = s.a.queryParams[e], i = 0; i < n.length; i++) {
                  for (
                    var r = !1,
                      a = e.replace(s.a.prefix + "_opt_", "") + ":" + n[i],
                      l = 0;
                    l < t.variants.length;
                    l++
                  ) {
                    var c = t.variants[l];
                    if (
                      (r =
                        Array.isArray(c.merged_options) &&
                        c.merged_options.includes(a) &&
                        c.image)
                    ) {
                      (t.featured_image = c.image),
                        Array.isArray(t.images_info) &&
                          t.images_info.sort(function (t, e) {
                            return e.src == c.image ? 1 : -1;
                          }),
                        Array.isArray(t.images) &&
                          t.images.sort(function (t, e) {
                            return e == c.image ? 1 : -1;
                          });
                      break;
                    }
                  }
                  if (r) break;
                }
              return t;
            },
          },
          {
            key: "buildProductList",
            value: function () {
              var t = this,
                e = [];
              if (
                (this.productItems.forEach(function (t) {
                  e.push(t.$element);
                }),
                this.$element.removeAttr("data-boost-sort"),
                (u.a.isDefaultPaginationType() ||
                  (!u.a.isDefaultPaginationType() &&
                    "page" != this.eventType)) &&
                  (this.$element.html(""), r()(window).off("scroll")),
                u.a.isLoadPreviousPagePaginationType() &&
                  parseInt(
                    window.sessionStorage.getItem(
                      this.settings.sessionStoragePreviousPageEvent
                    )
                  ))
              ) {
                var n = [];
                e.forEach(function (t) {
                  return n.push(t);
                }),
                  n.reverse(),
                  n.forEach(function (e) {
                    return t.$element.prepend(e);
                  });
              } else
                e.forEach(function (e) {
                  return t.$element.append(e);
                });
              y.a.call3rdAppFunction(this.data),
                y.a.call3rdIntegrationFunc(this.data),
                this.settings.loadProductFromLiquid &&
                  this.settings.loadProductFromLiquidType ==
                    p.Enum.loadProductType.AJAX &&
                  this.afterRender();
            },
          },
          {
            key: "buildExtrasProductListByAjax",
            value: function (t, e, n, i, a, s) {
              a || (a = 0), s || (s = []), (!i || i > 20) && (i = 20);
              for (
                var l = i * a,
                  c = Math.min(t.length, i * (a + 1)),
                  u = [],
                  p = l;
                p < c;
                p++
              )
                u.push(t[p].handle);
              var f = u.join("+"),
                h = window.location.pathname.split("/"),
                d = "",
                g = Shopify && Shopify.routes && void 0 !== Shopify.routes.root;
              o.a.getSettingValue(
                "general.useShopifyRouteForMultiLanguageURL"
              ) && g
                ? (d = Shopify.routes.root.replace(/\/$/, ""))
                : h.indexOf(boostPFSAppConfig.general.current_locale) > -1 &&
                  (d = "/" + boostPFSAppConfig.general.current_locale);
              var y = d + "/collections/all/" + f + "?view=" + e;
              r.a.ajax({
                type: "GET",
                url: y,
                success: function (r) {
                  this._onExtraProductListAjaxSuccess(t, e, n, i, a, r, s);
                }.bind(this),
              });
            },
          },
          {
            key: "_getProductListHtmlByAjax",
            value: function () {
              (this.isFetchedAjaxProductData = !1),
                this.$element.addClass(N.a.productWrapLoading);
              for (
                var t = 20 * this.ajaxPage,
                  e = Math.min(this.data.length, 20 * (this.ajaxPage + 1)),
                  n = [],
                  i = t;
                i < e;
                i++
              )
                n.push(this.data[i].handle);
              var o = n.join("+");
              r.a.ajax({
                type: "GET",
                url: "/collections/all/" + o + "?view=boost-pfs-product-item",
                success: this._onProductListAjaxSuccess.bind(this),
              });
            },
          },
          {
            key: "_getProductListHtmlBySync",
            value: function () {
              var t = this.settings.themeId,
                e = !1;
              this.productItems.forEach(function (n, i) {
                e ||
                  (n.data.html &&
                  n.data.html.value &&
                  t &&
                  t == n.data.html.theme_id
                    ? ((n.data.html = n.data.html.value), n.refresh())
                    : (e = !0));
              }),
                e ? this._getProductListHtmlByAjax() : this.buildProductList();
            },
          },
          {
            key: "_onProductListAjaxSuccess",
            value: function (t) {
              var e = this,
                n = [];
              try {
                /<\!--.*?-->/.test(t) && (t = t.replace(/<\!--.*?-->/g, "")),
                  (n = JSON.parse(t).products);
              } catch (i) {
                return void console.warn(
                  "Could not parse json from collection.boost-pfs-product-item.liquid"
                );
              }
              n.forEach(function (t) {
                e.data.forEach(function (e, n) {
                  e.id == t.id && (e.html = t.html.value);
                });
              });
              for (var r = 20 * this.ajaxPage, o = r; o < r + n.length; o++)
                this.productItems.forEach(function (t) {
                  t.id == e.data[o].id
                    ? (t.setData(e.data[o]), t.refresh())
                    : e.productItems.forEach(function (t) {
                        t.bindEvents();
                      });
                });
              0 == this.ajaxPage &&
                (u.a.isDefaultPaginationType() || "page" !== this.eventType) &&
                this.$element.html(""),
                this.buildProductList(),
                20 * (this.ajaxPage + 1) < this.data.length
                  ? (this.ajaxPage++, this._getProductListHtmlByAjax())
                  : ((this.isFetchedAjaxProductData = !0),
                    this.parent.pagination.refresh(),
                    this.parent.productPlaceholder.refresh(),
                    this.$element.removeClass(N.a.productWrapLoading));
            },
          },
          {
            key: "_onExtraProductListAjaxSuccess",
            value: function (t, e, n, i, r, o, a) {
              try {
                /<\!--.*?-->/.test(o) && (o = o.replace(/<\!--.*?-->/g, "")),
                  (a = a.concat(JSON.parse(o).products));
              } catch (s) {
                console.warn(
                  "Could not parse json from " + e + ": " + s.message
                );
              }
              i * r < t.length - 1
                ? (r++, this.buildExtrasProductListByAjax(t, e, n, i, r, a))
                : "function" == typeof n && n(a);
            },
          },
          {
            key: "_bindKeepScrollbackPositionEvent",
            value: function () {
              if ("init" == this.eventType || "history" == this.eventType) {
                history.scrollRestoration = "manual";
                var t =
                  "sessionStorage" == this.settings.keepScrollbackPositionType
                    ? this._getScrollDataFromSessionStorage()
                    : this._getScrollDataFromHistory();
                t &&
                  (this.parent._changeProductListGobackPreviousPositionStatus(
                    !0
                  ),
                  this._scrollBackToItem(t));
              }
            },
          },
          {
            key: "_getScrollDataFromSessionStorage",
            value: function () {
              var t = {};
              try {
                t = JSON.parse(
                  sessionStorage.getItem(
                    this.settings.sessionStorageScrollbackPosition
                  )
                );
              } catch (e) {}
              return (
                "object" != ts(t) && (t = {}),
                sessionStorage.removeItem(
                  this.settings.sessionStorageScrollbackPosition
                ),
                t
              );
            },
          },
          {
            key: "_getScrollDataFromHistory",
            value: function () {
              var t = null;
              if (history && history.state && history.state.productId) {
                t = history.state;
                var e = new URL(u.a.getWindowLocation().href);
                setTimeout(function () {
                  window.history.replaceState(
                    "",
                    document.title,
                    e.toString().replace(/\+/g, "%20")
                  );
                }, 500);
              }
              return t;
            },
          },
          {
            key: "_scrollBackToItem",
            value: function (t) {
              if (t && t.page && t.productId && t.position && t.url) {
                var e,
                  n,
                  i = JSON.parse(JSON.stringify(s.a.queryParams)),
                  r =
                    "string" == typeof t.url && 2 == t.url.split("?").length
                      ? t.url.split("?")[1]
                      : "",
                  a = new URLSearchParams(r).get("page");
                a && (i.page = a);
                var l = Navigation.buildAddressBarUrl(i);
                return (
                  o.a.getSettingValue("general.paginationType"),
                  ((e = this.$element
                    .find('[data-id="' + t.productId + '"]')
                    .first()).length &&
                    l == t.url) ||
                    console.log(n),
                  void n?.parent?._changeProductListGobackPreviousPositionStatus(!1)
                );
              }
            },
          },
          {
            key: "_catchError",
            value: function () {
              if (u.a.isNoFilterResult(this.totalProduct, this.eventType)) {
                var t = a.a.error.noProducts,
                  e = "";
                u.a.checkExistFilterOptionParam()
                  ? ((t = a.a.error.noFilterResult),
                    (e = this.getNoResultTemplate().replace(/{{content}}/g, t)))
                  : u.a.isSearchPage()
                  ? ((t = a.a.search.resultEmpty
                      .replace(
                        /{{ terms }}/g,
                        "<strong>" +
                          u.a.stripHtml(s.a.queryParams.q) +
                          "</strong>"
                      )
                      .replace(/{{ breakline }}/g, "<br />")),
                    (e = this.getNoResultSearchTemplate()
                      .replace(/{{content}}/g, t)
                      .replace(/{{link}}/g, "/collections/all")
                      .replace(
                        /{{label.seeAllProducts}}/g,
                        a.a.search.seeAllProducts
                      )))
                  : s.a.queryParams.incollection_search
                  ? ((t = a.a.error.noFilterResult),
                    (e = this.getNoResultTemplate().replace(/{{content}}/g, t)),
                    u.a.hideFilterTree())
                  : ((t = a.a.error.noFilterResult),
                    (e = this.getNoResultTemplate().replace(
                      /{{content}}/g,
                      t
                    ))),
                  "" != e && this.$element.html(e);
              }
            },
          },
        ]),
        tl(e.prototype, n),
        i && tl(e, i),
        p
      );
    })(g.a);
    function th(t) {
      return (th =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function td(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function tg(t, e) {
      return (tg =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function ty(t, e) {
      return e && ("object" === th(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function tm(t) {
      return (tm = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var tv = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && tg(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = tm(t);
            if (e()) {
              var r = tm(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return ty(this, n);
          };
        })(a);
      function a() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          ((t = o.call(this)).$element = r()(l.a.pagination)),
          (t.$buttomElement = r()(l.a.bottomPagination)),
          (t.$productList = r()(l.a.products)),
          t
        );
      }
      return (
        (e = a),
        (n = [
          {
            key: "compileTemplate",
            value: function () {
              return "";
            },
          },
          {
            key: "isRender",
            value: function () {
              return null !== this.data;
            },
          },
          {
            key: "render",
            value: function () {
              r()(l.a.pagination).html(this.compileTemplate());
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element.show(),
                this.$element.find("a").off("click"),
                this.$element
                  .find("a")
                  .on("click", this._onClickEvent.bind(this));
            },
          },
          {
            key: "_onClickEvent",
            value: function (t) {
              t.preventDefault(), (s.a.internalClick = !0);
              try {
                n = new URL(r()(t.currentTarget).attr("href"));
              } catch (e) {
                n = new URL(
                  "https://" +
                    boostPFSConfig.shop.domain +
                    r()(t.currentTarget).attr("href")
                );
              }
              var n,
                i = n && n.searchParams ? n.searchParams.get("page") : 1;
              (i && !isNaN(i)) || (i = 1),
                K.default.setParam("page", i),
                K.default.applyFilter("page"),
                window.scrollTo({
                  top: this.$productList.offset().top - 50,
                  behavior: "smooth",
                });
            },
          },
        ]),
        td(e.prototype, n),
        i && td(e, i),
        a
      );
    })(ta);
    function tb(t) {
      return (tb =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function tS(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function t$(t, e) {
      return (t$ =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function tT(t, e) {
      return e && ("object" === tb(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function tP(t) {
      return (tP = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var t_ = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && t$(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = tP(t);
            if (e()) {
              var r = tP(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return tT(this, n);
          };
        })(a);
      function a() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          ((t = o.call(this)).$element = r()(l.a.topDisplayType)),
          (t.selector = {
            productDisplayTypeItem: "." + N.a.productDisplayType + "-item",
            productDisplayTypeGrid: "." + N.a.productDisplayType + "-grid",
            productDisplayTypeList: "." + N.a.productDisplayType + "-list",
          }),
          t
        );
      }
      return (
        (e = a),
        (n = [
          { key: "compileTemplate", value: function () {} },
          {
            key: "render",
            value: function () {
              this.$element.html(this.compileTemplate()),
                this.$element.length &&
                  (this.$element
                    .find(this.selector.productDisplayTypeList)
                    .removeClass("active"),
                  this.$element
                    .find(this.selector.productDisplayTypeGrid)
                    .removeClass("active"),
                  "list" == s.a.queryParams.display
                    ? this.$element
                        .find(this.selector.productDisplayTypeList)
                        .addClass("active")
                    : "grid" == s.a.queryParams.display &&
                      this.$element
                        .find(this.selector.productDisplayTypeGrid)
                        .addClass("active"));
            },
          },
          {
            key: "bindEvents",
            value: function () {
              r()(l.a.topDisplayType + " a").on(
                "click",
                this._onClickEvent.bind(this)
              );
            },
          },
          {
            key: "_onClickEvent",
            value: function (t) {
              t.preventDefault(), (s.a.internalClick = !0);
              var e = r()(t.currentTarget);
              e.siblings().removeClass("active"), e.addClass("active");
              var n = u.a.stripHtml(e.data("display"));
              if (n) K.default.setParam("display", n);
              else {
                var i = window.location.href,
                  o = new URL(i);
                if (((o = o.hostname), -1 !== e.attr("href").indexOf(o)))
                  var a = new URL(e.attr("href"));
                else a = new URL("https://" + o + e.attr("href"));
                (n = u.a.stripHtml(a.searchParams.get("display"))) &&
                  K.default.setParam("display", n);
              }
              K.default.applyFilter("display");
            },
          },
        ]),
        tS(e.prototype, n),
        i && tS(e, i),
        a
      );
    })(g.a);
    function t8(t) {
      return (t8 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function tk(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function tO(t, e) {
      return (tO =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function tC(t, e) {
      return e && ("object" === t8(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function tw(t) {
      return (tw = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var tI = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && tO(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = tw(t);
            if (e()) {
              var r = tw(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return tC(this, n);
          };
        })(a);
      function a() {
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          o.call(this)
        );
      }
      return (
        (e = a),
        (n = [
          { key: "compileTemplate", value: function () {} },
          {
            key: "render",
            value: function () {
              r()(l.a.topSorting).html(this.compileTemplate());
              var t = r()(l.a.topSorting + " select");
              t.length && t.val(u.a.stripHtml(s.a.queryParams.sort));
            },
          },
          {
            key: "bindEvents",
            value: function () {
              r()(l.a.topSorting + " select").change(function (t) {
                K.default.setParam("sort", u.a.stripHtml(r()(this).val())),
                  K.default.setParam("page", 1),
                  K.default.applyFilter("sort");
              });
            },
          },
        ]),
        tk(e.prototype, n),
        i && tk(e, i),
        a
      );
    })(g.a);
    function tE(t) {
      return (tE =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function t0(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function tL(t, e) {
      return (tL =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function tA(t, e) {
      return e && ("object" === tE(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function tx(t) {
      return (tx = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var tB = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && tL(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = tx(t);
            if (e()) {
              var r = tx(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return tA(this, n);
          };
        })(a);
      function a() {
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          o.call(this)
        );
      }
      return (
        (e = a),
        (n = [
          { key: "compileTemplate", value: function () {} },
          {
            key: "render",
            value: function () {
              r()(l.a.topShowLimit).html(this.compileTemplate());
              var t = r()(l.a.topShowLimit + " select");
              t.length && t.val(u.a.stripHtml(Globals.queryParams.limit));
            },
          },
          {
            key: "bindEvents",
            value: function () {
              r()(l.a.topShowLimit + " select").change(function (t) {
                K.default.setParam("limit", u.a.stripHtml(r()(this).val())),
                  K.default.setParam("page", 1),
                  K.default.applyFilter();
              });
            },
          },
        ]),
        t0(e.prototype, n),
        i && t0(e, i),
        a
      );
    })(g.a);
    function tR(t) {
      return (tR =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function t9(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function tF(t, e) {
      return (tF =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function t2(t, e) {
      return e && ("object" === tR(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function t1(t) {
      return (t1 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var tV = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && tF(t, e);
      })(p, t);
      var e,
        n,
        i,
        c = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = t1(t);
            if (e()) {
              var r = t1(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return t2(this, n);
          };
        })(p);
      function p() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, p),
          ((t = c.call(this)).searchValue = ""),
          (t.selector = {
            clearButton: ".boost-pfs-in-collection-search-clear",
            searchInput: ".boost-pfs-in-collection-search-input",
            searchWrapper: ".boost-pfs-in-collection-search-wrapper",
          }),
          t
        );
      }
      return (
        (e = p),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n        <div class="boost-pfs-in-collection-search-wrapper">\n            <input aria-label="{{placeholder}}" class="boost-pfs-in-collection-search-input" type="text" placeholder="{{placeholder}}">\n                <button type="button" class="boost-pfs-in-collection-search-clear">\n                    <svg aria-hidden="true" width="15" height="16" viewBox="0 0 20 20">\n                        <path d="M11.414 10l6.293-6.293a1 1 0 10-1.414-1.414L10 8.586 3.707 2.293a1 1 0 00-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 101.414 1.414L10 11.414l6.293 6.293A.998.998 0 0018 17a.999.999 0 00-.293-.707L11.414 10z" fill="#222222"></path>\n                    </svg>\n                </button>\n                <button type="button" class="boost-pfs-in-collection-search-button">\n                    <svg aria-hidden="true" width="15" height="16" viewBox="0 0 15 16" fill="none">\n                        <path d="M14.4323 14.4001L10.4594 10.4801C12.1215 8.32012 11.9188 5.20012 9.93233 3.24012C7.74314 1.08012 4.17558 1.08012 1.94585 3.24012C-0.243342 5.40012 -0.243342 8.92012 1.94585 11.1201C2.9999 12.1601 4.41882 12.7601 5.91882 12.7601C7.13504 12.7601 8.31071 12.3601 9.28368 11.6401L13.2567 15.5601C13.4188 15.7201 13.6215 15.8001 13.8242 15.8001C14.0269 15.8001 14.2296 15.7201 14.3918 15.5601C14.7567 15.2001 14.7567 14.7201 14.4323 14.4001ZM5.95936 11.1201C4.90531 11.1201 3.89179 10.7201 3.12152 9.96012C1.54044 8.40012 1.54044 5.92012 3.12152 4.36012C3.89179 3.60012 4.94585 3.20012 5.95936 3.20012C6.97287 3.20012 8.02693 3.60012 8.7972 4.36012C10.3783 5.92012 10.3783 8.40012 8.7972 9.96012C8.02693 10.7201 7.01341 11.1201 5.95936 11.1201Z" fill="#222222"/>\n                    </svg>	\n                </button>\n        </div>\n        '.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t = a.a.inCollectionSearch;
              return this.getTemplate().replace(/{{placeholder}}/g, t);
            },
          },
          {
            key: "isRender",
            value: function () {
              return (
                o.a.getSettingValue("general.enableCollectionSearch") &&
                u.a.isCollectionPage()
              );
            },
          },
          {
            key: "render",
            value: function () {
              if (!r()(this.selector.searchWrapper).length) {
                l.a.inCollectionSearch &&
                  r()(l.a.inCollectionSearch).length > 0 &&
                  r()(l.a.inCollectionSearch).html(this.compileTemplate());
                var t = r()(this.selector.searchInput);
                t.length &&
                  (t.val(u.a.stripHtml(s.a.queryParams.q) || ""),
                  (this.searchValue = u.a.stripHtml(s.a.queryParams.q) || ""),
                  this.searchValue && r()(this.selector.clearButton).show());
              }
            },
          },
          {
            key: "bindEvents",
            value: function () {
              r()(this.selector.searchInput).off("input"),
                r()(this.selector.clearButton).off("click"),
                r()(this.selector.searchInput).on(
                  "input",
                  u.a.debounce(this.onTypeInCollectionSearch.bind(this), 300)
                ),
                r()(this.selector.clearButton).on(
                  "click",
                  this.onClickClearButton.bind(this)
                );
            },
          },
          {
            key: "onTypeInCollectionSearch",
            value: function (t) {
              this.setSearchValue(t),
                this.searchValue
                  ? r()(this.selector.clearButton).show()
                  : r()(this.selector.clearButton).hide(),
                this.applyApi();
            },
          },
          {
            key: "setSearchValue",
            value: function (t) {
              if (t && t.target) {
                var e = u.a.stripHtml(t.target.value);
                (e =
                  "function" == typeof e.toString
                    ? e.toLowerCase().trim()
                    : ""),
                  (this.searchValue = e);
              } else this.searchValue = "";
            },
          },
          {
            key: "onClickClearButton",
            value: function () {
              r()(this.selector.searchInput).val(""),
                (this.searchValue = ""),
                r()(this.selector.clearButton).hide(),
                this.applyApi(),
                this.afterClear();
            },
          },
          { key: "afterClear", value: function () {} },
          {
            key: "applyApi",
            value: function () {
              K.default.setParam("q", this.searchValue),
                K.default.setParam("page", 1),
                K.default.applyFilter("incollection_search");
            },
          },
        ]),
        t9(e.prototype, n),
        i && t9(e, i),
        p
      );
    })(g.a);
    function tD(t) {
      return (tD =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function tM(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function t4(t, e) {
      return (t4 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function t3(t, e) {
      return e && ("object" === tD(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function t6(t) {
      return (t6 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var t5 = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && t4(t, e);
      })(c, t);
      var e,
        n,
        i,
        l = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = t6(t);
            if (e()) {
              var r = t6(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return t3(this, n);
          };
        })(c);
      function c() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, c),
          ((t = l.call(this)).data = null),
          (s.a.currentTerm = u.a.stripHtml(u.a.getSearchTerm())),
          (t.$searchResultHeader = r()("." + N.a.searchResultHeader)),
          (t.$searchResultNumber = r()("." + N.a.searchResultNumber)),
          t
        );
      }
      return (
        (e = c),
        (n = [
          {
            key: "init",
            value: function () {
              s.a.currentTerm &&
                (this.searchTerm = u.a.stripHtml(s.a.currentTerm.trim()));
            },
          },
          {
            key: "compileSEOTitleTemplate",
            value: function () {
              var t =
                this.data.total_product <= 1
                  ? a.a.search.seoTitleOne
                  : a.a.search.seoTitleOther;
              return (
                t &&
                  (t = t
                    .replace(
                      /{{ count }}/g,
                      u.a.stripHtml(this.data.total_product)
                    )
                    .replace(/{{ terms }}/g, u.a.stripHtml(this.searchTerm))),
                t
              );
            },
          },
          {
            key: "compileSearchResultHeader",
            value: function () {
              if (this.searchTerm) var t = a.a.search.resultHeader;
              else t = a.a.search.generalTitle;
              return t.replace(/{{ terms }}/g, u.a.stripHtml(this.searchTerm));
            },
          },
          {
            key: "compileSearchResultNumber",
            value: function () {
              var t = "";
              return (
                this.searchTerm && (t = a.a.search.resultNumber),
                t
                  .replace(
                    /{{ count }}/g,
                    "<strong>" +
                      u.a.stripHtml(this.data.total_product) +
                      "</strong>"
                  )
                  .replace(
                    /{{ terms }}/g,
                    "<strong>" + u.a.stripHtml(this.searchTerm) + "</strong>"
                  )
              );
            },
          },
          {
            key: "isRender",
            value: function () {
              return !!this.data;
            },
          },
          {
            key: "render",
            value: function () {
              this._buildSEOTitle(),
                this._buildSearchResultHeader(),
                this._buildSearchResultNumber();
            },
          },
          {
            key: "setData",
            value: function (t) {
              t && (this.data = t);
            },
          },
          {
            key: "_buildSEOTitle",
            value: function () {
              if (this.searchTerm && "" !== this.searchTerm) {
                var t = o.a.getSettingValue("search.enableFixHeadTitle"),
                  e = this.compileSEOTitleTemplate();
                document.title =
                  t && e
                    ? e.replace(/&quot;/g, '"')
                    : document.title.replace(
                        /[0-9]+/,
                        u.a.stripHtml(this.data.total_product)
                      );
              }
            },
          },
          {
            key: "_buildSearchResultHeader",
            value: function () {
              var t = this.compileSearchResultHeader();
              this.$searchResultHeader.html(t);
            },
          },
          {
            key: "_buildSearchResultNumber",
            value: function () {
              var t = this.compileSearchResultNumber();
              this.$searchResultNumber.html(t);
            },
          },
        ]),
        tM(e.prototype, n),
        i && tM(e, i),
        c
      );
    })(g.a);
    function tH(t) {
      return (tH =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function t7(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function tN(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function tU(t, e) {
      return (tU =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function tW(t, e) {
      return e && ("object" === tH(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function tj(t) {
      return (tj = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var tq = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && tU(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = tj(t);
            if (e()) {
              var r = tj(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return tW(this, n);
          };
        })(a);
      function a() {
        return t7(this, a), o.apply(this, arguments);
      }
      return (
        (e = a),
        (n = [
          {
            key: "compileTemplate",
            value: function () {
              return "";
            },
          },
          {
            key: "buildBreadcrumb",
            value: function () {
              if (
                ((this.collectionData = this.parent.collectionData),
                this.collectionData && this.collectionData.collection)
              ) {
                var t = r()(l.a.breadcrumb);
                t.length && t.html(this.compileTemplate());
              }
            },
          },
        ]),
        tN(e.prototype, n),
        i && tN(e, i),
        a
      );
    })(g.a);
    function tG(t) {
      return (tG =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function tz(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function tK(t, e) {
      return (tK =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function tY(t, e) {
      return e && ("object" === tG(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function tQ(t) {
      return (tQ = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var tX = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && tK(t, e);
      })(c, t);
      var e,
        n,
        i,
        l = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = tQ(t);
            if (e()) {
              var r = tQ(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return tY(this, n);
          };
        })(c);
      function c() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, c),
          ((t = l.call(this)).data = null),
          (t.defaultCollectionData = {
            collection: {
              description: "",
              handle: o.a.getSettingValue("general.collection_handle"),
              title: a.a.collectionAll,
            },
          }),
          (t.collectionData = {}),
          (t.$collectionHeader = r()("." + N.a.collectionHeader)),
          (t.$collectionDescription = r()("." + N.a.collectionDescription)),
          (t.$collectionImage = r()("." + N.a.collectionImage)),
          t
        );
      }
      return (
        (e = c),
        (n = [
          {
            key: "init",
            value: function () {
              (this.breadcrumb = new tq()), this.addComponent(this.breadcrumb);
            },
          },
          {
            key: "isRender",
            value: function () {
              return (
                !!this.data &&
                ("collection" == this.parent.eventType ||
                  "history" == this.parent.eventType)
              );
            },
          },
          {
            key: "render",
            value: function () {
              var t = window.location.pathname;
              if (t && "/" != t) {
                if ("/collections/all" == t)
                  this.collectionData = this.defaultCollectionData;
                else if (u.a.isVendorPage() || u.a.isTypePage())
                  this.collectionData = {
                    collection: {
                      description: "",
                      handle: "",
                      title: u.a.stripHtml(u.a.getSearchTerm()),
                    },
                  };
                else if (!u.a.isSearchPage()) {
                  var e =
                    u.a.getWindowLocation().href.split("?")[0] + "?view=desc";
                  r.a.ajax({
                    method: "GET",
                    url: e,
                    dataType: "json",
                    success: this._onGetCollectionDataSuccess.bind(this),
                    error: this._onGetCollectionDataError.bind(this),
                  });
                }
                this._buildPageInfo();
              }
            },
          },
          {
            key: "setData",
            value: function (t) {
              t && (this.data = t);
            },
          },
          {
            key: "_buildPageInfo",
            value: function () {
              this.breadcrumb && this.breadcrumb.buildBreadcrumb(),
                this.buildCollectionDetail(),
                this.buildDocumentInfo();
            },
          },
          {
            key: "buildCollectionDetail",
            value: function () {
              if (
                void 0 !== this.collectionData &&
                this.collectionData.hasOwnProperty("collection")
              ) {
                var t = this.collectionData.collection,
                  e =
                    t.hasOwnProperty("title") && "" != t.title ? t.title : null,
                  n =
                    t.hasOwnProperty("description") && "" != t.description
                      ? t.description
                      : null,
                  i =
                    t.hasOwnProperty("image") && t.image && t.image.src
                      ? t.image.src
                      : null;
                e
                  ? this.$collectionHeader.html(u.a.stripHtml(e)).show()
                  : this.$collectionHeader.hide(),
                  n
                    ? this.$collectionDescription.html(n).show()
                    : this.$collectionDescription.hide(),
                  i && !u.a.isBadUrl(i)
                    ? this.$collectionImage
                        .attr("src", i)
                        .css("background-image", "url(" + i + ")")
                        .removeClass(N.a.collectionNoImage)
                        .addClass(N.a.collectionHasImage)
                    : this.$collectionImage
                        .attr(
                          "src",
                          "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                        )
                        .css("background-image", "none")
                        .removeClass(N.a.collectionHasImage)
                        .addClass(N.a.collectionNoImage);
              }
            },
          },
          {
            key: "buildDocumentInfo",
            value: function () {
              if (
                void 0 !== this.collectionData &&
                this.collectionData.hasOwnProperty("collection")
              ) {
                var t =
                  this.collectionData.collection.title + " - " + s.a.shopName;
                document.title = t;
              }
            },
          },
          {
            key: "_onGetCollectionDataSuccess",
            value: function (t) {
              (this.collectionData = t), this._buildPageInfo();
            },
          },
          {
            key: "_onGetCollectionDataError",
            value: function () {
              (this.collectionData = this.defaultCollectionData),
                this._buildPageInfo();
            },
          },
        ]),
        tz(e.prototype, n),
        i && tz(e, i),
        c
      );
    })(g.a);
    function tZ(t) {
      return (tZ =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function tJ(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function et(t, e) {
      return (et =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function ee(t, e) {
      return e && ("object" === tZ(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function en(t) {
      return (en = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ei = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && et(t, e);
      })(l, t);
      var e,
        n,
        i,
        a = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = en(t);
            if (e()) {
              var r = en(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return ee(this, n);
          };
        })(l);
      function l() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, l),
          ((t = a.call(this)).selecor = {
            robots: 'meta[content="noindex,nofollow,nosnippet"]',
          }),
          (t.currentCollection = boostPFSConfig.general.collection_handle),
          (t.settings = {
            boostCollection: o.a.getSettingValue("general.boostCollection"),
          }),
          t
        );
      }
      return (
        (e = l),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<meta name="robots" content="noindex,nofollow,nosnippet">\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate();
            },
          },
          {
            key: "isRender",
            value: function () {
              return (
                o.a.getSettingValue("general.enableSeo") &&
                !r()(this.selecor.robots).length &&
                (0 ==
                  this.currentCollection.indexOf(
                    this.settings.boostCollection
                  ) ||
                  u.a.checkExistFilterOptionParam() ||
                  (s.a.queryParams.q && !u.a.isSearchPage()))
              );
            },
          },
          {
            key: "render",
            value: function () {
              r()("head").append(this.compileTemplate());
            },
          },
        ]),
        tJ(e.prototype, n),
        i && tJ(e, i),
        l
      );
    })(g.a);
    function er(t) {
      return (er =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function eo(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ea(t, e) {
      return (ea =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function es(t, e) {
      return e && ("object" === er(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function el(t) {
      return (el = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ec = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && ea(t, e);
      })(p, t);
      var e,
        n,
        i,
        c = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = el(t);
            if (e()) {
              var r = el(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return es(this, n);
          };
        })(p);
      function p() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, p),
          ((t = c.call(this)).$loadMoreContainer = null),
          (t.$defaultElement = r()(l.a.pagination)),
          (t.$element = r()(l.a.loadMore)),
          (t.selector = {
            loadMoreButton: "." + N.a.productLoadMore + "-button",
            loadMoreTotal: l.a.loadMore + "-total",
          }),
          (t.settings.sessionStorageCurrentNextPage = o.a.getSettingValue(
            "general.sessionStorageCurrentNextPage"
          )),
          (t.settings.sessionStoragePreviousPageEvent = o.a.getSettingValue(
            "general.sessionStoragePreviousPageEvent"
          )),
          t
        );
      }
      return (
        (e = p),
        (n = [
          {
            key: "getTemplate",
            value: function (t) {
              return "total" === t
                ? '\n					<div class="{{class.productLoadMore}}-total">{{progressLabel}}</div>\n				'.trim()
                : '\n					{{loadMoreProgress}}\n					<div class="{{class.productLoadMore}}-button-container">\n						<button aria-label="{{label.loadMore}}" class="{{class.productLoadMore}}-button">{{label.loadMore}}</button>\n					</div>\n					<div class="{{class.productLoadMore}}-loading" style="display: none;">\n						<div class="{{class.productLoadMore}}-icon"></div>\n					</div>\n				'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t = this.compileTotalTemplate();
              (s.a.queryParams.page && !isNaN(s.a.queryParams.page)) ||
                (s.a.queryParams.page = 1);
              var e =
                this.totalProduct -
                s.a.queryParams.page * s.a.queryParams.limit;
              return (
                (e = Math.min(e, s.a.queryParams.limit)),
                this.getTemplate()
                  .replace(/{{loadMoreProgress}}/g, t)
                  .replace(/{{label.loadMore}}/g, a.a.loadMore)
                  .replace(/{{class.productLoadMore}}/g, N.a.productLoadMore)
                  .replace(/{{ amountProduct }}/g, e)
              );
            },
          },
          {
            key: "compileTotalTemplate",
            value: function () {
              (s.a.queryParams.page && !isNaN(s.a.queryParams.page)) ||
                (s.a.queryParams.page = 1),
                (s.a.queryParams.limit && !isNaN(s.a.queryParams.limit)) ||
                  (s.a.queryParams.limit = 20),
                u.a.isLoadPreviousPagePaginationType() &&
                "page" == this.parent.eventType
                  ? (this.nextPage = parseInt(
                      window.sessionStorage.getItem(
                        this.settings.sessionStorageCurrentNextPage
                      )
                    ))
                  : (this.nextPage = s.a.queryParams.page);
              var t = (this.nextPage - 1) * s.a.queryParams.limit + 1,
                e = r()(l.a.products + " > *:not(script):not(style)").length;
              e && (t -= e - s.a.queryParams.limit), (this.fromProduct = t);
              var n =
                (this.nextPage - 1) * s.a.queryParams.limit +
                1 +
                this.data.products.length -
                1;
              return (
                (this.toProduct = n),
                this.getTemplate("total")
                  .replace(/{{progressLabel}}/g, a.a.loadMoreTotal)
                  .replace(/{{ from }}/g, this.fromProduct)
                  .replace(/{{ to }}/g, this.toProduct)
                  .replace(/{{ total }}/g, this.totalProduct)
                  .replace(/{{class.productLoadMore}}/g, N.a.productLoadMore)
              );
            },
          },
          {
            key: "render",
            value: function () {
              this.$defaultElement.empty();
              var t = s.a.queryParams,
                e = this.compileTemplate();
              if (
                (this.$element.html(e),
                r()(l.a.loadMoreButtonContainer).length > 0)
              ) {
                var n = this.compileTotalTemplate();
                r()(this.selector.loadMoreTotal).replaceWith(n);
              }
              (this.$loadMoreContainer = r()(l.a.loadMoreButtonContainer)),
                this.hideLoading();
              var i = Math.ceil(this.totalProduct / t.limit);
              parseInt(t.page) < i && this.toProduct < this.totalProduct
                ? (this.$element.show(), this.$loadMoreContainer.show())
                : this.$element.hide();
            },
          },
          {
            key: "bindEvents",
            value: function () {
              u.a.isLoadPreviousPagePaginationType()
                ? (this.nextPage = parseInt(
                    window.sessionStorage.getItem(
                      this.settings.sessionStorageCurrentNextPage
                    )
                  ))
                : (this.nextPage = s.a.queryParams.page),
                this.$element
                  .find(this.selector.loadMoreButton)
                  .off("click")
                  .on("click", this._onClickEvent.bind(this));
            },
          },
          {
            key: "_onClickEvent",
            value: function (t) {
              if (
                (t.preventDefault(),
                this.$loadMoreContainer.hide(),
                this.showLoading(),
                this.nextPage++,
                (s.a.internalClick = !0),
                K.default.setParam("limit", s.a.queryParams.limit),
                K.default.setParam("page", this.nextPage),
                u.a.FilterResult.isAdvancedPaginationType())
              )
                u.a.isLoadPreviousPagePaginationType() &&
                  (window.sessionStorage.setItem(
                    this.settings.sessionStorageCurrentNextPage,
                    this.nextPage
                  ),
                  window.sessionStorage.setItem(
                    this.settings.sessionStoragePreviousPageEvent,
                    0
                  )),
                  K.default.applyFilter("page");
              else {
                var e = sz.instance.filter;
                K.default.getFilterData("page", e.setData.bind(e));
              }
            },
          },
        ]),
        eo(e.prototype, n),
        i && eo(e, i),
        p
      );
    })(ta);
    function eu(t) {
      return (eu =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function ep(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ef(t, e) {
      return (ef =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function eh(t, e) {
      return e && ("object" === eu(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function ed(t) {
      return (ed = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var eg = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && ef(t, e);
      })(c, t);
      var e,
        n,
        i,
        a = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = ed(t);
            if (e()) {
              var r = ed(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return eh(this, n);
          };
        })(c);
      function c() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, c),
          ((t = a.call(this)).$element = r()(l.a.bottomPagination)),
          (t.settings.positionShowInfiniteLoading = o.a.getSettingValue(
            "general.positionShowInfiniteLoading"
          )),
          (t.settings.sessionStorageCurrentNextPage = o.a.getSettingValue(
            "general.sessionStorageCurrentNextPage"
          )),
          (t.settings.sessionStoragePreviousPageEvent = o.a.getSettingValue(
            "general.sessionStoragePreviousPageEvent"
          )),
          t
        );
      }
      return (
        (e = c),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<div class="{{class.productLoadMore}}-loading" style="display: none;">\n				<div class="{{class.productLoadMore}}-icon"></div>\n			</div>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate().replace(
                /{{class.productLoadMore}}/g,
                N.a.productLoadMore
              );
            },
          },
          {
            key: "isRender",
            value: function () {
              return null !== this.data && z.isPanelActive(tt.Enum.PRODUCT);
            },
          },
          {
            key: "render",
            value: function () {
              if (
                (this.$element.empty(),
                this.$element.show(),
                0 == this.$loadMore.find(l.a.loadMoreLoading).length)
              ) {
                var t = this.compileTemplate();
                this.$loadMore.prepend(t), this.$loadMore.show();
              }
              this.hideLoading();
            },
          },
          {
            key: "bindEvents",
            value: function () {
              u.a.isLoadPreviousPagePaginationType()
                ? (this.nextPage = parseInt(
                    window.sessionStorage.getItem(
                      this.settings.sessionStorageCurrentNextPage
                    )
                  ))
                : (this.nextPage = s.a.queryParams.page),
                this.totalProduct > s.a.queryParams.limit * this.nextPage &&
                  ((this.scrolling = !1),
                  (this.scrollToBottom = !1),
                  this.$element.length > 0 &&
                    r()(window).on("scroll", this._onScrollEvent.bind(this)));
            },
          },
          {
            key: "_onScrollEvent",
            value: function (t) {
              if (
                (t.preventDefault(),
                t.stopPropagation(),
                r()(l.a.products).hasClass(N.a.productWrapLoading) ||
                  !z.isPanelActive(tt.Enum.PRODUCT))
              )
                return !1;
              this._isScrollToBottom() && this._loadMoreProducts();
            },
          },
          {
            key: "_isScrollToBottom",
            value: function () {
              var t =
                  window.innerHeight *
                  (window.innerHeight / r()(document).outerHeight()),
                e = parseInt(this.$element.offset().top),
                n = window.pageYOffset,
                i =
                  parseInt(n) +
                  t +
                  parseInt(this.settings.positionShowInfiniteLoading);
              return (
                n + window.innerHeight + t >=
                  r()(document).outerHeight() - 100 &&
                  (this.scrollToBottom = !0),
                !this.scrolling &&
                  this.data.products.length > 0 &&
                  (i >= e || (i < e && this.scrollToBottom))
              );
            },
          },
          {
            key: "_loadMoreProducts",
            value: function () {
              if (this.parent._productPaginationInfiniteShouldLoadmore()) {
                this.showLoading(), (this.scrolling = !0), this.nextPage++;
                var t = Math.ceil(this.totalProduct / s.a.queryParams.limit);
                if (this.nextPage <= t) {
                  if (
                    ((s.a.internalClick = !0),
                    K.default.setParam("limit", s.a.queryParams.limit),
                    K.default.setParam("page", this.nextPage),
                    u.a.FilterResult.isAdvancedPaginationType())
                  )
                    u.a.isLoadPreviousPagePaginationType() &&
                      (window.sessionStorage.setItem(
                        this.settings.sessionStorageCurrentNextPage,
                        this.nextPage
                      ),
                      window.sessionStorage.setItem(
                        this.settings.sessionStoragePreviousPageEvent,
                        0
                      )),
                      K.default.applyFilter("page");
                  else {
                    var e = sz.instance.filter;
                    K.default.getFilterData("page", e.setData.bind(e));
                  }
                }
              }
            },
          },
        ]),
        ep(e.prototype, n),
        i && ep(e, i),
        c
      );
    })(ta);
    function ey(t) {
      return (ey =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function em(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ev(t, e) {
      return (ev =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function eb(t, e) {
      return e && ("object" === ey(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function eS(t) {
      return (eS = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var e$ = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && ev(t, e);
      })(p, t);
      var e,
        n,
        i,
        c = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = eS(t);
            if (e()) {
              var r = eS(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return eb(this, n);
          };
        })(p);
      function p() {
        !(function (t, e) {
          if (!(t instanceof e))
            throw TypeError("Cannot call a class as a function");
        })(this, p),
          ((t = c.call(this)).$wrapper = r()(
            l.a.btnLoadPreviousPageWrapperSelector
          )),
          (t.$element = r()(l.a.btnLoadPreviousPageSelector)),
          (t.$productList = r()(l.a.products)),
          (t.settings.sessionStorageCurrentPreviousPage = o.a.getSettingValue(
            "general.sessionStorageCurrentPreviousPage"
          )),
          (t.settings.sessionStorageCurrentPage = o.a.getSettingValue(
            "general.sessionStorageCurrentPage"
          )),
          (t.settings.sessionStorageCurrentNextPage = o.a.getSettingValue(
            "general.sessionStorageCurrentNextPage"
          )),
          (t.settings.sessionStoragePreviousPageEvent = o.a.getSettingValue(
            "general.sessionStoragePreviousPageEvent"
          ));
        var t,
          e = o.a.getSettingValue("general.loadPreviousType");
        return (
          (t.settings.loadPreviousType =
            e || o.a.getSettingValue("general.paginationType")),
          (t.state = { isLoading: !1, lastScrollPos: window.scrollY }),
          t
        );
      }
      return (
        (e = p),
        (n = [
          {
            key: "init",
            value: function () {
              K.default.addAfterApplyFilter(
                this.doneLoadPreviousPage.bind(this)
              );
            },
          },
          {
            key: "getTemplate",
            value: function () {
              return '\n			<div class="{{class.buttonLoadPreviousPageSelector}}">\n				<span aria-label="{{label.loadPreviousPage}}" class="js-{{class.buttonLoadPreviousPageSelector}}">{{label.loadPreviousPage}}</span>\n			</div>\n		'.trim();
            },
          },
          {
            key: "getWrapperTemplate",
            value: function () {
              return '<div class="{{class.buttonLoadPreviousPageWrapper}}"></div>'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(
                  /{{class.buttonLoadPreviousPageSelector}}/g,
                  N.a.buttonLoadPreviousPageSelector
                )
                .replace(/{{label.loadPreviousPage}}/g, a.a.loadPreviousPage);
            },
          },
          {
            key: "compileWrapperTemplate",
            value: function () {
              return this.getWrapperTemplate().replace(
                /{{class.buttonLoadPreviousPageWrapper}}/g,
                N.a.buttonLoadPreviousPageWrapper
              );
            },
          },
          {
            key: "isRender",
            value: function () {
              return (
                this.data &&
                u.a.isLoadPreviousPagePaginationType() &&
                "page" != this.parent.eventType
              );
            },
          },
          {
            key: "render",
            value: function () {
              this.$wrapper.length ||
                ((this.$wrapper = r()(this.compileWrapperTemplate())),
                this.$wrapper.insertBefore(this.$productList)),
                this.$element.length ||
                  ((this.$element = r()(this.compileTemplate())),
                  this.$wrapper.append(this.$element));
              var t = Math.ceil(this.totalProduct / s.a.queryParams.limit),
                e = s.a.queryParams.page,
                n = t > 1 && e > 1;
              window.sessionStorage.setItem(
                this.settings.sessionStorageCurrentPreviousPage,
                e
              ),
                window.sessionStorage.setItem(
                  this.settings.sessionStorageCurrentPage,
                  e
                ),
                window.sessionStorage.setItem(
                  this.settings.sessionStorageCurrentNextPage,
                  e
                ),
                window.sessionStorage.setItem(
                  this.settings.sessionStoragePreviousPageEvent,
                  1
                ),
                n && this.settings.loadPreviousType == ta.Type.LOAD_MORE
                  ? this.$wrapper.show()
                  : (this.$wrapper.hide(),
                    u.a.isiOS() && (this.state.isLoading = !1));
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return u.a.isLoadPreviousPagePaginationType();
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.settings.loadPreviousType == ta.Type.LOAD_MORE
                ? (this.$element.off("click"),
                  this.$element.on("click", this._onClickEvent.bind(this)))
                : this.settings.loadPreviousType != ta.Type.INFINITE ||
                  this.isBoundEvent ||
                  r()(document).on("scroll", this._onScrollEvent.bind(this));
            },
          },
          {
            key: "_onClickEvent",
            value: function (t) {
              t && t.preventDefault(), this.loadPreviousPage();
            },
          },
          {
            key: "_onScrollEvent",
            value: function (t) {
              if (!this.state.isLoading) {
                var e = window.scrollY,
                  n = this.$productList.offset().top;
                e < this.state.lastScrollPos && e < n + 100
                  ? ((this.state.isLoading = !0), this.loadPreviousPage())
                  : (this.state.lastScrollPos = e);
              }
            },
          },
          {
            key: "loadPreviousPage",
            value: function () {
              var t = s.a.queryParams.page;
              if (
                (null !==
                window.sessionStorage.getItem(
                  this.settings.sessionStorageCurrentPreviousPage
                )
                  ? (this.currentPreviousPage = parseInt(
                      window.sessionStorage.getItem(
                        this.settings.sessionStorageCurrentPreviousPage
                      )
                    ))
                  : (this.currentPreviousPage = t),
                this.currentPreviousPage < 2)
              )
                return this.$wrapper.hide(), !1;
              (s.a.internalClick = !0),
                K.default.setParam("limit", s.a.queryParams.limit),
                this.currentPreviousPage--,
                window.sessionStorage.setItem(
                  this.settings.sessionStorageCurrentPreviousPage,
                  this.currentPreviousPage
                ),
                window.sessionStorage.setItem(
                  this.settings.sessionStoragePreviousPageEvent,
                  1
                ),
                K.default.setParam("page", this.currentPreviousPage),
                K.default.applyFilter("page", "previous"),
                this.currentPreviousPage < 2 && this.$wrapper.hide();
            },
          },
          {
            key: "doneLoadPreviousPage",
            value: function (t, e, n) {
              var i = this;
              "page" == e &&
                "previous" == n &&
                this.settings.loadPreviousType == ta.Type.INFINITE &&
                setTimeout(function () {
                  var t = s.a.queryParams.page + 1,
                    e = r()(l.a.products + ' [data-page="' + t + '"]');
                  if (e.length > 0) {
                    var n = parseInt(e.offset().top - 100);
                    window.scrollTo(0, n);
                  }
                  i.state.isLoading = !1;
                }, 200);
            },
          },
        ]),
        em(e.prototype, n),
        i && em(e, i),
        p
      );
    })(ta);
    function eT(t) {
      return (eT =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function eP(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function e_(t, e) {
      return (e_ =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function e8(t, e) {
      return e && ("object" === eT(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function ek(t) {
      return (ek = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var eO = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && e_(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = ek(t);
            if (e()) {
              var r = ek(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return e8(this, n);
          };
        })(a);
      function a(t, e) {
        var n;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          (n = o.call(this)),
          t || (t = l.a.searchPagePagination),
          (n.type = e),
          (n.$element = r()(t)),
          (n.$productList = r()(l.a.products)),
          (n.filterResult = n.parent),
          n
        );
      }
      return (
        (e = a),
        (n = [
          {
            key: "isRender",
            value: function () {
              return (
                s.a.hasOwnProperty("searchDisplay") &&
                s.a.searchDisplay === this.type
              );
            },
          },
          {
            key: "render",
            value: function () {
              this.$element.html(this.compileTemplate());
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element.show(),
                this.$element.find("a").off("click"),
                this.$element
                  .find("a")
                  .on("click", this._onClickEvent.bind(this));
            },
          },
          {
            key: "setData",
            value: function (t, e, n, i) {
              t && (this.data = t);
              var r = this.parent.searchResultPanels.children,
                o = this.type;
              (this.panelItem = r.find(function (t) {
                return t.type == o;
              })),
                (this.totalProduct = e),
                (this.limit = n),
                (this.page = i),
                (this.paginationType = Settings.getSettingValue(
                  "general.paginationType"
                ));
            },
          },
          {
            key: "_onClickEvent",
            value: function (t) {
              t.preventDefault(), (s.a.internalClick = !0);
              var e = new URL(
                r()(t.currentTarget).attr("href")
              ).searchParams.get("page");
              (e && !isNaN(e)) || (e = 1),
                K.default.setParam("page", e),
                K.default.setParam("limit", this.limit),
                K.default.getFilterData(
                  "search",
                  this.panelItem._searchPanelCallback.bind(this.panelItem)
                ),
                window.scrollTo({
                  top: this.$productList.offset().top - 50,
                  behavior: "smooth",
                });
            },
          },
        ]),
        eP(e.prototype, n),
        i && eP(e, i),
        a
      );
    })(tv);
    function eC(t) {
      return (eC =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function ew(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function eI(t, e) {
      return (eI =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function eE(t, e) {
      return e && ("object" === eC(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function e0(t) {
      return (e0 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var eL = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && eI(t, e);
      })(c, t);
      var e,
        n,
        i,
        a = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = e0(t);
            if (e()) {
              var r = e0(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return eE(this, n);
          };
        })(c);
      function c() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, c),
          ((t = a.call(this)).$productList = r()(l.a.products)),
          (t.$element = []),
          (t.isFetchedProductData = !1),
          (t.settings = {
            showPlaceholderProductList: o.a.getSettingValue(
              "general.showPlaceholderProductList"
            ),
            placeholderImageRatio: o.a.getSettingValue(
              "general.placeholderImageRatio"
            ),
            productGridClass: o.a.getSettingValue("custom.product_grid_class"),
            placeholderProductGridItemClass: o.a.getSettingValue(
              "general.placeholderProductGridItemClass"
            ),
            productsPerRow: o.a.getSettingValue("custom.products_per_row"),
            placeholderProductPerRow: o.a.getSettingValue(
              "general.placeholderProductPerRow"
            ),
            sessionStoragePreviousPageEvent: o.a.getSettingValue(
              "general.sessionStoragePreviousPageEvent"
            ),
          }),
          t
        );
      }
      return (
        (e = c),
        (n = [
          {
            key: "init",
            value: function () {
              (this.eventType = this.parent.eventType),
                K.default.addBeforeApplyFilter(
                  this.renderBeforeApplyFilter.bind(this)
                );
            },
          },
          {
            key: "getTemplate",
            value: function () {
              return '\n			<div class="{{wrapperClass}} {{class.filterProductSkeleton}}">\n				<div class="{{class.filterProductSkeleton}}-image" style="padding-top: 100%"></div>\n				<div class="{{class.filterProductSkeleton}}-meta">\n					<span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}"></span>\n					<span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}-width1"></span>\n				</div>\n			</div>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return void 0 !== s.a.queryParams.display &&
                "grid" != s.a.queryParams.display &&
                this.compileTemplateExtra
                ? this.compileTemplateExtra()
                : this.compileTemplateGridType();
            },
          },
          {
            key: "compileTemplateGridType",
            value: function () {
              var t = parseFloat(this.settings.placeholderImageRatio),
                e = t > 0 ? t : 1.4,
                n = "";
              return (
                "" ==
                  (n =
                    this.settings.productGridClass &&
                    "" !== this.settings.productGridClass
                      ? this.settings.productGridClass
                      : this.settings.placeholderProductGridItemClass) &&
                  (n =
                    this.$productList.children().length > 0
                      ? u.a.stripHtml(
                          this.$productList.children().first().attr("class")
                        )
                      : N.a.filterSkeleton + "-def-width"),
                this.getTemplate()
                  .replace(
                    /{{class.filterProductSkeleton}}/g,
                    N.a.filterProductSkeleton
                  )
                  .replace(/{{class.filterSkeleton}}/g, N.a.filterSkeleton)
                  .replace(
                    /{{class.filterSkeletonText}}/g,
                    N.a.filterSkeletonText
                  )
                  .replace(/{{paddingTop}}/g, 100 * e)
                  .replace(/{{wrapperClass}}/g, n)
              );
            },
          },
          {
            key: "compileTemplateExtra",
            value: function () {
              return !1;
            },
          },
          {
            key: "isRender",
            value: function () {
              var t = u.a.getDefaultSorting();
              return (
                this.settings.showPlaceholderProductList &&
                z.isPanelActive(tt.Enum.PRODUCT) &&
                (!s.a.loadProductFirst ||
                  !u.a.isCollectionPage() ||
                  u.a.isVendorPage() ||
                  u.a.isTagPage() ||
                  u.a.isTypePage() ||
                  ("" != t &&
                    t != o.a.getSettingValue("general.default_sort_by")) ||
                  ("best-selling" === s.a.defaultSorting &&
                    !o.a.getSettingValue(
                      "general.loadProductFirstBestSelling"
                    )) ||
                  s.a.defaultSorting.startsWith("extra") ||
                  o.a.getSettingValue("general.productAndVariantAvailable") ||
                  o.a.getSettingValue("general.sortingAvailableFirst") ||
                  s.a.hasFilterByLocation ||
                  (s.a.loadProductFirst &&
                    (s.a.hasFilterOptionParam || "init" != this.eventType)) ||
                  o.a.getSettingValue("general.enableVariantsDisplay"))
              );
            },
          },
          {
            key: "render",
            value: function () {
              var t =
                  this.settings.productsPerRow ||
                  this.settings.placeholderProductPerRow,
                e = this.compileTemplate();
              this.$element = [];
              for (var n = 0; n < t; n++) this.$element.push(r()(e));
              var i = this.parent.productList,
                o =
                  i.settings.loadProductFromLiquid &&
                  i.settings.loadProductFromLiquidType ==
                    ProductList.Enum.loadProductType.AJAX;
              this.isFetchedProductData
                ? (o && !i.isFetchedAjaxProductData) || this.setHide()
                : this.setShow();
            },
          },
          {
            key: "renderBeforeApplyFilter",
            value: function (t) {
              (this.eventType = t), this.refresh();
            },
          },
          {
            key: "setData",
            value: function (t) {
              t && this.isRender() && (this.isFetchedProductData = !0);
            },
          },
          {
            key: "setShow",
            value: function () {
              var t = this;
              this.$productList.addClass(N.a.productWrapLoading),
                this.$productList.css("min-height", this.$productList.height()),
                (u.a.isDefaultPaginationType() ||
                  (!u.a.isDefaultPaginationType() &&
                    "page" !== this.eventType)) &&
                  this.$productList.html(""),
                u.a.isLoadPreviousPagePaginationType() &&
                parseInt(
                  window.sessionStorage.getItem(
                    this.settings.sessionStoragePreviousPageEvent
                  )
                )
                  ? this.$element.forEach(function (e) {
                      return t.$productList.prepend(e);
                    })
                  : this.$element.forEach(function (e) {
                      return t.$productList.append(e);
                    });
            },
          },
          {
            key: "setHide",
            value: function () {
              var t = this;
              this.$productList.find("." + N.a.filterProductSkeleton).remove(),
                setTimeout(function () {
                  t.$productList.removeClass(N.a.productWrapLoading),
                    t.$productList.css("min-height", 0);
                }),
                (this.isFetchedProductData = !1);
            },
          },
        ]),
        ew(e.prototype, n),
        i && ew(e, i),
        c
      );
    })(g.a);
    function eA(t) {
      return (eA =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function ex(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function eB(t, e) {
      return (eB =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function eR(t, e) {
      return e && ("object" === eA(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function e9(t) {
      return (e9 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var eF = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && eB(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = e9(t);
            if (e()) {
              var r = e9(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return eR(this, n);
          };
        })(a);
      function a() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          ((t = o.call(this)).data = null),
          (t.id = null),
          (t.index = 0),
          (t.$element = null),
          (t.displayImage = !0),
          (t.displayExcerpt = !1),
          t
        );
      }
      return (
        (e = a),
        (n = [
          {
            key: "compileTemplate",
            value: function () {
              var t = this.data.hasOwnProperty("url") ? this.data.url : "#",
                e = "",
                n = "",
                i = "";
              if (
                (this.displayImage &&
                  (this.data.image &&
                    this.data.image.hasOwnProperty("src") &&
                    "" !== this.data.image.src &&
                    (n = u.a.optimizeImage(this.data.image.src, "200x")),
                  n.length > 0 &&
                    (e = this.getTemplate(e4.Enum.tempType.IMAGE))),
                this.displayExcerpt &&
                  this.data.body_html &&
                  "string" == typeof this.data.body_html)
              ) {
                var r = u.a.stripHtml(this.data.body_html);
                r.length > 264 &&
                  (r =
                    r.substr(
                      0,
                      Settings.getSettingValue(
                        "search.pageExcerptLimitCharacter"
                      )
                    ) + "..."),
                  (i = this.getTemplate(e4.Enum.tempType.EXCERPT).replace(
                    /{{itemExcerpt}}/g,
                    r
                  ));
              }
              return this.getTemplate()
                .replace(/{{itemThumbnail}}/g, e)
                .replace(/{{itemThumbSrc}}/g, n)
                .replace(/{{itemDesc}}/g, i)
                .replace(/{{class.filterResultItem}}/g, N.a.filterResultItem)
                .replace(/{{itemUrl}}/g, t)
                .replace(/{{itemTitle}}/g, u.a.stripHtml(this.data.title));
            },
          },
          {
            key: "render",
            value: function () {
              this.$element = r()(this.compileTemplate());
            },
          },
          {
            key: "setData",
            value: function (t, e) {
              (this.data = t),
                (this.id = t.id),
                (this.index = e),
                (this.displayImage =
                  this.parent.panelData.hasOwnProperty("displayImage") &&
                  this.parent.panelData.displayImage),
                (this.displayExcerpt =
                  this.parent.panelData.hasOwnProperty("displayExcerpt") &&
                  this.parent.panelData.displayExcerpt);
            },
          },
        ]),
        ex(e.prototype, n),
        i && ex(e, i),
        a
      );
    })(g.a);
    function e2(t) {
      return (e2 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function e1(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function eV(t, e) {
      return (eV =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function eD(t, e) {
      return e && ("object" === e2(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function eM(t) {
      return (eM = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var e4 = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && eV(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = eM(t);
            if (e()) {
              var r = eM(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return eD(this, n);
          };
        })(o);
      function o() {
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, o),
          r.call(this)
        );
      }
      return (
        (e = o),
        (i = [
          {
            key: "Enum",
            get: function () {
              return {
                tempType: {
                  ITEM: "page_item",
                  IMAGE: "image",
                  EXCERPT: "excerpt",
                },
              };
            },
          },
        ]),
        (n = [
          {
            key: "getTemplate",
            value: function (t) {
              switch (t) {
                case o.Enum.tempType.IMAGE:
                  return '\n					<div class="{{class.filterResultItem}}-image">\n						<img src="{{itemThumbSrc}}" alt="{{itemTitle}}" />\n					</div>\n				'.trim();
                case o.Enum.tempType.EXCERPT:
                  return '\n					<p class="{{class.filterResultItem}}-description">\n						{{itemExcerpt}}\n					</p>\n				'.trim();
                default:
                  return '\n					<div class="{{class.filterResultItem}} {{class.filterResultItem}}-page">\n						<a href="{{itemUrl}}" aria-label="{{itemTitle}}" title="{{itemTitle}}">\n							{{itemThumbnail}}\n							<div class="{{class.filterResultItem}}-content">\n								<div class="{{class.filterResultItem}}-title">{{itemTitle}}</div>\n								{{itemDesc}}\n							</div>\n						</a>\n					</div>\n				'.trim();
              }
            },
          },
        ]),
        e1(e.prototype, n),
        i && e1(e, i),
        o
      );
    })(eF);
    function e3(t) {
      return (e3 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function e6(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function e5(t, e) {
      return (e5 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function eH(t, e) {
      return e && ("object" === e3(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function e7(t) {
      return (e7 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var eN = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && e5(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = e7(t);
            if (e()) {
              var r = e7(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return eH(this, n);
          };
        })(a);
      function a() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          ((t = o.call(this)).data = null),
          (t.id = null),
          (t.index = 0),
          (t.$element = null),
          (t.displayImage = !0),
          (t.displayDescription = !1),
          t
        );
      }
      return (
        (e = a),
        (n = [
          {
            key: "compileTemplate",
            value: function () {
              var t = "/collections/" + this.data.handle,
                e = "",
                n = "",
                i = "";
              if (
                (this.displayImage &&
                  (this.data.image &&
                    this.data.image.hasOwnProperty("src") &&
                    "" !== this.data.image.src &&
                    (n = u.a.optimizeImage(this.data.image.src, "200x")),
                  n.length > 0 &&
                    (e = this.getTemplate(ez.Enum.tempType.IMAGE))),
                this.displayDescription &&
                  this.data.body_html &&
                  "string" == typeof this.data.body_html)
              ) {
                var r = u.a.stripHtml(this.data.body_html);
                r.length > 264 &&
                  (r =
                    r.substr(
                      0,
                      Settings.getSettingValue(
                        "search.collectionDescLimitCharacter"
                      )
                    ) + "..."),
                  (i = this.getTemplate(ez.Enum.tempType.DESCRIPTION).replace(
                    /{{itemDescription}}/g,
                    r
                  ));
              }
              return this.getTemplate()
                .replace(/{{itemThumbnail}}/g, e)
                .replace(/{{itemThumbSrc}}/g, n)
                .replace(/{{itemDesc}}/g, i)
                .replace(/{{class.filterResultItem}}/g, N.a.filterResultItem)
                .replace(/{{itemUrl}}/g, t)
                .replace(/{{itemTitle}}/g, u.a.stripHtml(this.data.title));
            },
          },
          {
            key: "render",
            value: function () {
              this.$element = r()(this.compileTemplate());
            },
          },
          {
            key: "setData",
            value: function (t, e) {
              (this.data = t),
                (this.id = t.id),
                (this.index = e),
                (this.displayImage =
                  this.parent.panelData.hasOwnProperty("displayImage") &&
                  this.parent.panelData.displayImage),
                (this.displayDescription =
                  this.parent.panelData.hasOwnProperty("displayDescription") &&
                  this.parent.panelData.displayDescription);
            },
          },
        ]),
        e6(e.prototype, n),
        i && e6(e, i),
        a
      );
    })(g.a);
    function eU(t) {
      return (eU =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function eW(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ej(t, e) {
      return (ej =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function eq(t, e) {
      return e && ("object" === eU(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function eG(t) {
      return (eG = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ez = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && ej(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = eG(t);
            if (e()) {
              var r = eG(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return eq(this, n);
          };
        })(o);
      function o() {
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, o),
          r.call(this)
        );
      }
      return (
        (e = o),
        (i = [
          {
            key: "Enum",
            get: function () {
              return {
                tempType: {
                  ITEM: "collection_item",
                  IMAGE: "image",
                  DESCRIPTION: "description",
                },
              };
            },
          },
        ]),
        (n = [
          {
            key: "getTemplate",
            value: function (t) {
              switch (t) {
                case o.Enum.tempType.IMAGE:
                  return '\n					<div class="{{class.filterResultItem}}-image">\n						<img src="{{itemThumbSrc}}" alt="{{itemTitle}}" />\n					</div>\n				'.trim();
                case o.Enum.tempType.DESCRIPTION:
                  return '\n					<p class="{{class.filterResultItem}}-description">\n						{{itemDescription}}\n					</p>\n				'.trim();
                default:
                  return '\n					<div class="{{class.filterResultItem}} {{class.filterResultItem}}-collection">\n						<a href="{{itemUrl}}" aria-label="{{itemTitle}}" title="{{itemTitle}}">\n							{{itemThumbnail}}\n							<div class="{{class.filterResultItem}}-content">\n								<div class="{{class.filterResultItem}}-title">{{itemTitle}}</div>\n								{{itemDesc}}\n							</div>\n						</a>\n					</div>\n				'.trim();
              }
            },
          },
        ]),
        eW(e.prototype, n),
        i && eW(e, i),
        o
      );
    })(eN);
    function eK(t) {
      return (eK =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function eY(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function eQ(t, e) {
      return (eQ =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function eX(t, e) {
      return e && ("object" === eK(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function eZ(t) {
      return (eZ = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var eJ = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && eQ(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = eZ(t);
            if (e()) {
              var r = eZ(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return eX(this, n);
          };
        })(a);
      function a() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          ((t = o.call(this)).$element = r()(l.a.collections)),
          (t.data = null),
          (t.totalCollection = 0),
          (t.settings = {
            searchPanelBlocks: Settings.getSettingValue(
              "search.searchPanelBlocks"
            ),
          }),
          (t.panelData = {}),
          t.settings.searchPanelBlocks.hasOwnProperty(tt.Enum.COLLECTION) &&
            (t.panelData = t.settings.searchPanelBlocks[tt.Enum.COLLECTION]),
          t
        );
      }
      return (
        (e = a),
        (n = [
          {
            key: "isRender",
            value: function () {
              return null != this.data && z.isPanelActive(tt.Enum.COLLECTION);
            },
          },
          {
            key: "render",
            value: function () {
              var t = this,
                e = [];
              this.collectionItems.forEach(function (t) {
                e.push(t.$element);
              }),
                this.$element.html(""),
                e.forEach(function (e) {
                  return t.$element.append(e);
                });
            },
          },
          {
            key: "setData",
            value: function (t) {
              var e = this;
              t &&
                t.collections &&
                t.collections.length &&
                ((this.data = t.collections),
                (this.totalCollection = t.total_collection
                  ? t.total_collection
                  : 0),
                (this.collectionItems = []),
                this.data.forEach(function (t, n) {
                  var i = new ez();
                  e.addComponent(i), i.setData(t), e.collectionItems.push(i);
                }));
            },
          },
        ]),
        eY(e.prototype, n),
        i && eY(e, i),
        a
      );
    })(g.a);
    function nt(t) {
      return (nt =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function ne(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function nn(t, e) {
      return (nn =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function ni(t, e) {
      return e && ("object" === nt(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function nr(t) {
      return (nr = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var no = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && nn(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = nr(t);
            if (e()) {
              var r = nr(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return ni(this, n);
          };
        })(a);
      function a() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          ((t = o.call(this)).$element = r()(l.a.pages)),
          (t.data = null),
          (t.totalPage = 0),
          (t.settings = {
            searchPanelBlocks: Settings.getSettingValue(
              "search.searchPanelBlocks"
            ),
          }),
          (t.panelData = {}),
          t.settings.searchPanelBlocks.hasOwnProperty(tt.Enum.PAGE) &&
            (t.panelData = t.settings.searchPanelBlocks[tt.Enum.PAGE]),
          t
        );
      }
      return (
        (e = a),
        (n = [
          {
            key: "isRender",
            value: function () {
              return null != this.data && z.isPanelActive(tt.Enum.PAGE);
            },
          },
          {
            key: "render",
            value: function () {
              var t = this;
              this.$element.html(""),
                this.pageItems.forEach(function (e) {
                  t.$element.append(e.$element);
                });
            },
          },
          {
            key: "setData",
            value: function (t) {
              var e = this;
              t &&
                t.pages &&
                t.pages.length &&
                ((this.data = t.pages),
                (this.totalPage = t.total_page ? t.total_page : 0),
                (this.pageItems = []),
                this.data.forEach(function (t, n) {
                  var i = new e4();
                  e.addComponent(i), i.setData(t), e.pageItems.push(i);
                }));
            },
          },
        ]),
        ne(e.prototype, n),
        i && ne(e, i),
        a
      );
    })(g.a);
    function na(t) {
      return (na =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function ns(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function nl(t, e) {
      return (nl =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function nc(t, e) {
      return e && ("object" === na(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function nu(t) {
      return (nu = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var np = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && nl(t, e);
      })(s, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = nu(t);
            if (e()) {
              var r = nu(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return nc(this, n);
          };
        })(s);
      function s() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, s),
          ((t = o.call(this)).$element = r()(l.a.searchTotalResult)),
          (t.total = 0),
          (t.panalType = tt.Enum.PRODUCT),
          t
        );
      }
      return (
        (e = s),
        (n = [
          {
            key: "compileTemplate",
            value: function () {
              return (
                this.total > 1
                  ? a.a.search.searchTotalResults
                  : a.a.search.searchTotalResult
              ).replace(
                /{{ count }}/g,
                "<strong>" + u.a.stripHtml(this.total) + "</strong>"
              );
            },
          },
          {
            key: "render",
            value: function () {
              var t = this.compileTemplate();
              this.$element.html(t);
            },
          },
          {
            key: "setData",
            value: function (t, e) {
              "number" == typeof t && (this.total = t),
                e && (this.panalType = e);
            },
          },
        ]),
        ns(e.prototype, n),
        i && ns(e, i),
        s
      );
    })(g.a);
    function nf(t) {
      return (nf =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function nh(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function nd(t, e) {
      return (nd =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function ng(t, e) {
      return e && ("object" === nf(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function ny(t) {
      return (ny = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    n(49), n(50);
    var nm = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && nd(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = ny(t);
            if (e()) {
              var r = ny(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return ng(this, n);
          };
        })(a);
      function a() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          ((t = o.call(this)).data = null),
          (t.id = null),
          (t.totalProduct = null),
          (t.$element = null),
          t
        );
      }
      return (
        (e = a),
        (n = [
          {
            key: "init",
            value: function () {
              window.BoostOTP && BoostOTP.OTPButtons.init(this);
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              if ("function" == typeof ProductGridItem) {
                var t = new ProductGridItem();
                t.data = this.data;
                var e = t.compileTemplate().trim();
                return (
                  (e = y.a.compileTemplate(e, this.data)),
                  (e = y.a.compileIntegrationTemplate(this.data, e))
                );
              }
              console.warn(
                "Missing buildProductGridItem function in theme lib"
              );
            },
          },
          {
            key: "render",
            value: function () {
              this.$element ||
                ((this.$element = r()(this.compileTemplate())),
                this.$element.addClass("boost-pfs-product-slider-item"),
                u.a.isMobile() && (this.parent.productSliderRange = 2),
                window.BoostOTP && BoostOTP.OTPButtons.render(this));
            },
          },
          {
            key: "bindEvents",
            value: function () {
              if (this.$element && this.parent.$element) {
                var t =
                  this.parent.$element.width() / this.parent.productSliderRange;
                this.$element.css({ width: t + "px" }),
                  window.BoostOTP && BoostOTP.OTPButtons.bindEvents(this);
              }
            },
          },
          {
            key: "setData",
            value: function (t) {
              this.data = t;
            },
          },
        ]),
        nh(e.prototype, n),
        i && nh(e, i),
        a
      );
    })(g.a);
    function nv(t) {
      return (nv =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function nb(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function nS(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function n$(t, e) {
      return (n$ =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function nT(t, e) {
      return e && ("object" === nv(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function nP(t) {
      return (nP = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var n_ = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && n$(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = nP(t);
            if (e()) {
              var r = nP(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return nT(this, n);
          };
        })(a);
      function a() {
        return nb(this, a), o.apply(this, arguments);
      }
      return (
        (e = a),
        (i = [
          {
            key: "ProductSliderType",
            get: function () {
              return {
                MOST_POPULAR: "most-popular",
                RECENTLY_VIEWED: "recently-viewed",
              };
            },
          },
        ]),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n    <div class="boost-pfs-product-slider">\n				<div class="boost-pfs-product-slider-inner">\n					<div class="boost-pfs-product-slider-item-wrapper"></div>\n				</div>\n				<div class="boost-pfs-product-slider-nav">\n					<div class="boost-pfs-product-slider-prev boost-pfs-product-slider-nav-btn-disabled"></div>\n          <div class="boost-pfs-product-slider-next"></div>\n				</div>\n			</div>\n    '.trim();
            },
          },
          {
            key: "render",
            value: function () {
              var t = this;
              if (r()(this.selector).length > 0) {
                (this.$element = r()(this.getTemplate())),
                  this.children.length > 0 &&
                    ((this.$productSlider = this.$element.find(
                      ".boost-pfs-product-slider-item-wrapper"
                    )),
                    this.children.forEach(function (e) {
                      t.$productSlider.append(e.$element);
                    })),
                  r()(this.selector).first().html("").append(this.$element),
                  y.a.call3rdAppFunction(this.data),
                  y.a.call3rdIntegrationFunc(this.data);
                var e = Settings.getSettingValue("actionlist.alStyle");
                this.$element.hasClass(e) || this.$element.addClass(e);
              }
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element && this.initImageSlider();
            },
          },
          {
            key: "setData",
            value: function (t, e) {
              var n = this;
              (this.data = t),
                (this.children = []),
                this.data.products.forEach(function (t) {
                  var e = new nm();
                  e.setData(t), n.addComponent(e);
                }),
                e && this.refresh();
            },
          },
          {
            key: "initImageSlider",
            value: function () {
              var t = this.$element.find(
                  ".boost-pfs-product-slider-item-wrapper"
                ),
                e = this.$element.find(".boost-pfs-product-slider-nav"),
                n = this.$element.find(".boost-pfs-product-slider-item"),
                i = this.$element.find(".boost-pfs-product-slider-prev"),
                r = this.$element.find(".boost-pfs-product-slider-next");
              0 != t.length &&
                0 != n.length &&
                ((this.imageSlider = {
                  $itemsWrapper: t,
                  $sliderNavWrapper: e,
                  $prev: i,
                  $next: r,
                  posX1: 0,
                  posX2: 0,
                  posInitial: 0,
                  posFinal: 0,
                  threshold: 50,
                  slidesLength: n.length,
                  slideSize: n[0].style.width.replace("px", ""),
                  index: 0,
                  allowShift: !0,
                  isDragging: !1,
                }),
                0 == this.imageSlider.index &&
                  this.imageSlider.$prev.addClass(
                    "boost-pfs-product-slider-nav-btn-disabled"
                  ),
                (this.imageSlider.index == this.imageSlider.slidesLength - 1 ||
                  this.imageSlider.slidesLength <= this.productSliderRange) &&
                  (this.imageSlider.$next.addClass(
                    "boost-pfs-product-slider-nav-btn-disabled"
                  ),
                  this.imageSlider.$sliderNavWrapper.addClass(
                    "boost-pfs-product-slider-nav-disabled"
                  )),
                this.imageSlider.$itemsWrapper.css("left", "0px"),
                this.imageSlider.slidesLength <= this.productSliderRange ||
                  (this.imageSlider.$itemsWrapper.on(
                    "mousedown",
                    this.dragStart.bind(this)
                  ),
                  this.imageSlider.$itemsWrapper.on(
                    "mousemove",
                    this.dragAction.bind(this)
                  ),
                  this.imageSlider.$itemsWrapper.on(
                    "mouseup",
                    this.dragEnd.bind(this)
                  ),
                  this.imageSlider.$itemsWrapper.on(
                    "touchstart",
                    this.dragStart.bind(this)
                  ),
                  this.imageSlider.$itemsWrapper.on(
                    "touchmove",
                    this.dragAction.bind(this)
                  ),
                  this.imageSlider.$itemsWrapper.on(
                    "touchend",
                    this.dragEnd.bind(this)
                  ),
                  this.imageSlider.$prev.on(
                    "click",
                    this.shiftSlide.bind(this, null, -1)
                  ),
                  this.imageSlider.$next.on(
                    "click",
                    this.shiftSlide.bind(this, null, 1)
                  )));
            },
          },
          {
            key: "dragStart",
            value: function (t) {
              (t = t || window.event),
                (this.imageSlider.posInitial =
                  this.imageSlider.$itemsWrapper[0].offsetLeft);
              var e = t.type.includes("touch")
                ? t.originalEvent.touches[0].clientX
                : t.clientX;
              (this.imageSlider.posX1 = e), (this.imageSlider.isDragging = !0);
            },
          },
          {
            key: "dragAction",
            value: function (t) {
              if (this.imageSlider.isDragging) {
                var e = (t = t || window.event).type.includes("touch")
                  ? t.originalEvent.touches[0].clientX
                  : t.clientX;
                (this.imageSlider.posX2 = this.imageSlider.posX1 - e),
                  (this.imageSlider.posX1 = e);
                var n =
                    this.imageSlider.$itemsWrapper[0].offsetLeft -
                    this.imageSlider.posX2,
                  i = 0.2 * this.imageSlider.slideSize,
                  r =
                    -this.imageSlider.slideSize *
                      (this.imageSlider.slidesLength -
                        this.productSliderRange) -
                    i;
                n > i ? (n = i) : n < r && (n = r),
                  this.imageSlider.$itemsWrapper.css("left", n + "px");
              }
            },
          },
          {
            key: "dragEnd",
            value: function (t) {
              if (this.imageSlider.isDragging) {
                if (
                  ((this.imageSlider.isDragging = !1),
                  (this.imageSlider.posFinal =
                    this.imageSlider.$itemsWrapper[0].offsetLeft),
                  this.imageSlider.posFinal - this.imageSlider.posInitial <
                    -this.imageSlider.threshold)
                ) {
                  var e = Math.round(
                    Math.abs(
                      this.imageSlider.posFinal - this.imageSlider.posInitial
                    ) / this.imageSlider.slideSize
                  );
                  this.shiftSlide(null, e);
                } else
                  this.imageSlider.posFinal - this.imageSlider.posInitial >
                  this.imageSlider.threshold
                    ? ((e = Math.round(
                        Math.abs(
                          this.imageSlider.posFinal -
                            this.imageSlider.posInitial
                        ) / this.imageSlider.slideSize
                      )),
                      this.shiftSlide(null, -1 * e))
                    : this.imageSlider.$itemsWrapper.css(
                        "left",
                        this.imageSlider.posInitial + "px"
                      );
              }
            },
          },
          {
            key: "shiftSlide",
            value: function (t, e) {
              if (
                (null == t && (t = this.imageSlider.index + e),
                this.imageSlider.allowShift)
              ) {
                var n,
                  i = this.imageSlider.$itemsWrapper.css("left");
                t > -1 &&
                t < this.imageSlider.slidesLength - this.productSliderRange + 1
                  ? ((n = -1 * t * this.imageSlider.slideSize + "px"),
                    (this.imageSlider.index = t))
                  : (n =
                      -1 * this.imageSlider.index * this.imageSlider.slideSize +
                      "px"),
                  i != n &&
                    (0 == this.imageSlider.index
                      ? this.imageSlider.$prev.addClass(
                          "boost-pfs-product-slider-nav-btn-disabled"
                        )
                      : this.imageSlider.$prev.removeClass(
                          "boost-pfs-product-slider-nav-btn-disabled"
                        ),
                    this.imageSlider.index ==
                    this.imageSlider.slidesLength - this.productSliderRange
                      ? this.imageSlider.$next.addClass(
                          "boost-pfs-product-slider-nav-btn-disabled"
                        )
                      : this.imageSlider.$next.removeClass(
                          "boost-pfs-product-slider-nav-btn-disabled"
                        ),
                    this.imageSlider.$itemsWrapper.addClass(
                      "boost-pfs-product-slider-shifting"
                    ),
                    this.imageSlider.$itemsWrapper.css("left", n),
                    (this.imageSlider.allowShift = !1),
                    setTimeout(this.afterShiftSlide.bind(this), 300));
              }
            },
          },
          {
            key: "afterShiftSlide",
            value: function () {
              this.imageSlider.$itemsWrapper.removeClass(
                "boost-pfs-product-slider-shifting"
              ),
                (this.imageSlider.allowShift = !0);
            },
          },
        ]),
        nS(e.prototype, n),
        i && nS(e, i),
        a
      );
    })(g.a);
    function n8(t) {
      return (n8 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function nk(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function nO(t, e, n) {
      return (nO =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = nI(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function nC(t, e) {
      return (nC =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function nw(t, e) {
      return e && ("object" === n8(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function nI(t) {
      return (nI = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var nE = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && nC(t, e);
      })(s, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = nI(t);
            if (e()) {
              var r = nI(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return nw(this, n);
          };
        })(s);
      function s() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, s),
          ((t = o.call(this)).type = n_.ProductSliderType.MOST_POPULAR),
          (t.selector = l.a.mostPopular),
          (t.header = a.a.mostPopular.popularProductsHeading),
          (t.productSliderRange = Settings.getSettingValue(
            "mostPopular.popularProductSliderRange"
          )),
          t.productSliderRange <= 0 && (t.productSliderRange = 4),
          (t.isFetchedMostPopularData = !1),
          (t.collectionHandle = boostPFSAppConfig.general.collection_handle
            ? boostPFSAppConfig.general.collection_handle
            : "all"),
          t
        );
      }
      return (
        (e = s),
        (n = [
          {
            key: "init",
            value: function () {
              var t = this;
              if (void 0 === this.data.products) {
                var e =
                  "/collections/" +
                  this.collectionHandle +
                  "?view=boost-pfs-most-popular&sort_by=best-selling";
                r.a.ajax({
                  type: "GET",
                  url: e,
                  success: function (e) {
                    var n = null;
                    try {
                      /<\!--.*?-->/.test(e) &&
                        (e = e.replace(/<\!--.*?-->/g, "")),
                        (n = t.prepareData(JSON.parse(e)));
                    } catch (i) {
                      console.warn(
                        "Could not parse json from collection.boost-pfs-most-popular.liquid"
                      );
                    }
                    (t.isFetchedMostPopularData = !0), t.setData(n, !0);
                  },
                  error: function (t) {
                    console.warn(
                      "Error getting most popular: " +
                        t.status +
                        " " +
                        t.statusText
                    );
                  },
                });
              }
            },
          },
          {
            key: "prepareData",
            value: function (t) {
              return (
                t.products.forEach(function (t) {
                  (t.price /= 100),
                    (t.price_min /= 100),
                    (t.price_max /= 100),
                    (t.compare_at_price /= 100),
                    (t.compare_at_price_min /= 100),
                    (t.compare_at_price_max /= 100),
                    t.variants.forEach(function (t) {
                      (t.price /= 100), (t.compare_at_price /= 100);
                    });
                }),
                t
              );
            },
          },
          {
            key: "setProductData",
            value: function (t) {
              this.isFetchedMostPopularData = !0;
              var e = { products: t };
              this.setData(e, !0);
            },
          },
          {
            key: "isRender",
            value: function () {
              return (
                this.isFetchedMostPopularData && this.data.products.length > 0
              );
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return this.$element;
            },
          },
          {
            key: "isLoopThroughChild",
            value: function () {
              return (
                this.isFetchedMostPopularData && this.data.products.length > 0
              );
            },
          },
          {
            key: "bindEvents",
            value: function () {
              nO(nI(s.prototype), "bindEvents", this).call(this),
                boostPFSConfig.general.isInitFilter &&
                  r()(window).on(
                    "boost-pfs-change-address-bar",
                    this.updateMostPopularData.bind(this)
                  );
            },
          },
          {
            key: "updateMostPopularData",
            value: function () {
              if (window.location.pathname.startsWith("/collections/")) {
                var t = window.location.pathname.replace("/collections/", "");
                t &&
                  t != this.collectionHandle &&
                  ((this.collectionHandle = t),
                  (this.isFetchedMostPopularData = !1),
                  (this.isInit = !1),
                  this.refresh());
              }
            },
          },
        ]),
        nk(e.prototype, n),
        i && nk(e, i),
        s
      );
    })(n_);
    function n0(t) {
      return (n0 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function nL(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function nA(t, e) {
      return (nA =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function nx(t, e) {
      return e && ("object" === n0(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function nB(t) {
      return (nB = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var nR = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && nA(t, e);
      })(p, t);
      var e,
        n,
        i,
        c = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = nB(t);
            if (e()) {
              var r = nB(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return nx(this, n);
          };
        })(p);
      function p() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, p),
          ((t = c.call(this)).productsData = null),
          (t.$element = r()(l.a.products)),
          t
        );
      }
      return (
        (e = p),
        (n = [
          {
            key: "getTitleTemplate",
            value: function () {
              return '\n			<div class="product-list-no-search-result-text boost-pfs-search-panel-product-show">{{label.resultEmpty}}</div>\n      {{noResultSearchTipsTemplate}}\n      {{noResultSearchSuggestionTemplate}}\n\n      {{noResultSearchMostPopular}}\n		'.trim();
            },
          },
          {
            key: "getNoResultSearchTipsTemplate",
            value: function () {
              return '\n			<div class="boost-pfs-filter-search-tips-content-wrapper boost-pfs-search-panel-product-show">\n				<div class="boost-pfs-filter-search-tips-title">{{searchTipsTitle}}</div>\n				<div class="boost-pfs-filter-search-tips-content">\n          <ul>{{searchTipsListItem}}</ul>\n        </div>\n			</div>\n		'.trim();
            },
          },
          {
            key: "getNoResultSearchSuggestionsTemplate",
            value: function () {
              return '\n      <div class="boost-pfs-filter-search-term-suggestion-wrapper boost-pfs-search-panel-product-show">\n        <div class="boost-pfs-filter-search-term-suggestion-title">{{searchTermSuggestionTitle}}</div>\n        <div class="boost-pfs-filter-search-term-suggestion-content">\n          <ul>\n            {{searchTermSuggestionListItem}}\n          </ul>\n        </div>\n      </div>\n    '.trim();
            },
          },
          {
            key: "getNoResultSearchMostPopular",
            value: function () {
              return '\n    <div class="boost-pfs-most-popular-wrapper boost-pfs-search-panel-product-show">\n    <div class="boost-pfs-product-no-search-result-title"><h2>{{noSearchResultTitle}}</h2></div>\n    <div class="boost-pfs-most-popular"></div>\n    </div>';
            },
          },
          {
            key: "compileTitleTemplate",
            value: function () {
              o.a.getSettingValue("search.suggestionNoResult");
              var t = a.a.suggestion.noSearchResultProductsLabel,
                e = a.a.search.resultEmpty,
                n = o.a.getSettingValue("general.current_locale"),
                i = o.a.getSettingValue(
                  "labelTranslations." + n + ".search.resultEmpty"
                );
              i && (e = i);
              var r = "";
              if (
                o.a.getSettingValue(
                  "search.searchPanelBlocks.searchTips.active"
                )
              ) {
                for (
                  var l = a.a.search.searchTipsContent.split("{{ breakline }}"),
                    c = "",
                    p = 0;
                  p < l.length;
                  p++
                )
                  "" != l[p] && (c += "<li>".concat(l[p], "</li>"));
                r = this.getNoResultSearchTipsTemplate()
                  .replace(/{{searchTipsTitle}}/g, a.a.search.searchTipsTitle)
                  .replace(/{{searchTipsListItem}}/g, c);
              }
              var f = "";
              if (
                o.a.getSettingValue(
                  "search.searchPanelBlocks.searchTermSuggestions.active"
                )
              ) {
                var h = o.a.getSettingValue(
                  "search.suggestionNoResult.search_terms.data"
                );
                for (p = 0; p < h.length; p++)
                  f += '\n          <li>\n            <a href="/search?q='
                    .concat(h[p], '">')
                    .concat(h[p], "</a>\n          </li>\n        ")
                    .trim();
                h.length > 0 &&
                  (f = this.getNoResultSearchSuggestionsTemplate()
                    .replace(
                      /{{searchTermSuggestionTitle}}/g,
                      a.a.suggestion.noSearchResultSearchTermLabel
                    )
                    .replace(/{{searchTermSuggestionListItem}}/g, f));
              }
              var d = "";
              return (
                o.a.getSettingValue(
                  "search.searchPanelBlocks.mostPopularProducts.active"
                ) &&
                  this.data.length > 0 &&
                  (d = this.getNoResultSearchMostPopular()),
                this.getTitleTemplate()
                  .replace(/{{noResultSearchTipsTemplate}}/g, r)
                  .replace(/{{noResultSearchSuggestionTemplate}}/g, f)
                  .replace(/{{noResultSearchMostPopular}}/g, d)
                  .replace(/{{noSearchResultTitle}}/g, t)
                  .replace(/{{label.resultEmpty}}/g, e)
                  .replace(
                    /{{ terms }}/g,
                    "<b>" + u.a.stripHtml(s.a.queryParams.q) + "</b>"
                  )
                  .replace(/{{ breakline }}/g, "<br />")
              );
            },
          },
          {
            key: "isRender",
            value: function () {
              return (
                u.a.isSearchPage() &&
                z.isPanelActive(tt.Enum.PRODUCT) &&
                0 == this.parent.totalProduct &&
                "filter" != this.eventType &&
                "collection" != this.eventType
              );
            },
          },
          {
            key: "render",
            value: function () {
              if (
                this.$element &&
                0 ==
                  this.$element.parent().find(".boost-pfs-product-slider-title")
                    .length
              ) {
                var t = this.compileTitleTemplate();
                r()(l.a.products).before(t);
              }
              "init" == this.eventType &&
                (r()(".boost-pfs-filter-tree-mobile-button").hide(),
                r()(".boost-pfs-filter-tree-desktop-button").hide(),
                r()(".boost-pfs-filter-tree").hide(),
                r()(".boost-pfs-filter-left-col").hide(),
                r()(".boost-pfs-filter-right-col, .boost-pfs-filter-right").css(
                  { width: "100%" }
                ),
                r()(l.a.filterTree).hide(),
                r()(l.a.topSorting).hide(),
                r()(l.a.topShowLimit).hide(),
                r()(l.a.topDisplayType).hide(),
                r()(l.a.bottomPagination).hide(),
                r()(l.a.btnLoadPreviousPageWrapperSelector).hide(),
                r()(l.a.loadMoreButtonContainer).hide(),
                r()(l.a.products).hide(),
                r()("body").addClass("boost-pfs-search-no-result-body")),
                o.a.getSettingValue(
                  "search.searchPanelBlocks.mostPopularProducts.active"
                ) && this.initMostPopular();
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !1;
            },
          },
          {
            key: "getNoSearchResultData",
            value: function () {
              var t = [];
              if (r()(l.a.searchNoResultJson).length > 0)
                try {
                  var e = JSON.parse(r()(l.a.searchNoResultJson).html());
                  if (
                    (Array.isArray(e.products) &&
                      e.products.length > 0 &&
                      (t = e.products),
                    r()(
                      "#boost-pfs-instant-search-products-not-found-metafields-json"
                    ).length > 0)
                  )
                    for (
                      var n = JSON.parse(
                          r()(
                            "#boost-pfs-instant-search-products-not-found-metafields-json"
                          ).html()
                        ),
                        i = 0;
                      i < n.products.length;
                      i++
                    )
                      t[i].metafields = n.products[i].metafields;
                } catch (o) {}
              return t;
            },
          },
          {
            key: "initMostPopular",
            value: function () {
              new nE().setProductData(this.data);
            },
          },
          {
            key: "prepareProductData",
            value: function () {
              this.data.forEach(function (t) {
                if (
                  ((t.price /= 100),
                  (t.price_max /= 100),
                  (t.price_min /= 100),
                  (t.compare_at_price /= 100),
                  (t.compare_at_price_max /= 100),
                  (t.compare_at_price_min /= 100),
                  t.variants.forEach(function (t) {
                    (t.price /= 100), (t.compare_at_price /= 100);
                  }),
                  (t.options_with_values = []),
                  Array.isArray(t.options)
                    ? t.options.forEach(function (e, n) {
                        t.options_with_values.push({
                          values: [],
                          name: u.a.slugify(e),
                          label: e,
                        }),
                          (t.options[n] = e.toLowerCase());
                      })
                    : (t.options = []),
                  t.options.length > 0 && Array.isArray(t.variants))
                ) {
                  var e = [];
                  t.variants.forEach(function (n) {
                    n.merged_options = [];
                    for (var i = 0; i < t.options_with_values.length; i++) {
                      var r = n["option" + (i + 1)];
                      r &&
                        !e.includes(r) &&
                        (t.options_with_values[i].values.push({
                          image: null,
                          title: r,
                        }),
                        e.push(r)),
                        n.merged_options.push(
                          t.options_with_values[i].name + ":" + r
                        ),
                        (n["option_" + t.options_with_values[i].name] = r);
                    }
                  });
                } else t.variants = [];
                (t.images_info = []),
                  Array.isArray(t.media) &&
                    (t.images_info = t.media.filter(function (t) {
                      return "image" == t.media_type;
                    })),
                  Array.isArray(t.variants) &&
                    t.variants.forEach(function (e) {
                      (e.image = e.featured_image
                        ? e.featured_image.src
                        : null),
                        e.image &&
                          Array.isArray(t.options_with_values) &&
                          Array.isArray(t.images) &&
                          t.options_with_values.forEach(function (n) {
                            var i = e["option_" + n.name];
                            i &&
                              n.values.forEach(function (n) {
                                if (n.title && n.title == i && !n.image) {
                                  var r = t.images.indexOf(
                                    e.image.replace("https:", "")
                                  );
                                  r >= 0 && (n.image = r + 1);
                                }
                              });
                          });
                    });
                var n = {};
                if (Array.isArray(t.images)) {
                  for (var i = 0; i < t.images.length; i++) {
                    var r = t.images[i];
                    r.startsWith("//") && (r = "https:" + r), (n[i + 1] = r);
                  }
                  t.images = n;
                }
                t.media || (t.media = []),
                  t.barcodes || (t.barcodes = []),
                  t.collections || (t.collections = []),
                  t.metafields || (t.metafields = []),
                  t.skus || (t.skus = []),
                  null == t.inventory_quantity &&
                    (t.inventory_quantity = t.available ? 99999 : 0),
                  t.body_html || (t.body_html = u.a.stripHtml(t.content));
              });
            },
          },
          {
            key: "setData",
            value: function () {
              var t = this.getNoSearchResultData();
              (this.data = t),
                (this.totalProduct = this.data.length),
                (this.eventType = this.parent.eventType),
                this.prepareProductData(),
                (this.children = []),
                (this.productItems = []);
            },
          },
        ]),
        nL(e.prototype, n),
        i && nL(e, i),
        p
      );
    })(tf);
    function n9(t) {
      return (n9 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function nF(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function n2(t, e) {
      return (n2 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function n1(t, e) {
      return e && ("object" === n9(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function nV(t) {
      return (nV = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var nD = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && n2(t, e);
        })(s, t);
        var e,
          n,
          i,
          a = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = nV(t);
              if (e()) {
                var r = nV(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return n1(this, n);
            };
          })(s);
        function s() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, s),
            ((t = a.call(this)).data = null),
            (t.productList = null),
            (t.totalProduct = 0),
            (t.pagination = ""),
            (t.sorting = ""),
            (t.breadcrumbs = ""),
            (t.eventType = ""),
            (t.displayType = ""),
            (t.$element = r()(l.a.products)),
            (t.settngs = {
              paginationType: o.a.getSettingValue("general.paginationType"),
            }),
            (t.productListGobackPreviousPosition = !1),
            t
          );
        }
        return (
          (e = s),
          (n = [
            {
              key: "init",
              value: function () {
                (this.productPlaceholder = new eL()),
                  this.addComponent(this.productPlaceholder),
                  (this.productList = new tf()),
                  this.addComponent(this.productList);
                var t = this._getProductPaginationClass();
                (this.pagination = new t()),
                  this.addComponent(this.pagination),
                  u.a.isLoadPreviousPagePaginationType() &&
                    ((this.loadPrevious = new e$()),
                    this.addComponent(this.loadPrevious)),
                  (this.sorting = new tI()),
                  this.addComponent(this.sorting),
                  (this.limit = new tB()),
                  this.addComponent(this.limit),
                  (this.displayType = new t_()),
                  this.addComponent(this.displayType);
                var e = this._getPageInfoClass();
                (this.pageInfo = new e()),
                  this.addComponent(this.pageInfo),
                  (this.rebotsMeta = new ei()),
                  this.addComponent(this.rebotsMeta),
                  u.a.isSearchPage() &&
                    ((this.searchResultPanels = new z()),
                    this.addComponent(this.searchResultPanels),
                    (this.collectionList = new eJ()),
                    this.addComponent(this.collectionList),
                    (this.collectionListPagination = new eO(
                      l.a.searchCollectionPagination,
                      tt.Enum.COLLECTION
                    )),
                    this.addComponent(this.collectionListPagination),
                    (this.pageList = new no()),
                    this.addComponent(this.pageList),
                    (this.pageListPagination = new eO(
                      l.a.searchPagePagination,
                      tt.Enum.PAGE
                    )),
                    this.addComponent(this.pageListPagination),
                    (this.searchResultTotal = new np()),
                    this.addComponent(this.searchResultTotal));
              },
            },
            {
              key: "isRender",
              value: function () {
                return this.parent.isFetchedProductData;
              },
            },
            {
              key: "setData",
              value: function (t) {
                (this.data = t),
                  (this.totalProduct = t.total_product),
                  (this.eventType = t.event_type),
                  this.productList.setData(t.products),
                  this.pagination.setData(t),
                  this.loadPrevious && this.loadPrevious.setData(t),
                  u.a.isSearchPage() &&
                    (this.searchResultPanels.setData(t, this.eventType),
                    this.collectionList.setData(t, this.eventType),
                    this.pageList.setData(t, this.eventType),
                    t.hasOwnProperty("total_product") &&
                      this.searchResultTotal.setData(t.total_product),
                    0 == this.totalProduct &&
                      "init" == this.eventType &&
                      ((this.productList = new nR()),
                      this.addComponent(this.productList),
                      this.productList.setData())),
                  this.productPlaceholder.setData(t),
                  this.pageInfo.setData(t);
              },
            },
            {
              key: "_getProductPaginationClass",
              value: function () {
                switch (o.a.getSettingValue("general.paginationType")) {
                  case ta.Type.DEFAULT:
                    return tv;
                  case ta.Type.LOAD_MORE:
                    return ec;
                  default:
                    return eg;
                }
              },
            },
            {
              key: "_getPageInfoClass",
              value: function () {
                return u.a.isSearchPage() ? t5 : tX;
              },
            },
            {
              key: "_shouldProductListGobackPreviousPosition",
              value: function () {
                return !this.productListGobackPreviousPosition;
              },
            },
            {
              key: "_changeProductListGobackPreviousPositionStatus",
              value: function () {
                var t =
                  arguments.length > 0 &&
                  void 0 !== arguments[0] &&
                  arguments[0];
                this.productListGobackPreviousPosition = t;
              },
            },
            {
              key: "_productPaginationInfiniteShouldLoadmore",
              value: function () {
                return !this.productListGobackPreviousPosition;
              },
            },
          ]),
          nF(e.prototype, n),
          i && nF(e, i),
          s
        );
      })(g.a),
      nM = n(6);
    function n4(t) {
      return (n4 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function n3(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function n6(t, e) {
      return (n6 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function n5(t, e) {
      return e && ("object" === n4(e) || "function" == typeof e) ? e : nH(t);
    }
    function nH(t) {
      if (void 0 === t)
        throw ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return t;
    }
    function n7(t) {
      return (n7 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var nN = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && n6(t, e);
      })(l, t);
      var e,
        n,
        i,
        s = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = n7(t);
            if (e()) {
              var r = n7(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return n5(this, n);
          };
        })(l);
      function l(t) {
        var e;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, l),
          ((e = s.call(this)).filterTree = t),
          (e.filterTree.mobileButton = nH(e)),
          (e.isCollapsed = !0),
          (e.label = a.a.refineMobile),
          (e.icon = o.a.getSettingValue("general.filterTreeMobileIcon")),
          (e.$element = null),
          e
        );
      }
      return (
        (e = l),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n				<button type="button" aria-label="{{label}}">{{icon}} <span class="{{filterTreeMobileButton}}-label">{{label}}</span></button>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(
                  /{{filterTreeMobileButton}}/g,
                  N.a.filterTreeMobileButton
                )
                .replace(/{{label}}/g, this.label)
                .replace(/{{icon}}/g, this.icon);
            },
          },
          {
            key: "render",
            value: function () {
              this.$element || (this.$element = r()(this.compileTemplate())),
                this.parent.isFetchedFilterData &&
                  (this.filterTree.filterOptions.size > 0 ||
                    this.$element.hide());
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvent;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                this.filterTree &&
                this.$element.on("click", this.onClick.bind(this));
            },
          },
          {
            key: "onClick",
            value: function () {
              "function" == typeof this.filterTree.onClickMobileButton
                ? this.filterTree.onClickMobileButton()
                : (this.toggleFilterTree(),
                  r()("body").toggleClass(N.a.filterTreeOpenBody));
            },
          },
          {
            key: "toggleFilterTree",
            value: function () {
              var t = r()("#" + this.filterTree.id);
              t &&
                !t.hasClass("toggling") &&
                ((this.isCollapsed = !this.isCollapsed),
                o.a.getSettingValue("general.changeMobileButtonLabel") &&
                  ((this.label = this.isCollapsed
                    ? a.a.refineMobile
                    : a.a.refineMobileCollapse),
                  this.$element.text(this.label)),
                this.afterToggleFilterTree());
            },
          },
          {
            key: "afterToggleFilterTree",
            value: function () {
              this.isCollapsed ||
                this.filterTree.filterOptions.forEach(function (t) {
                  t.displayType != nM.a.DisplayType.BOX ||
                    t.isCollapsed ||
                    t.filterItems.forEach(function (t) {
                      t.setBoxItemSize();
                    });
                });
            },
          },
        ]),
        n3(e.prototype, n),
        i && n3(e, i),
        l
      );
    })(g.a);
    function nU(t) {
      return (nU =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function nW(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function nj(t, e) {
      return (nj =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function nq(t, e) {
      return e && ("object" === nU(e) || "function" == typeof e) ? e : nG(t);
    }
    function nG(t) {
      if (void 0 === t)
        throw ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return t;
    }
    function nz(t) {
      return (nz = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var nK = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && nj(t, e);
      })(l, t);
      var e,
        n,
        i,
        s = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = nz(t);
            if (e()) {
              var r = nz(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return nq(this, n);
          };
        })(l);
      function l(t) {
        var e;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, l),
          ((e = s.call(this)).filterTree = t),
          (e.filterTree.desktopButton = nG(e)),
          (e.isCollapsed = !0),
          (e.label = a.a.refineDesktop),
          (e.icon = o.a.getSettingValue("general.filterTreeIcon")),
          (e.iconClose = o.a.getSettingValue("general.filterTreeIconClose")),
          (e.$element = null),
          e
        );
      }
      return (
        (e = l),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n				<button type="button" aria-label="{{label}}">{{icon}} <span class="{{filterTreeDesktopButton}}-label">{{label}}</span></button>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(
                  /{{filterTreeDesktopButton}}/g,
                  N.a.filterTreeDesktopButton
                )
                .replace(/{{label}}/g, this.label)
                .replace(/{{icon}}/g, this.icon);
            },
          },
          {
            key: "render",
            value: function () {
              this.$element || (this.$element = r()(this.compileTemplate())),
                this.parent.isFetchedFilterData &&
                  (this.filterTree.filterOptions.size > 0 ||
                    this.$element.hide());
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvent;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                this.filterTree &&
                this.$element.on("click", this.onClick.bind(this));
            },
          },
          {
            key: "onClick",
            value: function () {
              "function" == typeof this.filterTree.onClickDesktopButton
                ? this.filterTree.onClickDesktopButton()
                : (this.toggleFilterTree(),
                  r()("body").toggleClass(N.a.filterTreeOpenBody));
            },
          },
          {
            key: "toggleFilterTree",
            value: function () {
              var t = r()("#" + this.filterTree.id);
              t &&
                !t.hasClass("toggling") &&
                ((this.isCollapsed = !this.isCollapsed),
                o.a.getSettingValue("general.changeDesktopButtonLabel") &&
                  ((this.label = this.isCollapsed
                    ? a.a.refineDesktop
                    : a.a.refineDesktopCollapse),
                  this.$element.text(this.label)),
                o.a.getSettingValue("general.changeDesktopButtonIcon") &&
                  (this.icon = this.isCollapsed
                    ? o.a.getSettingValue("general.filterTreeIconClose")
                    : o.a.getSettingValue("general.filterTreeIcon")),
                this.afterToggleFilterTree());
            },
          },
          {
            key: "afterToggleFilterTree",
            value: function () {
              this.isCollapsed ||
                this.filterTree.filterOptions.forEach(function (t) {
                  t.displayType != nM.a.DisplayType.BOX ||
                    t.isCollapsed ||
                    t.filterItems.forEach(function (t) {
                      t.setBoxItemSize();
                    });
                });
            },
          },
        ]),
        nW(e.prototype, n),
        i && nW(e, i),
        l
      );
    })(g.a);
    function nY(t) {
      return (nY =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function nQ(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function nX(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function nZ(t, e) {
      return (nZ =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function nJ(t, e) {
      return e && ("object" === nY(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function it(t) {
      return (it = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ie = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && nZ(t, e);
      })(s, t);
      var e,
        n,
        i,
        a = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = it(t);
            if (e()) {
              var r = it(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return nJ(this, n);
          };
        })(s);
      function s() {
        return nQ(this, s), a.apply(this, arguments);
      }
      return (
        (e = s),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<div class="boost-pfs-filter-loading" style="display: none;"><span class="boost-pfs-filter-loading-icon"></span></div>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate();
            },
          },
          {
            key: "setShow",
            value: function (t) {
              this.$element ||
                ((this.$element = r()(this.compileTemplate())),
                r()("body").append(this.$element)),
                this.isEnabled() &&
                  (t ? this.$element.show() : this.$element.hide());
            },
          },
          {
            key: "isEnabled",
            value: function () {
              var t = u.a.isMobile();
              return (
                (!t && o.a.getSettingValue("general.showLoading")) ||
                (t && o.a.getSettingValue("general.showMobileLoading"))
              );
            },
          },
        ]),
        nX(e.prototype, n),
        i && nX(e, i),
        s
      );
    })(g.a);
    function ii(t) {
      return (ii =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function ir(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function io(t, e) {
      return (io =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function ia(t, e) {
      return e && ("object" === ii(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function is(t) {
      return (is = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var il = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && io(t, e);
        })(s, t);
        var e,
          n,
          i,
          a = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = is(t);
              if (e()) {
                var r = is(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return ia(this, n);
            };
          })(s);
        function s() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, s),
            ((t = a.call(this)).style = o.a.getSettingValue(
              "general.styleScrollToTop"
            )),
            (t.$element = null),
            t
          );
        }
        return (
          (e = s),
          (n = [
            {
              key: "getTemplate",
              value: function () {
                return '\n			<button aria-label="Back to top" class="boost-pfs-filter-scroll-to-top {{style}}" style="display: inline;"></button>\n		'.trim();
              },
            },
            {
              key: "compileTemplate",
              value: function () {
                return this.getTemplate().replace(/{{style}}/g, this.style);
              },
            },
            {
              key: "isRender",
              value: function () {
                return !this.$element;
              },
            },
            {
              key: "render",
              value: function () {
                !this.$element &&
                  this.isShow() &&
                  ((this.$element = r()(this.compileTemplate())),
                  r()("body").append(this.$element));
              },
            },
            {
              key: "isBindEvents",
              value: function () {
                return !this.isBoundEvent;
              },
            },
            {
              key: "bindEvents",
              value: function () {
                this.$element &&
                  (this.$element.on("click", this.scrollToTop.bind(this)),
                  r()(document).scroll(this.setVisibility.bind(this)));
              },
            },
            {
              key: "scrollToTop",
              value: function () {
                window.scrollTo({ top: 0, behavior: "smooth" });
              },
            },
            {
              key: "setVisibility",
              value: function () {
                ((document.documentElement &&
                  document.documentElement.scrollTop) ||
                  document.body.scrollTop) > 100
                  ? this.$element.show()
                  : this.$element.hide();
              },
            },
            {
              key: "isShow",
              value: function () {
                return o.a.getSettingValue("general.activeScrollToTop");
              },
            },
          ]),
          ir(e.prototype, n),
          i && ir(e, i),
          s
        );
      })(g.a),
      ic = {
        FilterTreeType: { VERTICAL: "vertical", HORIZONTAL: "horizontal" },
      };
    function iu(t) {
      return (iu =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function ip(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ih(t, e) {
      return (ih =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function id(t, e) {
      return e && ("object" === iu(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function ig(t) {
      return (ig = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    n(58), n(116), n(119), n(182), n(83), n(47);
    var iy = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && ih(t, e);
      })(c, t);
      var e,
        n,
        i,
        l = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = ig(t);
            if (e()) {
              var r = ig(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return id(this, n);
          };
        })(c);
      function c(t, e) {
        var n;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, c),
          ((n = l.call(this)).filterTreeType = t),
          (n.clearType = e),
          (n.requestInstantly = !0),
          (n.label =
            n.clearType == c.ClearType.CLEAR_ALL ? a.a.clearAll : a.a.clear),
          (n.filterOptionLabel = ""),
          (n.filterValueLabel = ""),
          n
        );
      }
      return (
        (e = c),
        (i = [
          {
            key: "ClearType",
            get: function () {
              return {
                CLEAR_SINGLE_VALUE: "clear-single-value",
                CLEAR_OPTION_VALUES: "clear-option-values",
                CLEAR_ALL: "clear-all",
              };
            },
          },
        ]),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              switch (this.clearType) {
                case c.ClearType.CLEAR_SINGLE_VALUE:
                  return '\n					<button aria-label="{{adaLabel}}" class="{{class.button}} {{class.clearButton}}">\n						<span class="refine-by-type">\n							<span class="refine-by-option">{{filterOptionLabel}}</span><span class="refine-by-value">{{filterValueLabel}}</span>\n						</span>\n					</button>\n				'.trim();
                case c.ClearType.CLEAR_OPTION_VALUES:
                  return '\n					<button aria-label="{{adaLabel}}" class="{{class.button}} {{class.clearButton}}">{{label}}</button>\n				'.trim();
                case c.ClearType.CLEAR_ALL:
                  return '\n					<button aria-label="{{adaLabel}}" class="{{class.button}} {{class.clearAllButton}}">{{label}}</button>\n				'.trim();
                default:
                  console.warn("Wrong filter clear type");
              }
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return (
                this.buildLabel(),
                this.getTemplate()
                  .replace(/{{label.clear}}/g, a.a.clear)
                  .replace(/{{class.button}}/g, N.a.button)
                  .replace(/{{class.clearButton}}/g, N.a.clearButton)
                  .replace(/{{class.clearAllButton}}/g, N.a.clearAllButton)
                  .replace(/{{adaLabel}}/g, u.a.stripHtml(this.adaLabel))
                  .replace(/{{label}}/g, u.a.stripHtml(this.label))
                  .replace(/{{filterOptionLabel}}/g, this.filterOptionLabel)
                  .replace(/{{filterValueLabel}}/g, this.filterValueLabel)
              );
            },
          },
          {
            key: "render",
            value: function () {
              this.$element || (this.$element = r()(this.compileTemplate())),
                this.isVisible() ? this.$element.show() : this.$element.hide();
            },
          },
          {
            key: "buildLabel",
            value: function () {
              switch (((this.adaLabel = ""), this.clearType)) {
                case c.ClearType.CLEAR_SINGLE_VALUE:
                  var t = this.parent;
                  if (t && t.type && t.label) {
                    var e = u.a.stripHtml(t.label);
                    o.a.getSettingValue("general.enable3rdCurrencySupport") &&
                      "Price" == this.parent.type &&
                      (e = ""),
                      (this.adaLabel = a.a.ada.clearFilterItem
                        .replace(/{{filterOption}}/g, u.a.stripHtml(t.type))
                        .replace(/{{filterItem}}/g, e)),
                      (this.filterOptionLabel = u.a.stripHtml(
                        t.type &&
                          this.filterTreeType == ic.FilterTreeType.VERTICAL
                          ? t.type + ": "
                          : ""
                      )),
                      (this.filterValueLabel = u.a.stripHtml(t.label));
                  }
                  break;
                case c.ClearType.CLEAR_OPTION_VALUES:
                  var n = this.parent;
                  n &&
                    n.label &&
                    (this.adaLabel = a.a.ada.clearFilterOption.replace(
                      /{{filterOption}}/g,
                      u.a.stripHtml(n.label)
                    ));
                  break;
                case c.ClearType.CLEAR_ALL:
                  this.adaLabel = a.a.ada.clearAllFilterItems;
              }
            },
          },
          {
            key: "isVisible",
            value: function () {
              var t = !0;
              switch (this.clearType) {
                case c.ClearType.CLEAR_OPTION_VALUES:
                  var e = this.parent;
                  if (
                    e.displayType == nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS
                  ) {
                    var n = e.filterOptionId.replace(
                      s.a.prefix + "_c_",
                      s.a.prefix + "_ct_"
                    );
                    t = s.a.queryParams[e.filterOptionId] || s.a.queryParams[n];
                  } else t = s.a.queryParams[e.filterOptionId];
                  break;
                case c.ClearType.CLEAR_ALL:
                  (t = !1),
                    Object.keys(s.a.queryParams).forEach(function (e) {
                      if (e.startsWith(s.a.prefix)) {
                        var n = s.a.queryParams[e];
                        (!u.a.isCollectionPage() &&
                          e.startsWith(s.a.prefix + "_c_") &&
                          0 == n) ||
                          (t = !0);
                      }
                    });
              }
              return !!t;
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvent;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                this.$element.on("click", this.onClick.bind(this));
            },
          },
          {
            key: "onClick",
            value: function (t) {
              if ((t && t.preventDefault(), this.requestInstantly))
                switch (this.clearType) {
                  case c.ClearType.CLEAR_SINGLE_VALUE:
                    this.onClearSingleValue();
                    break;
                  case c.ClearType.CLEAR_OPTION_VALUES:
                    this.onClearOptionValues();
                    break;
                  case c.ClearType.CLEAR_ALL:
                    this.onClearAll();
                }
              else
                this.clearType === c.ClearType.CLEAR_OPTION_VALUES &&
                  this.onDeselectOptionValues();
            },
          },
          {
            key: "onClearSingleValue",
            value: function () {
              var t = this.parent,
                e = t.filterOptionId,
                n = t.filterItemId,
                i = s.a.queryParams[e];
              if (null != i) {
                Array.isArray(i) || (i = [i]);
                var r = i.indexOf(n),
                  o = [];
                if (
                  (r > -1 &&
                    (o = i.filter(function (t, e) {
                      return e != r;
                    })),
                  0 == o.length
                    ? (K.default.setParam(e, null),
                      K.default.setParam(e + "_and_condition", null),
                      K.default.setParam(e + "_show_exact_rating", null),
                      K.default.setParam(e + "_exclude_from_value", null),
                      K.default.setParam(
                        e
                          .replace(s.a.prefix + "_l_", s.a.prefix + "_li_")
                          .replace(s.a.prefix + "_vl_", s.a.prefix + "_vli_") +
                          "_ibsl",
                        null
                      ))
                    : K.default.setParam(e, o),
                  !u.a.isCollectionPage() && e.startsWith(s.a.prefix + "_ct_"))
                ) {
                  var a = e.replace(s.a.prefix + "_ct_", s.a.prefix + "_c_");
                  K.default.setParam(a, null);
                }
                K.default.setParam("page", 1);
                var l = { filterOptionId: e, filterOptionValue: n };
                K.default.applyFilter("clear", l);
              }
            },
          },
          {
            key: "onClearOptionValues",
            value: function () {
              var t = this.parent;
              t.filterTreeType == ic.FilterTreeType.HORIZONTAL &&
                !o.a.getSettingValue("general.keepTabOpenState") &&
                t.collapse &&
                this.parent.collapse.onToggleHorizontal(),
                (s.a.internalClick = !0);
              var e = t.filterOptionId;
              t.displayType == nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS &&
                u.a.isCollectionPage() &&
                (e = e.replace(s.a.prefix + "_c_", s.a.prefix + "_ct_"));
              var n = { filterOptionId: e };
              K.default.setParam("page", 1),
                K.default.setParam(e, null),
                K.default.setParam(e + "_and_condition", null),
                K.default.setParam(e + "_show_exact_rating", null),
                K.default.setParam(e + "_exclude_from_value", null),
                K.default.setParam(
                  e
                    .replace(s.a.prefix + "_l_", s.a.prefix + "_li_")
                    .replace(s.a.prefix + "_vl_", s.a.prefix + "_vli_") +
                    "_ibsl",
                  null
                ),
                K.default.applyFilter("clear", n);
            },
          },
          {
            key: "onClearAll",
            value: function () {
              var t = [];
              Object.keys(s.a.queryParams).forEach(function (e) {
                e.startsWith(s.a.prefix) && t.push(e);
              }),
                t.forEach(function (t) {
                  K.default.setParam(t, null);
                }),
                K.default.setParam("page", 1),
                K.default.applyFilter("clearAll", {});
            },
          },
          {
            key: "onDeselectOptionValues",
            value: function () {
              this.parent.filterItems &&
                this.parent.filterItems.forEach(function (t) {
                  t.$element.removeClass("selected"), (t.isSelected = !1);
                });
            },
          },
        ]),
        ip(e.prototype, n),
        i && ip(e, i),
        c
      );
    })(g.a);
    function im(t) {
      return (im =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function iv(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ib(t, e) {
      return (ib =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function iS(t, e) {
      return e && ("object" === im(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function i$(t) {
      return (i$ = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var iT = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && ib(t, e);
      })(c, t);
      var e,
        n,
        i,
        l = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = i$(t);
            if (e()) {
              var r = i$(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return iS(this, n);
          };
        })(c);
      function c(t, e) {
        var n;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, c),
          ((n = l.call(this)).filterTreeType =
            t || ic.FilterTreeType.HORIZONTAL),
          (n.applyType = e || c.ApplyType.APPLY_OPTION_VALUES),
          n
        );
      }
      return (
        (e = c),
        (i = [
          {
            key: "ApplyType",
            get: function () {
              return {
                APPLY_OPTION_VALUES: "apply-option-values",
                APPLY_ALL: "apply-all",
              };
            },
          },
        ]),
        (n = [
          {
            key: "init",
            value: function () {
              this.label =
                this.filterTreeType == ic.FilterTreeType.HORIZONTAL &&
                o.a.getSettingValue("general.requestInstantly")
                  ? a.a.close
                  : a.a.apply;
            },
          },
          {
            key: "getTemplate",
            value: function () {
              return this.applyType == c.ApplyType.APPLY_ALL
                ? '\n				<button class="{{class.button}} {{class.applyAllButton}}">{{label.applyAll}}</button>\n			'.trim()
                : '\n				<button class="{{class.button}} {{class.applyButton}}">{{label.apply}}</button>\n			'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(/{{label.apply}}/g, u.a.stripHtml(this.label))
                .replace(/{{label.applyAll}}/g, a.a.applyAll)
                .replace(/{{class.button}}/g, N.a.button)
                .replace(/{{class.applyButton}}/g, N.a.applyButton)
                .replace(/{{class.applyAllButton}}/g, N.a.applyAllButton);
            },
          },
          {
            key: "isRender",
            value: function () {
              return this.parent.filterType != nM.a.FilterType.COLLECTION;
            },
          },
          {
            key: "render",
            value: function () {
              this.$element || (this.$element = r()(this.compileTemplate()));
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvent;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                this.$element.on("click", this.onClick.bind(this));
            },
          },
          {
            key: "onClick",
            value: function (t) {
              if (
                (t && t.preventDefault(),
                this.applyType == c.ApplyType.APPLY_ALL)
              )
                this.onApplyAll(),
                  window.scrollTo({ top: 0, behavior: "smooth" });
              else {
                if (this.filterTreeType == ic.FilterTreeType.HORIZONTAL) {
                  if (
                    !o.a.getSettingValue("general.keepTabOpenState") &&
                    this.parent.collapse
                  )
                    return void this.parent.collapse.onToggleHorizontal();
                  if (o.a.getSettingValue("general.requestInstantly")) return;
                }
                this.onApplyOptionValues();
              }
            },
          },
          {
            key: "onApplyOptionValues",
            value: function () {
              var t = [],
                e = this.parent.filterOptionId,
                n = this.parent.filterItems;
              this.parent.displayType == nM.a.DisplayType.MULTI_LEVEL_TAG &&
                (n = this.parent.allNestedFilterItems),
                n.forEach(function (e) {
                  e.isSelected && t.push(e.value);
                }),
                K.default.setParam(e, t),
                K.default.setParam(
                  e + "_and_condition",
                  !!(this.parent.useAndCondition && t.length > 0) || null
                ),
                K.default.setParam(
                  e + "_show_exact_rating",
                  !!(this.parent.showExactRating && t.length > 0) || null
                ),
                K.default.setParam(
                  e + "_exclude_from_value",
                  !!(this.parent.excludePriceFromValue && t.length > 0) || null
                ),
                K.default.setParam(
                  e
                    .replace(s.a.prefix + "_l_", s.a.prefix + "_li_")
                    .replace(s.a.prefix + "_vl_", s.a.prefix + "_vli_") +
                    "_ibsl",
                  !!(
                    this.parent.inventoryBaseSelectedLocations && t.length > 0
                  ) || null
                ),
                K.default.setParam("page", 1);
              var i = { filterOptionId: e, filterOptionValue: t };
              K.default.applyFilter("filter", i);
            },
          },
          {
            key: "onApplyAll",
            value: function () {
              (this.filterTreeType == ic.FilterTreeType.HORIZONTAL &&
                (this.parent.filterOptions &&
                  this.parent.filterOptions.forEach(function (t) {
                    t.collapse &&
                      !t.collapse.isCollapsed &&
                      t.collapse.onToggleHorizontal();
                  }),
                o.a.getSettingValue("general.requestInstantly"))) ||
                (this.parent.filterOptions &&
                  this.parent.filterOptions.forEach(function (t) {
                    var e = [],
                      n = t.filterOptionId;
                    (t.displayType == nM.a.DisplayType.MULTI_LEVEL_TAG
                      ? t.allNestedFilterItems
                      : t.filterItems
                    ).forEach(function (t) {
                      t.isSelected && e.push(t.value);
                    }),
                      K.default.setParam(n, e),
                      K.default.setParam(
                        n + "_and_condition",
                        !!(t.useAndCondition && e.length > 0) || null
                      ),
                      K.default.setParam(
                        n + "_show_exact_rating",
                        !!(t.showExactRating && e.length > 0) || null
                      ),
                      K.default.setParam(
                        n + "_exclude_from_value",
                        !!(t.excludePriceFromValue && e.length > 0) || null
                      ),
                      K.default.setParam(
                        n
                          .replace(s.a.prefix + "_l_", s.a.prefix + "_li_")
                          .replace(s.a.prefix + "_vl_", s.a.prefix + "_vli_") +
                          "_ibsl",
                        !!(t.inventoryBaseSelectedLocations && e.length > 0) ||
                          null
                      );
                  }),
                K.default.setParam("page", 1),
                K.default.applyFilter("filter"),
                "style-expand" ==
                  o.a.getSettingValue("general.filterTreeHorizontalStyle") &&
                  r()("body").removeClass(N.a.filterTreeOpenBody));
            },
          },
        ]),
        iv(e.prototype, n),
        i && iv(e, i),
        c
      );
    })(g.a);
    function iP(t) {
      return (iP =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function i_(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function i8(t, e) {
      return (i8 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function ik(t, e) {
      return e && ("object" === iP(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function iO(t) {
      return (iO = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    n(170);
    var iC = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && i8(t, e);
      })(p, t);
      var e,
        n,
        i,
        l = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = iO(t);
            if (e()) {
              var r = iO(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return ik(this, n);
          };
        })(p);
      function p(t) {
        var e;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, p),
          (e = l.call(this)),
          t ||
            console.warn(
              "Pass filterTreeType into FilterOptionItem constructor."
            ),
          (e.requestInstantly = !0),
          (e.filterTreeType = t),
          (e.$element = null),
          (e.settings = {
            enable3rdCurrencySupport: o.a.getSettingValue(
              "general.enable3rdCurrencySupport"
            ),
          }),
          e
        );
      }
      return (
        (e = p),
        (n = [
          {
            key: "init",
            value: function () {
              this.requestInstantly =
                this.filterTreeType == ic.FilterTreeType.VERTICAL ||
                o.a.getSettingValue("general.requestInstantly");
            },
          },
          {
            key: "getTemplate",
            value: function () {
              console.warn("Override this method");
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              console.warn("Override this method");
            },
          },
          {
            key: "isRender",
            value: function () {
              var t = this.filterOption ? this.filterOption : this.parent,
                e =
                  this.hasOwnProperty("docCount") &&
                  (this.docCount > 0 || null === this.docCount),
                n =
                  t.filterType == nM.a.FilterType.REVIEW_RATINGS &&
                  t.showExactRating,
                i =
                  t.filterType == nM.a.FilterType.COLLECTION &&
                  (t.keepValuesStatic || "all" == this.handle),
                r =
                  t.displayType == nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS &&
                  1 != this.level,
                a = o.a.getSettingValue("general.showOutOfStockOption");
              return n || i || r || e || a;
            },
          },
          {
            key: "render",
            value: function () {
              this.$element || (this.$element = r()(this.compileTemplate())),
                (this.isSelected = this.isAppliedFilter()),
                this.isSelected
                  ? (this.$element.addClass("selected"),
                    this.$element.find("button").attr("aria-checked", !0),
                    this.$element.find("a").attr("aria-current", !0),
                    this.$element
                      .find(".boost-pfs-check-box")
                      .attr("aria-checked", !0))
                  : (this.$element.removeClass("selected"),
                    this.$element.find("button").removeAttr("aria-checked"),
                    this.$element.find("a").removeAttr("aria-current"),
                    this.$element
                      .find(".boost-pfs-check-box")
                      .removeAttr("aria-checked"));
              var t = this.countLabel
                  ? a.a.ada.productCount.replace(/{{count}}/g, this.countLabel)
                  : "",
                e = this.$element.find(".boost-pfs-filter-option-amount");
              e && e.length > 0 && e.attr("aria-label", u.a.stripHtml(t));
            },
          },
          {
            key: "buildCount",
            value: function () {
              var t = "";
              if (
                o.a.getSettingValue("general.showFilterOptionCount") &&
                "box" != this.parent.displayType
              ) {
                var e = !1;
                (this.docCount > 0 ||
                  o.a.getSettingValue("general.showOutOfStockOption") ||
                  (this.parent.filterType == nM.a.FilterType.REVIEW_RATINGS &&
                    this.parent.showExactRating)) &&
                  (e = !0);
                var n = "all" == this.handle && 0 == this.docCount;
                !e ||
                  this.parent.keepValuesStatic ||
                  n ||
                  (t = "(" + this.docCount + ")");
              }
              return u.a.stripHtml(t);
            },
          },
          {
            key: "buildLabel",
            value: function () {
              var t = this.filterOption ? this.filterOption : this.parent,
                e = u.a.unescape(this.label),
                n = t.prefix;
              return "string" != typeof e
                ? ""
                : ("string" == typeof n &&
                    ((n = n.replace(/\\/g, "")), (e = e.replace(n, "").trim())),
                  e.indexOf("boost-pfs-filter-icon-star") > -1
                    ? e
                    : ((t.displayAllValuesInUppercaseForm =
                        t.displayAllValuesInUppercaseForm || !1),
                      t.displayAllValuesInUppercaseForm
                        ? e.toUpperCase()
                        : o.a.getSettingValue(
                            "general.forceCapitalizeFilterOptionValues"
                          )
                        ? u.a.capitalize(e, !0)
                        : o.a.getSettingValue(
                            "general.capitalizeFirstLetterFilterOptionValues"
                          )
                        ? u.a.capitalize(e, !0, !0)
                        : o.a.getSettingValue(
                            "general.capitalizeFilterOptionValues"
                          )
                        ? u.a.capitalize(e)
                        : u.a.stripHtml(e)));
            },
          },
          {
            key: "buildPercentSaleLabel",
            value: function () {
              var t = "";
              return (
                (t = this.from
                  ? this.to
                    ? this.from + "% - " + this.to + "%"
                    : a.a.above + " " + this.from + "%"
                  : a.a.under + " " + this.to + "%"),
                u.a.stripHtml(t)
              );
            },
          },
          {
            key: "buildPriceListLabel",
            value: function () {
              var t = "";
              return (
                (t = this.from
                  ? this.to
                    ? u.a.formatMoney(this.from, s.a.moneyFormat, !0) +
                      " - " +
                      u.a.formatMoney(this.to, s.a.moneyFormat, !0)
                    : a.a.above +
                      " " +
                      u.a.formatMoney(this.from, s.a.moneyFormat, !0)
                  : a.a.under +
                    " " +
                    u.a.formatMoney(this.to, s.a.moneyFormat, !0)),
                u.a.stripHtml(t)
              );
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvent;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                this.$element.on("click", this.onClick.bind(this));
            },
          },
          {
            key: "onClick",
            value: function (t) {
              t && t.preventDefault(),
                this.isDisabled() ||
                  (this.requestInstantly ||
                  this.parent.filterType == nM.a.FilterType.COLLECTION
                    ? this.onApplyFilter()
                    : this.onSelectFilter());
            },
          },
          {
            key: "isDisabled",
            value: function () {
              return this.parent.filterType == nM.a.FilterType.COLLECTION
                ? !this.parent.keepValuesStatic &&
                    "all" != this.handle &&
                    0 == this.docCount
                : 0 == this.docCount;
            },
          },
          {
            key: "isAppliedFilter",
            value: function () {
              var t = this.parent.filterOptionId;
              if (this.parent.filterType == nM.a.FilterType.COLLECTION) {
                if (s.a.queryParams.collection_scope == this.collectionId)
                  return !0;
              } else {
                var e = s.a.queryParams[t];
                if (Array.isArray(e) && e.includes(this.value)) return !0;
              }
              return !1;
            },
          },
          {
            key: "onSelectFilter",
            value: function () {
              var t = this;
              (this.isSelected = !this.isSelected),
                this.$element.toggleClass("selected"),
                this.isSelected
                  ? this.$element.find("button").attr("aria-checked", !0)
                  : this.$element.find("button").removeAttr("aria-checked"),
                this.isSelected
                  ? this.$element
                      .find(".boost-pfs-check-box")
                      .attr("aria-checked", !0)
                  : this.$element
                      .find(".boost-pfs-check-box")
                      .removeAttr("aria-checked"),
                this.isSelected &&
                  this.parent.selectType == nM.a.SelectType.SINGLE &&
                  this.parent.filterItems.forEach(function (e) {
                    e != t &&
                      (e.$element &&
                        (e.$element.removeClass("selected"),
                        t.$element.find("button").removeAttr("aria-checked"),
                        t.$element
                          .find(".boost-pfs-check-box")
                          .removeAttr("aria-checked")),
                      (e.isSelected = !1));
                  });
            },
          },
          {
            key: "onApplyFilter",
            value: function () {
              var t = this,
                e = this.parent.filterType,
                n = this.parent.displayType,
                i = this.parent.selectType,
                r = this.parent.filterOptionId,
                o =
                  "all" == this.handle &&
                  0 == this.docCount &&
                  e == nM.a.FilterType.COLLECTION;
              if (
                this.docCount > 0 ||
                this.parent.keepValuesStatic ||
                n == nM.a.DisplayType.RANGE ||
                o
              ) {
                s.a.internalClick = !0;
                var a = "";
                if (e == nM.a.FilterType.COLLECTION) {
                  (this.isSelected = !0),
                    (s.a.collectionId = this.collectionId),
                    K.default.setParam("collection_scope", this.collectionId),
                    u.a.isCollectionPage()
                      ? (c.a.setAddressBarPathAfterFilter(
                          "/collections/" + this.handle
                        ),
                        c.a.setWindowTitleAfterFilter(
                          u.a.stripHtml(this.label) + " - " + s.a.shopName
                        ),
                        K.default.setParam("sort", this.sortOrder),
                        (s.a.defaultSorting = this.sortOrder))
                      : K.default.setParam(r, this.collectionId);
                  var l = [];
                  Object.keys(s.a.queryParams).forEach(function (t) {
                    t.startsWith(s.a.prefix) &&
                      !t.startsWith(s.a.prefix + "_c") &&
                      l.push(t);
                  }),
                    l.forEach(function (t) {
                      K.default.setParam(t, null);
                    }),
                    (a = "collection");
                } else {
                  this.isSelected = !this.isSelected;
                  var p = null;
                  i == nM.a.SelectType.SINGLE
                    ? (p = this.isSelected ? [this.value] : [])
                    : (Array.isArray((p = s.a.queryParams[r])) || (p = []),
                      this.isSelected
                        ? p.includes(this.value) || p.push(this.value)
                        : (p = p.filter(function (e) {
                            return e !== t.value;
                          }))),
                    K.default.setParam(r, p),
                    K.default.setParam(
                      r + "_and_condition",
                      !!(this.parent.useAndCondition && p.length > 0) || null
                    ),
                    K.default.setParam(
                      r + "_show_exact_rating",
                      !!(this.parent.showExactRating && p.length > 0) || null
                    ),
                    K.default.setParam(
                      r + "_exclude_from_value",
                      !!(this.parent.excludePriceFromValue && p.length > 0) ||
                        null
                    ),
                    K.default.setParam(
                      r
                        .replace(s.a.prefix + "_l_", s.a.prefix + "_li_")
                        .replace(s.a.prefix + "_vl_", s.a.prefix + "_vli_") +
                        "_ibsl",
                      !!(
                        this.parent.inventoryBaseSelectedLocations &&
                        p.length > 0
                      ) || null
                    ),
                    (a = "filter");
                }
                K.default.setParam("page", 1);
                var f = { filterOptionId: r, filterValue: this.value };
                K.default.applyFilter(a, f);
              }
            },
          },
          {
            key: "setData",
            value: function (t) {
              switch (
                ((this.value = t.key),
                (this.label = u.a.stripHtml(t.key)),
                (this.docCount = t.doc_count ? t.doc_count : 0),
                (this.isRenderOnScroll = t.isRenderOnScroll),
                this.parent.filterType)
              ) {
                case nM.a.FilterType.COLLECTION:
                  (this.collectionId = t.key),
                    (this.label = u.a.stripHtml(
                      t.displayName ? t.displayName : t.label
                    )),
                    (this.handle = t.handle),
                    (this.href = u.a.isCollectionPage()
                      ? "/collections/" + this.handle
                      : "#");
                  var e = u.a.getDefaultSorting(this.collectionId);
                  this.sortOrder =
                    "" != e
                      ? e
                      : t.sort_order
                      ? t.sort_order
                      : s.a.defaultSorting;
                  break;
                case nM.a.FilterType.REVIEW_RATINGS:
                  (this.from = parseFloat(t.from).toFixed()),
                    (this.value = this.from);
                  break;
                case nM.a.FilterType.STOCK:
                  (this.value = "in-stock" == t.key ? "true" : "false"),
                    (this.label = u.a.stripHtml(t.label));
                  break;
                case nM.a.FilterType.PERCENT_SALE:
                  (this.from = t.from),
                    (this.to = t.to),
                    (this.label = this.buildPercentSaleLabel()),
                    (this.value =
                      (this.from ? this.from : "") +
                      ":" +
                      (this.to ? this.to : ""));
                  break;
                case nM.a.FilterType.PRICE:
                case nM.a.FilterType.VARIANTS_PRICE:
                  (this.from = t.from),
                    (this.to = t.to),
                    (this.label = this.buildPriceListLabel()),
                    (this.value =
                      (this.from ? this.from : "") +
                      ":" +
                      (this.to ? this.to : ""));
              }
              (this.label = this.buildLabel()),
                (this.countLabel = this.buildCount()),
                (this.isSelected = this.isAppliedFilter());
            },
          },
        ]),
        i_(e.prototype, n),
        i && i_(e, i),
        p
      );
    })(g.a);
    function iw(t) {
      return (iw =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function iI(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function iE(t, e) {
      return (iE =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function i0(t, e) {
      return e && ("object" === iw(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function iL(t) {
      return (iL = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var iA = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && iE(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = iL(t);
            if (e()) {
              var r = iL(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return i0(this, n);
          };
        })(o);
      function o(t) {
        var e;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, o),
          ((e = r.call(this, t)).$element = null),
          e
        );
      }
      return (
        (e = o),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return this.parent.filterType == nM.a.FilterType.COLLECTION
                ? '\n				<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n					<a class="{{class.button}}" href="{{href}}">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n						<span class="boost-pfs-filter-option-value">{{label}}</span>\n						<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n					</a>\n				</li>\n			'.trim()
                : '\n				<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n					<button role="checkbox" class="{{class.button}}">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n						<span class="boost-pfs-filter-option-value">{{label}}</span>\n						<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n					</button>\n				</li>\n			'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(/{{class.filterOptionItem}}/g, N.a.filterOptionItem)
                .replace(/{{class.filterOptionLabel}}/g, N.a.filterOptionLabel)
                .replace(/{{class.button}}/g, N.a.button)
                .replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "")
                .replace(/{{label}}/g, u.a.stripHtml(this.label))
                .replace(/{{href}}/g, this.href)
                .replace(/{{countLabel}}/g, u.a.stripHtml(this.countLabel));
            },
          },
        ]),
        iI(e.prototype, n),
        i && iI(e, i),
        o
      );
    })(iC);
    function ix(t) {
      return (ix =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function iB(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function iR(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function i9(t, e, n) {
      return (i9 =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = i1(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function iF(t, e) {
      return (iF =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function i2(t, e) {
      return e && ("object" === ix(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function i1(t) {
      return (i1 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var iV = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && iF(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = i1(t);
            if (e()) {
              var r = i1(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return i2(this, n);
          };
        })(o);
      function o() {
        return iB(this, o), r.apply(this, arguments);
      }
      return (
        (e = o),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n				<button role="checkbox" class="{{class.button}}">\n        <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n					<span class="boost-pfs-filter-option-value">{{label}}</span>\n					<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n				</button>\n			</li>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(/{{class.filterOptionItem}}/g, N.a.filterOptionItem)
                .replace(/{{class.filterOptionLabel}}/g, N.a.filterOptionLabel)
                .replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "")
                .replace(/{{class.button}}/g, N.a.button)
                .replace(/{{label}}/g, u.a.stripHtml(this.label))
                .replace(/{{countLabel}}/g, u.a.stripHtml(this.countLabel));
            },
          },
          {
            key: "bindEvents",
            value: function () {
              i9(i1(o.prototype), "bindEvents", this).call(this),
                this.setBoxItemSize();
            },
          },
          {
            key: "setBoxItemSize",
            value: function () {
              this.filterTreeType == ic.FilterTreeType.VERTICAL &&
                this.$element &&
                this.$element.css("width", this.parent.calculateBoxItemSize());
            },
          },
        ]),
        iR(e.prototype, n),
        i && iR(e, i),
        o
      );
    })(iC);
    function iD(t) {
      return (iD =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function iM(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function i4(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function i3(t, e, n) {
      return (i3 =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = iH(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function i6(t, e) {
      return (i6 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function i5(t, e) {
      return e && ("object" === iD(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function iH(t) {
      return (iH = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var i7 = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && i6(t, e);
      })(a, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = iH(t);
            if (e()) {
              var r = iH(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return i5(this, n);
          };
        })(a);
      function a() {
        return iM(this, a), r.apply(this, arguments);
      }
      return (
        (e = a),
        (i = [
          {
            key: "SwatchType",
            get: function () {
              return {
                ONE_COLOR: "one_color",
                TWO_COLORS: "two_colors",
                IMAGE: "image",
              };
            },
          },
        ]),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<li class="{{class.filterOptionItem}} {{disabled}} {{swatchBorder}}">\n				<span class="boost-pfs-filter-option-swatch-image" \n					style="background-color: {{backgroundColor}}; \n					background-image: {{backgroundImage}};" title="{{label}}">\n				</span>\n				<button role="checkbox" class="{{class.button}}">\n          <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n					<span class="boost-pfs-filter-option-value">{{label}}</span>\n					<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n				</button>\n			</li> \n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(/{{class.filterOptionItem}}/g, N.a.filterOptionItem)
                .replace(/{{class.filterOptionLabel}}/g, N.a.filterOptionLabel)
                .replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "")
                .replace(/{{class.button}}/g, N.a.button)
                .replace(/{{label}}/g, this.label)
                .replace(/{{countLabel}}/g, this.countLabel)
                .replace(/{{backgroundColor}}/g, this.backgroundColor)
                .replace(/{{backgroundImage}}/g, this.backgroundImage)
                .replace(/{{swatchBorder}}/g, this.swatchBorder);
            },
          },
          {
            key: "render",
            value: function () {
              this.buildSwatchSettings() ||
                ((this.swatchFileName = this.buildSwatchFileName()),
                (this.swatchFileUrl = u.a.getFilePath(
                  this.swatchFileName,
                  s.a.swatchExtension,
                  o.a.getSettingValue("general.swatchImageVersion")
                )),
                (this.backgroundImage = "url(" + this.swatchFileUrl + ");"),
                (this.backgroundColor = this.buildBackgroundColor())),
                (this.swatchBorder = ["white", "#FFFFFF"].includes(
                  this.backgroundColor
                )
                  ? "has-border"
                  : ""),
                i3(iH(a.prototype), "render", this).call(this);
            },
          },
          {
            key: "buildSwatchSettings",
            value: function () {
              var t = this,
                e = o.a.getSettingValue("swatch_settings"),
                n = !1;
              if (
                ((this.swatchSettingKey = null), (this.swatchSetting = null), e)
              ) {
                var i = Object.keys(e);
                Array.isArray(i) &&
                  i.length > 0 &&
                  ((this.swatchSettingKey = i.find(function (e) {
                    return (
                      e.replace("pfs-swatch-", "") == t.value ||
                      e.replace("pfs-swatch-", "").toLowerCase() ==
                        t.value.toLowerCase()
                    );
                  })),
                  (this.swatchSetting = e[this.swatchSettingKey]));
              }
              if (e && this.swatchSetting)
                switch (this.swatchSetting.type) {
                  case a.SwatchType.ONE_COLOR:
                    this.swatchSetting.colorCodes.length > 0 &&
                      this.swatchSetting.colorCodes[0] &&
                      ((this.backgroundImage = "none"),
                      (this.backgroundColor = this.swatchSetting.colorCodes[0]),
                      (n = !0));
                    break;
                  case a.SwatchType.TWO_COLORS:
                    this.swatchSetting.colorCodes.length > 1 &&
                      this.swatchSetting.colorCodes[0] &&
                      this.swatchSetting.colorCodes[1] &&
                      ((this.backgroundImage =
                        "linear-gradient(to top left, " +
                        this.swatchSetting.colorCodes[1] +
                        " 50%, " +
                        this.swatchSetting.colorCodes[0] +
                        " 50%);"),
                      (this.backgroundColor = "transparent"),
                      (n = !0));
                    break;
                  case a.SwatchType.IMAGE:
                    this.swatchSetting.imageUrl &&
                      ((this.swatchFileUrl = this.swatchSetting.imageUrl),
                      (this.backgroundImage =
                        "url(" + this.swatchFileUrl + ");"),
                      (this.backgroundColor = this.buildBackgroundColor()),
                      (n = !0));
                }
              return n;
            },
          },
          {
            key: "buildSwatchFileName",
            value: function () {
              this.parent.filterOptionId;
              var t = this.parent.prefix,
                e = this.value;
              this.parent.filterType == nM.a.FilterType.COLLECTION &&
                (e = this.label);
              var n = this.parent.label.trim().toLowerCase().replace(/ /g, "_");
              if (
                o.a.getSettingValue("general.removePrefixFromSwatchFile") &&
                t
              ) {
                var i = t.replace(/\\/g, "");
                e = e.replace(i, "");
              }
              return n + "-" + u.a.slugify(e).replace(/\#/g, "");
            },
          },
          {
            key: "buildBackgroundColor",
            value: function () {
              var t = u.a.slugify(this.label).split("-");
              return t[t.length - 1];
            },
          },
        ]),
        i4(e.prototype, n),
        i && i4(e, i),
        a
      );
    })(iC);
    function iN(t) {
      return (iN =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function iU(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function iW(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ij(t, e, n) {
      return (ij =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = iz(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function iq(t, e) {
      return (iq =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function iG(t, e) {
      return e && ("object" === iN(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function iz(t) {
      return (iz = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var iK = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && iq(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = iz(t);
            if (e()) {
              var r = iz(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return iG(this, n);
          };
        })(o);
      function o() {
        return iU(this, o), r.apply(this, arguments);
      }
      return (
        (e = o),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n				<button role="checkbox" class="{{class.button}}" aria-label="{{adaLabel}}">\n          <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span> \n					<span role="presentation" class="boost-pfs-filter-option-value">\n						<i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i><!--\n						--><i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i><!--\n						--><i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i><!--\n						--><i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i><!--\n						--><i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i>\n						<span>{{label}}</span>\n					</span>	\n					<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n				</button>\n			</li>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              for (var t = this.getTemplate(), e = 0; e < this.from; e++)
                t = t.replace(
                  /{{active}}/,
                  "{{class.filterOptionItemStarActive}}"
                );
              return (t = t.replace(/{{active}}/g, ""))
                .replace(/{{class.filterOptionItem}}/g, N.a.filterOptionItem)
                .replace(/{{class.filterOptionLabel}}/g, N.a.filterOptionLabel)
                .replace(
                  /{{class.filterOptionItemStar}}/g,
                  N.a.filterOptionItemStar
                )
                .replace(
                  /{{class.filterOptionItemStarActive}}/g,
                  N.a.filterOptionItemStarActive
                )
                .replace(/{{class.button}}/g, N.a.button)
                .replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "")
                .replace(/{{label}}/g, u.a.stripHtml(this.label))
                .replace(/{{countLabel}}/g, u.a.stripHtml(this.countLabel))
                .replace(/{{adaLabel}}/g, u.a.stripHtml(this.adaLabel))
                .replace(/{{starColor}}/g, u.a.stripHtml(this.parent.starColor))
                .replace(/{{class.button}}/g, N.a.button)
                .replace(/\r?\n|\r/g, "");
            },
          },
          {
            key: "render",
            value: function () {
              (this.label = u.a.stripHtml(
                this.parent.showExactRating ? "" : a.a.ratingUp
              )),
                (this.adaLabel = this.from),
                1 == this.from
                  ? (this.adaLabel += " " + a.a.ratingStar)
                  : (this.adaLabel += " " + a.a.ratingStars),
                this.parent.showExactRating &&
                  (this.adaLabel += " " + a.a.ratingUp);
              var t = this.countLabel
                ? a.a.ada.productCount.replace(/{{count}}/g, this.countLabel)
                : "";
              (this.adaLabel += ". " + t),
                (this.adaLabel = u.a.stripHtml(this.adaLabel)),
                ij(iz(o.prototype), "render", this).call(this);
            },
          },
        ]),
        iW(e.prototype, n),
        i && iW(e, i),
        o
      );
    })(iC);
    function iY(t) {
      return (iY =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function iQ(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function iX(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function iZ(t, e, n) {
      return (iZ =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = re(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function iJ(t, e) {
      return (iJ =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function rt(t, e) {
      return e && ("object" === iY(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function re(t) {
      return (re = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var rn = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && iJ(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = re(t);
            if (e()) {
              var r = re(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return rt(this, n);
          };
        })(a);
      function a() {
        return iQ(this, a), o.apply(this, arguments);
      }
      return (
        (e = a),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n				<div class="boost-pfs-filter-option-item-parent-category">\n					<span role="button" aria-controls="sub-category-{{value}}" aria-expanded="true" class="sub-icon {{closeClass}}"></span>\n					<span class="{{class.filterOptionItem}} {{class.filterOptionLabel}} boost-pfs-filter-option-main-cat">\n						{{label}}\n					</span>\n				</div>\n				<ul class="boost-pfs-filter-option-item-sub-category-list">\n					{{subItems}}\n				</ul>\n			</li>\n		'.trim();
            },
          },
          {
            key: "getSubItemTemplate",
            value: function () {
              return '\n			<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{selected}} boost-pfs-filter-option-item-sub-category">\n				<span>\n					{{subLabel}}\n				</span>\n			</li>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t = this,
                e = "";
              return (
                Array.isArray(this.tags) &&
                  this.tags.forEach(function (n) {
                    var i = t.isSubCategorySelected(n);
                    e += t
                      .getSubItemTemplate()
                      .replace(/{{subLabel}}/g, n)
                      .replace(/{{selected}}/g, i ? "selected" : "");
                  }),
                this.getTemplate()
                  .replace(/{{subItems}}/g, e)
                  .replace(/{{class.filterOptionItem}}/g, N.a.filterOptionItem)
                  .replace(
                    /{{class.filterOptionLabel}}/g,
                    N.a.filterOptionLabel
                  )
                  .replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "")
                  .replace(/{{label}}/g, u.a.stripHtml(this.label))
                  .replace(/{{value}}/g, u.a.stripHtml(this.value))
                  .replace(/{{countLabel}}/g, u.a.stripHtml(this.countLabel))
              );
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element.on("click", this.redirectToCollection.bind(this)),
                this.$element
                  .find("ul > li")
                  .on("click", this.redirectToSubCategory.bind(this));
            },
          },
          {
            key: "isSubCategorySelected",
            value: function (t) {
              if (!u.a.isSearchPage()) {
                var e = decodeURIComponent(window.location.pathname).split("/");
                if (e[e.length - 1] == u.a.slugify(t))
                  return (this.isAnyTagSelected = !0), !0;
              }
              return !1;
            },
          },
          {
            key: "redirectToCollection",
            value: function (t) {
              t.preventDefault(), t.stopPropagation();
              var e = "/collections/" + this.handle;
              u.a.setWindowLocation(e);
            },
          },
          {
            key: "redirectToSubCategory",
            value: function (t) {
              t.preventDefault(), t.stopPropagation();
              var e = r()(t.currentTarget).find("a").html(),
                n = u.a.slugify(e),
                i = "/collections/" + this.handle + "/" + n;
              u.a.setWindowLocation(i);
            },
          },
          {
            key: "setData",
            value: function (t) {
              iZ(re(a.prototype), "setData", this).call(this, t),
                (this.tags = t.tags);
            },
          },
        ]),
        iX(e.prototype, n),
        i && iX(e, i),
        a
      );
    })(iC);
    function ri(t) {
      return (ri =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function rr(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function ro(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ra(t, e, n) {
      return (ra =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = rc(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function rs(t, e) {
      return (rs =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function rl(t, e) {
      return e && ("object" === ri(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function rc(t) {
      return (rc = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ru = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && rs(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = rc(t);
            if (e()) {
              var r = rc(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return rl(this, n);
          };
        })(o);
      function o() {
        return rr(this, o), r.apply(this, arguments);
      }
      return (
        (e = o),
        (n = [
          {
            key: "isRender",
            value: function () {
              return !1;
            },
          },
          {
            key: "setValue",
            value: function (t, e) {
              (this.value = t + ":" + e),
                (this.isSelected = this.min != t || this.max != e);
            },
          },
          {
            key: "setData",
            value: function (t) {
              ra(rc(o.prototype), "setData", this).call(this, t),
                null != t.min &&
                  null != t.max &&
                  ((this.min = t.min),
                  (this.max = t.max),
                  (this.key = this.parent.filterOptionId),
                  (this.value = t.min + ":" + t.max));
            },
          },
        ]),
        ro(e.prototype, n),
        i && ro(e, i),
        o
      );
    })(iC);
    function rp(t) {
      return (rp =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function rf(t, e) {
      return (
        (function (t) {
          if (Array.isArray(t)) return t;
        })(t) ||
        (function (t, e) {
          if (
            Symbol.iterator in Object(t) ||
            "[object Arguments]" === Object.prototype.toString.call(t)
          ) {
            var n = [],
              i = !0,
              r = !1,
              o = void 0;
            try {
              for (
                var a, s = t[Symbol.iterator]();
                !(i = (a = s.next()).done) &&
                (n.push(a.value), !e || n.length !== e);
                i = !0
              );
            } catch (l) {
              (r = !0), (o = l);
            } finally {
              try {
                i || null == s.return || s.return();
              } finally {
                if (r) throw o;
              }
            }
            return n;
          }
        })(t, e) ||
        (function () {
          throw TypeError(
            "Invalid attempt to destructure non-iterable instance"
          );
        })()
      );
    }
    function rh(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function rd(t, e) {
      return (rd =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function rg(t, e) {
      return e && ("object" === rp(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function ry(t) {
      return (ry = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    n(188), n(183), n(81);
    var rm = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && rd(t, e);
        })(l, t);
        var e,
          n,
          i,
          s = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = ry(t);
              if (e()) {
                var r = ry(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return rg(this, n);
            };
          })(l);
        function l(t) {
          var e;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, l),
            ((e = s.call(this)).filterTreeType = t),
            (e.isExpanded = !1),
            (e.label = a.a.viewMore),
            (e.class = N.a.filterOptionViewMore),
            (e.isVisible = !0),
            (e.$element = null),
            e
          );
        }
        return (
          (e = l),
          (i = [
            {
              key: "getViewMoreStateData",
              value: function (t) {
                return rv.get(t);
              },
            },
            {
              key: "setViewMoreStateData",
              value: function (t, e) {
                rv.set(t, e);
              },
            },
          ]),
          (n = [
            {
              key: "init",
              value: function () {
                this.numberVisibleItems = this.getNumberVisibleItems();
              },
            },
            {
              key: "getTemplate",
              value: function () {
                switch (this.filterTreeType) {
                  case ic.FilterTreeType.VERTICAL:
                    return '\n					<div class="{{class.button}} {{class}}"><button>{{label}}</button></div>\n				'.trim();
                  case ic.FilterTreeType.HORIZONTAL:
                    return '\n					<div class="{{class.button}} {{class}}"><button aria-label="{{label}}"></button></div>\n				'.trim();
                  default:
                    console.warn(
                      "Pass a filter tree type into the constructor"
                    );
                }
              },
            },
            {
              key: "compileTemplate",
              value: function () {
                return this.getTemplate()
                  .replace(/{{class.button}}/g, N.a.button)
                  .replace(/{{class}}/g, this.class)
                  .replace(/{{label}}/g, u.a.stripHtml(this.label));
              },
            },
            {
              key: "isRender",
              value: function () {
                return (
                  this.parent.displayType != nM.a.DisplayType.RANGE &&
                  (this.parent.showMoreType == nM.a.ShowMoreType.VIEWMORE ||
                    this.parent.showMoreType ==
                      nM.a.ShowMoreType.VIEWMORE_SCROLLBAR)
                );
              },
            },
            {
              key: "render",
              value: function () {
                this.$element || (this.$element = r()(this.compileTemplate())),
                  this.setVisibility();
              },
            },
            {
              key: "bindEvents",
              value: function () {
                this.$element &&
                  (this.isBoundEvent ||
                    this.$element.on("click", this.onClick.bind(this)),
                  this.parent.$filterOptionContentElement &&
                    this.parent.$filterOptionContentElement.addClass(
                      N.a.filterHasViewMore
                    ),
                  !this.isExpanded &&
                  l.getViewMoreStateData(this.parent.filterOptionId)
                    ? this.onClick()
                    : this.setFilterItemsVisibility());
              },
            },
            {
              key: "onClick",
              value: function () {
                (this.isExpanded = !this.isExpanded),
                  l.setViewMoreStateData(
                    this.parent.filterOptionId,
                    this.isExpanded
                  );
                var t = "";
                this.isExpanded
                  ? ((this.label = a.a.viewLess),
                    (this.class = N.a.filterOptionViewLess),
                    (t = N.a.filterOptionViewMore))
                  : ((this.label = a.a.viewMore),
                    (this.class = N.a.filterOptionViewMore),
                    (t = N.a.filterOptionViewLess)),
                  this.filterTreeType == ic.FilterTreeType.VERTICAL
                    ? this.$element
                        .find("button")
                        .html(u.a.stripHtml(this.label))
                    : this.$element.removeClass(t).addClass(this.class),
                  this.setFilterItemsVisibility();
              },
            },
            {
              key: "getNumberVisibleItems",
              value: function () {
                var t = o.a.getSettingValue("general.startViewMore")[
                  this.parent.displayType
                ];
                if (this.filterTreeType == ic.FilterTreeType.HORIZONTAL) {
                  var e = o.a.getSettingValue("general.filterHorizontalColumn");
                  Number.isInteger(e)
                    ? (t *= e)
                    : (t = o.a.getSettingValue("general.startViewMoreH")[
                        this.parent.displayType
                      ]);
                }
                return (!t || t <= 1) && (t = 5), t;
              },
            },
            {
              key: "setVisibility",
              value: function () {
                if (this.$element) {
                  var t = this.parent.filterItems.size;
                  this.parent.keepValuesStatic ||
                    o.a.getSettingValue("general.showOutOfStockOption") ||
                    (t = Array.from(this.parent.filterItems, function (t) {
                      var e = rf(t, 2);
                      return { key: e[0], value: e[1] };
                    }).filter(function (t) {
                      return t.value.docCount > 0;
                    }).length),
                    this.parent.$filterItemsContainerElement &&
                      (t =
                        this.parent.$filterItemsContainerElement.find(
                          "li"
                        ).length),
                    (this.isVisible = t > this.numberVisibleItems),
                    this.isVisible
                      ? this.$element.show()
                      : this.$element.hide();
                } else this.isVisible = !1;
              },
            },
            {
              key: "setFilterItemsVisibility",
              value: function () {
                if (this.parent.$filterItemsContainerElement) {
                  var t = this.parent.$filterItemsContainerElement.find("li");
                  if ((t.show(), !this.isExpanded)) {
                    var e = this.numberVisibleItems,
                      n = t.length;
                    t.slice(e, n).hide();
                  }
                }
              },
            },
          ]),
          rh(e.prototype, n),
          i && rh(e, i),
          l
        );
      })(g.a),
      rv = new Map(),
      rb = rm;
    function rS(t) {
      return (rS =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function r$(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function rT(t, e) {
      return (rT =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function rP(t, e) {
      return e && ("object" === rS(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function r_(t) {
      return (r_ = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var r8 = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && rT(t, e);
      })(l, t);
      var e,
        n,
        i,
        s = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = r_(t);
            if (e()) {
              var r = r_(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return rP(this, n);
          };
        })(l);
      function l() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, l),
          ((t = s.call(this)).$element = null),
          (t.searchValue = ""),
          t
        );
      }
      return (
        (e = l),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              return '\n			<div class="{{class.filterOptionShowSearchBox}}-wrapper">\n				<input role="textbox" aria-label="Search Options" class="{{class.filterOptionShowSearchBox}}" type="text" autocomplete="on" placeholder="{{label.searchOptions}}" />\n			</div>\n        '.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(
                  /{{class.filterOptionShowSearchBox}}/g,
                  N.a.filterOptionShowSearchBox
                )
                .replace(/{{label.searchOptions}}/g, a.a.searchOptions);
            },
          },
          {
            key: "isRender",
            value: function () {
              if (this.parent.filterTreeType == ic.FilterTreeType.HORIZONTAL)
                return !1;
              var t =
                  this.parent.showSearchBoxFilterPC ||
                  o.a.getSettingValue("general.showSearchBoxFilterPCByDefault"),
                e =
                  this.parent.showSearchBoxFilterMobile ||
                  o.a.getSettingValue(
                    "general.showSearchBoxFilterMobileByDefault"
                  ),
                n = [
                  nM.a.FilterType.PRICE,
                  nM.a.FilterType.PERCENT_SALE,
                  nM.a.FilterType.STOCK,
                ],
                i = [
                  nM.a.DisplayType.RANGE,
                  nM.a.DisplayType.MULTI_LEVEL_TAG,
                  nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS,
                ],
                r =
                  !n.includes(this.parent.filterType) &&
                  !i.includes(this.parent.displayType),
                a = u.a.isMobile();
              return r && ((!a && t) || (a && e));
            },
          },
          {
            key: "render",
            value: function () {
              this.$element || (this.$element = r()(this.compileTemplate()));
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvent;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                (this.$element
                  .find("input")
                  .on("keyup", this.onKeyUp.bind(this)),
                this.parent.$filterOptionContentElement &&
                  this.parent.$filterOptionContentElement.addClass(
                    N.a.filterHasSearchBox
                  ));
            },
          },
          {
            key: "onKeyUp",
            value: function (t) {
              this.setSearchValue(t), this.setFilterItemsList();
            },
          },
          {
            key: "setSearchValue",
            value: function (t) {
              if (t && t.target) {
                var e = u.a.stripHtml(t.target.value);
                if (u.a.isBadSearchTerm(e)) return void (this.searchValue = "");
                (e =
                  "function" == typeof e.toString
                    ? e.toLowerCase().trim()
                    : ""),
                  (this.searchValue = e);
              } else this.searchValue = "";
            },
          },
          {
            key: "setFilterItemsList",
            value: function () {
              var t = this;
              if (this.parent.$filterItemsContainerElement) {
                if (this.searchValue)
                  this.parent.filterItems.forEach(function (e) {
                    e.$element &&
                      (e.label && e.label.toLowerCase().includes(t.searchValue)
                        ? e.$element.appendTo(
                            t.parent.$filterItemsContainerElement
                          )
                        : e.$element.detach());
                  });
                else {
                  var e = 0,
                    n = o.a.getSettingValue("general.scrollFirstLoadLength");
                  this.parent.filterItems.forEach(function (i) {
                    (i.isRenderOnScroll =
                      t.parent.isLoadMoreOnScroll && e >= n),
                      i.$element &&
                        (i.isRenderOnScroll
                          ? i.$element.detach()
                          : i.$element.appendTo(
                              t.parent.$filterItemsContainerElement
                            )),
                      e++;
                  }),
                    (this.parent.scrollbar.numberFilterItemsRendered = n);
                }
                this.parent.viewMore &&
                  this.parent.viewMore.isRender() &&
                  (this.parent.viewMore.setVisibility(),
                  this.parent.viewMore.setFilterItemsVisibility());
              }
            },
          },
        ]),
        r$(e.prototype, n),
        i && r$(e, i),
        l
      );
    })(g.a);
    function rk(t) {
      return (rk =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function rO(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function rC(t, e) {
      return (rC =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function rw(t, e) {
      return e && ("object" === rk(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function rI(t) {
      return (rI = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var rE = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && rC(t, e);
      })(a, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = rI(t);
            if (e()) {
              var r = rI(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return rw(this, n);
          };
        })(a);
      function a(t) {
        var e;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          ((e = o.call(this)).tooltipText =
            "string" == typeof t
              ? u.a.stripHtml(u.a.stripHtml(t)).trim()
              : null),
          (e.$element = null),
          (e.$popupElement = null),
          e
        );
      }
      return (
        (e = a),
        (n = [
          {
            key: "getTemplate",
            value: function (t) {
              return "popup" === t
                ? '\n					<div class="boost-pfs-filter-tooltip-wrapper">\n						<div class="boost-pfs-filter-qtip-content">{{tooltipText}}</div>\n					</div>\n				'.trim()
                : '\n					<div class="{{class.filterOptionTooltip}}">\n						<span class="boost-pfs-filter-tooltip-arrow"></span>\n					</div>\n				'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function (t) {
              return this.getTemplate(t)
                .replace(/{{tooltipText}}/g, this.tooltipText)
                .replace(
                  /{{class.filterOptionTooltip}}/g,
                  N.a.filterOptionTooltip
                );
            },
          },
          {
            key: "isRender",
            value: function () {
              return !!this.tooltipText;
            },
          },
          {
            key: "render",
            value: function () {
              this.$element || (this.$element = r()(this.compileTemplate())),
                this.$popupElement ||
                  (this.$popupElement = r()(this.compileTemplate("popup")));
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvent;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              this.$element &&
                this.$popupElement &&
                this.$element.on("mouseover", this.showTooltipPopup.bind(this));
            },
          },
          {
            key: "showTooltipPopup",
            value: function () {
              var t = this.$element.position(),
                e = this.$popupElement
                  .find(".boost-pfs-filter-qtip-content")
                  .outerWidth();
              this.$popupElement.css("left", t.left + "px"),
                e / 2 < t.left
                  ? this.$popupElement.css("margin-left", -(e / 2 - 12) + "px")
                  : e / 2 > t.left &&
                    this.$popupElement.css("margin-left", -t.left / 2 + "px");
            },
          },
        ]),
        rO(e.prototype, n),
        i && rO(e, i),
        a
      );
    })(g.a);
    function r0(t) {
      return (r0 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function rL(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function rA(t, e) {
      return (rA =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function rx(t, e) {
      return e && ("object" === r0(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function rB(t) {
      return (rB = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var rR = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && rA(t, e);
        })(a, t);
        var e,
          n,
          i,
          r = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = rB(t);
              if (e()) {
                var r = rB(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return rx(this, n);
            };
          })(a);
        function a() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, a),
            ((t = r.call(this)).placeHolderHeight = ""),
            (t.numberFilterItemsRendered = 0),
            (t.$scrollElement = null),
            t
          );
        }
        return (
          (e = a),
          (i = [
            {
              key: "getScrollStateData",
              value: function (t) {
                return r9.get(t);
              },
            },
            {
              key: "setScrollStateData",
              value: function (t, e) {
                r9.set(t, e);
              },
            },
            {
              key: "isEnabled",
              value: function (t, e, n) {
                var i = [nM.a.DisplayType.RANGE],
                  r = [
                    nM.a.FilterType.REVIEW_RATINGS,
                    nM.a.FilterType.STOCK,
                    nM.a.FilterType.PERCENT_SALE,
                    nM.a.FilterType.PRICE,
                    nM.a.FilterType.VARIANTS_PRICE,
                  ],
                  a =
                    n == nM.a.ShowMoreType.SCROLLBAR ||
                    n == nM.a.ShowMoreType.VIEWMORE_SCROLLBAR,
                  s = u.a.isMobile(),
                  l =
                    (s &&
                      o.a.getSettingValue(
                        "general.activeFilterScrollbarMobile"
                      )) ||
                    (!s &&
                      o.a.getSettingValue("general.activeFilterScrollbarPC"));
                return !i.includes(t) && !r.includes(e) && a && l;
              },
            },
          ]),
          (n = [
            {
              key: "isBindEvents",
              value: function () {
                return !this.isBoundEvent;
              },
            },
            {
              key: "bindEvents",
              value: function () {
                if (
                  this.parent.$element &&
                  a.isEnabled(
                    this.parent.displayType,
                    this.parent.filterType,
                    this.parent.showMoreType
                  )
                ) {
                  var t = this.parent.$element.find(
                    "." + N.a.filterOptionContentInner
                  );
                  if (
                    t.length > 0 &&
                    ((this.$scrollElement = t),
                    (this.parent.isLoadMoreOnScroll ||
                      o.a.getSettingValue("general.keepScrollState")) &&
                      this.$scrollElement.on(
                        "scroll",
                        this.onScroll.bind(this)
                      ),
                    o.a.getSettingValue("general.keepScrollState"))
                  ) {
                    var e = a.getScrollStateData(this.parent.filterOptionId);
                    isNaN(e) || (this.$scrollElement[0].scrollTop = e);
                  }
                }
              },
            },
            {
              key: "onScroll",
              value: function () {
                if (o.a.getSettingValue("general.keepScrollState")) {
                  var t = this.$scrollElement[0].scrollTop;
                  a.setScrollStateData(this.parent.filterOptionId, t);
                }
                this.parent.isLoadMoreOnScroll &&
                  this.isScrollToBottom() &&
                  ((this.parent.searchBox &&
                    this.parent.searchBox.searchValue) ||
                    this.appendFilterItems());
              },
            },
            {
              key: "isScrollToBottom",
              value: function () {
                return (
                  !!this.$scrollElement &&
                  this.$scrollElement[0].scrollHeight -
                    this.$scrollElement[0].scrollTop -
                    this.$scrollElement.outerHeight() <
                    1
                );
              },
            },
            {
              key: "appendFilterItems",
              value: function () {
                var t = this;
                if (this.parent.$filterItemsContainerElement) {
                  var e = o.a.getSettingValue("general.scrollFirstLoadLength");
                  if (0 == this.numberFilterItemsRendered)
                    this.numberFilterItemsRendered = e;
                  else if (
                    this.numberFilterItemsRendered ==
                    this.parent.filterItems.size
                  )
                    return;
                  this.parent.$element.addClass(
                    "boost-pfs-filter-scrollbar-loading"
                  );
                  var n = 0;
                  this.parent.filterItems.forEach(function (i) {
                    i.isRenderOnScroll &&
                      n < e &&
                      (t.parent.$filterItemsContainerElement.append(i.$element),
                      (i.isRenderOnScroll = !1),
                      n++,
                      t.numberFilterItemsRendered++);
                  }),
                    setTimeout(
                      function () {
                        this.parent.$element.removeClass(
                          "boost-pfs-filter-scrollbar-loading"
                        );
                      }.bind(this),
                      200
                    );
                }
              },
            },
          ]),
          rL(e.prototype, n),
          i && rL(e, i),
          a
        );
      })(g.a),
      r9 = new Map(),
      rF = rR;
    function r2(t) {
      return (r2 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function r1(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function rV(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function rD(t, e, n) {
      return e && rV(t.prototype, e), n && rV(t, n), t;
    }
    function rM(t, e, n) {
      return (rM =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = rH(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function r4(t, e) {
      if ("function" != typeof e && null !== e)
        throw TypeError("Super expression must either be null or a function");
      (t.prototype = Object.create(e && e.prototype, {
        constructor: { value: t, writable: !0, configurable: !0 },
      })),
        e && r3(t, e);
    }
    function r3(t, e) {
      return (r3 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function r6(t) {
      function e() {
        if (
          "undefined" == typeof Reflect ||
          !Reflect.construct ||
          Reflect.construct.sham
        )
          return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Date.prototype.toString.call(
              Reflect.construct(Date, [], function () {})
            ),
            !0
          );
        } catch (t) {
          return !1;
        }
      }
      return function () {
        var n,
          i = rH(t);
        if (e()) {
          var r = rH(this).constructor;
          n = Reflect.construct(i, arguments, r);
        } else n = i.apply(this, arguments);
        return r5(this, n);
      };
    }
    function r5(t, e) {
      return e && ("object" === r2(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function rH(t) {
      return (rH = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var r7 = (function (t) {
        r4(n, t);
        var e = r6(n);
        function n(t) {
          var i;
          return (
            r1(this, n),
            ((i = e.call(this, t)).$element = null),
            (i.$itemElement = null),
            (i.$childContainerElement = null),
            i
          );
        }
        return (
          rD(
            n,
            [
              {
                key: "init",
                value: function () {
                  var t = this.filterOption
                    ? this.filterOption.selectType
                    : this.parent.selectType;
                  this.requestInstantly =
                    this.filterTreeType == ic.FilterTreeType.VERTICAL ||
                    t == nM.a.SelectType.SINGLE ||
                    o.a.getSettingValue("general.requestInstantly");
                },
              },
              {
                key: "getTemplate",
                value: function () {
                  return '\n			<li class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-first-level-item">\n				<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n					<a class="{{class.button}}" data-action="select-filter-item" href="{{href}}">\n						<span class="boost-pfs-filter-option-value">{{label}}</span>\n					</a>\n					{{arrow}}\n				</div>\n				<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-second-level-list">\n					{{childItems}}\n				</div>\n			</li>\n		'.trim();
                },
              },
              {
                key: "getArrowTemplate",
                value: function () {
                  return '\n			<button class="{{class.button}} {{class.button}}-arrow" data-action="expand-filter-item" aria-label="{{label.ada.toggleMultiLevel}}">\n				<span class="boost-pfs-arrow"></span>\n			</button>\n		'.trim();
                },
              },
              {
                key: "compileArrowTemplate",
                value: function () {
                  return 3 != this.level &&
                    this.children &&
                    this.children.length > 0
                    ? this.getArrowTemplate().replace(
                        /{{label.ada.toggleMultiLevel}}/g,
                        Labels.ada.toggleMultiLevel.replace(
                          /{{filterItem}}/g,
                          this.label
                        )
                      )
                    : "";
                },
              },
              {
                key: "compileTemplate",
                value: function () {
                  return this.getTemplate()
                    .replace(
                      /{{class.filterOptionItem}}/g,
                      N.a.filterOptionItem
                    )
                    .replace(
                      /{{class.filterOptionLabel}}/g,
                      N.a.filterOptionLabel
                    )
                    .replace(/{{label}}/g, this.label)
                    .replace(/{{href}}/g, this.href)
                    .replace(/{{arrow}}/g, this.compileArrowTemplate())
                    .replace(/{{class.button}}/g, N.a.button)
                    .replace(/{{childItems}}/g, "");
                },
              },
              {
                key: "render",
                value: function () {
                  var t = this;
                  if (
                    (this.$element ||
                      ((this.$element = r()(this.compileTemplate())),
                      (this.$itemElement = this.$element.find(
                        "." + N.a.filterOptionItem
                      )),
                      (this.$itemClickElement = this.$itemElement.find(
                        '[data-action="select-filter-item"]'
                      )),
                      (this.$toggleClickElement = this.$itemElement.find(
                        '[data-action="expand-filter-item"]'
                      )),
                      (this.$childContainerElement = this.$element.find(
                        ".boost-pfs-filter-option-multi-level-list"
                      )),
                      this.$childContainerElement &&
                        this.children &&
                        this.children.length > 0 &&
                        this.children.forEach(function (e) {
                          e.$element &&
                            t.$childContainerElement.append(e.$element);
                        })),
                    this.$itemElement)
                  ) {
                    this.isSelected || this.isSelectedChild
                      ? (this.$itemElement.addClass("selected"),
                        this.$itemElement.find("a").attr("aria-current", !0))
                      : (this.$itemElement.removeClass("selected"),
                        this.$itemElement.find("a").removeAttr("aria-current"));
                    var e = n.getLevelOpenStateData(this),
                      i = o.a.getSettingValue(
                        "general.openMultiLevelByDefault"
                      );
                    e ||
                    (Array.isArray(i) && i.includes(this.level)) ||
                    (null == e && this.isSelectedChild)
                      ? (this.$itemElement.addClass("boost-pfs-open"),
                        n.setLevelOpenStateData(this, !0))
                      : n.setLevelOpenStateData(this, !1);
                  }
                },
              },
              {
                key: "bindEvents",
                value: function () {
                  this.$itemClickElement &&
                    this.$itemClickElement.on("click", this.onClick.bind(this)),
                    this.$toggleClickElement &&
                      this.$toggleClickElement.on(
                        "click",
                        this.onClickToggle.bind(this)
                      );
                },
              },
              {
                key: "onClick",
                value: function (t) {
                  t && t.preventDefault(),
                    this.setCollectionParams(),
                    this.clearAllTagParams(),
                    K.default.setParam("page", 1),
                    this.children &&
                      this.children.length > 0 &&
                      n.setLevelOpenStateData(this, !0),
                    this.requestInstantly &&
                      K.default.applyFilter("collection");
                },
              },
              {
                key: "onClickToggle",
                value: function () {
                  this.$itemElement.toggleClass("boost-pfs-open"),
                    this.$itemElement.hasClass("boost-pfs-open")
                      ? n.setLevelOpenStateData(this, !0)
                      : n.setLevelOpenStateData(this, !1);
                },
              },
              {
                key: "isAppliedFilter",
                value: function () {
                  return s.a.collectionId == this.collectionId;
                },
              },
              {
                key: "setCollectionParams",
                value: function () {
                  u.a.isCollectionPage()
                    ? (c.a.setAddressBarPathAfterFilter(this.href),
                      c.a.setWindowTitleAfterFilter(
                        this.label + " - " + s.a.shopName
                      ),
                      K.default.setParam("sort", this.sortOrder),
                      (s.a.defaultSorting = this.sortOrder))
                    : K.default.setParam(
                        this.filterOption.filterOptionId,
                        this.collectionId
                      ),
                    (s.a.collectionId = this.collectionId),
                    K.default.setParam("collection_scope", this.collectionId);
                },
              },
              {
                key: "clearAllTagParams",
                value: function () {
                  var t = this.filterOption.filterOptionId.replace(
                    s.a.prefix + "_c",
                    s.a.prefix + "_ct"
                  );
                  K.default.setParam(t, null), (s.a.collectionTags = []);
                  var e = [];
                  Object.keys(s.a.queryParams).forEach(function (t) {
                    t.startsWith(s.a.prefix) &&
                      !t.startsWith(s.a.prefix + "_c") &&
                      e.push(t);
                  }),
                    e.forEach(function (t) {
                      K.default.setParam(t, null);
                    });
                },
              },
              {
                key: "setData",
                value: function (t) {
                  var e = this;
                  rM(rH(n.prototype), "setData", this).call(this, t),
                    (this.filterOption = this.parent),
                    (this.level = 1),
                    (this.href = u.a.isCollectionPage()
                      ? "/collections/" + this.handle
                      : "#");
                  var i = u.a.getDefaultSorting(this.collectionId);
                  (this.sortOrder =
                    "" != i
                      ? i
                      : t.sort_order
                      ? t.sort_order
                      : s.a.defaultSorting),
                    (this.children = []),
                    Array.isArray(t.tags) &&
                      t.tags.forEach(function (t) {
                        if (t.tag) {
                          var n = new rN(e.filterTreeType);
                          e.addComponent(n), n.setData(t);
                        }
                      }),
                    (this.isSelected = this.isAppliedFilter()),
                    (this.isSelectedChild = this.children.some(function (t) {
                      return t.isSelected || t.isSelectedChild;
                    })),
                    this.filterOption.allNestedFilterItems.set(
                      this.collectionId,
                      this
                    );
                },
              },
            ],
            [
              {
                key: "getLevelOpenStateData",
                value: function (t) {
                  var e = t.filterOption.filterOptionId,
                    n = t.collectionId,
                    i = t.tag,
                    r = e + ":" + n + (i ? ":" + i : "");
                  return rW.get(r);
                },
              },
              {
                key: "setLevelOpenStateData",
                value: function (t, e) {
                  var n = t.filterOption.filterOptionId,
                    i = t.collectionId,
                    r = t.tag,
                    o = n + ":" + i + (r ? ":" + r : "");
                  rW.set(o, e);
                },
              },
            ]
          ),
          n
        );
      })(iC),
      rN = (function (t) {
        r4(n, t);
        var e = r6(n);
        function n() {
          return r1(this, n), e.apply(this, arguments);
        }
        return (
          rD(n, [
            {
              key: "getTemplate",
              value: function () {
                return '\n			<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-second-level-item">\n				<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n					<a class="{{class.button}}" data-action="select-filter-item" href="{{href}}">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n						<span class="boost-pfs-filter-option-value">{{label}}</span>\n					</a>\n					{{arrow}}\n				</div>\n				<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-third-level-list">\n					{{childItems}}\n				</div>\n			</div>\n		'.trim();
              },
            },
            {
              key: "onClick",
              value: function (t) {
                t && t.preventDefault(),
                  (this.collectionId == s.a.collectionId &&
                    o.a.getSettingValue(
                      "general.multiLevelCollectionSelectType"
                    ) != nM.a.SelectType.SINGLE) ||
                    this.clearAllTagParams(),
                  this.setCollectionParams(),
                  this.setTagParams(),
                  K.default.setParam("page", 1),
                  this.children &&
                    this.children.length > 0 &&
                    r7.setLevelOpenStateData(this, !0),
                  this.requestInstantly && K.default.applyFilter("collection");
              },
            },
            {
              key: "setTagParams",
              value: function () {
                if (
                  u.a.isCollectionPage() &&
                  o.a.getSettingValue(
                    "general.multiLevelCollectionSelectType"
                  ) != nM.a.SelectType.MULTIPLE
                )
                  (s.a.collectionTags = this.tag),
                    c.a.setAddressBarPathAfterFilter(this.href);
                else {
                  Array.isArray(s.a.collectionTags) ||
                    (s.a.collectionTags = []);
                  var t = s.a.collectionTags.indexOf(this.tag);
                  t > -1
                    ? s.a.collectionTags.splice(t, 1)
                    : s.a.collectionTags.push(this.tag),
                    (o.a.general.tagMode = "2");
                  var e = this.filterOption.filterOptionId.replace(
                    s.a.prefix + "_c_",
                    s.a.prefix + "_ct_"
                  );
                  Array.isArray(s.a.collectionTags) &&
                  s.a.collectionTags.length > 0
                    ? K.default.setParam(e, s.a.collectionTags)
                    : K.default.setParam(e, null);
                }
              },
            },
            {
              key: "isAppliedFilter",
              value: function () {
                var t =
                  (Array.isArray(s.a.collectionTags) &&
                    s.a.collectionTags.includes(this.tag)) ||
                  s.a.collectionTags == this.tag;
                return s.a.collectionId == this.collectionId && t;
              },
            },
            {
              key: "setData",
              value: function (t) {
                var e = this;
                (this.tag = t.tag),
                  (this.slugifyTag = u.a.slugify(this.tag)),
                  (this.label = t.displayName ? t.displayName : t.tag),
                  (this.filterOption = this.parent.filterOption),
                  (this.requestInstantly = this.parent.requestInstantly),
                  (this.collectionId = this.parent.collectionId),
                  (this.handle = this.parent.handle),
                  (this.level = 2),
                  (this.href =
                    u.a.isCollectionPage() &&
                    o.a.getSettingValue(
                      "general.multiLevelCollectionSelectType"
                    ) != nM.a.SelectType.MULTIPLE
                      ? "/collections/" + this.handle + "/" + this.slugifyTag
                      : "#"),
                  (this.sortOrder = this.parent.sortOrder
                    ? this.parent.sortOrder
                    : s.a.defaultSorting),
                  (this.children = []),
                  Array.isArray(t.subTags) &&
                    t.subTags.forEach(function (t) {
                      if (t.tag) {
                        var n = new rU(e.filterTreeType);
                        e.addComponent(n), n.setData(t);
                      }
                    }),
                  (this.label = this.buildLabel()),
                  (this.isSelected = this.isAppliedFilter()),
                  (this.isSelectedChild = this.children.some(function (t) {
                    return t.isSelected || t.isSelectedChild;
                  })),
                  this.filterOption.allNestedFilterItems.set(
                    this.collectionId + ":" + this.tag,
                    this
                  );
              },
            },
          ]),
          n
        );
      })(r7),
      rU = (function (t) {
        r4(n, t);
        var e = r6(n);
        function n() {
          return r1(this, n), e.apply(this, arguments);
        }
        return (
          rD(n, [
            {
              key: "getTemplate",
              value: function () {
                return '\n			<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-third-level-item">\n				<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n					<a class="{{class.button}}" data-action="select-filter-item" href="{{href}}">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n						<span class="boost-pfs-filter-option-value">{{label}}</span>\n					</a>\n				</div>\n			</div>\n		'.trim();
              },
            },
            {
              key: "setData",
              value: function (t) {
                (this.tag = t.tag),
                  (this.slugifyTag = u.a.slugify(this.tag)),
                  (this.label = t.displayName ? t.displayName : t.tag),
                  (this.filterOption = this.parent.filterOption),
                  (this.requestInstantly = this.parent.requestInstantly),
                  (this.collectionId = this.parent.collectionId),
                  (this.handle = this.parent.handle),
                  (this.level = 3),
                  (this.href =
                    u.a.isCollectionPage() &&
                    o.a.getSettingValue(
                      "general.multiLevelCollectionSelectType"
                    ) != nM.a.SelectType.MULTIPLE
                      ? "/collections/" + this.handle + "/" + this.slugifyTag
                      : "#"),
                  this.filterOption.allNestedFilterItems.set(
                    this.collectionId + ":" + this.tag,
                    this
                  ),
                  (this.sortOrder = this.parent.sortOrder
                    ? this.parent.sortOrder
                    : s.a.defaultSorting),
                  (this.label = this.buildLabel()),
                  (this.isSelected = this.isAppliedFilter());
              },
            },
          ]),
          n
        );
      })(rN),
      rW = new Map(),
      rj = r7;
    function rq(t) {
      return (rq =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function rG(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function rz(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function rK(t, e, n) {
      return e && rz(t.prototype, e), n && rz(t, n), t;
    }
    function rY(t, e) {
      if ("function" != typeof e && null !== e)
        throw TypeError("Super expression must either be null or a function");
      (t.prototype = Object.create(e && e.prototype, {
        constructor: { value: t, writable: !0, configurable: !0 },
      })),
        e && rQ(t, e);
    }
    function rQ(t, e) {
      return (rQ =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function rX(t) {
      function e() {
        if (
          "undefined" == typeof Reflect ||
          !Reflect.construct ||
          Reflect.construct.sham
        )
          return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Date.prototype.toString.call(
              Reflect.construct(Date, [], function () {})
            ),
            !0
          );
        } catch (t) {
          return !1;
        }
      }
      return function () {
        var n,
          i = rJ(t);
        if (e()) {
          var r = rJ(this).constructor;
          n = Reflect.construct(i, arguments, r);
        } else n = i.apply(this, arguments);
        return rZ(this, n);
      };
    }
    function rZ(t, e) {
      return e && ("object" === rq(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function rJ(t) {
      return (rJ = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ot = (function (t) {
        rY(n, t);
        var e = rX(n);
        function n(t) {
          var i;
          return (
            rG(this, n),
            ((i = e.call(this, t)).$element = null),
            (i.$itemElement = null),
            (i.$childContainerElement = null),
            i
          );
        }
        return (
          rK(
            n,
            [
              {
                key: "init",
                value: function () {
                  this.filterOption
                    ? this.filterOption.selectType
                    : this.parent.selectType,
                    (this.requestInstantly =
                      this.filterTreeType == ic.FilterTreeType.VERTICAL ||
                      o.a.getSettingValue("general.requestInstantly"));
                },
              },
              {
                key: "getTemplate",
                value: function () {
                  return '\n			<li class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-first-level-item">\n				<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n					{{swatch}}\n					<button class="{{class.button}}" data-action="select-filter-item">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n						<span class="boost-pfs-filter-option-value">{{label}}</span>\n					</button>\n					{{arrow}}\n				</div>\n				<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-second-level-list">\n					{{childItems}}\n				</div>\n			</li>\n		'.trim();
                },
              },
              {
                key: "getSwatchTemplate",
                value: function () {
                  return '\n			<span class="boost-pfs-filter-option-swatch-image" \n				style="background-color: {{backgroundColor}}; \n				background-image: url({{swatchFileUrl}});" title="{{label}}">\n			</span>\n		'.trim();
                },
              },
              {
                key: "getArrowTemplate",
                value: function () {
                  return '\n			<button class="{{class.button}} {{class.button}}-arrow" data-action="expand-filter-item" aria-label="{{label.ada.toggleMultiLevel}}">\n				<span class="boost-pfs-arrow"></span>\n			</button>\n		'.trim();
                },
              },
              {
                key: "compileSwatchTemplate",
                value: function () {
                  return this.getSwatchTemplate()
                    .replace(/{{backgroundColor}}/g, this.backgroundColor)
                    .replace(/{{swatchFileUrl}}/g, this.swatchFileUrl);
                },
              },
              {
                key: "compileArrowTemplate",
                value: function () {
                  return 3 != this.level &&
                    this.children &&
                    this.children.length > 0
                    ? this.getArrowTemplate().replace(
                        /{{label.ada.toggleMultiLevel}}/g,
                        Labels.ada.toggleMultiLevel.replace(
                          /{{filterItem}}/g,
                          u.a.stripHtml(this.label)
                        )
                      )
                    : "";
                },
              },
              {
                key: "compileTemplate",
                value: function () {
                  return this.getTemplate()
                    .replace(
                      /{{class.filterOptionItem}}/g,
                      N.a.filterOptionItem
                    )
                    .replace(
                      /{{class.filterOptionLabel}}/g,
                      N.a.filterOptionLabel
                    )
                    .replace(/{{label}}/g, u.a.stripHtml(this.label))
                    .replace(
                      /{{swatch}}/g,
                      this.filterOption.displayTypeItem ==
                        nM.a.DisplayType.SWATCH
                        ? this.compileSwatchTemplate()
                        : ""
                    )
                    .replace(/{{arrow}}/g, this.compileArrowTemplate())
                    .replace(/{{class.button}}/g, N.a.button)
                    .replace(/{{childItems}}/g, "");
                },
              },
              {
                key: "render",
                value: function () {
                  var t = this;
                  if (
                    (this.$element ||
                      ((this.$element = r()(this.compileTemplate())),
                      (this.$itemElement = this.$element.find(
                        "." + N.a.filterOptionItem
                      )),
                      (this.$itemClickElement = this.$itemElement.find(
                        '[data-action="select-filter-item"]'
                      )),
                      (this.$toggleClickElement = this.$itemElement.find(
                        '[data-action="expand-filter-item"]'
                      )),
                      (this.$childContainerElement = this.$element.find(
                        ".boost-pfs-filter-option-multi-level-list"
                      )),
                      this.$childContainerElement &&
                        this.children &&
                        this.children.length > 0 &&
                        this.children.forEach(function (e) {
                          e.$element &&
                            t.$childContainerElement.append(e.$element);
                        })),
                    (this.isSelected = this.isAppliedFilter()),
                    (this.isSelectedChild = !1),
                    Array.isArray(this.children) &&
                      (this.isSelectedChild = this.children.some(function (t) {
                        return t.isSelected || t.isSelectedChild;
                      })),
                    this.$itemElement)
                  ) {
                    this.isSelected ||
                    (this.filterOption.selectType == nM.a.SelectType.SINGLE &&
                      this.isSelectedChild)
                      ? (this.$itemElement.addClass("selected"),
                        this.$itemElement
                          .find("button")
                          .attr("aria-checked", !0),
                        this.$itemElement
                          .find(".boost-pfs-check-box")
                          .attr("aria-checked", !0))
                      : (this.$itemElement.removeClass("selected"),
                        this.$itemElement
                          .find("button")
                          .removeAttr("aria-checked"),
                        this.$itemElement
                          .find(".boost-pfs-check-box")
                          .removeAttr("aria-checked"));
                    var e = n.getLevelOpenStateData(this),
                      i = o.a.getSettingValue(
                        "general.openMultiLevelByDefault"
                      );
                    e ||
                    (Array.isArray(i) && i.includes(this.level)) ||
                    (null == e && this.isSelectedChild)
                      ? (this.$itemElement.addClass("boost-pfs-open"),
                        n.setLevelOpenStateData(this, !0))
                      : n.setLevelOpenStateData(this, !1);
                  }
                },
              },
              {
                key: "bindEvents",
                value: function () {
                  this.$itemClickElement &&
                    this.$itemClickElement.on("click", this.onClick.bind(this)),
                    this.$toggleClickElement &&
                      this.$toggleClickElement.on(
                        "click",
                        this.onClickToggle.bind(this)
                      );
                },
              },
              {
                key: "isAppliedFilter",
                value: function () {
                  var t = s.a.queryParams[this.filterOption.filterOptionId];
                  return !(!Array.isArray(t) || !t.includes(this.value));
                },
              },
              {
                key: "onSelectFilter",
                value: function () {
                  this.children &&
                    this.children.length > 0 &&
                    (this.$itemElement.addClass("boost-pfs-open"),
                    n.setLevelOpenStateData(this, !0)),
                    this.filterOption.selectType == nM.a.SelectType.SINGLE &&
                      this.filterOption.allNestedFilterItems.forEach(function (
                        t
                      ) {
                        t.$itemElement &&
                          (t.$itemElement.removeClass("selected"),
                          t.$itemElement
                            .find("button")
                            .removeAttr("aria-checked"),
                          t.$itemElement
                            .find(".boost-pfs-check-box")
                            .removeAttr("aria-checked"),
                          (t.isSelected = !1));
                      }),
                    this.filterOption.selectType == nM.a.SelectType.SINGLE
                      ? ((this.isSelected = !0),
                        this.$itemElement.addClass("selected"),
                        this.level > 1 &&
                          (this.parent.$itemElement.addClass("selected"),
                          this.parent.$itemElement
                            .find("button")
                            .attr("aria-checked", !0),
                          this.parent.$itemElement
                            .find(".boost-pfs-check-box")
                            .attr("aria-checked", !0)),
                        this.level > 2 &&
                          (this.parent.parent.$itemElement.addClass("selected"),
                          this.parent.parent.$itemElement
                            .find("button")
                            .attr("aria-checked", !0),
                          this.parent.parent.$itemElement
                            .find(".boost-pfs-check-box")
                            .attr("aria-checked", !0)))
                      : ((this.isSelected = !this.isSelected),
                        this.$itemElement.toggleClass("selected"),
                        this.$itemElement
                          .find("button")
                          .toggleAttr("aria-checked"),
                        this.$itemElement
                          .find(".boost-pfs-check-box")
                          .toggleAttr("aria-checked"));
                },
              },
              {
                key: "onApplyFilter",
                value: function () {
                  var t = this;
                  if (
                    this.isSelected &&
                    this.filterOption.selectType == nM.a.SelectType.SINGLE
                  )
                    this.children &&
                      this.children.length > 0 &&
                      (this.$itemElement.addClass("boost-pfs-open"),
                      n.setLevelOpenStateData(this, !0));
                  else {
                    this.children &&
                      this.children.length > 0 &&
                      n.setLevelOpenStateData(this, !0);
                    var e = this.filterOption.filterOptionId;
                    this.isSelected = !this.isSelected;
                    var i = null;
                    this.filterOption.selectType == nM.a.SelectType.SINGLE
                      ? (i = this.isSelected ? [this.value] : [])
                      : (Array.isArray((i = s.a.queryParams[e])) || (i = []),
                        this.isSelected
                          ? i.includes(this.value) || i.push(this.value)
                          : (i = i.filter(function (e) {
                              return e !== t.value;
                            }))),
                      K.default.setParam(e, i),
                      K.default.setParam(
                        e + "_and_condition",
                        !!(this.filterOption.useAndCondition && i.length > 0) ||
                          null
                      ),
                      K.default.setParam("page", 1);
                    var r = { filterOptionId: e, filterValue: this.value };
                    K.default.applyFilter("filter", r);
                  }
                },
              },
              {
                key: "onClickToggle",
                value: function () {
                  this.$itemElement.toggleClass("boost-pfs-open"),
                    this.$itemElement.hasClass("boost-pfs-open")
                      ? n.setLevelOpenStateData(this, !0)
                      : n.setLevelOpenStateData(this, !1);
                },
              },
              {
                key: "setData",
                value: function (t) {
                  var e = this;
                  (this.value = t.tag),
                    (this.label = u.a.stripHtml(
                      t.displayName ? t.displayName : t.tag
                    )),
                    (this.docCount = t.doc_count ? t.doc_count : 0),
                    (this.level = 1),
                    (this.id = this.value),
                    (this.filterOption = this.parent),
                    (this.label = u.a.stripHtml(this.buildLabel())),
                    this.filterOption.displayTypeItem ==
                      nM.a.DisplayType.SWATCH && this.setSwatchData(),
                    (this.children = []),
                    Array.isArray(t.subTags) &&
                      t.subTags.forEach(function (t) {
                        if (t.tag) {
                          var n = new oe(e.filterTreeType);
                          e.addComponent(n), n.setData(t);
                        }
                      }),
                    this.filterOption.allNestedFilterItems.set(
                      this.value,
                      this
                    );
                },
              },
              {
                key: "setSwatchData",
                value: function () {
                  var t = this.filterOption.filterOptionId
                    .replace("pf_t_", "")
                    .replace("pf_opt_", "");
                  (this.swatchFileName =
                    t +
                    "-" +
                    u.a.slugify(u.a.stripHtml(this.label)).replace(/\#/g, "")),
                    (this.swatchFileUrl = u.a.getFilePath(
                      this.swatchFileName,
                      s.a.swatchExtension,
                      o.a.getSettingValue("general.swatchImageVersion")
                    ));
                  var e = u.a.slugify(u.a.stripHtml(this.label)).split("-");
                  this.backgroundColor = e[e.length - 1];
                },
              },
            ],
            [
              {
                key: "getLevelOpenStateData",
                value: function (t) {
                  var e = t.filterOption.filterOptionId + ":" + t.value;
                  return oi.get(e);
                },
              },
              {
                key: "setLevelOpenStateData",
                value: function (t, e) {
                  var n = t.filterOption.filterOptionId + ":" + t.value;
                  oi.set(n, e);
                },
              },
            ]
          ),
          n
        );
      })(iC),
      oe = (function (t) {
        rY(n, t);
        var e = rX(n);
        function n() {
          return rG(this, n), e.apply(this, arguments);
        }
        return (
          rK(n, [
            {
              key: "getTemplate",
              value: function () {
                return '\n			<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-second-level-item">\n				<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n					{{swatch}}\n					<button class="{{class.button}}" data-action="select-filter-item">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n						<span class="boost-pfs-filter-option-value">{{label}}</span>\n					</button>\n					{{arrow}}\n				</div>\n				<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-third-level-list">\n					{{childItems}}\n				</div>\n			</div>\n		'.trim();
              },
            },
            {
              key: "setData",
              value: function (t) {
                var e = this;
                (this.value = t.tag),
                  (this.label = u.a.stripHtml(
                    t.displayName ? t.displayName : t.tag
                  )),
                  (this.docCount = t.doc_count ? t.doc_count : 0),
                  (this.level = 2),
                  this.parent &&
                    ((this.requestInstantly = this.parent.requestInstantly),
                    (this.filterOption = this.parent.filterOption)),
                  (this.label = u.a.stripHtml(this.buildLabel())),
                  this.filterOption.displayTypeItem ==
                    nM.a.DisplayType.SWATCH && this.setSwatchData(),
                  (this.children = []),
                  Array.isArray(t.subTags) &&
                    t.subTags.forEach(function (t) {
                      if (t.tag) {
                        var n = new on(e.filterTreeType);
                        e.addComponent(n), n.setData(t);
                      }
                    }),
                  this.filterOption.allNestedFilterItems.set(this.value, this);
              },
            },
          ]),
          n
        );
      })(ot),
      on = (function (t) {
        rY(n, t);
        var e = rX(n);
        function n() {
          return rG(this, n), e.apply(this, arguments);
        }
        return (
          rK(n, [
            {
              key: "getTemplate",
              value: function () {
                return '\n			<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-third-level-item">\n				<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n					{{swatch}}\n					<button class="{{class.button}}" data-action="select-filter-item">\n            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{label}}"></span>\n						<span class="boost-pfs-filter-option-value">{{label}}</span>\n					</button>\n				</div>\n			</div>\n		'.trim();
              },
            },
            {
              key: "setData",
              value: function (t) {
                (this.value = t.tag),
                  (this.label = u.a.stripHtml(
                    t.displayName ? t.displayName : t.tag
                  )),
                  (this.docCount = t.doc_count ? t.doc_count : 0),
                  (this.level = 3),
                  this.parent &&
                    ((this.requestInstantly = this.parent.requestInstantly),
                    (this.filterOption = this.parent.filterOption)),
                  (this.label = u.a.stripHtml(this.buildLabel())),
                  this.filterOption.displayTypeItem ==
                    nM.a.DisplayType.SWATCH && this.setSwatchData(),
                  this.filterOption.allNestedFilterItems.set(this.value, this);
              },
            },
          ]),
          n
        );
      })(oe),
      oi = new Map(),
      or = ot;
    function oo(t) {
      return (oo =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function oa(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function os(t, e) {
      return (os =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function ol(t, e) {
      return e && ("object" === oo(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function oc(t) {
      return (oc = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ou = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && os(t, e);
        })(s, t);
        var e,
          n,
          i,
          a = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = oc(t);
              if (e()) {
                var r = oc(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return ol(this, n);
            };
          })(s);
        function s(t) {
          var e;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, s),
            ((e = a.call(this)).filterTreeType = t),
            (e.$clickElement = null),
            (e.$toggleElement = null),
            e
          );
        }
        return (
          (e = s),
          (i = [
            {
              key: "getCollapsedStateData",
              value: function (t) {
                return of.get(t);
              },
            },
            {
              key: "setCollapsedStateData",
              value: function (t, e) {
                of.set(t, e);
              },
            },
          ]),
          (n = [
            {
              key: "init",
              value: function () {
                var t;
                if (
                  ((this.isCollapsed = !1),
                  this.filterTreeType == ic.FilterTreeType.HORIZONTAL)
                )
                  this.isCollapsed = !0;
                else if (
                  (o.a.getSettingValue("general.keepToggleState") &&
                    (t = s.getCollapsedStateData(this.parent.filterOptionId)),
                  void 0 === t)
                ) {
                  var e = u.a.isMobile();
                  this.isCollapsed =
                    (e &&
                      (this.parent.isCollapseMobile ||
                        o.a.getSettingValue(
                          "general.collapseOnMobileByDefault"
                        ))) ||
                    (!e &&
                      (this.parent.isCollapsePC ||
                        o.a.getSettingValue("general.collapseOnPCByDefault")));
                } else this.isCollapsed = t;
              },
            },
            {
              key: "isBindEvents",
              value: function () {
                return !(
                  this.isBoundEvent ||
                  !this.parent.$element ||
                  !this.parent.$filterOptionContentElement ||
                  !this.parent.$filterOptionTitleElement
                );
              },
            },
            {
              key: "bindEvents",
              value: function () {
                (this.$clickElement = this.parent.$filterOptionTitleElement),
                  (this.$toggleElement =
                    this.parent.$filterOptionContentElement),
                  this.filterTreeType == ic.FilterTreeType.VERTICAL
                    ? this.$clickElement.on(
                        "click",
                        this.onToggleVertical.bind(this)
                      )
                    : (this.$clickElement.on(
                        "click",
                        this.onToggleHorizontal.bind(this)
                      ),
                      oh ||
                        ((oh = !0),
                        r()("body").on(
                          "click",
                          this.onClickOutSideHorizontal.bind(this)
                        )),
                      this.parent.filterOptionId == op &&
                        ((op = ""), this.onToggleHorizontal())),
                  this.$clickElement.attr("aria-expanded", !this.isCollapsed);
              },
            },
            {
              key: "onToggleVertical",
              value: function () {
                (this.isCollapsed = !this.isCollapsed),
                  o.a.getSettingValue("general.keepToggleState") &&
                    s.setCollapsedStateData(
                      this.parent.filterOptionId,
                      this.isCollapsed
                    ),
                  this.parent.$element.toggleClass(
                    "boost-pfs-filter-option-collapsed"
                  ),
                  this.$clickElement.attr("aria-expanded", !this.isCollapsed),
                  this.isCollapsed
                    ? this.$toggleElement.addClass("toggled")
                    : (this.$toggleElement.show(),
                      this.$toggleElement.removeClass("toggled"),
                      !u.a.isMobile() &&
                        o.a.getSettingValue("general.stickyFilterOnDesktop") &&
                        u.a.sticky(
                          r()(l.a.stickyElementDesktop),
                          l.a.endStickyDesktop,
                          l.a.avoidStickyHeader
                        )),
                  this.afterToggle();
              },
            },
            {
              key: "onToggleHorizontal",
              value: function () {
                var t = !this.isCollapsed;
                this.calculateHorizontalColumn();
                var e = this.closeAllHorizontalTabs();
                t ||
                  (e
                    ? (op = this.parent.filterOptionId)
                    : ((op = ""),
                      this.parent.$element.removeClass(
                        "boost-pfs-filter-option-collapsed"
                      ),
                      this.$clickElement.attr("aria-expanded", !0),
                      this.$toggleElement.show(),
                      (this.isCollapsed = !1))),
                  this.afterToggle();
              },
            },
            {
              key: "onClickOutSideHorizontal",
              value: function (t) {
                if (t && t.target) {
                  var e = r()(t.target);
                  e.closest(l.a.filterTreeHorizontal + " ." + N.a.filterOption)
                    .length > 0 ||
                    e.closest(l.a.filterTreeHorizontal + " ." + N.a.clearButton)
                      .length > 0 ||
                    e.closest(
                      l.a.filterTreeHorizontal + " ." + N.a.clearAllButton
                    ).length > 0 ||
                    this.closeAllHorizontalTabs();
                }
              },
            },
            {
              key: "closeAllHorizontalTabs",
              value: function () {
                var t = this.parent.parent,
                  e = !1;
                return (
                  t.filterOptions.forEach(function (t) {
                    t.$element &&
                      t.collapse &&
                      !t.collapse.isCollapsed &&
                      (t.$element.addClass("boost-pfs-filter-option-collapsed"),
                      t.$filterOptionTitleElement.attr("aria-expanded", !1),
                      (t.collapse.isCollapsed = !0),
                      t.collapse.$toggleElement.hide(),
                      (t.allNestedFilterItems
                        ? t.allNestedFilterItems
                        : t.filterItems
                      ).forEach(function (n) {
                        e ||
                          (void 0 !== n.isSelected &&
                            n.isAppliedFilter() != n.isSelected &&
                            (e = t));
                      }));
                  }),
                  !!e && (e.applyButton.onApplyOptionValues(), !0)
                );
              },
            },
            { key: "afterToggle", value: function () {} },
            {
              key: "calculateHorizontalColumn",
              value: function () {
                var t = this.parent.displayColumn,
                  e = "left",
                  n = this.parent.$filterOptionTitleElement.offset();
                if (
                  ((1 != t && "1" != t) ||
                    this.parent.displayType !=
                      FilterOptionEnum.DisplayType.RANGE ||
                    (t = 2),
                  n && n.left)
                )
                  switch (t) {
                    case 1:
                    case "1":
                      n.left + 250 > r()(window).width() && (e = "right");
                      break;
                    case 2:
                    case "2":
                      n.left + 532 > r()(window).width() &&
                        (e = n.left < 532 ? "center" : "right");
                      break;
                    case 3:
                    case "3":
                      n.left + 700 > r()(window).width() && (e = "right");
                  }
                "left" == e
                  ? (this.parent.$element.removeClass(
                      "boost-pfs-filter-option-right"
                    ),
                    this.parent.$element.addClass(
                      "boost-pfs-filter-option-left"
                    ))
                  : "center" == e
                  ? (this.parent.$element.removeClass(
                      "boost-pfs-filter-option-left"
                    ),
                    this.parent.$element.removeClass(
                      "boost-pfs-filter-option-right"
                    ),
                    this.parent.$element.addClass(
                      "boost-pfs-filter-option-center"
                    ))
                  : (this.parent.$element.removeClass(
                      "boost-pfs-filter-option-left"
                    ),
                    this.parent.$element.addClass(
                      "boost-pfs-filter-option-right"
                    ));
              },
            },
          ]),
          oa(e.prototype, n),
          i && oa(e, i),
          s
        );
      })(g.a),
      op = "",
      of = new Map(),
      oh = !1,
      od = ou;
    function og(t) {
      return (og =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function oy(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function om(t, e) {
      return (om =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function ov(t, e) {
      return e && ("object" === og(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function ob(t) {
      return (ob = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var oS = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && om(t, e);
      })(c, t);
      var e,
        n,
        i,
        l = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = ob(t);
            if (e()) {
              var r = ob(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return ov(this, n);
          };
        })(c);
      function c(t) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw TypeError("Cannot call a class as a function");
        })(this, c),
          ((e = l.call(this)).filterItems = new Map()),
          (e.clearButton = null),
          (e.applyButton = null),
          (e.searchBox = null),
          (e.filterTreeType = t),
          (e.$element = null),
          (e.$filterOptionTitleElement = null),
          (e.$filterOptionContentElement = null),
          (e.$filterItemsContainerElement = null);
        var e,
          n = e.filterTreeType == ic.FilterTreeType.VERTICAL;
        return (
          (e.selector = {
            filterOptionTitle:
              "." +
              N.a.filterOptionTitle +
              " ." +
              N.a.filterOptionTitle +
              "-heading",
            filterOptionContent: "." + N.a.filterOptionContent,
            filterItemsContainer: "ul",
            clearButtonContainer: n
              ? "." + N.a.filterOptionTitle
              : "." + N.a.filterOptionContent,
            applyButtonContainer: "." + N.a.filterOptionContent,
            viewMoreContainer: "." + N.a.filterOptionContent,
            searchBoxContainer: "." + N.a.filterOptionContent,
            tooltipContainer:
              "." +
              N.a.filterOptionTitle +
              " ." +
              N.a.filterOptionTitle +
              "-heading",
            numberFilterItemsContainer: "." + N.a.filterOptionTitle + "-count",
          }),
          e
        );
      }
      return (
        (e = c),
        (n = [
          {
            key: "init",
            value: function () {
              (this.collapse = new od(this.filterTreeType)),
                this.addComponent(this.collapse),
                (this.clearButton = new iy(
                  this.filterTreeType,
                  iy.ClearType.CLEAR_OPTION_VALUES
                )),
                this.addComponent(this.clearButton),
                (this.applyButton = new iT(
                  this.filterTreeType,
                  iT.ApplyType.APPLY_OPTION_VALUES
                )),
                this.addComponent(this.applyButton),
                (this.viewMore = new rb(this.filterTreeType)),
                this.addComponent(this.viewMore),
                (this.scrollbar = new rF()),
                this.addComponent(this.scrollbar),
                (this.searchBox = new r8()),
                this.addComponent(this.searchBox),
                (this.filterTooltip = new rE(this.tooltip)),
                this.addComponent(this.filterTooltip);
            },
          },
          {
            key: "getTemplate",
            value: function () {
              switch (this.filterTreeType) {
                case "vertical":
                  return '\n				<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}} {{class.filterScrollbar}} {{displayColumn}}">\n					<div class="{{class.filterOptionTitle}}">\n						<button aria-controls="{{ada.filterOptionDomId}}" aria-label="{{ada.filterOptionTitle}}" tabindex="0" class="{{class.button}} {{class.filterOptionTitle}}-heading">\n							<span class="{{class.filterOptionTitle}}-text">\n								{{blockTitle}}\n								<span class="{{class.filterOptionTitle}}-count">\n									{{numberAppliedFilterItems}}\n								</span>\n							</span>\n							{{tooltip}}\n						</button>\n						<p class="boost-pfs-filter-selected-items-mobile"></p>\n						{{clearButton}}\n					</div>\n					<div class="{{class.filterOptionContent}}">\n						{{searchBox}}\n						<div class="{{class.filterOptionContentInner}}">\n							{{blockContent}}\n						</div>\n						{{viewMore}}\n					</div>\n				</div>\n			'.trim();
                case "horizontal":
                  return '\n				<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}} {{class.filterScrollbar}} {{displayColumn}}">\n					<div class="{{class.filterOptionTitle}}">\n						<button aria-controls="{{ada.filterOptionDomId}}" aria-label="{{ada.filterOptionTitle}}" tabindex="0" class="{{class.button}} {{class.filterOptionTitle}}-heading">\n							<span class="{{class.filterOptionTitle}}-text">\n							{{blockTitle}}\n								<span class="{{class.filterOptionTitle}}-count">\n									{{numberAppliedFilterItems}}\n								</span>\n							</span>\n							{{tooltip}}\n						</button>\n					</div>\n					<div class="{{class.filterOptionContent}}">\n						<div class="{{class.filterOptionContentInner}}">\n							{{blockContent}}\n						</div>\n						{{viewMore}}\n						{{applyButton}}\n						{{clearButton}}\n					</div>\n				</div>\n			'.trim();
                default:
                  console.warn("filterTreeType is wrong");
              }
            },
          },
          {
            key: "getBlockContentTemplate",
            value: function () {
              console.warn("Override this method");
            },
          },
          {
            key: "compileBlockContentTemplate",
            value: function () {
              return this.getBlockContentTemplate();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t = u.a.slugify(u.a.stripHtml(this.label)),
                e = u.a.slugify(this.displayType.replace(/_/g, "-")),
                n = rF.isEnabled(
                  this.displayType,
                  this.filterType,
                  this.showMoreType
                )
                  ? N.a.filterHasScrollbar
                  : N.a.filterNoScrollbar,
                i = "boost-pfs-filter-option-column-" + this.displayColumn;
              return this.getTemplate()
                .replace(/{{blockTitle}}/g, u.a.stripHtml(this.label))
                .replace(/{{blockTypeClass}}/g, N.a.filterOption + "-" + e)
                .replace(/{{blockId}}/g, N.a.filterOption + "-" + t)
                .replace(
                  /{{blockContent}}/g,
                  this.compileBlockContentTemplate()
                )
                .replace(
                  /{{blockContentId}}/g,
                  N.a.filterOptionContent + "-" + t
                )
                .replace(/{{displayColumn}}/g, i)
                .replace(/{{class.filterOption}}/g, N.a.filterOption)
                .replace(
                  /{{class.filterOptionContent}}/g,
                  N.a.filterOptionContent
                )
                .replace(
                  /{{class.filterOptionContentInner}}/g,
                  N.a.filterOptionContentInner
                )
                .replace(/{{class.filterOptionTitle}}/g, N.a.filterOptionTitle)
                .replace(/{{class.filterScrollbar}}/g, n)
                .replace(
                  /{{class.filterOptionItemList}}/g,
                  N.a.filterOptionItemList
                )
                .replace(
                  /{{class.filterOptionItemListSingleList}}/g,
                  N.a.filterOptionItemListSingleList
                )
                .replace(
                  /{{class.filterOptionItemListMultipleList}}/g,
                  N.a.filterOptionItemListMultipleList
                )
                .replace(
                  /{{class.filterOptionItemListBox}}/g,
                  N.a.filterOptionItemListBox
                )
                .replace(
                  /{{class.filterOptionItemListSwatch}}/g,
                  N.a.filterOptionItemListSwatch
                )
                .replace(
                  /{{class.filterOptionItemListRating}}/g,
                  N.a.filterOptionItemListRating
                )
                .replace(
                  /{{class.filterOptionMultiLevelTag}}/g,
                  N.a.filterOptionMultiLevelTag
                )
                .replace(
                  /{{class.filterOptiontemListMultiLevelCollections}}/g,
                  N.a.filterOptiontemListMultiLevelCollections
                )
                .replace(/{{class.button}}/g, N.a.button)
                .replace(
                  /{{ada.filterOptionTitle}}/g,
                  a.a.ada.filterOptionTitle.replace(
                    "{{filterOption}}",
                    u.a.stripHtml(this.label)
                  )
                )
                .replace(
                  /{{ada.filterOptionDomId}}/g,
                  this.parent.id + "-" + this.filterOptionId.replace(/_/g, "-")
                )
                .replace(/{{tooltip}}/g, "")
                .replace(/{{clearButton}}/g, "")
                .replace(/{{applyButton}}/g, "")
                .replace(/{{searchBox}}/g, "")
                .replace(/{{viewMore}}/g, "")
                .replace(/{{filterItems}}/g, "")
                .replace(/\n/g, "")
                .replace(/\t/g, "");
            },
          },
          {
            key: "isRender",
            value: function () {
              if (this.status == nM.a.Status.ACTIVE) {
                var t = o.a.getSettingValue("general.showSingleOption"),
                  e = 0,
                  n =
                    this.displayType ==
                      nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS ||
                    this.displayType == nM.a.DisplayType.MULTI_LEVEL_TAG;
                return (
                  this.filterItems.forEach(function (t) {
                    t.$element &&
                      t.$element.length &&
                      (e++,
                      n &&
                        Array.isArray(t.children) &&
                        t.children.length > 0 &&
                        (e += t.children.length));
                  }),
                  t ? e > 1 : e > 0
                );
              }
              return !1;
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvent;
            },
          },
          {
            key: "render",
            value: function () {
              var t = this;
              if (!this.$element) {
                (this.$element = r()(this.compileTemplate())),
                  (this.$filterOptionContentElement = this.$element.find(
                    this.selector.filterOptionContent
                  )),
                  (this.$filterOptionTitleElement = this.$element.find(
                    this.selector.filterOptionTitle
                  )),
                  (this.$filterItemsContainerElement = this.$element
                    .find(this.selector.filterItemsContainer)
                    .html("")),
                  this.filterItems.forEach(function (e) {
                    e.isRenderOnScroll ||
                      t.$filterItemsContainerElement.append(e.$element);
                  }),
                  this.$element
                    .find(this.selector.searchBoxContainer)
                    .prepend(this.searchBox.$element),
                  this.$element
                    .find(this.selector.viewMoreContainer)
                    .append(this.viewMore.$element),
                  this.$element
                    .find(this.selector.applyButtonContainer)
                    .append(this.applyButton.$element),
                  this.$element
                    .find(this.selector.clearButtonContainer)
                    .append(this.clearButton.$element);
                var e = this.$element.find(this.selector.tooltipContainer);
                e.append(this.filterTooltip.$element),
                  e.append(this.filterTooltip.$popupElement),
                  this.collapse.isCollapsed &&
                    (this.$element.addClass(
                      "boost-pfs-filter-option-collapsed"
                    ),
                    this.$filterOptionContentElement.addClass("toggled"),
                    this.$filterOptionContentElement.hide()),
                  this.$filterOptionContentElement.attr(
                    "id",
                    u.a.stripHtml(
                      this.parent.id +
                        "-" +
                        this.filterOptionId.replace(/_/g, "-")
                    )
                  );
              }
              (this.numberAppliedFilterItems =
                this.getNumberAppliedFilterItems()),
                this.$element
                  .find(this.selector.numberFilterItemsContainer)
                  .html(
                    u.a.stripHtml(
                      this.numberAppliedFilterItems > 0
                        ? this.numberAppliedFilterItems
                        : ""
                    )
                  );
            },
          },
          {
            key: "getNumberAppliedFilterItems",
            value: function () {
              var t = 0,
                e = [
                  nM.a.DisplayType.LIST,
                  nM.a.DisplayType.BOX,
                  nM.a.DisplayType.SWATCH,
                  nM.a.DisplayType.RATING,
                  nM.a.DisplayType.MULTI_LEVEL_TAG,
                ];
              return (
                this.filterItems &&
                  e.includes(this.displayType) &&
                  this.filterItems.forEach(function (e) {
                    e.isSelected && t++;
                  }),
                t
              );
            },
          },
          {
            key: "setData",
            value: function (t) {
              var e = this;
              (this.status = t.status),
                (this.position = t.position),
                (this.label = u.a.stripHtml(t.label)),
                (this.filterOptionId = t.filterOptionId),
                (this.filterType = t.filterType),
                (this.displayType = t.displayType),
                (this.selectType = t.selectType),
                (this.valueType = t.valueType),
                (this.displayTypeItem = t.displayTypeItem),
                (this.manualValues = t.manualValues ? t.manualValues : []),
                (this.prefix = t.prefix),
                (this.isCollapsePC = t.isCollapsePC),
                (this.isCollapseMobile = t.isCollapseMobile),
                (this.showSearchBoxFilterPC = t.showSearchBoxFilterPC),
                (this.showSearchBoxFilterMobile = t.showSearchBoxFilterMobile),
                (this.keepValuesStatic = t.keepValuesStatic),
                (this.activeCollectionAll = t.activeCollectionAll),
                (this.tooltip = t.tooltip),
                (this.showMoreType =
                  null == t.showMoreType || "" == t.showMoreType
                    ? nM.a.ShowMoreType.SCROLLBAR
                    : t.showMoreType),
                (this.sortType = t.sortType),
                (this.sortManualValues = t.sortManualValues),
                (this.displayAllValuesInUppercaseForm =
                  t.displayAllValuesInUppercaseForm),
                (this.useAndCondition = t.useAndCondition),
                (this.showExactRating = t.showExactRating),
                (this.excludePriceFromValue = t.excludePriceFromValue),
                (this.starColor = u.a.stripHtml(t.starColor)),
                (this.displayColumn = t.displayColumn
                  ? t.displayColumn
                  : o.a.getSettingValue("general.filterHorizontalColumn")),
                (this.filterTreeHorizontalStyle = o.a.getSettingValue(
                  "general.filterTreeHorizontalStyle"
                )),
                "style1" == this.filterTreeHorizontalStyle
                  ? (this.displayColumn = "1")
                  : "style2" == this.filterTreeHorizontalStyle
                  ? (this.displayColumn = "2")
                  : "style3" == this.filterTreeHorizontalStyle &&
                    (this.displayColumn = "full"),
                (this.swatchStyle = t.swatchStyle),
                (this.shortenPipsRange = t.shortenPipsRange),
                t.inventoryBaseSelectedLocations &&
                  ((this.inventoryBaseSelectedLocations =
                    t.inventoryBaseSelectedLocations),
                  (s.a.inventoryBaseSelectedLocations =
                    t.inventoryBaseSelectedLocations)),
                t.filterType == nM.a.FilterType.LOCATION &&
                  (s.a.hasFilterByLocation = !0),
                (this.children = []),
                (this.filterItems = new Map());
              var n = [];
              t.values
                ? (n = Array.isArray(t.values) ? t.values : [t.values])
                : t.manualValues &&
                  (n = Array.isArray(t.manualValues)
                    ? t.manualValues
                    : [t.manualValues]),
                this.isSortValues() && this.sortValues(n),
                this.modifyValues(n),
                this.markValuesAsNoRender(n),
                n.forEach(function (t) {
                  var n = null;
                  switch (e.displayType) {
                    case nM.a.DisplayType.LIST:
                      n = new iA(e.filterTreeType);
                      break;
                    case nM.a.DisplayType.BOX:
                      n = new iV(e.filterTreeType);
                      break;
                    case nM.a.DisplayType.SWATCH:
                      n = new i7(e.filterTreeType);
                      break;
                    case nM.a.DisplayType.RATING:
                      n = new iK(e.filterTreeType);
                      break;
                    case nM.a.DisplayType.RANGE:
                      n = new ru(e.filterTreeType);
                      break;
                    case nM.a.DisplayType.SUB_CATEGORY:
                      n = new rn(e.filterTreeType);
                      break;
                    case nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS:
                      n = new rj(e.filterTreeType);
                      break;
                    case nM.a.DisplayType.MULTI_LEVEL_TAG:
                      n = new or(e.filterTreeType);
                  }
                  if (n) {
                    e.addComponent(n), n.setData(t);
                    var i = n.key ? n.key : n.value;
                    e.filterItems.set(i, n);
                  }
                });
            },
          },
          {
            key: "isSortValues",
            value: function () {
              if (
                [
                  nM.a.FilterType.REVIEW_RATINGS,
                  nM.a.FilterType.PERCENT_SALE,
                ].includes(this.filterType)
              )
                return !0;
              var t = [nM.a.FilterType.STOCK],
                e = [
                  nM.a.DisplayType.RANGE,
                  nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS,
                ],
                n = this.valueType == nM.a.ValueType.ALL,
                i =
                  this.valueType != nM.a.ValueType.ALL &&
                  (this.sortManualValues ||
                    o.a.getSettingValue("general.sortManualValues")),
                r =
                  this.displayType == nM.a.DisplayType.RANGE &&
                  0 == this.isNumberRangeSlider;
              return (
                !t.includes(this.filterType) &&
                (!e.includes(this.displayType) || r) &&
                (n || i)
              );
            },
          },
          {
            key: "sortValues",
            value: function (t) {
              var e = this.sortType
                  ? this.sortType
                  : nM.a.SortType.KEY_ASCENDING,
                n = e.split("-")[0],
                i = "key" == n ? "doc_count" : "key";
              this.filterType == nM.a.FilterType.COLLECTION &&
                "key" == n &&
                (n = "label"),
                t &&
                  t.length > 0 &&
                  t.sort(
                    function (t, e) {
                      var r = -1;
                      if (null != t[n] && null != e[n]) {
                        var o = t[n].toString().toLowerCase(),
                          a = e[n].toString().toLowerCase();
                        if (
                          0 == (r = this.naturalSortFunction(o, a)) &&
                          null != t[i] &&
                          null != e[i]
                        ) {
                          var s = t[i].toString().toLowerCase(),
                            l = e[i].toString().toLowerCase();
                          r = this.naturalSortFunction(s, l);
                        }
                      }
                      return r;
                    }.bind(this)
                  ),
                (e.indexOf("desc") > -1 ||
                  (e.startsWith("alpha") &&
                    (this.filterType == nM.a.FilterType.REVIEW_RATINGS ||
                      this.filterType == nM.a.FilterType.PERCENT_SALE))) &&
                  t.reverse();
            },
          },
          {
            key: "naturalSortFunction",
            value: function (t, e) {
              function n(t) {
                for (
                  var e, n, i = [], r = 0, o = -1, a = 0;
                  (e = (n = t.charAt(r++)).charCodeAt(0));

                ) {
                  var s = 46 == e || (e >= 48 && e <= 57);
                  s !== a && ((i[++o] = ""), (a = s)), (i[o] += n);
                }
                return i;
              }
              for (var i = n(t), r = n(e), o = 0; i[o] && r[o]; o++)
                if (i[o] !== r[o]) {
                  var a = Number(i[o]),
                    s = Number(r[o]);
                  return a == i[o] && s == r[o] ? a - s : i[o] > r[o] ? 1 : -1;
                }
              return i.length - r.length;
            },
          },
          {
            key: "modifyValues",
            value: function (t) {
              if (this.filterType == nM.a.FilterType.COLLECTION) {
                if (
                  this.activeCollectionAll &&
                  !t.some(function (t) {
                    return "all" == t.handle;
                  })
                ) {
                  var e = { key: "0", label: a.a.collectionAll, handle: "all" };
                  t.unshift(e);
                }
                if (
                  (t.forEach(function (t) {
                    t.sort_order &&
                      (t.sort_order.endsWith("-desc")
                        ? (t.sort_order = t.sort_order.replace(
                            /-desc$/,
                            "-descending"
                          ))
                        : t.sort_order.endsWith("-asc") &&
                          (t.sort_order = t.sort_order.replace(
                            /-asc$/,
                            "-ascending"
                          )),
                      t.sort_order.startsWith("alpha") &&
                        (t.sort_order = t.sort_order.replace(
                          /alpha/,
                          "title"
                        )));
                  }),
                  !this.keepValuesStatic &&
                    !o.a.getSettingValue("general.showOutOfStockOption"))
                )
                  for (var n = t.length - 1; n >= 0; n--)
                    0 == t[n].doc_count && t.splice(n, 1);
              }
            },
          },
          {
            key: "markValuesAsNoRender",
            value: function (t) {
              var e = o.a.getSettingValue("general.scrollFirstLoadLength"),
                n = [nM.a.DisplayType.LIST];
              Array.isArray(t) &&
                t.length > e &&
                n.includes(this.displayType) &&
                rF.isEnabled(
                  this.displayType,
                  this.filterType,
                  this.showMoreType
                ) &&
                ((this.isLoadMoreOnScroll = !0),
                t.forEach(function (t, n) {
                  t.isRenderOnScroll = n >= e;
                }));
            },
          },
        ]),
        oy(e.prototype, n),
        i && oy(e, i),
        c
      );
    })(g.a);
    function o$(t) {
      return (o$ =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function oT(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function oP(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function o_(t, e, n) {
      return (o_ =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = oO(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function o8(t, e) {
      return (o8 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function ok(t, e) {
      return e && ("object" === o$(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function oO(t) {
      return (oO = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var oC = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && o8(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = oO(t);
            if (e()) {
              var r = oO(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return ok(this, n);
          };
        })(o);
      function o() {
        return oT(this, o), r.apply(this, arguments);
      }
      return (
        (e = o),
        (n = [
          {
            key: "getBlockContentTemplate",
            value: function () {
              return this.selectType == nM.a.SelectType.SINGLE
                ? '\n				<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListSingleList}}">\n					{{filterItems}}\n				</ul>\n			'.trim()
                : '\n				<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListMultipleList}}">\n					{{filterItems}}\n				</ul>\n			'.trim();
            },
          },
          {
            key: "prepareFilterOptionData",
            value: function (t) {
              if (
                ("price" == t.filterType || "variants_price" == t.filterType) &&
                t.values &&
                Array.isArray(t.values) &&
                !t.isConvertedPrice &&
                u.a.isEnableShopifyMultipleCurrencies() &&
                u.a.isConvertCurrenciesOnFrontEnd()
              ) {
                for (var e = 0; e < t.values.length; e++) {
                  var n = !1,
                    i = !1;
                  t.values[e].hasOwnProperty("to") &&
                    ((n = !0),
                    (t.values[e].to = u.a.convertPriceBasedOnActiveCurrency(
                      t.values[e].to
                    ))),
                    t.values[e].hasOwnProperty("from") &&
                      ((i = !0),
                      (t.values[e].from = u.a.convertPriceBasedOnActiveCurrency(
                        t.values[e].from
                      ))),
                    (t.values[e].key =
                      n && i
                        ? t.values[e].from + "-" + t.values[e].to
                        : n
                        ? "*-" + t.values[e].to
                        : t.values[e].from + "-*");
                }
                t.isConvertedPrice = !0;
              }
              return t;
            },
          },
          {
            key: "setData",
            value: function (t) {
              (t = this.prepareFilterOptionData(t)),
                o_(oO(o.prototype), "setData", this).call(this, t);
            },
          },
        ]),
        oP(e.prototype, n),
        i && oP(e, i),
        o
      );
    })(oS);
    function ow(t) {
      return (ow =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function oI(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function oE(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function o0(t, e) {
      return (o0 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function oL(t, e) {
      return e && ("object" === ow(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function oA(t) {
      return (oA = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ox = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && o0(t, e);
      })(a, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = oA(t);
            if (e()) {
              var r = oA(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return oL(this, n);
          };
        })(a);
      function a() {
        return oI(this, a), r.apply(this, arguments);
      }
      return (
        (e = a),
        (n = [
          {
            key: "getBlockContentTemplate",
            value: function () {
              return '\n			<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListBox}}">{{filterItems}}</ul>\n		'.trim();
            },
          },
          {
            key: "calculateBoxItemSize",
            value: function () {
              if (!o.a.getSettingValue("general.enableFilterOptionBoxStyle"))
                return "";
              var t = this.$element ? this.$element.width() : 0;
              if (!t || t < 0) return "100%";
              if (!this.boxItemSize) {
                var e = 4,
                  n =
                    o.a.getSettingValue("general.filterOptionBoxCharWidth") ||
                    14;
                this.filterItems.forEach(function (t) {
                  e = Math.max(u.a.stripHtml(t.label).length * n, e);
                });
                var i =
                  100 / (Math.floor(this.$element.width() / (e + 8)) || 1) - 2;
                i < 1 && (i = 100), (this.boxItemSize = i + "%");
              }
              return this.boxItemSize;
            },
          },
        ]),
        oE(e.prototype, n),
        i && oE(e, i),
        a
      );
    })(oS);
    function oB(t) {
      return (oB =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function oR(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function o9(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function oF(t, e) {
      return (oF =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function o2(t, e) {
      return e && ("object" === oB(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function o1(t) {
      return (o1 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var oV = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && oF(t, e);
      })(a, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = o1(t);
            if (e()) {
              var r = o1(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return o2(this, n);
          };
        })(a);
      function a() {
        return oR(this, a), r.apply(this, arguments);
      }
      return (
        (e = a),
        (n = [
          {
            key: "getBlockContentTemplate",
            value: function () {
              return '\n			<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListSwatch}} {{swatchStyle}}">\n				{{filterItems}}\n			</ul>\n		'.trim();
            },
          },
          {
            key: "compileBlockContentTemplate",
            value: function () {
              return (
                (this.swatchStyle = this.buildSwatchStyle()),
                this.getBlockContentTemplate().replace(
                  /{{swatchStyle}}/g,
                  this.swatchStyle
                )
              );
            },
          },
          {
            key: "buildSwatchStyle",
            value: function () {
              return (
                this.swatchStyle ||
                (this.filterTreeType == ic.FilterTreeType.HORIZONTAL ||
                (u.a.isMobile() &&
                  "style2" ==
                    o.a.getSettingValue("general.filterTreeMobileStyle"))
                  ? "circle-list"
                  : "circle-grid")
              );
            },
          },
        ]),
        o9(e.prototype, n),
        i && o9(e, i),
        a
      );
    })(oS);
    function oD(t) {
      return (oD =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function oM(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function o4(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function o3(t, e) {
      return (o3 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function o6(t, e) {
      return e && ("object" === oD(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function o5(t) {
      return (o5 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var oH = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && o3(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = o5(t);
            if (e()) {
              var r = o5(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return o6(this, n);
          };
        })(o);
      function o() {
        return oM(this, o), r.apply(this, arguments);
      }
      return (
        (e = o),
        (n = [
          {
            key: "getBlockContentTemplate",
            value: function () {
              return this.selectType == nM.a.SelectType.MULTIPLE &&
                this.showExactRating
                ? '\n				<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListRating}} {{class.filterOptionItemListMultipleList}}">\n					{{filterItems}}\n				</ul>\n			'.trim()
                : '\n				<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListRating}}">\n					{{filterItems}}\n				</ul>\n			'.trim();
            },
          },
        ]),
        o4(e.prototype, n),
        i && o4(e, i),
        o
      );
    })(oS);
    function o7(t) {
      return (o7 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function oN(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function oU(t, e) {
      return (oU =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function oW(t, e) {
      return e && ("object" === o7(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function oj(t) {
      return (oj = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var oq = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && oU(t, e);
      })(s, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = oj(t);
            if (e()) {
              var r = oj(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return oW(this, n);
          };
        })(s);
      function s(t) {
        var e;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, s),
          ((e = o.call(this)).filterTreeType = t),
          (e.$element = null),
          e
        );
      }
      return (
        (e = s),
        (n = [
          {
            key: "init",
            value: function () {
              (this.clearButton = new iy(
                this.filterTreeType,
                iy.ClearType.CLEAR_SINGLE_VALUE
              )),
                this.addComponent(this.clearButton);
            },
          },
          {
            key: "getTemplate",
            value: function () {
              switch (this.filterTreeType) {
                case ic.FilterTreeType.VERTICAL:
                  return '\n					<div class="refine-by-item {{class.filterOptionLabel}}">\n						{{clearButton}}\n					</div>\n				'.trim();
                case ic.FilterTreeType.HORIZONTAL:
                  return '\n					<div class="refine-by-item">\n						{{clearButton}}\n					</div>\n				'.trim();
                default:
                  console.warn("Wrong filterTreeType");
              }
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .trim()
                .replace(/{{class.filterOptionLabel}}/g, N.a.filterOptionLabel)
                .replace(
                  /{{type}}/g,
                  this.type ? u.a.stripHtml(this.type + ": ") : ""
                )
                .replace(/{{label}}/g, u.a.stripHtml(this.label))
                .replace(/{{clearButton}}/g, "");
            },
          },
          {
            key: "isRender",
            value: function () {
              return "" != this.label;
            },
          },
          {
            key: "render",
            value: function () {
              (this.$element = r()(this.compileTemplate())),
                this.$element.append(this.clearButton.$element);
            },
          },
          {
            key: "setData",
            value: function (t, e, n) {
              (this.filterOption = t),
                (this.filterItem = e),
                (this.filterOptionId = t.filterOptionId),
                (this.filterItemId = n),
                (this.type = u.a.stripHtml(t.label)),
                (this.label = u.a.stripHtml(this.buildLabel()));
            },
          },
          {
            key: "buildLabel",
            value: function () {
              var t = this.filterItemId;
              if (this.filterOption)
                switch (this.filterOption.displayType) {
                  case nM.a.DisplayType.RANGE:
                    t = this.buildLabelRange();
                    break;
                  case nM.a.DisplayType.RATING:
                    t = this.buildLabelRating();
                    break;
                  case nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS:
                  case nM.a.DisplayType.MULTI_LEVEL_TAG:
                    t = this.buildLabelMultiLevel();
                    break;
                  default:
                    if (this.filterItem)
                      t = u.a.stripHtml(this.filterItem.label);
                    else {
                      var e = new iC(this.filterOption.filterTreeType);
                      (e.filterOption = this.filterOption),
                        (e.label = u.a.stripHtml(this.filterItemId)),
                        (t = u.a.stripHtml(e.buildLabel()));
                    }
                }
              return u.a.stripHtml(t);
            },
          },
          {
            key: "buildLabelRating",
            value: function () {
              var t = "";
              if (this.filterItem) {
                var e = this.filterItem.from;
                (t = Math.ceil(e) + " "),
                  1 == Math.ceil(e)
                    ? (t += a.a.ratingStar)
                    : (t += a.a.ratingStars),
                  this.filterOption.showExactRating ||
                    (t += " " + a.a.ratingUp);
              }
              return t;
            },
          },
          {
            key: "buildLabelRange",
            value: function () {
              var t = "";
              if (this.filterOption) {
                if (this.filterOption.isNumberRangeSlider) {
                  if ((r = this.filterItemId.split(":")) && 2 == r.length) {
                    var e = this.filterOption.buildLabel(r[0]),
                      n = this.filterOption.buildLabel(r[1]);
                    if (
                      "price" === this.filterOption.filterType ||
                      "variants_price" === this.filterOption.filterType
                    ) {
                      var i = Globals.moneyFormat
                        .replace(/{{.+}}/g, "")
                        .replace("&#36;", "$");
                      -1 === e.indexOf(i) && ((e = i + e), (n = i + n));
                    }
                    t = e == n ? e : e + " - " + n;
                  }
                } else {
                  var r = this.filterItemId;
                  if (
                    ((e = ""),
                    (n = ""),
                    this.filterOption.currentMax - 1 > 0 &&
                    this.filterOption.currentMax - 1 <
                      this.filterOption.valuesData.length
                      ? ((e =
                          this.filterOption.valuesData[
                            this.filterOption.currentMin
                          ].key),
                        (n =
                          this.filterOption.valuesData[
                            this.filterOption.currentMax - 1
                          ].key))
                      : Array.isArray(r) &&
                        r.length > 0 &&
                        ((e = r[0]), (n = r[r.length - 1])),
                    this.filterOption.prefix)
                  ) {
                    var o = this.filterOption.prefix.replace(/\\/g, "");
                    (e = e.replace(o, "").trim()),
                      (n = n.replace(o, "").trim());
                  }
                  t = e == n ? e : e + " - " + n;
                }
              }
              return t;
            },
          },
          {
            key: "buildLabelMultiLevel",
            value: function () {
              var t = "";
              if (
                this.filterOption &&
                this.filterItem &&
                (this.filterOption.displayType ==
                  nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS ||
                  this.filterOption.displayType ==
                    nM.a.DisplayType.MULTI_LEVEL_TAG)
              )
                switch (this.filterItem.level) {
                  case 1:
                    (this.type = u.a.stripHtml(this.filterOption.label)),
                      (t = u.a.stripHtml(this.filterItem.buildLabel()));
                    break;
                  case 2:
                  case 3:
                    (this.filterOptionId = this.filterOptionId.replace(
                      Globals.prefix + "_c_",
                      Globals.prefix + "_ct_"
                    )),
                      (this.type = u.a.stripHtml(this.filterOption.label)),
                      (t = u.a.stripHtml(this.filterItem.buildLabel()));
                }
              var e = t || this.filterItemId;
              return (
                isNaN(e) || 1 != this.filterItem.level || (e = ""),
                u.a.stripHtml(e)
              );
            },
          },
        ]),
        oN(e.prototype, n),
        i && oN(e, i),
        s
      );
    })(g.a);
    function oG(t) {
      return (oG =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function oz(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function oK(t, e) {
      return (oK =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function oY(t, e) {
      return e && ("object" === oG(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function oQ(t) {
      return (oQ = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var oX = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && oK(t, e);
      })(c, t);
      var e,
        n,
        i,
        o = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = oQ(t);
            if (e()) {
              var r = oQ(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return oY(this, n);
          };
        })(c);
      function c(t) {
        var e;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, c),
          ((e = o.call(this)).refineByItems = []),
          (e.clearAllButton = null),
          (e.filterTreeType = t),
          (e.$element = null),
          e
        );
      }
      return (
        (e = c),
        (n = [
          {
            key: "init",
            value: function () {
              Settings.getSettingValue("general.separateRefineByFromFilter") &&
                (r()(l.a.filterRefineByHorizontal).length > 0
                  ? (this.filterTreeType = ic.FilterTreeType.HORIZONTAL)
                  : r()(l.a.filterRefineByVertical).length > 0 &&
                    (this.filterTreeType = ic.FilterTreeType.VERTICAL)),
                (this.clearAllButton = new iy(
                  this.filterTreeType,
                  iy.ClearType.CLEAR_ALL
                )),
                this.addComponent(this.clearAllButton);
            },
          },
          {
            key: "getTemplate",
            value: function () {
              switch (this.filterTreeType) {
                case ic.FilterTreeType.VERTICAL:
                  return '\n					<div class="{{class.filterRefineBy}}">\n						<div class="{{class.filterOptionTitle}}">\n							<div class="{{class.filterOptionTitle}}-heading" role="heading" aria-level="2"><span>{{label}}</span></div>\n							{{clearAllButton}}\n						</div>\n						<div class="{{class.filterSelectedItems}}">{{refineByItems}}</div>\n					</div>\n				'.trim();
                case ic.FilterTreeType.HORIZONTAL:
                  return '\n					<div class="boost-pfs-filter-pc {{class.filterRefineBy}}">\n						<span>{{label}}</span>\n						<div class="{{class.filterSelectedItems}}">{{refineByItems}}</div>\n						{{clearAllButton}}\n					</div>\n				'.trim();
                default:
                  console.warn("Wrong filterTreeType");
              }
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(/{{class.filterRefineBy}}/g, N.a.filterRefineBy)
                .replace(/{{class.filterOptionTitle}}/g, N.a.filterOptionTitle)
                .replace(
                  /{{class.filterSelectedItems}}/g,
                  N.a.filterSelectedItems
                )
                .replace(/{{label}}/g, a.a.refine)
                .replace(/{{refineByItems}}/g, "")
                .replace(/{{clearAllButton}}/g, "");
            },
          },
          {
            key: "render",
            value: function () {
              var t = this;
              this.refineByItems && this.refineByItems.length > 0
                ? ((this.$element = r()(this.compileTemplate())),
                  (this.$refineByItemsContainer = this.$element.find(
                    "." + N.a.filterSelectedItems
                  )),
                  this.refineByItems.forEach(function (e) {
                    t.$refineByItemsContainer.append(e.$element);
                  }),
                  (this.$clearAllButtonContainer =
                    this.filterTreeType == ic.FilterTreeType.VERTICAL
                      ? this.$element.find("." + N.a.filterOptionTitle)
                      : this.$element),
                  this.$clearAllButtonContainer.append(
                    this.clearAllButton.$element
                  ))
                : (this.$element = null);
            },
          },
          {
            key: "setData",
            value: function () {
              var t = this;
              this.refineByItems = [];
              var e = Object.keys(s.a.queryParams).filter(function (t) {
                return t.startsWith(s.a.prefix);
              });
              e &&
                e.length > 0 &&
                e.forEach(function (e) {
                  var n = t.parent.filterOptions.get(e),
                    i = e.startsWith(s.a.prefix + "_ct_");
                  i &&
                    (n = t.parent.filterOptions.get(
                      e.replace(s.a.prefix + "_ct_", s.a.prefix + "_c_")
                    ));
                  var r = s.a.queryParams[e],
                    o = e.startsWith(s.a.prefix + "_c_");
                  if ((o && !Array.isArray(r) && (r = [r]), n && r)) {
                    var a =
                      n.displayType ==
                        nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS ||
                      n.displayType == nM.a.DisplayType.MULTI_LEVEL_TAG;
                    if (n.displayType == nM.a.DisplayType.RANGE) {
                      var l = new oq(t.filterTreeType),
                        c = "";
                      (c = n.isNumberRangeSlider ? r[0] : r),
                        l.setData(n, null, c),
                        t.refineByItems.push(l),
                        t.addComponent(l);
                    } else if (a) {
                      var u =
                        (n.displayType ==
                          nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS &&
                          Settings.getSettingValue(
                            "general.multiLevelCollectionSelectType"
                          ) == nM.a.SelectType.SINGLE) ||
                        (n.displayType == nM.a.DisplayType.MULTI_LEVEL_TAG &&
                          n.selectType == nM.a.SelectType.SINGLE);
                      Object.values(r).forEach(function (e) {
                        var r = e;
                        i && (r = s.a.collectionId + ":" + e);
                        var a = n.allNestedFilterItems.get(r);
                        if (!(u && o && a && a.isSelectedChild)) {
                          var l = new oq(t.filterTreeType);
                          l.setData(n, a, e),
                            t.refineByItems.push(l),
                            t.addComponent(l);
                        }
                      });
                    } else
                      Object.values(r).forEach(function (e) {
                        var i = n.filterItems.get(e),
                          r = new oq(t.filterTreeType);
                        r.setData(n, i, e),
                          t.refineByItems.push(r),
                          t.addComponent(r);
                      });
                  }
                });
            },
          },
        ]),
        oz(e.prototype, n),
        i && oz(e, i),
        c
      );
    })(g.a);
    function oZ(t) {
      return (oZ =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function oJ(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function at(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ae(t, e) {
      return (ae =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function an(t, e) {
      return e && ("object" === oZ(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function ai(t) {
      return (ai = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ar = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && ae(t, e);
        })(o, t);
        var e,
          n,
          i,
          r = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = ai(t);
              if (e()) {
                var r = ai(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return an(this, n);
            };
          })(o);
        function o() {
          return oJ(this, o), r.apply(this, arguments);
        }
        return (
          (e = o),
          (n = [
            {
              key: "getBlockContentTemplate",
              value: function () {
                return '\n			<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListSingleList}}">\n				{{filterItems}}\n			</ul>\n		'.trim();
              },
            },
          ]),
          at(e.prototype, n),
          i && at(e, i),
          o
        );
      })(oS),
      ao = (n(98), n(131)),
      aa = n.n(ao);
    function as(t) {
      return (as =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function al(t, e) {
      if (!(t instanceof e))
        throw TypeError("Cannot call a class as a function");
    }
    function ac(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function au(t, e, n) {
      return (au =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = ah(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function ap(t, e) {
      return (ap =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function af(t, e) {
      return e && ("object" === as(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function ah(t) {
      return (ah = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ad = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && ap(t, e);
      })(l, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = ah(t);
            if (e()) {
              var r = ah(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return af(this, n);
          };
        })(l);
      function l() {
        return al(this, l), r.apply(this, arguments);
      }
      return (
        (e = l),
        (n = [
          {
            key: "init",
            value: function () {
              au(ah(l.prototype), "init", this).call(this),
                (this.requestInstantly =
                  this.filterTreeType == ic.FilterTreeType.VERTICAL ||
                  o.a.getSettingValue("general.requestInstantly"));
            },
          },
          {
            key: "getBlockContentTemplate",
            value: function () {
              return this.hideInputElement
                ? '\n				<div>\n					<div class="boost-pfs-filter-option-range-slider"></div>\n				</div>\n			'.trim()
                : "style3" == this.style
                ? '\n				<div class="boost-pfs-filter-block-content-inner">\n					<div class="boost-pfs-filter-option-range-slider"></div>\n					<div class="boost-pfs-filter-option-range-amount">\n						<input class="boost-pfs-filter-option-range-amount-min" type="text" role="textbox" readonly />\n						<input class="boost-pfs-filter-option-range-amount-max" type="text" role="textbox" readonly />\n					</div>\n				</div>\n				'.trim()
                : '\n				<div class="boost-pfs-filter-block-content-inner">\n					<div class="boost-pfs-filter-option-range-amount">\n						<div class="boost-pfs-filter-option-range-amount-wrapper boost-pfs-filter-option-range-amount-min-wrapper">\n							<div class="boost-pfs-filter-option-range-slider-unit">{{itemCurrencySymbol}}</div>\n							<input class="boost-pfs-filter-option-range-amount-min" role="textbox" type="text" />\n						</div>\n						<div class="boost-pfs-filter-option-range-amount-split"> - </div>\n						<div class="boost-pfs-filter-option-range-amount-wrapper boost-pfs-filter-option-range-amount-max-wrapper">\n							<div class="boost-pfs-filter-option-range-slider-unit">{{itemCurrencySymbol}}</div>\n							<input class="boost-pfs-filter-option-range-amount-max" role="textbox" type="text"/>\n						</div>\n					</div>\n					<div class="boost-pfs-filter-option-range-slider"></div>\n				</div>\n				'
                    .trim()
                    .replace(
                      /{{itemCurrencySymbol}}/g,
                      s.a.moneyFormat
                        .replace(/{{.+}}/g, "")
                        .replace("&#36;", "$")
                    );
            },
          },
          {
            key: "isRender",
            value: function () {
              if (this.status == nM.a.Status.ACTIVE) {
                var t = o.a.getSettingValue("general.oneValueRangeSlider");
                return (
                  !(this.isNumberRangeSlider
                    ? this.rangeMax == this.rangeMin
                    : this.valuesData.length <= 1) || t
                );
              }
              return !1;
            },
          },
          {
            key: "render",
            value: function () {
              au(ah(l.prototype), "render", this).call(this),
                this.$element.addClass(
                  "boost-pfs-filter-option-range-" + this.style
                ),
                this.renderRangeValue(),
                this.renderInputField();
            },
          },
          {
            key: "renderRangeValue",
            value: function () {
              this.setCurrentValues(),
                this.noUiSlider &&
                  this.noUiSlider.set([this.currentMin, this.currentMax]);
            },
          },
          {
            key: "renderInputField",
            value: function () {
              if (this.$element && !this.hideInputElement) {
                (this.$minInputElement && this.$maxInputElement) ||
                  ((this.$minInputElement = this.$element.find(
                    ".boost-pfs-filter-option-range-amount-min"
                  )),
                  (this.$maxInputElement = this.$element.find(
                    ".boost-pfs-filter-option-range-amount-max"
                  )));
                var t = this.buildNumberLabel(this.currentMin),
                  e = this.buildNumberLabel(this.currentMax);
                this.$minInputElement.val(t), this.$maxInputElement.val(e);
              }
            },
          },
          {
            key: "renderTextLabelPosition",
            value: function () {
              var t = this.$element.find(".noUi-value"),
                e = 100 / (2 * this.valuesData.length);
              t.each(function (t, n) {
                var i = n.style.left;
                if ("string" == typeof i) {
                  var r = parseFloat(i.replace("%", "")) + e;
                  n.style.left = r + "%";
                }
              });
            },
          },
          {
            key: "bindEvents",
            value: function () {
              au(ah(l.prototype), "bindEvents", this).call(this),
                this.$element &&
                  ((this.$rangeSliderElement = this.$element.find(
                    ".boost-pfs-filter-option-range-slider"
                  )),
                  (this.noUiSlider = aa.a.create(
                    this.$rangeSliderElement[0],
                    this.getSliderConfig()
                  )),
                  this.noUiSlider.on("slide", this.onDrag.bind(this)),
                  this.noUiSlider.on(
                    "change",
                    this.onFinishDragging.bind(this)
                  ),
                  this.hideInputElement ||
                    (this.$minInputElement.on(
                      "change",
                      this.onChangeInput.bind(this, "min")
                    ),
                    this.$maxInputElement.on(
                      "change",
                      this.onChangeInput.bind(this, "max")
                    )),
                  this.isNumberRangeSlider || this.renderTextLabelPosition(),
                  this.$element
                    .find(
                      ".boost-pfs-filter-option-range-amount-min, .noUi-handle-lower"
                    )
                    .attr("aria-label", a.a.ada.minValue),
                  this.$element
                    .find(
                      ".boost-pfs-filter-option-range-amount-max, .noUi-handle-upper"
                    )
                    .attr("aria-label", a.a.ada.maxValue));
            },
          },
          {
            key: "onChangeInput",
            value: function (t) {
              var e =
                  "min" == t
                    ? u.a.stripHtml(this.$minInputElement.val().trim())
                    : this.currentMin.toString(),
                n =
                  "max" == t
                    ? u.a.stripHtml(this.$maxInputElement.val().trim())
                    : this.currentMax.toString();
              this.thousandSeparator &&
                ((e = e.split(this.thousandSeparator).join("")),
                (n = n.split(this.thousandSeparator).join(""))),
                this.decimalSeparator &&
                  "." != this.decimalSeparator &&
                  ((e = e.replace(this.decimalSeparator, ".")),
                  (n = n.replace(this.decimalSeparator, "."))),
                !this.isNumberRangeSlider ||
                null == e ||
                null == n ||
                "" == e ||
                "" == n ||
                isNaN(e) ||
                isNaN(n) ||
                (e = parseFloat(e)) > (n = parseFloat(n))
                  ? this.renderInputField()
                  : ((this.currentMin = Math.max(e, this.rangeMin)),
                    (this.currentMax = Math.min(n, this.rangeMax)),
                    this.noUiSlider &&
                      this.noUiSlider.set([this.currentMin, this.currentMax]),
                    this.onFinishDragging());
            },
          },
          {
            key: "onDrag",
            value: function () {
              var t = this.noUiSlider.get();
              if (null != t) {
                if (Array.isArray(t) && 2 == t.length) {
                  if (this.isNumberRangeSlider)
                    (this.currentMin = t[0]), (this.currentMax = t[1]);
                  else {
                    var e = Math.round(t[0]),
                      n = Math.round(t[1]);
                    n <= e
                      ? this.noUiSlider.set([this.currentMin, this.currentMax])
                      : ((this.currentMin = e), (this.currentMax = n));
                  }
                  this.renderInputField();
                } else
                  ("string" != typeof t && "number" != typeof t) ||
                    ((this.currentMin = t), (this.currentMax = t));
              }
            },
          },
          {
            key: "onFinishDragging",
            value: function () {
              var t = this;
              if (this.isNumberRangeSlider)
                this.filterItems.forEach(function (e) {
                  e.setValue(t.currentMin, t.currentMax);
                });
              else {
                var e = [];
                if (
                  this.currentMin != this.rangeMin ||
                  this.currentMax != this.rangeMax
                )
                  for (var n = this.currentMin; n <= this.currentMax - 1; n++)
                    e.push(this.valuesData[n].key);
                this.filterItems.forEach(function (t) {
                  t.isSelected = e.includes(t.value);
                });
              }
              if (this.requestInstantly) {
                var i = [];
                this.filterItems.forEach(function (t) {
                  t.isSelected && i.push(t.value);
                }),
                  K.default.setParam(this.filterOptionId, i),
                  K.default.setParam("page", 1);
                var r = {
                  filterOptionId: this.filterOptionId,
                  filterOptionValue: i,
                };
                K.default.applyFilter("filter", r);
              }
            },
          },
          {
            key: "getSliderConfig",
            value: function () {
              var t = {
                start: this.isSingleHandle
                  ? [this.currentMin]
                  : [this.currentMin, this.currentMax],
                step: this.sliderStep,
                connect: !0,
                snap: !this.isNumberRangeSlider,
                animate: !0,
                animationDuration: 300,
                range: this.getSliderRange(),
                pips: this.getSliderPipsConfig(),
              };
              if (this.isShowTooltip) {
                var e = { to: this.buildLabel.bind(this) };
                t.tooltips = [e, e];
              }
              return t;
            },
          },
          {
            key: "getSliderRange",
            value: function () {
              var t = { min: this.rangeMin, max: this.rangeMax };
              if (!this.isNumberRangeSlider)
                for (var e = 1; e < this.valuesData.length; e++)
                  t[e * (100 / this.valuesData.length) + "%"] = e;
              return t;
            },
          },
          {
            key: "getSliderPipsConfig",
            value: function () {
              var t = this.isNumberRangeSlider
                ? this.sliderRange + 1
                : this.valuesData.length + 1;
              return (
                t < 2 && (t = 2),
                {
                  mode: "count",
                  values: t,
                  filter: function (t, e) {
                    return 1 == e ? e : -1;
                  },
                  format: { to: this.buildLabel.bind(this) },
                }
              );
            },
          },
          {
            key: "buildLabel",
            value: function (t) {
              var e = "";
              if (this.isNumberRangeSlider) {
                var n = s.a.moneyFormat
                  .replace(/{{.+}}/g, "")
                  .replace("&#36;", "$");
                e = this.isPriceFilter
                  ? "style2" == this.style
                    ? '<span class="boost-pfs-filter-option-range-slider-unit">' +
                      n +
                      "</span>" +
                      this.buildMoneyLabel(t)
                    : this.buildMoneyLabel(t)
                  : this.buildNumberLabel(t, !0);
              } else
                Number.isInteger(t) &&
                  t >= 0 &&
                  t < this.valuesData.length &&
                  ((e = this.valuesData[t].key), (e = this.buildTextLabel(e)));
              return e;
            },
          },
          {
            key: "buildMoneyLabel",
            value: function (t) {
              var e = o.a.getSettingValue("general.enable3rdCurrencySupport"),
                n = this.buildNumberLabel(t, !0),
                i = this.moneyFormat.replace(/{{\s*(\w+)\s*}}/, n);
              return (
                (i = i.replace(/[A-Z][A-Z][A-Z]/, "")),
                e && (i = u.a.moneyWrapper(i)),
                i
              );
            },
          },
          {
            key: "buildNumberLabel",
            value: function (t, e) {
              if (this.shortenPipsRange && e) {
                var n = o.a.getSettingValue("general.formatPipsRange");
                if (Array.isArray(n) && n.length > 0)
                  for (var i = 0, r = 0, a = n.length - 1; a >= 0; a--) {
                    var s = n[a];
                    if (t >= s.node)
                      return (
                        (i = Math.floor(t / s.node).toString()),
                        (r =
                          (r = Math.round(t % s.node)) > 0 ? r.toString() : "")
                          .length > s.fix && (r = r.substring(0, s.fix)),
                        s.suffix
                          ? i + this.decimalSeparator + r + s.symbol
                          : i + s.symbol + r
                      );
                  }
              }
              var l = !o.a.getSettingValue("general.removePriceDecimal");
              return u.a.formatNumberWithSeparator(
                t,
                this.precision,
                this.thousandSeparator,
                this.decimalSeparator,
                l
              );
            },
          },
          {
            key: "buildTextLabel",
            value: function (t) {
              if (this.prefix) {
                var e = this.prefix.replace(/\\/g, "");
                t = t.replace(e, "").trim();
              }
              return t;
            },
          },
          {
            key: "setMoneyFormat",
            value: function () {
              if (this.isPriceFilter) {
                var t = o.a.getSettingValue("general.rangeSliderMoneyFormat");
                this.moneyFormat = t || "{{amount}}";
              }
            },
          },
          {
            key: "setCurrentValues",
            value: function () {
              var t = this,
                e = this.rangeMin,
                n = this.rangeMax,
                i = null;
              if (s.a.queryParams.hasOwnProperty(this.filterOptionId)) {
                if (this.isNumberRangeSlider)
                  (i = s.a.queryParams[this.filterOptionId][0].split(":")) &&
                    2 == i.length &&
                    ((e = i[0]), (n = i[1]));
                else if (
                  Array.isArray((i = s.a.queryParams[this.filterOptionId]))
                ) {
                  var r = this.valuesData.map(function (t) {
                    return t.key;
                  });
                  (e = this.rangeMax),
                    (n = this.rangeMin),
                    i.forEach(function (i) {
                      var o = r.indexOf(i);
                      o >= t.rangeMin &&
                        o <= t.rangeMax &&
                        (o < e && (e = o), o + 1 > n && (n = o + 1));
                    });
                }
              }
              (this.currentMin = e), (this.currentMax = n);
            },
          },
          {
            key: "setDisplayStyle",
            value: function () {
              var t = o.a.getSettingValue("general.rangeSlidersStyle3"),
                e = o.a.getSettingValue("general.rangeSlidersSingleHandle");
              this.isNumberRangeSlider
                ? Array.isArray(e) && e.includes(this.filterOptionId)
                  ? ((this.style = "style4"),
                    (this.hideInputElement = !0),
                    (this.isSingleHandle = !0),
                    (this.currentMax = this.currentMin))
                  : Array.isArray(t) && t.includes(this.filterOptionId)
                  ? ((this.style = "style3"), (this.hideInputElement = !1))
                  : this.hideInputElement
                  ? ((this.style = "style2"), (this.isShowTooltip = !0))
                  : (this.style = "style1")
                : ((this.style = "style5"), (this.hideInputElement = !0)),
                o.a.getSettingValue("general.enable3rdCurrencySupport") &&
                  ["style1", "style3"].indexOf(this.style) > -1 &&
                  ((this.style = "style2"),
                  (this.hideInputElement = !0),
                  (this.isShowTooltip = !0));
            },
          },
          {
            key: "prepareFilterOptionData",
            value: function (t) {
              return (
                t.isConvertedPrice ||
                  (t.values.max &&
                    t.values.min &&
                    ((t.values.max = Math.ceil(100 * t.values.max) / 100),
                    (t.values.min = Math.floor(100 * t.values.min) / 100)),
                  ("price" != t.filterType &&
                    "variants_price" != t.filterType) ||
                    !t.values ||
                    (u.a.isEnableShopifyMultipleCurrencies() &&
                      u.a.isConvertCurrenciesOnFrontEnd() &&
                      ((t.values.min = u.a.convertPriceBasedOnActiveCurrency(
                        t.values.min
                      )),
                      (t.values.max = u.a.convertPriceBasedOnActiveCurrency(
                        t.values.max
                      )))),
                  (t.isConvertedPrice = !0)),
                t
              );
            },
          },
          {
            key: "setData",
            value: function (t) {
              if (
                ((t = this.prepareFilterOptionData(t)),
                au(ah(l.prototype), "setData", this).call(this, t),
                ("price" == this.filterType ||
                  "variants_price" == this.filterType) &&
                  !o.a.getSettingValue("general.enable3rdCurrencySupport"))
              ) {
                var e = o.a.getSettingValue("general.rangeSliderMoneyFormat");
                e || (e = s.a.moneyFormat);
                var n = e.replace(/<.*?>/g, "").replace(/{{.*?}}/, "");
                1 == n.length && (this.label += u.a.stripHtml(" (" + n + ")"));
              }
              if (
                ((this.isNumberRangeSlider = !Array.isArray(t.values)),
                (this.isPriceFilter =
                  t.filterType == nM.a.FilterType.PRICE ||
                  t.filterType == nM.a.FilterType.VARIANTS_PRICE),
                this.isPriceFilter && this.setMoneyFormat(),
                this.isSortValues() && this.sortValues(t.values),
                (this.valuesData = JSON.parse(JSON.stringify(t.values))),
                this.isNumberRangeSlider &&
                  null != t.values.min &&
                  null != t.values.max &&
                  t.values.min != t.values.max)
              ) {
                if (
                  ((this.hideInputElement = t.hideTextBoxes),
                  (this.sliderStep = parseFloat(t.sliderStep)),
                  (isNaN(this.sliderStep) || this.sliderStep > t.values.max) &&
                    (this.sliderStep = 1),
                  (this.sliderRange = parseFloat(t.sliderRange)),
                  isNaN(this.sliderRange) && (this.sliderRange = 4),
                  t.values.max - t.values.min < 2 * this.sliderStep &&
                    (this.sliderRange = 1),
                  (this.precision = 0),
                  Math.floor(this.sliderStep) != this.sliderStep)
                ) {
                  var i = this.sliderStep.toString().split(".");
                  i.length > 1 && (this.precision = i[1].length);
                }
                (this.thousandSeparator = t.sliderDelimiter
                  ? t.sliderDelimiter
                  : ""),
                  "." == this.thousandSeparator
                    ? (this.decimalSeparator = ",")
                    : (this.decimalSeparator = "."),
                  (this.rangeMin =
                    Math.round(100 * parseFloat(t.values.min)) / 100),
                  (this.rangeMax =
                    Math.round(100 * parseFloat(t.values.max)) / 100),
                  this.setCurrentValues(),
                  this.setDisplayStyle();
              } else
                Array.isArray(t.values) && t.values.length > 1
                  ? ((this.hideInputElement = !0),
                    (this.sliderStep = 1),
                    (this.rangeMin = 0),
                    (this.rangeMax = this.valuesData.length),
                    this.setCurrentValues(),
                    this.setDisplayStyle())
                  : (this.status = nM.a.Status.DISABLED);
            },
          },
        ]),
        ac(e.prototype, n),
        i && ac(e, i),
        l
      );
    })(oS);
    function ag(t) {
      return (ag =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function ay(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function am(t, e) {
      return (am =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function av(t, e) {
      return e && ("object" === ag(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function ab(t) {
      return (ab = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var aS = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && am(t, e);
      })(o, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = ab(t);
            if (e()) {
              var r = ab(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return av(this, n);
          };
        })(o);
      function o(t) {
        var e;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, o),
          ((e = r.call(this, t)).allNestedFilterItems = new Map()),
          e
        );
      }
      return (
        (e = o),
        (n = [
          {
            key: "getBlockContentTemplate",
            value: function () {
              return '\n			<ul class="{{class.filterOptionItemList}} {{class.filterOptiontemListMultiLevelCollections}} {{class.filterOptionItemListSingleList}} boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-first-level-list">\n				{{filterItems}}\n			</ul>\n		'.trim();
            },
          },
        ]),
        ay(e.prototype, n),
        i && ay(e, i),
        o
      );
    })(oS);
    function a$(t) {
      return (a$ =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function aT(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function aP(t, e) {
      return (aP =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function a_(t, e) {
      return e && ("object" === a$(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function a8(t) {
      return (a8 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var ak = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && aP(t, e);
      })(a, t);
      var e,
        n,
        i,
        r = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = a8(t);
            if (e()) {
              var r = a8(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return a_(this, n);
          };
        })(a);
      function a(t) {
        var e;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, a),
          ((e = r.call(this, t)).allNestedFilterItems = new Map()),
          e
        );
      }
      return (
        (e = a),
        (n = [
          {
            key: "getBlockContentTemplate",
            value: function () {
              return '\n			<ul class="{{class.filterOptionItemList}} {{class.filterOptiontemListMultiLevelCollections}} {{displayTypeClass}} boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-first-level-list">\n				{{filterItems}}\n			</ul>\n		'.trim();
            },
          },
          {
            key: "compileBlockContentTemplate",
            value: function () {
              var t = this.getDisplayTypeClass();
              return this.getBlockContentTemplate().replace(
                /{{displayTypeClass}}/g,
                t
              );
            },
          },
          {
            key: "getDisplayTypeClass",
            value: function () {
              var t = "";
              switch (this.displayTypeItem) {
                case nM.a.DisplayType.LIST:
                  t =
                    this.selectType == nM.a.SelectType.SINGLE
                      ? N.a.filterOptionItemListSingleList
                      : N.a.filterOptionItemListMultipleList;
                  break;
                case nM.a.DisplayType.BOX:
                  t = N.a.filterOptionItemListBox;
                  break;
                case nM.a.DisplayType.SWATCH:
                  t = N.a.filterOptionItemListSwatch;
                  var e = o.a.getSettingValue("general.swatchStyle");
                  t +=
                    " " + (e = e ? e.replace("grid", "list") : "circle-list");
              }
              return t;
            },
          },
        ]),
        aT(e.prototype, n),
        i && aT(e, i),
        a
      );
    })(oS);
    function aO(t) {
      return (aO =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function aC(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function aw(t, e) {
      return (aw =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function aI(t, e) {
      return e && ("object" === aO(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function aE(t) {
      return (aE = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var a0 = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && aw(t, e);
      })(p, t);
      var e,
        n,
        i,
        c = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = aE(t);
            if (e()) {
              var r = aE(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return aI(this, n);
          };
        })(p);
      function p(t, e) {
        var n;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, p),
          ((n = c.call(this)).id = t),
          (n.idSelector = "#" + n.id),
          (n.filterTreeType = e),
          (n.isMobileOnly = !1),
          (n.isDesktopOnly = !1),
          (n.isRenderOnDOM = !0),
          (n.collectionId = s.a.collectionId),
          (n.clickedFilterOption = null),
          (n.refineBy = null),
          (n.filterOptions = new Map()),
          (n.$element = null),
          (n.filterHorizontalOptionsAlign = o.a.getSettingValue(
            "general.filterHorizontalOptionsAlign"
          )),
          (n.numberResult = ""),
          (n.selector = {
            refineByWrapper: "." + N.a.filterRefineByWrapper,
            filterOptionsWrapper: "." + N.a.filterOptionsWrapper,
            clearAllButton:
              ".boost-pfs-filter-mobile-toolbar-bottom ." + N.a.clearAllButton,
            clearAllButtonContainer: ".boost-pfs-filter-mobile-toolbar-bottom",
            applyAllButton:
              ".boost-pfs-filter-mobile-toolbar-bottom ." +
              N.a.applyAllFilterOptionButton,
            applyAllButtonContainer: ".boost-pfs-filter-mobile-footer",
            closeFilter:
              "." + N.a.closeFilterButton + ",." + N.a.showResultFilterButton,
            filterHeader: ".boost-pfs-filter-mobile-toolbar",
            filterHeaderTop:
              ".boost-pfs-filter-mobile-toolbar .boost-pfs-filter-mobile-toolbar-top",
            filterHeaderBottom:
              ".boost-pfs-filter-mobile-toolbar .boost-pfs-filter-mobile-toolbar-bottom",
            filterFooter: ".boost-pfs-filter-mobile-footer",
            numberResult: "." + N.a.numberResult,
          }),
          n
        );
      }
      return (
        (e = p),
        (n = [
          {
            key: "getTemplate",
            value: function () {
              switch (this.filterTreeType) {
                case "vertical":
                  return '\n					<div class="boost-pfs-filter-tree-content" aria-live="polite" role="navigation" aria-label="{{label.productFilter}}">\n						{{header}}\n						<div class="{{class.filterRefineByWrapper}}">\n							{{refineBy}}\n						</div>\n						<div class="{{class.filterOptionsWrapper}}">\n							{{filterOptions}}\n						</div>\n						{{footer}}\n					</div>\n				'.trim();
                case "horizontal":
                  return "top" ==
                    o.a.getSettingValue("general.refineByHorizontalPosition")
                    ? '\n						<div class="boost-pfs-filter-tree-content boost-pfs-filter-tree-options-align-{{filterHorizontalOptionsAlign}}" aria-live="polite" role="navigation" aria-label="{{label.productFilter}}">\n							{{header}}\n							<div class="{{class.filterRefineByWrapper}}">\n								{{refineBy}}\n							</div>\n							<div class="{{class.filterOptionsWrapper}}">\n								{{filterOptions}}\n							</div>\n							{{footer}}\n						</div>	\n					'.trim()
                    : '\n						<div class="boost-pfs-filter-tree-content boost-pfs-filter-tree-options-align-{{filterHorizontalOptionsAlign}}" aria-live="polite" role="navigation" aria-label="{{label.productFilter}}">\n							{{header}}\n							<div class="{{class.filterOptionsWrapper}}">\n								{{filterOptions}}\n							</div>\n							<div class="{{class.filterRefineByWrapper}}">\n								{{refineBy}}\n							</div>\n							{{footer}}\n						</div>	\n					'.trim();
                default:
                  console.warn("filterTreeType is wrong");
              }
            },
          },
          {
            key: "getHeaderTemplate",
            value: function () {
              return '\n			<div class="boost-pfs-filter-mobile-toolbar">\n				<div class="boost-pfs-filter-mobile-toolbar-top">\n					<a href="javascript:;" class="{{class.closeFilterButton}}"><span>{{label.close}}</span></a>\n				</div>\n				<div class="boost-pfs-filter-mobile-toolbar-header">{{label.refineMobile}}</div>\n				<div class="boost-pfs-filter-mobile-toolbar-bottom">\n					{{clearButton}}\n				</div>\n			</div>\n		'.trim();
            },
          },
          {
            key: "getFooterTemplate",
            value: function () {
              return '\n			<div class="boost-pfs-filter-mobile-footer">\n				<button class="{{class.showResultFilterButton}}" type="button">{{label.showResult}}<span class="{{class.numberResult}}">{{numberResult}}</span></button>\n			</div>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              return this.getTemplate()
                .replace(/{{header}}/g, this.getHeaderTemplate())
                .replace(/{{footer}}/g, this.getFooterTemplate())
                .replace(
                  /{{filterHorizontalOptionsAlign}}/g,
                  this.filterHorizontalOptionsAlign
                )
                .replace(/{{label.productFilter}}/g, a.a.productFilter)
                .replace(/{{label.showResult}}/g, a.a.showResult)
                .replace(/{{label.refineMobile}}/g, a.a.refineMobile)
                .replace(/{{label.apply}}/g, a.a.apply)
                .replace(/{{label.close}}/g, a.a.close)
                .replace(/{{label.back}}/g, a.a.back)
                .replace(
                  /{{class.filterOptionsWrapper}}/g,
                  N.a.filterOptionsWrapper
                )
                .replace(
                  /{{class.filterRefineByWrapper}}/g,
                  N.a.filterRefineByWrapper
                )
                .replace(/{{class.closeFilterButton}}/g, N.a.closeFilterButton)
                .replace(
                  /{{class.showResultFilterButton}}/g,
                  N.a.showResultFilterButton
                )
                .replace(/{{class.numberResult}}/g, N.a.numberResult)
                .replace(/{{numberResult}}/g, this.numberResult)
                .replace(/{{refineBy}}/g, "")
                .replace(/{{clearButton}}/g, "")
                .replace(/{{applyButton}}/g, "")
                .replace(/{{filterOptions}}/g, "");
            },
          },
          {
            key: "init",
            value: function () {
              var t = r()(this.idSelector);
              if (1 == t.length) {
                if (
                  ((this.isMobileOnly = t[0].hasAttribute("data-is-mobile")),
                  (this.isDesktopOnly = t[0].hasAttribute("data-is-desktop")),
                  (this.isDesktopOnly && this.isMobileOnly) ||
                    (!this.isMobileOnly && !this.isDesktopOnly))
                )
                  (this.isDesktopOnly = !1), (this.isMobileOnly = !1);
                else {
                  var e = u.a.isMobile();
                  this.isRenderOnDOM =
                    (e && this.isMobileOnly) || (!e && this.isDesktopOnly);
                }
              }
              (this.clearAllButton = new iy(
                this.filterTreeType,
                iy.ClearType.CLEAR_ALL
              )),
                (this.applyAllButton = new FilterApplyButton(
                  this.filterTreeType,
                  FilterApplyButton.ApplyType.APPLY_ALL
                ));
            },
          },
          {
            key: "isRender",
            value: function () {
              return (
                this.parent.isFetchedFilterData &&
                this.isRenderOnDOM &&
                z.isPanelActive(tt.Enum.PRODUCT)
              );
            },
          },
          {
            key: "isLoopThroughChild",
            value: function () {
              return this.isRenderOnDOM && this.parent.isFetchedFilterData;
            },
          },
          {
            key: "render",
            value: function () {
              if (
                (!0 === s.a.queryParams.build_filter_tree &&
                  this.filterOptions &&
                  (this.isRenderPartially
                    ? this.renderPartially()
                    : this.renderFull(),
                  this.renderRefineBy(),
                  this.renderExtraElements()),
                o.a.getSettingValue("general.filterTreeNumberResultEnable"))
              ) {
                var t =
                  this.parent && this.parent.data
                    ? " (" + this.parent.data.total_product + ")"
                    : "";
                this.$element
                  .find(this.selector.numberResult)
                  .addClass(N.a.numberResult + "-has-data")
                  .html(t);
              }
            },
          },
          {
            key: "renderFull",
            value: function () {
              var t = this;
              (this.$element = r()(this.compileTemplate())),
                (this.$filterOptionsContainerElement = this.$element.find(
                  this.selector.filterOptionsWrapper
                )),
                this.filterOptions.forEach(function (e) {
                  t.$filterOptionsContainerElement.append(e.$element);
                });
            },
          },
          {
            key: "renderPartially",
            value: function () {
              var t = this;
              this.$filterOptionsContainerElement = this.$element.find(
                this.selector.filterOptionsWrapper
              );
              var e = !1;
              this.clickedFilterOption.$element.siblings().remove(),
                this.filterOptions.forEach(function (n) {
                  if (n.$element) {
                    if (n == t.clickedFilterOption) return void (e = !0);
                    e
                      ? t.$filterOptionsContainerElement.append(n.$element)
                      : n.$element.insertBefore(t.clickedFilterOption.$element);
                  }
                });
            },
          },
          {
            key: "renderRefineBy",
            value: function () {
              o.a.getSettingValue("general.separateRefineByFromFilter")
                ? this.renderSeparateRefineBy()
                : this.renderAttachedRefineBy();
            },
          },
          {
            key: "renderAttachedRefineBy",
            value: function () {
              this.refineBy &&
                this.$element &&
                ((this.$refineByElementContainer = this.$element.find(
                  this.selector.refineByWrapper
                )),
                this.$refineByElementContainer.length > 0 &&
                  (this.$refineByElementContainer
                    .first()
                    .html("")
                    .append(this.refineBy.$element),
                  (this.$refineByElement = this.refineBy.$element)));
            },
          },
          {
            key: "renderSeparateRefineBy",
            value: function () {
              if (this.refineBy) {
                var t =
                  this.refineBy.filterTreeType == ic.FilterTreeType.VERTICAL
                    ? l.a.filterRefineByVertical
                    : l.a.filterRefineByHorizontal;
                r()(t).length > 0 &&
                  r()(t).first().html("").append(this.refineBy.$element);
              }
            },
          },
          {
            key: "renderExtraElements",
            value: function () {
              0 == this.$element.find(this.selector.clearAllButton).length &&
                this.$element
                  .find(this.selector.clearAllButtonContainer)
                  .append(this.clearAllButton.$element),
                0 == this.$element.find(this.selector.applyAllButton).length &&
                  this.$element
                    .find(this.selector.applyAllButtonContainer)
                    .append(this.applyAllButton.$element),
                u.a.isMobile() ||
                  "style-expand" !=
                    o.a.getSettingValue("general.filterTreeHorizontalStyle") ||
                  this.$element
                    .find(this.selector.filterFooter)
                    .append(this.clearAllButton.$element);
            },
          },
          {
            key: "bindEvents",
            value: function () {
              (this.isMobileOnly || this.isDesktopOnly) &&
                ((this.resizeTimer = null),
                r()(window).on(
                  "resize",
                  function () {
                    this.resizeTimer && clearTimeout(this.resizeTimer),
                      (this.resizeTimer = setTimeout(
                        this.onScreenResize.bind(this),
                        500
                      ));
                  }.bind(this)
                )),
                this.$element &&
                  this.$element.find(this.selector.closeFilter).length > 0 &&
                  (this.$element.find(this.selector.closeFilter).off("click"),
                  this.$element
                    .find(this.selector.closeFilter)
                    .on("click", this.onCloseFilterTree.bind(this))),
                r()(".boost-pfs-filter-overlay").length > 0 &&
                  r()(".boost-pfs-filter-overlay")
                    .off("click")
                    .on("click", this.onCloseFilterTree.bind(this));
            },
          },
          {
            key: "onScreenResize",
            value: function () {
              var t = u.a.isMobile(),
                e = (t && this.isMobileOnly) || (!t && this.isDesktopOnly);
              this.isRenderOnDOM != e &&
                ((this.isRenderOnDOM = e),
                this.isRenderOnDOM
                  ? ((this.isRenderPartially = !1),
                    this.refresh(),
                    r()(this.idSelector).first().html("").append(this.$element))
                  : this.$element &&
                    (this.$element.detach(), (this.$element = null)));
            },
          },
          {
            key: "onCloseFilterTree",
            value: function () {
              var t = r()(this.idSelector);
              t &&
                (this.mobileButton && (this.mobileButton.isCollapsed = !0),
                t.removeClass(N.a.filterTreeMobileOpen),
                r()("body")
                  .removeClass(N.a.filterTreeOpenBody)
                  .removeClass("boost-pfs-body-no-scroll"),
                r()("html")
                  .removeClass(N.a.filterTreeOpenBody)
                  .removeClass("boost-pfs-body-no-scroll"));
            },
          },
          {
            key: "setData",
            value: function (t) {
              var e = this;
              o.a.getSettingValue("general.filterTreeEnableRenderPartially") &&
              this.collectionId == s.a.collectionId
                ? (this.clickedFilterOption = this.filterOptions.get(
                    this.parent.clickedFilterOptionId
                  ))
                : ((this.collectionId = s.a.collectionId),
                  (this.clickedFilterOption = null)),
                (this.isRenderPartially = !!(
                  this.$element &&
                  this.clickedFilterOption &&
                  this.clickedFilterOption.$element
                )),
                this.modifyOptionsData(t.options),
                (this.children = []),
                (this.filterOptions = new Map()),
                t.options.forEach(function (t) {
                  if (
                    !(
                      t.status != nM.a.Status.ACTIVE ||
                      (Array.isArray(t.values) &&
                        0 == t.values.length &&
                        Array.isArray(t.manualValues) &&
                        0 == t.manualValues.length)
                    )
                  ) {
                    var n = null;
                    if (
                      (e.clickedFilterOption &&
                        t.filterOptionId ==
                          e.clickedFilterOption.filterOptionId &&
                        (n = e.clickedFilterOption),
                      null == n)
                    ) {
                      switch (t.displayType) {
                        case nM.a.DisplayType.LIST:
                          n = new oC(e.filterTreeType);
                          break;
                        case nM.a.DisplayType.BOX:
                          n = new ox(e.filterTreeType);
                          break;
                        case nM.a.DisplayType.RANGE:
                          n = new ad(e.filterTreeType);
                          break;
                        case nM.a.DisplayType.SWATCH:
                          n = new oV(e.filterTreeType);
                          break;
                        case nM.a.DisplayType.RATING:
                          n = new oH(e.filterTreeType);
                          break;
                        case nM.a.DisplayType.SUB_CATEGORY:
                          n = new ar(e.filterTreeType);
                          break;
                        case nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS:
                          n = new aS(e.filterTreeType);
                          break;
                        case nM.a.DisplayType.MULTI_LEVEL_TAG:
                          n = new ak(e.filterTreeType);
                      }
                      if (!n) return;
                      n.setData(t);
                    }
                    e.addComponent(n), e.filterOptions.set(t.filterOptionId, n);
                  }
                }),
                o.a.getSettingValue("general.showRefineBy") &&
                  ((this.refineBy = new oX(this.filterTreeType)),
                  this.addComponent(this.refineBy),
                  this.refineBy.setData()),
                this.addComponent(this.clearAllButton),
                this.addComponent(this.applyAllButton);
            },
          },
          {
            key: "modifyOptionsData",
            value: function (t) {
              var e = o.a.getSettingValue("general.advancedRangeSliders");
              t.forEach(function (t) {
                if (
                  (Array.isArray(e) &&
                    e.includes(t.filterOptionId) &&
                    t.selectType == nM.a.SelectType.MULTIPLE &&
                    (t.displayType = nM.a.DisplayType.RANGE),
                  t.filterType == nM.a.FilterType.MULTI_LEVEL_TAG)
                ) {
                  switch (t.displayType) {
                    case nM.a.DisplayType.LIST:
                      t.displayTypeItem = nM.a.DisplayType.LIST;
                      break;
                    case nM.a.DisplayType.BOX:
                      t.displayTypeItem = nM.a.DisplayType.BOX;
                      break;
                    case nM.a.DisplayType.SWATCH:
                      t.displayTypeItem = nM.a.DisplayType.SWATCH;
                      break;
                    default:
                      return;
                  }
                  t.displayType = nM.a.DisplayType.MULTI_LEVEL_TAG;
                }
                ((u.a.isVendorPage() &&
                  t.filterType == nM.a.FilterType.VENDOR) ||
                  (u.a.isTypePage() &&
                    t.filterType == nM.a.FilterType.PRODUCT_TYPE)) &&
                  (t.status = nM.a.Status.DISABLED),
                  t.displayType == nM.a.DisplayType.SUB_CATEGORY &&
                    (t.status = nM.a.Status.DISABLED);
              });
            },
          },
        ]),
        aC(e.prototype, n),
        i && aC(e, i),
        p
      );
    })(g.a);
    function aL(t) {
      return (aL =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function aA(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ax(t, e, n) {
      return (ax =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = a9(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function aB(t, e) {
      return (aB =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function aR(t, e) {
      return e && ("object" === aL(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function a9(t) {
      return (a9 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var aF = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && aB(t, e);
      })(c, t);
      var e,
        n,
        i,
        l = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = a9(t);
            if (e()) {
              var r = a9(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return aR(this, n);
          };
        })(c);
      function c(t, e) {
        var n;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, c),
          ((n = l.call(this, t, e)).style = "style2"),
          (n.selector.clearAllButtonContainer =
            ".boost-pfs-filter-mobile-toolbar-right"),
          (n.selector.backButton = ".boost-pfs-filter-back-btn"),
          (n.selector.refineByOnTitle =
            ".boost-pfs-filter-selected-items-mobile"),
          (n.selector.headerTitle = ".boost-pfs-filter-mobile-toolbar-middle"),
          (n.style2ActiveFilterOption = null),
          n
        );
      }
      return (
        (e = c),
        (i = [
          {
            key: "isActive",
            value: function (t) {
              return (
                t == ic.FilterTreeType.VERTICAL &&
                "style2" == o.a.getSettingValue("general.filterTreeMobileStyle")
              );
            },
          },
        ]),
        (n = [
          {
            key: "init",
            value: function () {
              ax(a9(c.prototype), "init", this).call(this),
                r()(this.idSelector).length > 0 &&
                  (r()(this.idSelector)
                    .addClass("boost-pfs-filter-tree-mobile-style2")
                    .addClass("boost-pfs-filter-tree-mobile-sticky"),
                  o.a.getSettingValue(
                    "general.filterTreeMobileStyleFullWidth"
                  ) &&
                    r()(this.idSelector).addClass(
                      "boost-pfs-filter-tree-mobile-full-width-style"
                    ));
            },
          },
          {
            key: "getHeaderTemplate",
            value: function () {
              return '\n			<div class="boost-pfs-filter-mobile-toolbar">\n				<div class="boost-pfs-filter-mobile-toolbar-top">\n					<span class="{{class.closeFilterButton}}"><span>{{label.close}}</span></span>\n				</div>\n				<div class="boost-pfs-filter-mobile-toolbar-items">\n					<div class="boost-pfs-filter-mobile-toolbar-left">\n						<span class="boost-pfs-filter-back-btn" aria-label="{{label.back}}"></span>\n					</div>\n					<div class="boost-pfs-filter-mobile-toolbar-middle">{{label.refineMobile}}</div>\n					<div class="boost-pfs-filter-mobile-toolbar-right">\n						{{clearButton}}\n					</div>\n				</div>\n			</div>\n		'.trim();
            },
          },
          {
            key: "render",
            value: function () {
              var t = this;
              if (
                (ax(a9(c.prototype), "render", this).call(this),
                this.$element && u.a.isMobile())
              ) {
                var e = null;
                this.filterOptions.forEach(function (n) {
                  t.style2ActiveFilterOption &&
                    t.style2ActiveFilterOption.filterOptionId ==
                      n.filterOptionId &&
                    (e = n);
                }),
                  (this.style2ActiveFilterOption = e),
                  this.renderFilterTreeHeader(),
                  this.renderFilterTreeFooter(),
                  this.renderFilterOptionCollapse(),
                  this.renderFilterOptionClear(),
                  this.renderRefineByOnTitle();
              }
            },
          },
          {
            key: "bindEvents",
            value: function () {
              var t = this;
              ax(a9(c.prototype), "bindEvents", this).call(this),
                this.$element &&
                  u.a.isMobile() &&
                  (this.$element
                    .find(this.selector.backButton)
                    .on("click", this.closeFilterOption.bind(this)),
                  this.filterOptions.forEach(function (e) {
                    e.$filterOptionTitleElement &&
                      (e.$filterOptionTitleElement.off("click"),
                      e.$filterOptionTitleElement.on(
                        "click",
                        t.openFilterOption.bind(t, e)
                      ));
                  })),
                this.mathHeightToolbarHeader();
            },
          },
          {
            key: "renderFilterTreeHeader",
            value: function () {
              this.style2ActiveFilterOption
                ? (this.$element
                    .find(this.selector.headerTitle)
                    .html(u.a.stripHtml(this.style2ActiveFilterOption.label)),
                  this.$element.find(this.selector.backButton).show())
                : (this.$element
                    .find(this.selector.headerTitle)
                    .html(a.a.refineMobile),
                  this.$element.find(this.selector.backButton).hide()),
                this.mathHeightToolbarHeader();
            },
          },
          {
            key: "renderFilterTreeFooter",
            value: function () {
              var t =
                this.parent && this.parent.data
                  ? " (" + this.parent.data.total_product + ")"
                  : "";
              this.$element
                .find("." + N.a.showResultFilterButton)
                .html(u.a.stripHtml(a.a.showResult + t));
            },
          },
          {
            key: "renderFilterOptionCollapse",
            value: function () {
              var t = this;
              this.filterOptions.forEach(function (e) {
                if (
                  e.$filterOptionTitleElement &&
                  e.$filterOptionContentElement &&
                  e.collapse
                ) {
                  e.$element.removeClass("boost-pfs-filter-option-collapsed");
                  var n = e.$element.find(".boost-pfs-filter-option-title"),
                    i = e.$filterOptionContentElement;
                  t.style2ActiveFilterOption
                    ? e == t.style2ActiveFilterOption
                      ? (n.hide(), i.show())
                      : (n.hide(), i.hide())
                    : (n.show(), i.hide());
                }
              });
            },
          },
          {
            key: "renderFilterOptionClear",
            value: function () {
              var t = this.clearAllButton.$element,
                e = this.$element.find(this.selector.clearAllButtonContainer);
              e &&
                (t &&
                  (null == this.style2ActiveFilterOption &&
                  s.a.hasFilterOptionParam
                    ? e.append(t)
                    : t.detach()),
                this.filterOptions.forEach(function (t) {
                  t.clearButton &&
                    t.clearButton.$element &&
                    t.clearButton.$element.detach();
                }),
                this.style2ActiveFilterOption &&
                  this.style2ActiveFilterOption.clearButton &&
                  this.style2ActiveFilterOption.clearButton.$element &&
                  e.append(this.style2ActiveFilterOption.clearButton.$element));
            },
          },
          {
            key: "renderRefineByOnTitle",
            value: function () {
              var t = this;
              this.filterOptions.forEach(function (e) {
                if (e.$element) {
                  var n = "";
                  if (e.filterOptionId.startsWith(s.a.prefix + "_c_")) {
                    var i =
                      e.displayType == nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS
                        ? e.allNestedFilterItems
                        : e.filterItems;
                    if (i && i.size > 0) {
                      var r = "",
                        o = [];
                      i.forEach(function (t) {
                        t.isSelected &&
                          (2 == t.level || 3 == t.level
                            ? o.push(u.a.stripHtml(t.label))
                            : (r = u.a.stripHtml(t.label)));
                      }),
                        (n = r && o.length > 0 ? r + ": " + o.join(", ") : r);
                    }
                  } else if (t.refineBy && t.refineBy.refineByItems) {
                    var a = [];
                    t.refineBy.refineByItems.forEach(function (t) {
                      if (t.filterOptionId == e.filterOptionId) {
                        var n = u.a.stripHtml(t.label);
                        n && a.push(n);
                      }
                    }),
                      (n = a.join(", "));
                  }
                  var l = n ? "<span>" + u.a.stripHtml(n) + "</span>" : "";
                  e.$element.find(t.selector.refineByOnTitle).html(l);
                }
              });
            },
          },
          {
            key: "openFilterOption",
            value: function (t) {
              (this.style2ActiveFilterOption = t),
                this.renderFilterTreeHeader(),
                this.renderFilterOptionCollapse(),
                this.renderFilterOptionClear(),
                this.mathHeightToolbarHeader();
            },
          },
          {
            key: "closeFilterOption",
            value: function () {
              (this.style2ActiveFilterOption = null),
                this.renderFilterTreeHeader(),
                this.renderFilterOptionCollapse(),
                this.renderFilterOptionClear();
            },
          },
          {
            key: "onClickMobileButton",
            value: function (t) {
              t && (t.stopImmediatePropagation(), t.stopPropagation()),
                (this.style2ActiveFilterOption = null);
              var e = r()(this.idSelector);
              e &&
                ((this.mobileButton.isCollapsed =
                  !this.mobileButton.isCollapsed),
                this.mobileButton.isCollapsed
                  ? (e.removeClass(N.a.filterTreeMobileOpen),
                    r()("body").removeClass(N.a.filterTreeOpenBody),
                    r()("html").removeClass("boost-pfs-body-no-scroll"))
                  : (this.closeFilterOption(),
                    e.addClass(N.a.filterTreeMobileOpen),
                    r()("body").addClass(N.a.filterTreeOpenBody),
                    r()("html").addClass("boost-pfs-body-no-scroll"))),
                this.mobileButton.afterToggleFilterTree(),
                this.mathHeightToolbarHeader();
            },
          },
          {
            key: "mathHeightToolbarHeader",
            value: function () {
              var t = r()(".boost-pfs-filter-mobile-toolbar").height();
              this.filterTreeType == ic.FilterTreeType.VERTICAL &&
                u.a.isMobile() &&
                r()(".boost-pfs-filter-options-wrapper").css("top", t + "px");
            },
          },
        ]),
        aA(e.prototype, n),
        i && aA(e, i),
        c
      );
    })(a0);
    function a2(t) {
      return (a2 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function a1(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function aV(t, e, n) {
      return (aV =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = a4(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function aD(t, e) {
      return (aD =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function aM(t, e) {
      return e && ("object" === a2(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function a4(t) {
      return (a4 = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var a3 = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && aD(t, e);
      })(s, t);
      var e,
        n,
        i,
        a = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = a4(t);
            if (e()) {
              var r = a4(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return aM(this, n);
          };
        })(s);
      function s(t, e) {
        var n;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, s),
          ((n = a.call(this, t, e)).style = "style2-fullwidth"),
          n
        );
      }
      return (
        (e = s),
        (i = [
          {
            key: "isActive",
            value: function (t) {
              return (
                t == ic.FilterTreeType.VERTICAL &&
                "style2-fullwidth" ==
                  o.a.getSettingValue("general.filterTreeMobileStyle")
              );
            },
          },
        ]),
        (n = [
          {
            key: "init",
            value: function () {
              aV(a4(s.prototype), "init", this).call(this),
                r()(this.idSelector).length > 0 &&
                  (r()(this.idSelector)
                    .addClass("boost-pfs-filter-tree-mobile-style2")
                    .addClass("boost-pfs-filter-tree-mobile-sticky")
                    .addClass("boost-pfs-filter-tree-mobile-full-width-style"),
                  o.a.getSettingValue(
                    "general.filterTreeMobileStyleFullWidth"
                  ) &&
                    r()(this.idSelector).addClass(
                      "boost-pfs-filter-tree-mobile-full-width-style"
                    ));
            },
          },
        ]),
        a1(e.prototype, n),
        i && a1(e, i),
        s
      );
    })(aF);
    function a6(t) {
      return (a6 =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function a5(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function aH(t, e, n) {
      return (aH =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = aU(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function a7(t, e) {
      return (a7 =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function aN(t, e) {
      return e && ("object" === a6(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function aU(t) {
      return (aU = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var aW = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && a7(t, e);
      })(s, t);
      var e,
        n,
        i,
        a = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = aU(t);
            if (e()) {
              var r = aU(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return aN(this, n);
          };
        })(s);
      function s(t, e) {
        var n;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, s),
          ((n = a.call(this, t, e)).style = "style3"),
          (n.selector.refineByOnTitle =
            ".boost-pfs-filter-selected-items-mobile"),
          (n.selector.clearAllButtonContainer =
            ".boost-pfs-filter-mobile-toolbar-bottom"),
          n
        );
      }
      return (
        (e = s),
        (i = [
          {
            key: "isActive",
            value: function (t) {
              return (
                t == ic.FilterTreeType.VERTICAL &&
                "style3" == o.a.getSettingValue("general.filterTreeMobileStyle")
              );
            },
          },
        ]),
        (n = [
          {
            key: "init",
            value: function () {
              aH(aU(s.prototype), "init", this).call(this),
                r()(this.idSelector).length > 0 &&
                  (r()(this.idSelector)
                    .addClass("boost-pfs-filter-tree-mobile-style3")
                    .addClass("boost-pfs-filter-tree-mobile-sticky"),
                  o.a.getSettingValue(
                    "general.filterTreeMobileStyleFullWidth"
                  ) &&
                    r()(this.idSelector).addClass(
                      "boost-pfs-filter-tree-mobile-full-width-style"
                    ));
            },
          },
          {
            key: "render",
            value: function () {
              var t = this;
              aH(aU(s.prototype), "render", this).call(this),
                this.$element &&
                  u.a.isMobile() &&
                  this.filterOptions.forEach(function (e) {
                    if (e.$element && t.refineBy && t.refineBy.refineByItems) {
                      var n = [];
                      t.refineBy.refineByItems.forEach(function (t) {
                        if (t.filterOptionId == e.filterOptionId) {
                          var i = t.buildLabel();
                          i && n.push(i);
                        }
                      }),
                        e.$element
                          .find(t.selector.refineByOnTitle)
                          .html(u.a.stripHtml(n.join(", ")));
                    }
                  });
            },
          },
          {
            key: "bindEvents",
            value: function () {
              aH(aU(s.prototype), "bindEvents", this).call(this),
                this.mathHeightToolbarHeader();
            },
          },
          {
            key: "renderFilterTreeHeader",
            value: function () {
              this.mathHeightToolbarHeader();
            },
          },
          {
            key: "renderFilterTreeFooter",
            value: function () {
              var t =
                this.parent && this.parent.data
                  ? " (" + this.parent.data.total_product + ")"
                  : "";
              this.$element
                .find("." + N.a.showResultFilterButton)
                .html(u.a.stripHtml(Labels.showResult + t));
            },
          },
          {
            key: "onClickMobileButton",
            value: function (t) {
              t && (t.stopImmediatePropagation(), t.stopPropagation());
              var e = r()(this.idSelector);
              e &&
                ((this.mobileButton.isCollapsed =
                  !this.mobileButton.isCollapsed),
                this.mobileButton.isCollapsed
                  ? (e.removeClass(N.a.filterTreeMobileOpen),
                    r()("body").removeClass(N.a.filterTreeOpenBody),
                    r()("html").removeClass("boost-pfs-body-no-scroll"))
                  : (e.addClass(N.a.filterTreeMobileOpen),
                    r()("body").addClass(N.a.filterTreeOpenBody),
                    r()("html").addClass("boost-pfs-body-no-scroll"))),
                this.mobileButton.afterToggleFilterTree(),
                this.mathHeightToolbarHeader();
            },
          },
          {
            key: "mathHeightToolbarHeader",
            value: function () {
              var t = r()(".boost-pfs-filter-mobile-toolbar").height();
              this.filterTreeType == ic.FilterTreeType.VERTICAL &&
                u.a.isMobile() &&
                r()(".boost-pfs-filter-options-wrapper").css("top", t + "px");
            },
          },
        ]),
        a5(e.prototype, n),
        i && a5(e, i),
        s
      );
    })(a0);
    function aj(t) {
      return (aj =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function aq(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function aG(t, e, n) {
      return (aG =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = aY(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function az(t, e) {
      return (az =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function aK(t, e) {
      return e && ("object" === aj(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function aY(t) {
      return (aY = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var aQ = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && az(t, e);
      })(s, t);
      var e,
        n,
        i,
        a = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = aY(t);
            if (e()) {
              var r = aY(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return aK(this, n);
          };
        })(s);
      function s(t, e) {
        var n;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, s),
          ((n = a.call(this, t, e)).style = "style3-fullwidth"),
          n
        );
      }
      return (
        (e = s),
        (i = [
          {
            key: "isActive",
            value: function (t) {
              return (
                t == ic.FilterTreeType.VERTICAL &&
                "style3-fullwidth" ==
                  o.a.getSettingValue("general.filterTreeMobileStyle")
              );
            },
          },
        ]),
        (n = [
          {
            key: "init",
            value: function () {
              aG(aY(s.prototype), "init", this).call(this),
                r()(this.idSelector).length > 0 &&
                  (r()(this.idSelector)
                    .addClass("boost-pfs-filter-tree-mobile-style3")
                    .addClass("boost-pfs-filter-tree-mobile-sticky")
                    .addClass("boost-pfs-filter-tree-mobile-full-width-style"),
                  o.a.getSettingValue(
                    "general.filterTreeMobileStyleFullWidth"
                  ) &&
                    r()(this.idSelector).addClass(
                      "boost-pfs-filter-tree-mobile-full-width-style"
                    ));
            },
          },
        ]),
        aq(e.prototype, n),
        i && aq(e, i),
        s
      );
    })(aW);
    function aX(t) {
      return (aX =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function aZ(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function aJ(t, e, n) {
      return (aJ =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var i = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) &&
                  null !== (t = sn(t));

                );
                return t;
              })(t, e);
              if (i) {
                var r = Object.getOwnPropertyDescriptor(i, e);
                return r.get ? r.get.call(n) : r.value;
              }
            })(t, e, n || t);
    }
    function st(t, e) {
      return (st =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function se(t, e) {
      return e && ("object" === aX(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function sn(t) {
      return (sn = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var si = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && st(t, e);
        })(c, t);
        var e,
          n,
          i,
          l = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = sn(t);
              if (e()) {
                var r = sn(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return se(this, n);
            };
          })(c);
        function c(t, e) {
          var n;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, c),
            ((n = l.call(this, t, e)).style = "style4"),
            (n.selector.clearAllButtonContainer =
              ".boost-pfs-filter-mobile-toolbar-right"),
            (n.selector.backButton = ".boost-pfs-filter-back-btn"),
            (n.selector.refineByOnTitle =
              ".boost-pfs-filter-selected-items-mobile"),
            (n.selector.headerTitle = ".bc-sf-filter-mobile-toolbar-header"),
            (n.selector.headerClose = ".boost-pfs-filter-close"),
            (n.style4ActiveFilterOption = null),
            (o.a.activeFilterScrollbarMobile = !1),
            n
          );
        }
        return (
          (e = c),
          (i = [
            {
              key: "isActive",
              value: function (t) {
                return (
                  t == ic.FilterTreeType.VERTICAL &&
                  "style4" ==
                    o.a.getSettingValue("general.filterTreeMobileStyle")
                );
              },
            },
          ]),
          (n = [
            {
              key: "init",
              value: function () {
                aJ(sn(c.prototype), "init", this).call(this),
                  r()(this.idSelector).length > 0 &&
                    (r()(this.idSelector)
                      .addClass("boost-pfs-filter-tree-mobile-style4")
                      .addClass("boost-pfs-filter-tree-mobile-sticky"),
                    o.a.getSettingValue(
                      "general.filterTreeMobileStyleFullWidth"
                    ) &&
                      r()(this.idSelector).addClass(
                        "boost-pfs-filter-tree-mobile-full-width-style"
                      ));
              },
            },
            {
              key: "getHeaderTemplate",
              value: function () {
                return '\n        <div class="boost-pfs-filter-mobile-toolbar">\n            <div class="bc-sf-filter-mobile-toolbar-header">{{label.refineMobile}}</div>\n            <div class="boost-pfs-filter-mobile-toolbar-items">\n                <div class="boost-pfs-filter-mobile-toolbar-left">\n                    <span class="{{class.closeFilterButton}}"><span>{{label.close}}</span></span>\n                    <span class="boost-pfs-filter-back-btn">{{label.apply}}</span>\n                </div>\n                <div class="boost-pfs-filter-mobile-toolbar-right">\n                    {{clearButton}}\n                </div>\n            </div>\n        </div>\n    '.trim();
              },
            },
            {
              key: "render",
              value: function () {
                var t = this;
                if (
                  (aJ(sn(c.prototype), "render", this).call(this),
                  this.$element && u.a.isMobile())
                ) {
                  var e = null;
                  this.filterOptions.forEach(function (n) {
                    t.style4ActiveFilterOption &&
                      t.style4ActiveFilterOption.filterOptionId ==
                        n.filterOptionId &&
                      (e = n);
                  }),
                    (this.style4ActiveFilterOption = e),
                    this.renderFilterTreeHeader(),
                    this.renderFilterTreeFooter(),
                    this.renderFilterOptionCollapse(),
                    this.renderFilterOptionClear(),
                    this.renderRefineByOnTitle();
                }
              },
            },
            {
              key: "bindEvents",
              value: function () {
                var t = this;
                aJ(sn(c.prototype), "bindEvents", this).call(this),
                  this.$element &&
                    u.a.isMobile() &&
                    (this.$element
                      .find(this.selector.backButton)
                      .on("click", this.closeFilterOption.bind(this)),
                    this.filterOptions.forEach(function (e) {
                      e.$filterOptionTitleElement &&
                        (e.$filterOptionTitleElement.off("click"),
                        e.$filterOptionTitleElement.on(
                          "click",
                          t.openFilterOption.bind(t, e)
                        ));
                    }));
              },
            },
            {
              key: "renderFilterTreeHeader",
              value: function () {
                this.style4ActiveFilterOption
                  ? (this.$element
                      .find(this.selector.headerTitle)
                      .html(u.a.stripHtml(this.style4ActiveFilterOption.label)),
                    this.$element.find(this.selector.backButton).show(),
                    this.$element.find(this.selector.headerClose).hide())
                  : (this.$element
                      .find(this.selector.headerTitle)
                      .html(a.a.refineMobile),
                    this.$element.find(this.selector.backButton).hide(),
                    this.$element.find(this.selector.headerClose).show());
              },
            },
            {
              key: "renderFilterTreeFooter",
              value: function () {
                var t =
                  this.parent && this.parent.data
                    ? " (" + this.parent.data.total_product + ")"
                    : "";
                this.$element
                  .find("." + N.a.showResultFilterButton)
                  .html(
                    a.a.showResult +
                      '<span class="boost-pfs-number-result">' +
                      u.a.stripHtml(t) +
                      "</span>"
                  );
              },
            },
            {
              key: "renderFilterOptionCollapse",
              value: function () {
                var t = this;
                this.filterOptions.forEach(function (e) {
                  if (
                    e.$filterOptionTitleElement &&
                    e.$filterOptionContentElement &&
                    e.collapse
                  ) {
                    e.$element.removeClass("boost-pfs-filter-option-collapsed");
                    var n = e.$element.find(".boost-pfs-filter-option-title"),
                      i = e.$filterOptionContentElement;
                    t.style4ActiveFilterOption
                      ? e == t.style4ActiveFilterOption
                        ? (n.hide(), i.show())
                        : (n.hide(), i.hide())
                      : (n.show(), i.hide());
                  }
                });
              },
            },
            {
              key: "renderFilterOptionClear",
              value: function () {
                var t = this.clearAllButton.$element,
                  e = this.$element.find(this.selector.clearAllButtonContainer);
                e &&
                  (t &&
                    (null == this.style4ActiveFilterOption &&
                    s.a.hasFilterOptionParam
                      ? e.append(t)
                      : t.detach()),
                  this.filterOptions.forEach(function (t) {
                    t.clearButton &&
                      t.clearButton.$element &&
                      t.clearButton.$element.detach();
                  }),
                  this.style4ActiveFilterOption &&
                    this.style4ActiveFilterOption.clearButton &&
                    this.style4ActiveFilterOption.clearButton.$element &&
                    e.append(
                      this.style4ActiveFilterOption.clearButton.$element
                    ));
              },
            },
            {
              key: "renderRefineByOnTitle",
              value: function () {
                var t = this;
                this.filterOptions.forEach(function (e) {
                  if (e.$element) {
                    var n = "";
                    if (e.filterOptionId.startsWith(s.a.prefix + "_c_")) {
                      var i =
                        e.displayType ==
                        nM.a.DisplayType.MULTI_LEVEL_COLLECTIONS
                          ? e.allNestedFilterItems
                          : e.filterItems;
                      if (i && i.size > 0) {
                        var r = "",
                          o = [];
                        i.forEach(function (t) {
                          t.isSelected &&
                            (2 == t.level || 3 == t.level
                              ? o.push(u.a.stripHtml(t.label))
                              : (r = u.a.stripHtml(t.label)));
                        }),
                          (n = r && o.length > 0 ? r + ": " + o.join(", ") : r);
                      }
                    } else if (t.refineBy && t.refineBy.refineByItems) {
                      var a = [];
                      t.refineBy.refineByItems.forEach(function (t) {
                        if (t.filterOptionId == e.filterOptionId) {
                          var n = u.a.stripHtml(t.label);
                          n && a.push(n);
                        }
                      }),
                        (n = a.join(", "));
                    }
                    var l = n ? "<span>" + u.a.stripHtml(n) + "</span>" : "";
                    e.$element.find(t.selector.refineByOnTitle).html(l);
                  }
                });
              },
            },
            {
              key: "openFilterOption",
              value: function (t) {
                (this.style4ActiveFilterOption = t),
                  this.renderFilterTreeHeader(),
                  this.renderFilterOptionCollapse(),
                  this.renderFilterOptionClear();
                var e = r()(".boost-pfs-filter-mobile-toolbar").height();
                r()(".boost-pfs-filter-options-wrapper").css("top", e + "px");
              },
            },
            {
              key: "closeFilterOption",
              value: function () {
                (this.style4ActiveFilterOption = null),
                  this.renderFilterTreeHeader(),
                  this.renderFilterOptionCollapse(),
                  this.renderFilterOptionClear();
              },
            },
            {
              key: "onClickMobileButton",
              value: function (t) {
                t && (t.stopImmediatePropagation(), t.stopPropagation()),
                  (this.style4ActiveFilterOption = null);
                var e = r()(this.idSelector);
                e &&
                  ((this.mobileButton.isCollapsed =
                    !this.mobileButton.isCollapsed),
                  this.mobileButton.isCollapsed
                    ? (e.removeClass(N.a.filterTreeMobileOpen),
                      r()("body").removeClass(N.a.filterTreeOpenBody),
                      r()("html").removeClass("boost-pfs-body-no-scroll"))
                    : (e.addClass(N.a.filterTreeMobileOpen),
                      r()("body").addClass(N.a.filterTreeOpenBody),
                      r()("html").addClass("boost-pfs-body-no-scroll"))),
                  this.mobileButton.afterToggleFilterTree();
              },
            },
          ]),
          aZ(e.prototype, n),
          i && aZ(e, i),
          c
        );
      })(a0),
      sr = {
        newFilterTree: function (t, e) {
          return aW.isActive(e)
            ? new aW(t, e)
            : aF.isActive(e)
            ? new aF(t, e)
            : a3.isActive(e)
            ? new a3(t, e)
            : aQ.isActive(e)
            ? new aQ(t, e)
            : si.isActive(e)
            ? new si(t, e)
            : new a0(t, e);
        },
      };
    function so(t) {
      return (so =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function sa(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function ss(t, e) {
      return (ss =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function sl(t, e) {
      return e && ("object" === so(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function sc(t) {
      return (sc = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var su = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && ss(t, e);
        })(c, t);
        var e,
          n,
          i,
          a = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = sc(t);
              if (e()) {
                var r = sc(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return sl(this, n);
            };
          })(c);
        function c() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, c),
            ((t = a.call(this)).filterTrees = []),
            (t.filterMobileButton = null),
            (t.filterDesktopButton = null),
            (t.filterResult = null),
            (t.filterLoadingIcon = null),
            (t.filterScrollToTop = null),
            (t.data = null),
            (t.fromCache = !1),
            (t.eventType = ""),
            (t.error = ""),
            (t.isFetchedFilterData = !1),
            t
          );
        }
        return (
          (e = c),
          (n = [
            {
              key: "beforeInit",
              value: function () {
                u.a.isBadUrl() &&
                  ((this.isInit = !0),
                  u.a.setWindowLocation(window.location.pathname));
              },
            },
            {
              key: "init",
              value: function () {
                this.initInCollectionSearch(),
                  this.initFilterTrees(),
                  this.initFilterMobileButton(),
                  this.initFilterDesktopButton(),
                  (this.filterResult = new nD()),
                  this.addComponent(this.filterResult),
                  (this.filterLoadingIcon = new ie()),
                  this.addComponent(this.filterLoadingIcon),
                  (this.filterScrollToTop = new il()),
                  this.addComponent(this.filterScrollToTop),
                  this.filterLoadingIcon.setShow(!0);
              },
            },
            {
              key: "afterInit",
              value: function () {
                K.default.updateParamsFromUrl(),
                  K.default.getFilterData(
                    "init",
                    this.afterGetFilterData.bind(this),
                    this.errorFilterCallback.bind(this)
                  );
              },
            },
            {
              key: "initFilterTrees",
              value: function () {
                var t = this;
                r()(l.a.filterTree).each(function (e, n) {
                  var i = r()(n),
                    a = "";
                  if (
                    (i.hasClass(N.a.filterTreeVertical)
                      ? ((a = ic.FilterTreeType.VERTICAL),
                        r()("body").addClass(
                          N.a.filterTree +
                            "-vertical-" +
                            o.a.getSettingValue(
                              "general.filterTreeVerticalStyle"
                            )
                        ))
                      : i.hasClass(N.a.filterTreeHorizontal) &&
                        ((a = ic.FilterTreeType.HORIZONTAL),
                        r()("body").addClass(
                          N.a.filterTree +
                            "-horizontal-" +
                            o.a.getSettingValue(
                              "general.filterTreeHorizontalStyle"
                            )
                        )),
                    a)
                  ) {
                    var s = N.a.filterTree + (0 == e ? "" : (e + 1).toString());
                    i.attr("id", u.a.stripHtml(s));
                    var l = sr.newFilterTree(s, a);
                    t.addComponent(l),
                      t.filterTrees.push(l),
                      t.renderFilterBackdrop(l);
                  }
                });
              },
            },
            {
              key: "initFilterMobileButton",
              value: function () {
                if (r()(l.a.filterTreeMobileButton).length > 0) {
                  var t = r()(l.a.filterTreeMobileButton).first(),
                    e = u.a.stripHtml(t.attr("data-filter-tree-id"));
                  this.filterMobileButton = null;
                  for (var n = this.filterTrees.length, i = 0; i < n; i++)
                    this.filterMobileButton ||
                      (0 !=
                        r()("#" + this.filterTrees[i].id).not(
                          "[data-is-desktop]"
                        ).length &&
                        ((e && this.filterTrees[i].id == e) ||
                          (!e &&
                            this.filterTrees[i].filterTreeType ==
                              ic.FilterTreeType.VERTICAL)) &&
                        ((this.filterMobileButton = new nN(
                          this.filterTrees[i]
                        )),
                        this.addComponent(this.filterMobileButton)));
                }
              },
            },
            {
              key: "initFilterDesktopButton",
              value: function () {
                if (r()(l.a.filterTreeDesktopButton).length > 0) {
                  var t = r()(l.a.filterTreeDesktopButton)
                    .first()
                    .attr("data-filter-tree-id");
                  this.filterDesktopButton = null;
                  for (var e = this.filterTrees.length, n = 0; n < e; n++)
                    this.filterDesktopButton ||
                      (0 !=
                        r()("#" + this.filterTrees[n].id).not(
                          "[data-is-mobile]"
                        ).length &&
                        ((t && this.filterTrees[n].id == t) || !t) &&
                        ((this.filterDesktopButton = new nK(
                          this.filterTrees[n]
                        )),
                        this.addComponent(this.filterDesktopButton)));
                }
              },
            },
            {
              key: "initInCollectionSearch",
              value: function () {
                var t = new tV();
                this.addComponent(t);
              },
            },
            {
              key: "isRender",
              value: function () {
                return this.isFetchedFilterData || this.isFetchedProductData;
              },
            },
            {
              key: "render",
              value: function () {
                this.isFetchedFilterData &&
                  (this.filterTrees.forEach(function (t) {
                    r()(t.idSelector).length > 0 &&
                      !t.isRenderPartially &&
                      r()(t.idSelector).first().html("").append(t.$element);
                  }),
                  r()(l.a.filterTreeMobileButton).length > 0 &&
                    "init" == this.eventType &&
                    this.filterMobileButton &&
                    r()(l.a.filterTreeMobileButton)
                      .first()
                      .html("")
                      .append(this.filterMobileButton.$element),
                  r()(l.a.filterTreeDesktopButton).length > 0 &&
                    "init" == this.eventType &&
                    this.filterDesktopButton &&
                    (r()("body").addClass(
                      N.a.filterTreeDesktopButton + "-body"
                    ),
                    r()(l.a.filterTreeDesktopButton)
                      .first()
                      .html("")
                      .append(this.filterDesktopButton.$element)));
              },
            },
            {
              key: "renderFilterBackdrop",
              value: function (t) {
                (!u.a.isMobile() &&
                  "style-off-canvas" !=
                    o.a.getSettingValue("general.filterTreeVerticalStyle")) ||
                  t.filterTreeType != ic.FilterTreeType.VERTICAL ||
                  r()("body").hasClass("boost-pfs-filter-overlay") ||
                  r()(t.idSelector).before(
                    '<div class="boost-pfs-filter-overlay" role="button" tabindex="0" aria-label="Background overlay"></div>'
                  ),
                  u.a.isMobile() &&
                    (r()(t.idSelector).addClass(
                      "boost-pfs-filter-mobile-" +
                        o.a.getSettingValue("general.filterTreeMobileStyle")
                    ),
                    r()("body").addClass(
                      "boost-pfs-filter-mobile-" +
                        o.a.getSettingValue("general.filterTreeMobileStyle") +
                        "-body"
                    ));
              },
            },
            {
              key: "bindEvents",
              value: function () {
                u.a.isMobile() &&
                o.a.getSettingValue("general.stickyFilterOnMobile")
                  ? this.stickyFilterMobile()
                  : !u.a.isMobile() &&
                    o.a.getSettingValue("general.stickyFilterOnDesktop") &&
                    this.stickyFilterDesktop();
              },
            },
            {
              key: "stickyFilterMobile",
              value: function () {
                (r()(l.a.stickyFilterTreeMobileButtonWrapper).length > 0
                  ? r()(l.a.stickyFilterTreeMobileButtonWrapper)
                  : r()(l.a.stickyElementMobile)
                ).each(function (t, e) {
                  u.a.sticky(
                    r()(e),
                    l.a.endStickyMobile,
                    l.a.avoidStickyHeader
                  );
                });
              },
            },
            {
              key: "stickyFilterDesktop",
              value: function () {
                var t = r()(l.a.stickyElementDesktop),
                  e = o.a.getSettingValue("general.filterTreeVerticalStyle"),
                  n = r()(l.a.stickyFilterTreeDesktopButtonWrapper),
                  i = r()(l.a.filterTreeHorizontalWrapper),
                  a = l.a.avoidStickyHeader,
                  s =
                    r()(l.a.filterTreeWrapper).length > 0
                      ? l.a.filterTreeWrapper
                      : l.a.endStickyDesktop;
                n.length > 0 &&
                  (a =
                    r()(l.a.avoidStickyHeader).length > 0
                      ? l.a.avoidStickyHeader +
                        "," +
                        l.a.stickyFilterTreeDesktopButtonWrapper
                      : l.a.stickyFilterTreeDesktopButtonWrapper);
                var c = n.attr("data-offset-top"),
                  p = i.attr("data-offset-top");
                n.length > 0 &&
                  i.length > 0 &&
                  void 0 !== c &&
                  c > 0 &&
                  ((p = p > c ? c : p), i.attr("data-offset-top", p));
                var f = !!t.hasClass(N.a.filterTreeHorizontal);
                ("style-off-canvas" === e || "style-expand" === e || f) &&
                  (n.each(function (t, e) {
                    u.a.sticky(
                      r()(e),
                      l.a.endStickyDesktop,
                      l.a.avoidStickyHeader
                    ),
                      n.css({ maxWidth: r()(s).width() + "px" });
                  }),
                  i.each(function (e, n) {
                    u.a.sticky(r()(n), l.a.endStickyDesktop, a),
                      t.css({ maxWidth: r()(s).width() + "px" });
                  })),
                  t.each(function (i, o) {
                    (n.length < 1 || "style-expand" === e) &&
                      (u.a.sticky(r()(o), l.a.endStickyDesktop, a),
                      f && t.css({ maxWidth: r()(s).width() + "px" }));
                  });
              },
            },
            {
              key: "afterGetFilterData",
              value: function (t, e, n) {
                !t ||
                !Array.isArray(t.products) ||
                0 != t.products.length ||
                void 0 === boostPFSAppConfig.general.collection_product_count ||
                t.products.length ==
                  boostPFSAppConfig.general.collection_product_count ||
                o.a.getSettingValue("general.productAndVariantAvailable") ||
                !o.a.getSettingValue("general.enableBackToOriginal") ||
                "init" != e ||
                s.a.hasFilterOptionParam ||
                s.a.collectionTags ||
                "function" == typeof K.default.beforeCall ||
                "function" == typeof K.default.beforeCallAsync
                  ? this.setData(t, e, n)
                  : this.errorFilterCallback();
              },
            },
            {
              key: "setData",
              value: function (t, e, n) {
                (this.isFetchedFilterData = !1),
                  (this.isFetchedProductData = !1),
                  (this.data = JSON.parse(JSON.stringify(t))),
                  (this.fromCache = t.from_cache),
                  (this.error = t.error);
                var i = JSON.parse(JSON.stringify(s.a.queryParams));
                (s.a.queryParams = i),
                  void 0 !== s.a.activeCurrencyPrices &&
                    r.a.extend(s.a.queryParams, s.a.activeCurrencyPrices),
                  (this.eventType = e || t.event_type),
                  (this.clickedFilterOptionId =
                    n && n.filterOptionId && "clear" != e
                      ? n.filterOptionId
                      : ""),
                  (t = this.modifyData(t)).filter &&
                    t.filter.options &&
                    -1 == s.a.imutableFilterTree.indexOf(this.eventType) &&
                    ((this.isFetchedFilterData = !0),
                    this.filterTrees.forEach(function (e) {
                      e.setData(t.filter);
                    })),
                  (t.products || t.collections || t.pages) &&
                    ((this.isFetchedProductData = !0),
                    this.filterResult.setData(t)),
                  this.refresh(),
                  this.filterLoadingIcon.setShow(!1);
              },
            },
            {
              key: "modifyData",
              value: function (t) {
                return t;
              },
            },
            {
              key: "errorFilterCallback",
              value: function () {
                if (
                  !(
                    u.a.isiOS() ||
                    u.a.isSafari() ||
                    u.a.isBackButton() ||
                    u.a
                      .getWindowLocation()
                      .href.includes("view=boost-pfs-original")
                  )
                ) {
                  if(u.a
                      .getWindowLocation()
                      .href.includes("power-equipment"))
                      {
                        //debugger;
                        //return;
                      }
                  var t =
                    u.a.getWindowLocation().href.split("?")[0] +
                    "?view=boost-pfs-original" +
                    (u.a.isSearchPage() && s.a.queryParams.hasOwnProperty("q")
                      ? "&q=" + s.a.queryParams.q
                      : "");
                  u.a.isBadUrl(t) || (window.location.href = t);
                }
              },
            },
          ]),
          sa(e.prototype, n),
          i && sa(e, i),
          c
        );
      })(g.a),
      sp = [
        {
          name: "getSettingValue",
          mapToFunction: function (t, e) {
            return o.a.getSettingValue(t, e);
          },
        },
        {
          name: "getSortingList",
          mapToFunction: function () {
            return u.a.FilterResult.getSortingList();
          },
        },
        {
          name: "buildToolbarLink",
          mapToFunction: function (t, e, n) {
            return u.a.buildToolbarLink(t, e, n);
          },
        },
        {
          name: "optimizeImage",
          mapToFunction: function (t, e) {
            return u.a.optimizeImage(t, e);
          },
        },
        {
          name: "buildProductItemUrl",
          mapToFunction: function (t, e) {
            return u.a.buildProductItemUrl(t, e);
          },
        },
        {
          name: "refreshProperties",
          mapToFunction: function () {
            (BoostPFS.prototype.selector = l.a),
              (BoostPFS.prototype.queryParams = s.a.queryParams);
          },
        },
      ],
      sf = [
        {
          name: "beforeBuildSearchBox",
          mapToFunction: "beforeBindEvents",
          mapArguments: ["id"],
          component: p.a,
        },
        {
          name: "afterBuildSearchBox",
          mapToFunction: "afterBindEvents",
          mapArguments: ["id"],
          component: p.a,
        },
        {
          name: "customizeSuggestion",
          mapToFunction: "customizeAutoCompleteResizeMenu",
          mapArguments: ["$uiMenuElement", "$element", "id"],
          component: p.a,
        },
        {
          name: "afterShowSearchBoxMobile",
          mapToFunction: "afterShowSearchBoxMobile",
          mapArguments: ["inputMobileId"],
          component: f.a,
        },
        {
          name: "afterCloseSuggestionMobile",
          mapToFunction: "afterCloseInstantSearchMobile",
          mapArguments: ["inputMobileId", "@0"],
          component: f.a,
        },
        {
          name: "afterShowSearchBoxStyle3",
          mapToFunction: "afterShowSearchBoxStyle3",
          mapArguments: ["inputStyle3Id"],
          component: h.a,
        },
        {
          name: "afterCloseInstantSearchStyle3",
          mapToFunction: "afterCloseInstantSearchStyle3",
          mapArguments: ["inputStyle3Id", "@0"],
          component: h.a,
        },
        {
          name: "customizeSuggetionProductTitle",
          mapToFunction: "customizeProductTitle",
          mapArguments: ["title", "currentTerm", "data"],
          component: d.a,
        },
        {
          name: "buildProductGridItem",
          mapToFunction: "compileTemplate",
          mapArguments: ["data", "index", "totalProduct"],
          component: w,
        },
        {
          name: "buildProductListItem",
          mapToFunction: "compileTemplate",
          mapArguments: ["data", "index", "totalProduct"],
          component: B,
        },
        {
          name: "buildProductCollageItem",
          mapToFunction: "compileTemplate",
          mapArguments: ["data", "index", "totalProduct"],
          component: H,
        },
        {
          name: "prepareProductData",
          mapToFunction: "prepareProductData",
          mapArguments: ["data"],
          component: tf,
        },
        {
          name: "buildExtrasProductList",
          mapToFunction: "afterRender",
          mapArguments: ["data", "eventType"],
          component: tf,
        },
        {
          name: "buildAdditionalElements",
          mapToFunction: "afterRender",
          mapArguments: ["data", "totalProduct", "eventType"],
          component: su,
        },
        {
          name: "buildPagination",
          mapToFunction: "render",
          mapArguments: ["totalProduct", "paginationType"],
          component: tv,
        },
        {
          name: "buildFilterDisplayType",
          mapToFunction: "render",
          mapArguments: [],
          component: t_,
        },
        {
          name: "buildFilterSorting",
          mapToFunction: "compileTemplate",
          mapArguments: [],
          component: tI,
        },
        {
          name: "buildFilterShowLimit",
          mapToFunction: "compileTemplate",
          mapArguments: [],
          component: tB,
        },
        {
          name: "buildBreadcrumb",
          mapToFunction: "buildBreadcrumb",
          mapArguments: ["collectionData", "data"],
          component: tX,
        },
      ],
      sh = function (t, e) {
        BoostPFS.prototype.hasOwnProperty(t) || (BoostPFS.prototype[t] = e);
      },
      sd = function (t, e, n, i) {
        BoostPFS.prototype.hasOwnProperty(t) &&
          (i.prototype[e] = function () {
            var e,
              i = [];
            if (n && n.length > 0)
              for (var r = 0; r < n.length; r++) {
                var o = n[r];
                if (this.hasOwnProperty(o)) i.push(this[o]);
                else if (0 == o.indexOf("@")) {
                  var a = parseInt(o.substr(1));
                  void 0 !== arguments[a] ? i.push(arguments[a]) : i.push(null);
                } else i.push(null);
              }
            return (e = BoostPFS.prototype[t]).call.apply(
              e,
              [BoostPFS.instance].concat(i)
            );
          });
      },
      sg = {
        mapLegacyFunctions: function () {
          sp.forEach(function (t) {
            sh(t.name, t.mapToFunction);
          }),
            sf.forEach(function (t) {
              sd(t.name, t.mapToFunction, t.mapArguments, t.component);
            });
        },
        mapLegacyFunctionCall: sh,
        mapLegacyFunctionOverride: sd,
      },
      sy = n(69),
      sm = n(39),
      sv = n(84),
      sb = n(20),
      sS = n(130),
      s$ = n(75);
    function sT(t) {
      return (sT =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function sP(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function s_(t, e) {
      return (s_ =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function s8(t, e) {
      return e && ("object" === sT(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function sk(t) {
      return (sk = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var sO = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && s_(t, e);
        })(s, t);
        var e,
          n,
          i,
          a = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = sk(t);
              if (e()) {
                var r = sk(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return s8(this, n);
            };
          })(s);
        function s() {
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, s),
            a.call(this)
          );
        }
        return (
          (e = s),
          (n = [
            {
              key: "init",
              value: function () {
                var t = this;
                if (
                  (r()(
                    'input[name="' +
                      o.a.getSettingValue("search.termKey") +
                      '"]:not([data-disable-instant-search]):not([data-already-init])'
                  ).each(function (e, n) {
                    var i = "boost-pfs-search-box-" + e,
                      o = new p.a(i, r()(n));
                    t.addComponent(o);
                  }),
                  u.a.isMobile() &&
                    o.a.getSettingValue("search.suggestionMobileStyle") !==
                      sb.a.Mobile.SuggestionType.STYLE_2)
                ) {
                  var e = s$.a.instantSearchMobile();
                  this.addComponent(e);
                }
                if (
                  (!u.a.isMobile() &&
                    "style3" ===
                      o.a.getSettingValue("search.suggestionStyle")) ||
                  "2-overlay-fullwidth" ===
                    o.a.getSettingValue("search.suggestionColumn")
                ) {
                  var n = s$.a.instantSearchStyle3();
                  this.addComponent(n);
                }
              },
            },
          ]),
          sP(e.prototype, n),
          i && sP(e, i),
          s
        );
      })(g.a),
      sC = n(85),
      sw = n(129),
      sI = n(70),
      sE = n(43),
      s0 = n(121),
      sL = n(125),
      sA = n(128),
      sx = n(127),
      sB = n(126),
      sR = n(59),
      s9 = n(123),
      sF = n(124),
      s2 = n(122),
      s1 = n(100),
      sV = {
        inject: function (t) {
          (t.jQ = r.a),
            (t.noUiSlider = aa.a),
            (t.Analytics = sy.a),
            (t.Class = N.a),
            (t.Globals = s.a),
            (t.Labels = a.a),
            (t.Navigation = c.a),
            (t.Selector = l.a),
            (t.Settings = o.a),
            (t.Utils = u.a),
            (t.FunctionMapper = sg),
            (t.Integration = y.a),
            (t.Api = sm.a),
            (t.FilterApi = K.default),
            (t.InstantSearchApi = sv.default),
            (t.FilterTreeEnum = ic),
            (t.FilterOptionEnum = nM.a),
            (t.InstantSearchEnum = sb.a),
            (t.Filter = su),
            (t.FilterTree = a0),
            (t.FilterStyle = sr),
            (t.FilterTreeStyle2 = aF),
            (t.FilterTreeStyle2Fullwidth = a3),
            (t.FilterTreeStyle3 = aW),
            (t.FilterTreeStyle3Fullwidth = aQ),
            (t.FilterTreeStyle4 = si),
            (t.FilterOption = oS),
            (t.FilterOptionList = oC),
            (t.FilterOptionBox = ox),
            (t.FilterOptionSwatch = oV),
            (t.FilterOptionMultiLevelCollections = aS),
            (t.FilterOptionMultiLevelTag = ak),
            (t.FilterOptionRangeSlider = ad),
            (t.FilterOptionRating = oH),
            (t.FilterOptionSubCategory = ar),
            (t.FilterApplyButton = iT),
            (t.FilterClearButton = iy),
            (t.FilterCollapse = od),
            (t.FilterScrollbar = rF),
            (t.FilterSearchBox = r8),
            (t.FilterTooltip = rE),
            (t.FilterViewMore = rb),
            (t.FilterOptionItem = iC),
            (t.FilterOptionItemList = iA),
            (t.FilterOptionItemBox = iV),
            (t.FilterOptionItemSwatch = i7),
            (t.FilterOptionItemMultiLevelCollections = rj),
            (t.FilterOptionItemSecondLevelCollections = rN),
            (t.FilterOptionItemThirdLevelCollections = rU),
            (t.FilterOptionItemMultiLevelTag = or),
            (t.FilterOptionItemSecondLevelTag = oe),
            (t.FilterOptionItemThirdLevelTag = on),
            (t.FilterOptionItemRangeSlider = ru),
            (t.FilterOptionItemRating = iK),
            (t.FilterOptionItemSubCategory = rn),
            (t.FilterRefineBy = oX),
            (t.FilterRefineByItem = oq),
            (t.FilterLoadingIcon = ie),
            (t.FilterMobileButton = nN),
            (t.FilterDesktopButton = nK),
            (t.FilterScrollToTop = il),
            (t.FilterResult = nD),
            (t.ProductList = tf),
            (t.ProductListPlaceholder = eL),
            (t.ProductListNoSearchResult = nR),
            (t.ProductItem = T),
            (t.ProductGridItem = w),
            (t.ProductListItem = B),
            (t.ProductCollageItem = H),
            (t.Breadcrumb = tq),
            (t.PageInfoCollection = tX),
            (t.PageInfoSearch = t5),
            (t.ProductDisplayType = t_),
            (t.ProductLimit = tB),
            (t.ProductSorting = tI),
            (t.RobotsMeta = ei),
            (t.InCollectionSearch = tV),
            (t.SearchResultPanels = z),
            (t.SearchResultPanelItem = tt),
            (t.SearchResultTotal = np),
            (t.CollectionItem = eN),
            (t.CollectionItemList = ez),
            (t.CollectionList = eJ),
            (t.PageItem = eF),
            (t.PageItemList = e4),
            (t.PageList = no),
            (t.MostPopular = nE),
            (t.ProductSlider = n_),
            (t.ProductSliderItem = nm),
            (t.ProductPagination = ta),
            (t.ProductPaginationDefault = tv),
            (t.ProductPaginationInfinite = eg),
            (t.ProductPaginationLoadMore = ec),
            (t.ProductPaginationLoadPrevious = e$),
            (t.SearchDisplayPagination = eO),
            (t.SearchInput = p.a),
            (t.InstantSearch = sO),
            (t.InstantSearchMobile = f.a),
            (t.InstantSearchResult = sC.a),
            (t.InstantSearchStyle = s$.a),
            (t.InstantSearchResultStyle2 = sw.a),
            (t.InstantSearchStyle3 = h.a),
            (t.InstantSearchNoResult = sI.a),
            (t.InstantSearchOnclick = sE.a),
            (t.InstantSearchResultBlock = s0.a),
            (t.InstantSearchResultBlockDym = sL.a),
            (t.InstantSearchResultBlockEmpty = sA.a),
            (t.InstantSearchResultBlockLoading = sx.a),
            (t.InstantSearchResultBlockViewAll = sB.a),
            (t.InstantSearchResultItem = sR.a),
            (t.InstantSearchResultItemCollection = s9.a),
            (t.InstantSearchResultItemPage = sF.a),
            (t.InstantSearchResultItemPopular = s2.a),
            (t.InstantSearchResultItemProduct = d.a),
            (t.InstantSearchResultRedirect = s1.a),
            (t.SearchAutoComplete = sS.a);
        },
      };
    function sD(t) {
      return (sD =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    var sM = function () {
        r.a.each(
          "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
            " "
          ),
          function (t, e) {
            r.a.fn[e] = function (t, n) {
              return arguments.length > 0
                ? this.on(e, null, t, n)
                : this.trigger(e);
            };
          }
        ),
          (r.a.fn.hover = function (t, e) {
            return this.mouseenter(t).mouseleave(e || t);
          });
      },
      s4 = function () {
        r.a.ajax = function (t) {
          var e = t.type,
            n = void 0 === e ? "GET" : e,
            i = t.url,
            o = void 0 === i ? "" : i,
            a = t.data,
            s = t.dataType,
            l = t.success,
            c = t.error,
            u = new XMLHttpRequest(),
            p = "application/json";
          s || (p = "text/html"),
            "object" === sD(a) &&
              "string" == typeof n &&
              "get" === n.toLowerCase() &&
              (o += "?" + r.a.param(a)),
            u.open(n, o),
            u.setRequestHeader("Content-Type", "".concat(p, ";charset=UTF-8")),
            "json" === s &&
              u.setRequestHeader("Accept", "application/json, text/javascript"),
            (u.onload = function () {
              var t;
              (t = "json" === s ? JSON.parse(u.responseText) : u.responseText),
                u.readyState > 3 &&
                  (200 == u.status
                    ? "function" == typeof l && l(t)
                    : "function" == typeof c && c(t));
            }),
            a && "string" == typeof n && "get" !== n.toLowerCase()
              ? u.send(JSON.stringify(a))
              : u.send();
        };
      },
      s3 = function () {
        r.a.fn.serializeArray = function () {
          var t = [],
            e = this.length > 0 ? this[0] : {};
          return (
            Array.prototype.slice.call(e).forEach(function (e) {
              !e.name ||
                e.disabled ||
                ["file", "reset", "submit", "button"].indexOf(e.type) > -1 ||
                ("select-multiple" !== e.type
                  ? (["checkbox", "radio"].indexOf(e.type) > -1 &&
                      !e.checked) ||
                    t.push({ name: e.name, value: e.value })
                  : Array.prototype.slice.call(e.options).forEach(function (n) {
                      n.selected && t.push({ name: e.name, value: n.value });
                    }));
            }),
            t
          );
        };
      },
      s6 = function () {
        r.a.param = function (t) {
          return Object.keys(t)
            .map(function (e) {
              if (Array.isArray(t[e])) {
                for (var n = [], i = 0; i < t[e].length; i++)
                  n.push(
                    encodeURIComponent(e + "[]") +
                      "=" +
                      encodeURIComponent(t[e][i])
                  );
                return n.join("&");
              }
              return (
                encodeURIComponent(e) +
                "=" +
                encodeURIComponent(null === t[e] ? "" : t[e])
              );
            })
            .join("&");
        };
      },
      s5 = {
        init: function () {
          sM(), s4(), s3(), s6();
        },
      };
    function sH(t) {
      return (sH =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function s7(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function sN(t, e) {
      return (sN =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function sU(t, e) {
      return e && ("object" === sH(e) || "function" == typeof e) ? e : sW(t);
    }
    function sW(t) {
      if (void 0 === t)
        throw ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return t;
    }
    function sj(t) {
      return (sj = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var sq = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw TypeError(
              "Super expression must either be null or a function"
            );
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && sN(t, e);
        })(h, t);
        var e,
          n,
          i,
          f = (function (t) {
            function e() {
              if (
                "undefined" == typeof Reflect ||
                !Reflect.construct ||
                Reflect.construct.sham
              )
                return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Date.prototype.toString.call(
                    Reflect.construct(Date, [], function () {})
                  ),
                  !0
                );
              } catch (t) {
                return !1;
              }
            }
            return function () {
              var n,
                i = sj(t);
              if (e()) {
                var r = sj(this).constructor;
                n = Reflect.construct(i, arguments, r);
              } else n = i.apply(this, arguments);
              return sU(this, n);
            };
          })(h);
        function h() {
          var t;
          return (
            (function (t, e) {
              if (!(t instanceof e))
                throw TypeError("Cannot call a class as a function");
            })(this, h),
            ((t = f.call(this)).search = null),
            (t.filter = null),
            (sG = sW(t)),
            t
          );
        }
        return (
          (e = h),
          (i = [
            {
              key: "instance",
              get: function () {
                return sG;
              },
            },
            {
              key: "jQ",
              get: function () {
                return r.a;
              },
            },
            {
              key: "Globals",
              get: function () {
                return s.a;
              },
            },
            {
              key: "Labels",
              get: function () {
                return a.a;
              },
            },
            {
              key: "Selector",
              get: function () {
                return l.a;
              },
            },
            {
              key: "Settings",
              get: function () {
                return o.a;
              },
            },
            {
              key: "Utils",
              get: function () {
                return u.a;
              },
            },
            {
              key: "inject",
              value: function (t) {
                sV.inject(t);
              },
            },
          ]),
          (n = [
            {
              key: "init",
              value: function () {
                s5.init(),
                  sg.mapLegacyFunctions(),
                  o.a.init(),
                  a.a.init(),
                  l.a.init(),
                  s.a.init(),
                  c.a.init(),
                  this.initApp(),
                  this.initOTP(),
                  this.initADA(),
                  this.initVariantsDisplay();
              },
            },
            {
              key: "initApp",
              value: function () {
                u.a.addClassToBody("enableApp");
              },
            },
            {
              key: "initSearchBox",
              value: function (t) {
                if (
                  o.a.getSettingValue("search.enableSuggestion") &&
                  !u.a.isGLHMobile()
                ) {
                  if (
                    (u.a.addClassToBody("enableInstantSearch"),
                    (this.search = new sO()),
                    this.addComponent(this.search),
                    t)
                  ) {
                    var e = new p.a(t);
                    this.search.addComponent(e);
                  }
                  this.search.refresh();
                }
              },
            },
            {
              key: "initFilter",
              value: function () {
                o.a.getSettingValue("general.enableFilter") &&
                  !u.a.isGLHMobile() &&
                  (u.a.addClassToBody("enableFilter"),
                  (this.filter = new su()),
                  this.addComponent(this.filter),
                  this.filter.refresh());
              },
            },
            {
              key: "initAnalytics",
              value: function () {
                o.a.getSettingValue("general.enableTrackingOrderRevenue") &&
                  !u.a.isGLHMobile() &&
                  sy.a.init();
              },
            },
            {
              key: "initOTP",
              value: function () {
                window.BoostOTP &&
                  "function" == typeof window.BoostOTP.init &&
                  r()(window).on("load", function () {
                    BoostOTP.init();
                  });
              },
            },
            {
              key: "initADA",
              value: function () {
                r()("body").on("keyup", function (t) {
                  t && 9 == t.keyCode && r()("body").addClass(Class.adaWrapper);
                }),
                  r()("body").on("click", function (t) {
                    (!t ||
                      !t.originalEvent ||
                      (t.originalEvent.screenX && t.originalEvent.screenY)) &&
                      r()("body").removeClass(Class.adaWrapper);
                  });
              },
            },
            {
              key: "initVariantsDisplay",
              value: function () {
                o.a.getSettingValue("general.enableVariantsDisplay") &&
                  u.a.addClassToBody("variantsDisplay");
              },
            },
          ]),
          s7(e.prototype, n),
          i && s7(e, i),
          h
        );
      })(g.a),
      sG = null,
      sz = (e.default = sq);
  },
  69: function (t, e, n) {
    "use strict";
    n(24), n(9), n(25), n(22), n(23), n(48), n(40), n(47), n(45), n(151), n(27);
    var i = n(1),
      r = n.n(i),
      o = n(39),
      a = {
        UserAction: {
          VIEW_PRODUCT: "view_product",
          QUICK_VIEW: "quick_view",
          ADD_TO_CART: "add_to_cart",
          BUY_NOW: "buy_now",
        },
        Action: { FILTER: "filter", SEARCH: "search", SUGGEST: "suggest" },
      },
      s = n(3),
      l = n(5),
      c = n(0),
      u = n(2),
      p = n(4),
      f = "boostPFSAnalytics",
      h = "",
      d = "",
      g = null,
      y = function () {
        u.a.getSettingValue("search.enableSuggestion") &&
          r()("." + p.a.searchSuggestionWrapper).length > 0 &&
          r()("." + p.a.searchSuggestionWrapper).each(function (t, e) {
            e.addEventListener("click", $, !0),
              document.addEventListener("keydown", $, !0);
          });
      },
      m = function () {
        l.a.trackingProduct &&
          r()(l.a.products).length > 0 &&
          document.addEventListener("click", S, !0);
      },
      v = function () {
        var t = O(f);
        Array.isArray(t) &&
          (t.forEach(function (t) {
            w(t), t.pid == boostPFSAppConfig.general.product_id && (g = t);
          }),
          c.a.isProductPage() &&
            (l.a.trackingAddToCart &&
              r()(l.a.trackingAddToCart).length > 0 &&
              document.addEventListener("click", T, !0),
            l.a.trackingBuyNow &&
              r()(l.a.trackingBuyNow).length > 0 &&
              document.addEventListener("click", P, !0)));
      },
      b = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (t) {
            var e = (16 * Math.random()) | 0;
            return ("x" == t ? e : (3 & e) | 8).toString(16);
          }
        );
      },
      S = function (t) {
        if (t && t.target) {
          var e = r()(t.target),
            n = c.a.isSearchPage() ? a.Action.SEARCH : a.Action.FILTER,
            i = a.UserAction.VIEW_PRODUCT;
          l.a.trackingQuickView &&
            e.closest(l.a.trackingQuickView).length > 0 &&
            (i = a.UserAction.QUICK_VIEW),
            l.a.trackingAddToCart &&
              e.closest(l.a.trackingAddToCart).length > 0 &&
              (i = a.UserAction.ADD_TO_CART),
            l.a.trackingBuyNow &&
              e.closest(l.a.trackingBuyNow).length > 0 &&
              (i = a.UserAction.BUY_NOW);
          var o = "",
            s = e.closest(l.a.trackingProduct);
          if (
            (s.length > 0
              ? (o = s.attr("data-id"))
              : g &&
                ((i != a.UserAction.ADD_TO_CART && i != a.UserAction.BUY_NOW) ||
                  (o = g.pid)),
            o)
          ) {
            var u = _(o, i, n);
            k(u), w(u), (g = i == a.UserAction.QUICK_VIEW ? u : null);
          }
        }
      },
      $ = function (t) {
        if (t && t.target && ("keydown" != t.type || 13 == t.keyCode)) {
          var e = r()(t.target).closest(
            "." + p.a.searchSuggestionItem + "-product"
          );
          if (e) {
            var n = e.attr("data-id");
            if (n) {
              var i = _(n, a.UserAction.VIEW_PRODUCT, a.Action.SUGGEST);
              k(i);
            }
          }
        }
      },
      T = function (t) {
        if (
          t &&
          t.target &&
          r()(t.target).closest(l.a.trackingAddToCart).length > 0
        ) {
          var e = {
            tid: s.a.shopDomain,
            pid: boostPFSAppConfig.general.product_id.toString(),
            u: a.UserAction.ADD_TO_CART,
            ct: h,
          };
          k(e), w(e);
        }
      },
      P = function (t) {
        if (
          t &&
          t.target &&
          r()(t.target).closest(l.a.trackingBuyNow).length > 0
        ) {
          var e = {
            tid: s.a.shopDomain,
            pid: boostPFSAppConfig.general.product_id.toString(),
            u: a.UserAction.BUY_NOW,
          };
          k(e), w(e);
        }
      },
      _ = function (t, e, n) {
        var i = new Date(),
          r = h,
          o = e == a.UserAction.QUICK_VIEW ? a.UserAction.VIEW_PRODUCT : e,
          l = "";
        if (
          (n == a.Action.FILTER
            ? (l += "collection_scope=" + s.a.collectionId)
            : (l += "q=" + s.a.currentTerm),
          n == a.Action.FILTER || n == a.Action.SEARCH)
        ) {
          var c = Object.keys(s.a.queryParams).filter(function (t) {
            return t.startsWith(s.a.prefix);
          });
          c &&
            c.length > 0 &&
            c.forEach(function (t) {
              var e = s.a.queryParams[t];
              Array.isArray(e)
                ? e.forEach(function (e) {
                    l += "&" + t + "=" + encodeURIComponent(e);
                  })
                : (l += "&" + t + "=" + encodeURIComponent(e));
            });
        }
        return {
          tid: s.a.shopDomain,
          ct: r,
          pid: t,
          t: i.toISOString(),
          u: o,
          a: n,
          qs: l,
          r: document.referrer,
        };
      },
      k = function (t) {
        var e = O(f);
        Array.isArray(e) || (e = []);
        var n = e.filter(function (e) {
          return e.pid != t.productId;
        });
        n.push(t), C(f, n);
      },
      O = function (t) {
        try {
          return JSON.parse(localStorage.getItem(t));
        } catch (e) {
          return null;
        }
      },
      C = function (t, e) {
        try {
          null != e
            ? localStorage.setItem(t, JSON.stringify(e))
            : localStorage.setItem(t, "");
        } catch (n) {}
      },
      w = function (t, e) {
        if (e || t.ct) {
          t.sid = d;
          var n = new XMLHttpRequest();
          n.open("POST", o.a.getApiUrl("analytics")),
            n.setRequestHeader(
              "Content-Type",
              "application/json;charset=UTF-8"
            ),
            (n.onload = function () {
              var e, i;
              n.readyState > 3 &&
                200 == n.status &&
                ((e = t.pid),
                (i = O(f)),
                Array.isArray(i) &&
                  C(
                    f,
                    i.filter(function (t) {
                      return t.pid != e;
                    })
                  ));
            }),
            n.send(JSON.stringify(t));
        } else
          setTimeout(function () {
            var e, n;
            (e = t),
              (n = new XMLHttpRequest()).open("GET", "/cart.js"),
              (n.onload = function () {
                if (n.readyState > 3 && 200 == n.status) {
                  var t = JSON.parse(n.responseText),
                    i = t.item_count <= 0 ? "" : t.token;
                  (h = i), e && ((e.ct = i), w(e, !0));
                }
              }),
              n.send();
          }, 1e3);
      },
      I = {
        init: function () {
          window.XMLHttpRequest &&
            ((h = ""),
            (d = O("boostPFSSessionId")) ||
              ((d = b()), C("boostPFSSessionId", d)),
            y(),
            m(),
            v());
        },
        getSessionId: function () {
          return (
            d ||
            ((d = O("boostPFSSessionId")) ||
              ((d = b()), C("boostPFSSessionId", d)),
            d)
          );
        },
      };
    e.a = I;
  },
  7: function (t, e, n) {
    "use strict";
    var i = n(0),
      r = n(2),
      o = {
        productFilter: "Product filter",
        refine: "Refine By",
        refineMobile: "Refine By",
        refineMobileCollapse: "Hide Filter",
        refineDesktop: "Filter",
        refineDesktopCollapse: "Hide Filter",
        clear: "Clear",
        clearAll: "Clear All",
        apply: "Apply",
        applyAll: "Apply All",
        close: "Close",
        back: "Back",
        loadMore: "Load more {{ amountProduct }} Products",
        loadMoreTotal: "{{ from }} - {{ to }} of {{ total }} Products",
        loadPreviousPage: "Load Previous Page",
        searchOptions: "Search options",
        collectionAll: "All",
        viewMore: "View More",
        viewLess: "View Less",
        under: "Under",
        above: "Above",
        ratingStar: "Star",
        ratingStars: "Stars",
        ratingUp: "& Up",
        showResult: "Show Results",
        showLimit: "Show",
        sorting: "Sorting",
        sortingList: {
          "best-selling": "Best Selling",
          manual: "Featured",
          "price-ascending": "Lowest Price",
          "price-descending": "Highest Price",
          "title-ascending": "Alphabetically, A-Z",
          "title-descending": "Alphabetically, Z-A",
          "created-descending": "Date, New to Old",
          "created-ascending": "Date, Old to New",
          "published-descending": "Date, New to Old",
          "published-ascending": "Date, Old to New",
          "sale-descending": "% Off",
          "sale-ascending": "% Off, Low to High",
          relevance: "Relevance",
          "review-ratings-ascending": "Total reviews, Low to High",
          "review-ratings-descending": "Total reviews, High to Low",
        },
        listView: "List View",
        gridView: "Grid View",
        gridViewColumns: "Grid view {{ count }} Columns",
        inCollectionSearch: "Search for products in this collection",
        search: {
          generalTitle: "Search",
          resultHeader: 'Search Results for "{{ terms }}"',
          resultEmpty:
            "We are sorry! We couldn't find results for \"{{ terms }}\".{{ breakline }}But don't give up – check the spelling or try less specific search terms.",
          resultEmptyWithSuggestion:
            'Sorry, nothing found for "{{ terms }}". Check out these items instead?',
          resultNumber: 'Showing {{ count }} results for "{{ terms }}"',
          searchTotalResult: "Showing {{ count }} result",
          searchTotalResults: "Showing {{ count }} results",
          seeAllProducts: "See all products →",
          searchPanelCollection: "Collections",
          searchPanelPage: "Pages",
          searchPanelProduct: "Products",
        },
        suggestion: {
          instantSearchSuggestionsLabel: "Popular suggestions",
          instantSearchCollectionsLabel: "Collections",
          instantSearchProductsLabel: "Products",
          instantSearchPagesLabel: "Pages",
          viewAll: "View all {{ count }} products",
          suggestQuery: 'Showing {{ count }} results for "{{ terms }}".',
          didYouMean: "Did you mean: {{ terms }}",
          searchBoxPlaceholder: "Search",
          searchBoxOnclickRecentSearchLabel: "Recent searches",
          searchBoxOnclickSearchTermLabel: "Popular searches",
          searchBoxOnclickProductsLabel: "Trending products",
          noSearchResultSearchTermLabel: "Popular searches",
          noSearchResultProductsLabel: "Trending products",
        },
        error: {
          noFilterResult: "Sorry, no products matched your selection",
          noSearchResult: "Sorry, no products matched the keyword",
          noProducts: "No products found in this collection",
          noSuggestionProducts: 'Sorry, nothing found for "{{ terms }}".',
          noSuggestionResult: 'Sorry, nothing found for "{{ terms }}".',
        },
        action_list: {
          qvBtnLabel: "Quick View",
          qvAddToCartBtnLabel: "Add To Cart",
          qvSoldOutLabel: "Sold Out",
          qvSaleLabel: "Sale",
          qvQtyLeftLabel: "Hurry, there are only {{item}} item(s) left!",
          qvNotifyMeSuccessfullyLabel:
            "Thanks! We will notify you when this product becomes available!",
          qvNotifyMeErrorLabel: "Please provide a valid email address.",
          qvNotifyMeMessageLabel: "Notify me when {{item}} becomes available",
          qvNotifyMeFormBodyLabel:
            "Please notify me when {{item}} becomes available.",
          atcAvailableLabel: "Add To Cart",
          atcSelectOptionsLabel: "Select Options",
          atcSoldOutLabel: "Sold Out",
          atcAddingToCartBtnLabel: "Adding...",
          atcAddedToCartBtnLabel: "Added!",
          atcPopupAddedToCartLabel: "has been added to shopping cart",
          atcPopupSubtotalLabel: "Cart Subtotal",
          atcPopupCheckoutLabel: "Checkout",
          atcPopupGoToCartLabel: "Your Cart",
          atcPopupTotalItemsLabel: "items",
          atcPopupCrossSellHeadingLabel: "Frequently bought with",
          atcMiniCartCountItemLabel: "item",
          atcMiniCartCountItemLabelPlural: "items",
          atcMiniCartTotalItemsLabel: "Total Items",
          atcMiniCartSubtotalLabel: "Subtotal",
          atcMiniCartCheckoutLabel: "Checkout",
          atcMiniCartViewCartLabel: "View cart",
          atcMiniCartEmptyCartLabel: "Your Cart Is Currently Empty",
          atcMiniCartRemoveItemLabel: "Remove This Item",
          atcMiniCartShopingCartLabel: "Your cart",
        },
        mostPopular: { popularProductsHeading: "Popular products" },
        recentlyViewed: { recentProductHeading: "Recently viewed products" },
        ada: {
          searchAutoComplete:
            "When autocomplete results are available use up and down arrows to review and enter to select",
          toggleMultiLevel: "Expand/Collapse {{filterItem}}",
          filterOption: "Filter by {{filterOption}}",
          clearFilterOption: "Clear filter by {{filterOption}}",
          clearFilterItem: "Clear filter by {{filterOption}} {{filterItem}}",
          clearAllFilterItems: "Clear all filters",
          filterOptionTitle: "Filter by {{filterOption}}",
          minValue: "Min value",
          maxValue: "Max value",
          productCount: "Number of products: {{count}}",
          closeQuickViewSelectOption: "Close select option",
        },
        init: function () {
          var t = {};
          void 0 !== r.a.label && (t = i.a.mergeObject(o, r.a.label)),
            (o = t),
            i.a.iterateObject(o, i.a.stripHtml);
        },
      };
    e.a = o;
  },
  70: function (t, e, n) {
    "use strict";
    n(24), n(9), n(25);
    var i = n(1),
      r = n.n(i),
      o = n(2),
      a = n(5),
      s = n(20),
      l = (n(0), n(7)),
      c = null,
      u = {
        getNoResultBlockSettings: function () {
          var t = u.getNoResultData().no_result_suggestions,
            e = {
              type: s.a.ResultType.NO_RESULT_SUGGESTIONS,
              label: l.a.suggestion.noSearchResultSearchTermLabel,
              status: o.a.getSettingValue(
                "search.suggestionNoResult.search_terms.status"
              )
                ? "active"
                : "inactive",
              number: t && t.length ? t.length : 0,
            },
            n = o.a.getSettingValue("search.suggestionNoResult.products.data");
          return [
            e,
            {
              type: s.a.ResultType.NO_RESULT_PRODUCTS,
              label: l.a.suggestion.noSearchResultProductsLabel,
              status: o.a.getSettingValue(
                "search.suggestionNoResult.products.status"
              )
                ? "active"
                : "inactive",
              number: n && n.length ? n.length : 0,
            },
          ];
        },
        getNoResultData: function () {
          if (c) return c;
          var t = {},
            e = r()(a.a.searchNoResultJson);
          if (e.length)
            try {
              t = JSON.parse(e.html());
            } catch (n) {
              console.log("Failed to parse notFoundJson.");
            }
          var i = { isAllEmpty: !0 },
            l = o.a.getSettingValue(
              "search.suggestionNoResult.search_terms.status"
            );
          t.search_terms &&
            l &&
            ((i[s.a.ResultType.NO_RESULT_SUGGESTIONS] = t.search_terms),
            t.search_terms.length > 0 && (i.isAllEmpty = !1));
          var p = o.a.getSettingValue(
            "search.suggestionNoResult.products.status"
          );
          return (
            t.products &&
              p &&
              ((i[s.a.ResultType.NO_RESULT_PRODUCTS] = u.prepareProducts(
                t.products
              )),
              t.products.length > 0 && (i.isAllEmpty = !1)),
            (c = i)
          );
        },
        prepareProducts: function (t) {
          return Array.isArray(t)
            ? (t.forEach(function (t) {
                var e = [];
                Array.isArray(t.media) || (t.media = []),
                  t.media.forEach(function (t) {
                    "image" == t.media_type &&
                      e.push({
                        id: t.id,
                        position: t.position,
                        src: t.src,
                        width: t.width,
                        height: t.height,
                      });
                  }),
                  (t.images_info = e),
                  (t.price /= 100),
                  (t.price_min /= 100),
                  (t.price_max /= 100),
                  (t.compare_at_price /= 100),
                  (t.compare_at_price_min /= 100),
                  (t.compare_at_price_max /= 100);
              }),
              t)
            : [];
        },
        noResultData: c,
      };
    e.a = u;
  },
  75: function (t, e, n) {
    "use strict";
    var i = n(2),
      r = n(0),
      o = n(85),
      a = n(129),
      s = n(76),
      l = n(61),
      c = {
        InstantSearchResult: o.a,
        InstantSearchResultStyle2: a.a,
        InstantSearchStyle3: s.a,
        InstantSearchMobile: l.a,
      },
      u = {
        instantSearchResult: function (t, e) {
          var n = i.a.getSettingValue("search.suggestionStyle"),
            o = "InstantSearchResult" + r.a.capitalize(n, !0, !0);
          return (
            (c[o] && c[o].isActive()) || (o = "InstantSearchResult"),
            new c[o](t, e)
          );
        },
        instantSearchMobile: function () {
          var t = i.a.getSettingValue("search.suggestionMobileStyle");
          "style1" == t && (t = "");
          var e = "InstantSearchMobile" + r.a.capitalize(t, !0, !0);
          return (
            (c[e] && c[e].isActive()) || (e = "InstantSearchMobile"), new c[e]()
          );
        },
        instantSearchStyle3: function () {
          var t = "InstantSearchStyle3";
          return (
            (c[t] && c[t].isActive()) || (t = "InstantSearchStyle3"), new c[t]()
          );
        },
      };
    e.a = u;
  },
  76: function (t, e, n) {
    "use strict";
    n(21),
      n(22),
      n(23),
      n(17),
      n(18),
      n(9),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = (n(10), n(42)),
      a = n(4),
      s = n(2),
      l = n(7),
      c = n(5),
      u = n(0),
      p = n(3);
    function f(t) {
      return (f =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function h(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function d(t, e) {
      return (d =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function g(t, e) {
      return e && ("object" === f(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function y(t) {
      return (y = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var m = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && d(t, e);
      })(m, t);
      var e,
        n,
        i,
        f = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = y(t);
            if (e()) {
              var r = y(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return g(this, n);
          };
        })(m);
      function m() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, m),
          ((t = f.call(this)).data = ""),
          (t.isBoundEvents = !1),
          (t.isOpen = !1),
          (t.inputStyle3Id = c.a.searchBoxStyle3.substr(1)),
          (t.searchBox = null),
          (t.selector = {
            searchInput: c.a.searchBoxStyle3,
            clearButton: "." + a.a.searchSuggestionBtnClearStyle3,
            closebutton: "." + a.a.searchSuggestionBtnCloseStyle3,
            submitButton: "." + a.a.searchSuggestionBtnSubmitStyle3,
            topPanel: "." + a.a.searchSuggestion + "-style3-top-panel",
            overlay: "." + a.a.searchSuggestion + "-style3-overlay",
            searchInputs:
              'input[name="' + s.a.getSettingValue("search.termKey") + '"]',
          }),
          t
        );
      }
      return (
        (e = m),
        (i = [
          {
            key: "tempType",
            get: function () {
              return { SEARCH_BTN: "search_btn", DEFAULT: "default" };
            },
          },
          {
            key: "isActive",
            value: function () {
              return !0;
            },
          },
        ]),
        (n = [
          {
            key: "getTemplate",
            value: function (t) {
              return t === m.tempType.SEARCH_BTN
                ? '\n					<button class="{{class.searchSuggestionBtnSubmitStyle3}}" type="submit"><span>Submit</span></button>\n				'.trim()
                : '\n					<div class="{{class.searchSuggestion}}-style3-overlay"></div>\n					<div class="{{class.searchSuggestion}}-style3-top-panel">\n						<form action="/search" method="get">\n            				<div class="{{class.searchSuggestion}}-style3-top-panel-input-group">\n            					{{btnSearch}}\n								<input role="textbox" type="text" name="{{searchTermKey}}" placeholder="{{searchBoxPlaceholder}}" id="{{searchId}}" />\n            					<button type="button" class="{{class.searchSuggestionBtnClearStyle3}}"><span>X</span></button>\n            				</div>\n            				<button type="button" class="{{class.searchSuggestionBtnCloseStyle3}}"><span><-</span></button>\n						</form>\n					</div>\n					'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t = "";
              return (
                s.a.getSettingValue("search.showSearchBtnStyle3") &&
                  (t = this.getTemplate(m.tempType.SEARCH_BTN)),
                this.getTemplate()
                  .replace(/{{btnSearch}}/g, t)
                  .replace(
                    /{{searchTermKey}}/g,
                    s.a.getSettingValue("search.termKey")
                  )
                  .replace(
                    /{{searchBoxPlaceholder}}/g,
                    l.a.suggestion.searchBoxPlaceholder
                  )
                  .replace(/{{searchId}}/g, this.inputStyle3Id)
                  .replace(/{{class.searchSuggestion}}/g, a.a.searchSuggestion)
                  .replace(
                    /{{class.searchSuggestionBtnSubmitStyle3}}/g,
                    a.a.searchSuggestionBtnSubmitStyle3
                  )
                  .replace(
                    /{{class.searchSuggestionBtnCloseStyle3}}/g,
                    a.a.searchSuggestionBtnCloseStyle3
                  )
                  .replace(
                    /{{class.searchSuggestionBtnClearStyle3}}/g,
                    a.a.searchSuggestionBtnClearStyle3
                  )
              );
            },
          },
          {
            key: "render",
            value: function () {
              r()("body").append(this.compileTemplate());
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvents;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              (this.$searchInput = r()(this.selector.searchInput)),
                (this.$clearButtonElement = r()(this.selector.clearButton)),
                (this.$closebuttonElement = r()(this.selector.closebutton)),
                (this.$submitButtonElement = r()(this.selector.submitButton)),
                (this.$topPanelElement = r()(this.selector.topPanel)),
                (this.$overlayElement = r()(this.selector.overlay)),
                (this.searchBox = new o.a(
                  this.inputStyle3Id,
                  this.$searchInput
                )),
                this.searchBox.refresh(),
                this.$closebuttonElement.on(
                  "click",
                  this.closeInstantSearchStyle3.bind(this, !0)
                ),
                this.$clearButtonElement.on(
                  "click",
                  this.clearInstantSearchStyle3.bind(this)
                ),
                (this.$searchInputs = r()(this.selector.searchInputs)),
                this.$searchInputs
                  .on("click", this._onClickSearchBox.bind(this))
                  .on("focus", this._onFocusSearchBox.bind(this))
                  .on("keyup", this._onTypeSearchBoxEvent.bind(this)),
                this.$searchInput.on(
                  "focus",
                  this._onFocusStyle3Input.bind(this)
                ),
                this.$searchInput.on(
                  "keyup",
                  this._onKeyupSearchBox.bind(this)
                ),
                (this.$targetInput = null),
                (this.isBoundEvents = !0);
            },
          },
          {
            key: "_onClickSearchBox",
            value: function (t) {
              if (u.a.InstantSearch.isStyle3()) {
                var e =
                  this.$targetInput && u.a.stripHtml(this.$targetInput.val());
                e && this.$searchInputs.val(e),
                  this.$searchInput &&
                    (this.$searchInput.length > 0 &&
                    "" != u.a.stripHtml(this.$searchInput.val())
                      ? this.openSuggestionStyle3()
                      : this.searchBox &&
                        this.searchBox.searchAutoComplete &&
                        this.searchBox.searchAutoComplete
                          .enableOnClickSearchBox &&
                        (this.openSuggestionStyle3(),
                        this.searchBox.searchAutoComplete.showOnClickSuggestion()));
              }
            },
          },
          {
            key: "_onKeyupSearchBox",
            value: function (t) {
              var e;
              this.$targetInput.val(
                u.a.stripHtml(
                  null == t || null === (e = t.currentTarget) || void 0 === e
                    ? void 0
                    : e.value
                )
              );
            },
          },
          {
            key: "_onFocusSearchBox",
            value: function (t) {
              if (u.a.InstantSearch.isStyle3()) {
                var e = t && t.target ? t.target.id : "",
                  n = this.$searchInput ? this.$searchInput.attr("id") : "";
                "" != e &&
                  "" != n &&
                  e != n &&
                  ((this.$targetInput = r()("#" + e)),
                  this.showSearchBoxStyle3(),
                  this.$searchInput.trigger("click"));
              }
            },
          },
          {
            key: "_onFocusStyle3Input",
            value: function (t) {
              var e = this;
              this.isReFocus
                ? (t &&
                    (t.stopImmediatePropagation(),
                    t.stopPropagation(),
                    t.preventDefault()),
                  (this.isReFocus = !1),
                  this._onFocusSearchBox(t))
                : setTimeout(function () {
                    (document.activeElement && document.activeElement.id
                      ? "#" + document.activeElement.id
                      : "") != c.a.searchBoxStyle3 &&
                      ((e.isReFocus = !0), e.$searchInput.focus());
                  }, 0);
            },
          },
          {
            key: "_onTypeSearchBoxEvent",
            value: function (t) {
              u.a.InstantSearch.isStyle3() &&
                (this.searchBox.instantSearchResult.$wrapper.show(),
                "" == u.a.stripHtml(t.target.value)
                  ? (this.searchBox &&
                    this.searchBox.searchAutoComplete &&
                    this.searchBox.searchAutoComplete.enableOnClickSearchBox
                      ? this.searchBox.searchAutoComplete.showOnClickSuggestion()
                      : this.closeInstantSearchStyle3(),
                    this.$clearButtonElement.hide())
                  : this.$clearButtonElement.show());
            },
          },
          {
            key: "showSearchBoxStyle3",
            value: function () {
              var t = this;
              (this.isOpen = !0),
                this.onClickOutsideSuggestionStyle3Event(),
                this.scrollSuggestionStyle3Event(),
                "" == u.a.stripHtml(this.$searchInput.val())
                  ? this.$clearButtonElement.hide()
                  : this.$clearButtonElement.show(),
                this.$searchInput.is(":focus") ||
                  (this.$topPanelElement.show(),
                  this.$overlayElement.show(),
                  r()('[tabindex="-1"]')
                    .removeAttr("tabindex")
                    .addClass(a.a.searchSuggestionNoTabIndex),
                  u.a.InstantSearch.isStyle3() &&
                    r()("[data-open=true]").length > 0 &&
                    r()("[data-open=true]").attr("data-open", !1),
                  setTimeout(function () {
                    t.$searchInput.focus();
                  }, 100),
                  this.afterShowSearchBoxStyle3());
            },
          },
          {
            key: "closeInstantSearchStyle3",
            value: function (t) {
              r()(
                ".js-drawer-close, .search-modal__close-button, .fancybox-close-small, .drawer__close > button"
              ).trigger("click"),
                this.searchBox.instantSearchResult.$wrapper.hide(),
                (t = void 0 !== t && t) &&
                  (this.$topPanelElement.hide(), this.$overlayElement.hide()),
                this._setValueAllSearchBoxes(),
                r()("." + a.a.searchSuggestionNoTabIndex).attr("tabindex", -1),
                r()("body").hasClass(a.a.searchSuggestionStyle3Open) &&
                  r()("body").removeClass(a.a.searchSuggestionStyle3Open),
                this.afterCloseInstantSearchStyle3(t);
            },
          },
          {
            key: "clearInstantSearchStyle3",
            value: function () {
              this.$clearButtonElement.hide(),
                (p.a.currentTerm = ""),
                this._setValueAllSearchBoxes(""),
                this.searchBox &&
                this.searchBox.searchAutoComplete &&
                this.searchBox.searchAutoComplete.enableOnClickSearchBox
                  ? this.searchBox.searchAutoComplete.showOnClickSuggestion()
                  : this.closeInstantSearchStyle3(),
                this.$searchInput.focus();
            },
          },
          { key: "afterCloseInstantSearchStyle3", value: function (t) {} },
          {
            key: "_setValueAllSearchBoxes",
            value: function (t) {
              void 0 === t && (t = u.a.stripHtml(p.a.currentTerm)),
                (p.a.currentTerm = u.a.stripHtml(t)),
                this.$searchInputs.val(u.a.stripHtml(t));
            },
          },
          {
            key: "onClickOutsideSuggestionStyle3Event",
            value: function () {
              var t = this;
              r()(document).on("touchstart", function (e) {
                if (e.target) {
                  var n = r()(e.target),
                    i =
                      n.closest(
                        "." + a.a.searchSuggestion + "-style3-top-panel"
                      ).length > 0,
                    o =
                      n.closest("." + a.a.searchSuggestionWrapper + " div")
                        .length > 0;
                  i || o || t.closeInstantSearchStyle3(!0);
                }
              });
            },
          },
          {
            key: "scrollSuggestionStyle3Event",
            value: function () {
              var t = this;
              r()(document).on("touchmove", function (e) {
                t.$searchInput.is(":focus") && t.$searchInput.blur();
              });
            },
          },
          { key: "afterShowSearchBoxStyle3", value: function () {} },
          {
            key: "openSuggestionStyle3",
            value: function () {
              this.beforeOpenSuggestionStyle3(),
                r()("body").hasClass(a.a.searchSuggestionStyle3Open) ||
                  r()("body").addClass(a.a.searchSuggestionStyle3Open),
                this.showSearchBoxStyle3(),
                this.searchBox.instantSearchResult.$wrapper.show(),
                this.afterOpenSuggestionStyle3();
            },
          },
          { key: "beforeOpenSuggestionStyle3", value: function () {} },
          { key: "afterOpenSuggestionStyle3", value: function () {} },
        ]),
        h(e.prototype, n),
        i && h(e, i),
        m
      );
    })(n(61).a);
    e.a = m;
  },
  8: function (t, e, n) {
    "use strict";
    n.r(e),
      n(24),
      n(9),
      n(25),
      n(47),
      n(40),
      n(30),
      n(34),
      n(41),
      n(22),
      n(38),
      n(98),
      n(66),
      n(68),
      n(119),
      n(45),
      n(27),
      n(182),
      n(82),
      n(54),
      n(11),
      n(13),
      n(12),
      n(67),
      n(149),
      n(48),
      n(208),
      n(23),
      n(151),
      n(16),
      n(14),
      n(15),
      n(183);
    var i = n(1),
      r = n.n(i),
      o = n(3),
      a = n(2),
      s = n(0),
      l = n(39),
      c = n(36),
      u = n(62),
      p = n(6),
      f = n(69);
    function h(t) {
      return (
        (function (t) {
          if (Array.isArray(t)) {
            for (var e = 0, n = Array(t.length); e < t.length; e++) n[e] = t[e];
            return n;
          }
        })(t) ||
        (function (t) {
          if (
            Symbol.iterator in Object(t) ||
            "[object Arguments]" === Object.prototype.toString.call(t)
          )
            return Array.from(t);
        })(t) ||
        (function () {
          throw TypeError("Invalid attempt to spread non-iterable instance");
        })()
      );
    }
    var d = null,
      g = { eventType: "init", eventInfo: {} },
      y = function (t, e, n) {
        ($(t),
        b &&
          b.forEach(function (e) {
            "function" == typeof e && e(t);
          }),
        "function" == typeof C.beforeCall && C.beforeCall(t, g.eventInfo),
        "function" != typeof C.beforeCallAsync)
          ? m(t, e, n)
          : C.beforeCallAsync(
              function () {
                m(t, e, n);
              },
              t,
              g.eventInfo
            );
      },
      m = function t(e, n, i, a) {
        (a = void 0 !== a ? a : 0),
          (d = n),
          (o.a.queryParams.callback = "BoostPFSFilterCallback"),
          (o.a.queryParams.event_type = e);
        var c,
          u = l.a.getApiUrl("filter"),
          p = s.a.isCollectionPage() && o.a.queryParams.q;
        (s.a.isSearchPage() || p) &&
          ((u = l.a.getApiUrl("search")),
          o.a.hasOwnProperty("searchDisplay") &&
            o.a.searchDisplay &&
            "products" !== o.a.searchDisplay &&
            (u += "/" + o.a.searchDisplay));
        var f = document.createElement("script");
        f.type = "text/javascript";
        var h = new Date().getTime(),
          g = JSON.parse(JSON.stringify(o.a.queryParams));
        (o.a.queryParams = g),
          (f.src = u + "?t=" + h + "&" + r.a.param(o.a.queryParams)),
          (f.id = "boost-pfs-filter-script"),
          (f.async = !0),
          f.addEventListener("error", function (e) {
            "function" == typeof document.getElementById(f.id).remove
              ? document.getElementById(f.id).remove()
              : (document.getElementById(f.id).outerHTML = ""),
              a < 2
                ? (a++,
                  c && clearTimeout(c),
                  (c = setTimeout(t("resend", n, i, a), 2e3)))
                : "function" == typeof i && i();
          }),
          document.getElementsByTagName("head")[0].appendChild(f),
          f.addEventListener("load", function (t) {
            "function" == typeof document.getElementById(f.id).remove
              ? document.getElementById(f.id).remove()
              : (document.getElementById(f.id).outerHTML = "");
          });
      },
      v = function (t) {
        S &&
          S.forEach(function (e) {
            "function" == typeof e && e(t, g.eventType, g.eventInfo);
          }),
          "function" == typeof d && d(t, g.eventType, g.eventInfo);
      },
      b = [],
      S = [],
      $ = function (t) {
        var e = s.a.mergeObject({}, o.a.queryParams);
        (e = P(e, t)),
          (e = _(e, t)),
          (e = l.a.setApiLocaleParams(e)),
          s.a.isEnableShopifyMultipleCurrencies() &&
            (s.a.isConvertCurrenciesOnFrontEnd()
              ? ((e = T(e, t)).hasOwnProperty("currency") && delete e.currency,
                e.hasOwnProperty("country") && delete e.country)
              : (e = l.a.setShopifyMultiCurrencyParams(e))),
          (e.sid = f.a.getSessionId()),
          (o.a.queryParams = e);
      },
      T = function (t, e) {
        var n = Object.keys(t);
        return (
          (n = n.filter(function (t) {
            return (
              (0 == t.indexOf("pf_p_") || 0 == t.indexOf("pf_vp_")) &&
              !t.includes("_exclude_from_value")
            );
          })),
          (o.a.activeCurrencyPrices = []),
          n.length &&
            n.forEach(function (e) {
              var n = [];
              Array.isArray(t[e]) &&
                t[e].forEach(function (t) {
                  var e = t.split(":");
                  (e = e.map(function (t, e) {
                    var n = 0 == e;
                    return 0 == t.length
                      ? ""
                      : s.a.revertPriceToDefaultCurrency(t, n);
                  })),
                    n.push(e.join(":"));
                }),
                (o.a.activeCurrencyPrices[e] = t[e]),
                (t[e] = n);
            }),
          t
        );
      },
      P = function (t, e) {
        var n = c.a.getHistoryState(),
          i = 0;
        "history" == e
          ? (i =
              n && n.param && n.param.hasOwnProperty("collection_scope")
                ? parseInt(n.param.collection_scope)
                : parseInt(boostPFSConfig.general.collection_id))
          : null != o.a.collectionId
          ? (i = parseInt(o.a.collectionId))
          : boostPFSConfig.general.collection_id
          ? (i = parseInt(boostPFSConfig.general.collection_id))
          : s.a.isCollectionPage() ||
            s.a.isSearchPage() ||
            (i = a.a.getSettingValue("general.filterEverywhereCollectionId")),
          (o.a.collectionId = i),
          (t.collection_scope = i);
        var r = null;
        "history" == e
          ? (r =
              n && n.param && n.param.tag
                ? n.param.tag
                : boostPFSConfig.general.collection_tags)
          : o.a.collectionTags
          ? (r = o.a.collectionTags)
          : boostPFSConfig.general.collectionTags &&
            (r = boostPFSConfig.general.collectionTags),
          (o.a.collectionTags = r),
          (t.tag = r),
          a.a.getSettingValue("general.loadProductFromLiquid") &&
            "sync" ==
              a.a.getSettingValue("general.loadProductFromLiquidType") &&
            a.a.getSettingValue("general.theme_id") &&
            (t.theme_id = a.a.getSettingValue("general.theme_id")),
          1 == a.a.getSettingValue("general.availableAfterFiltering")
            ? ((t.product_available =
                !0 === s.a.checkExistFilterOptionParam() ||
                o.a.productAvailable),
              (t.variant_available =
                !0 === s.a.checkExistFilterOptionParam() ||
                o.a.variantAvailable))
            : ((t.product_available = o.a.productAvailable),
              (t.variant_available = o.a.variantAvailable));
        var l = Object.keys(t).some(function (t) {
            return (
              t.startsWith(o.a.prefix + "_l_") ||
              t.startsWith(o.a.prefix + "_vl_")
            );
          }),
          u = Object.keys(t).find(function (t) {
            return t.endsWith("ibsl");
          });
        return (
          l && (o.a.inventoryBaseSelectedLocations || u)
            ? (t.inventory_base_selected_locations = !0)
            : delete t.inventory_base_selected_locations,
          a.a.getSettingValue("general.showOutOfStockOption") &&
            (t.zero_options = !0),
          (t.build_filter_tree = !(
            void 0 !== e && o.a.imutableFilterTree.indexOf(e) > -1
          )),
          (t.check_cache = !(
            !1 !== s.a.checkExistFilterOptionParam() ||
            1 != t.page ||
            t.sort != o.a.defaultSorting ||
            t.limit != a.a.getSettingValue("general.limit") ||
            s.a.isSearchPage() ||
            s.a.isVendorPage() ||
            s.a.isTypePage() ||
            t.q
          )),
          s.a.isCollectionPage() && t.q && (t.incollection_search = !0),
          a.a.getSettingValue("general.showVariantsAsProduct") &&
            (t.variants_as_products = !0),
          "" != a.a.getSettingValue("general.priceMode") &&
            (t.price_mode = a.a.getSettingValue("general.priceMode")),
          "" != a.a.getSettingValue("general.tagMode") &&
            (t.tag_mode = a.a.getSettingValue("general.tagMode")),
          a.a.getSettingValue("general.sortingAvailableFirst") &&
            (t.sort_first = "available"),
          s.a.isVendorPage() &&
            t.hasOwnProperty("q") &&
            ((t[a.a.getSettingValue("general.vendorParam")] = [t.q]),
            delete t.q),
          s.a.isTypePage() &&
            t.hasOwnProperty("q") &&
            ((t[a.a.getSettingValue("general.typeParam")] = [t.q]), delete t.q),
          t
        );
      },
      _ = function (t, e) {
        if (s.a.isSearchPage()) {
          (t.q = s.a.stripHtml(s.a.getSearchTerm())),
            "q" != o.a.searchTermKey && delete t[o.a.searchTermKey];
          var n = a.a.getSettingValue("search.enableFuzzy");
          !0 !== n && (t.fuzzy = n),
            !1 !== a.a.getSettingValue("search.reduceMinMatch") &&
              (t.reduce_min_match = a.a.getSettingValue(
                "search.reduceMinMatch"
              )),
            a.a.getSettingValue("search.fullMinMatch") &&
              (t.full_min_match = !0),
            a.a.getSettingValue("general.sortingAvailableFirst") &&
              (t.sort_first = "available"),
            a.a.getSettingValue("search.enablePlusCharacterSearch") &&
              (t.enable_plus_character_search = !0);
        }
        return t;
      },
      k = function (t) {
        var e = "";
        e = t
          ? "string" == typeof t && 2 == t.split("?").length
            ? t.split("?")[1]
            : ""
          : s.a.getWindowLocation().search;
        var n = new URLSearchParams(e),
          i = {},
          r =
            s.a.isCollectionPage() || s.a.isSearchPage()
              ? a.a.getSettingValue("general.urlScheme")
              : 0;
        return (
          n.forEach(function (t, e) {
            var n = c.a.longParamMap.get(e);
            n || (n = e);
            var l =
                o.a.imutableFilterTree.includes(n) ||
                n == o.a.searchTermKey ||
                (n.startsWith(o.a.prefix) && n.includes("_and_condition")) ||
                (n.startsWith(o.a.prefix) &&
                  n.includes("_show_exact_rating")) ||
                (n.startsWith(o.a.prefix) && n.includes("_exclude_from_value")),
              u = n.startsWith(o.a.prefix);
            if (l) (i[n] = t), (o.a.hasFilterOptionParam = !0);
            else if (u) {
              var f = n.startsWith(o.a.prefix + "_c_"),
                h = n.startsWith(o.a.prefix + "_ct_"),
                d = RegExp(o.a.prefix + "_v?li_[a-z_]+?_ibsl$").test(n);
              if (f) {
                if (s.a.isCollectionPage()) return;
                i.collection_scope = t;
              } else if (h) {
                var g = a.a.getSettingValue(
                  "general.multiLevelCollectionSelectType"
                );
                (i.tag_mode = g == p.a.SelectType.MULTIPLE ? "2" : "1"),
                  i.hasOwnProperty("tag") ? i.tag.push(t) : (i.tag = [t]);
              } else if (d)
                return (
                  (i.inventory_base_selected_locations = t),
                  (o.a.inventoryBaseSelectedLocations = t),
                  void delete i[n]
                );
              2 === r
                ? (i[n] = t.split(","))
                : i.hasOwnProperty(n)
                ? i[n].push(t)
                : (i[n] = [t]),
                f
                  ? (o.a.collectionId = i.collection_scope)
                  : h && (o.a.collectionTags = i.tag),
                (o.a.hasFilterOptionParam = !0);
            }
          }),
          i
        );
      },
      O = function (t) {
        (t._ = o.a.prefix),
          (t.shop = t.hasOwnProperty("shop") ? t.shop : o.a.shopDomain),
          (t.page = t.hasOwnProperty("page") ? parseInt(t.page) : 1);
        var e = a.a.getSettingValue("general.limit");
        (e <= 0 || e > 70) && (e = 24),
          "default" == a.a.getSettingValue("general.paginationType") ||
          a.a.getSettingValue("general.paginationTypeAdvanced")
            ? (t.limit = t.hasOwnProperty("limit") ? t.limit : e)
            : (t.limit = (t.hasOwnProperty("limit") ? t.limit : e) * t.page);
        var n = s.a.getDefaultSorting();
        "" != n
          ? (o.a.defaultSorting = n)
          : s.a.isCollectionPage() ||
            (o.a.defaultSorting = a.a.getSettingValue(
              "general.filterEverywhereDefaultSorting"
            )),
          (t.sort = t.hasOwnProperty("sort") ? t.sort : o.a.defaultSorting),
          (t.display = t.hasOwnProperty("display")
            ? t.display
            : a.a.getSettingValue("general.defaultDisplay")),
          (t = l.a.setShopifyMultiCurrencyParams(t));
        var i = a.a.getSettingValue("general.location");
        return i && "string" == typeof i && (t.location = i), t;
      },
      C = {
        BoostPFSFilterCallback: function (t) {
          C.setDefaultValueForExcludedFields(t),
            "function" == typeof C.afterCall &&
              C.afterCall(t, g.eventType, g.eventInfo),
            "function" != typeof C.afterCallAsync
              ? v(t)
              : C.afterCallAsync(t, v, g.eventType, g.eventInfo);
        },
        getFilterData: y,
        updateParamsFromUrl: function (t) {
          var e,
            n,
            i = k(t);
          (i = O(i)),
            s.a.isEnableShopifyMultipleCurrencies() &&
              (i = s.a.isConvertCurrenciesOnFrontEnd()
                ? ((n = (n = Object.keys((e = i))).filter(function (t) {
                    return (
                      (0 == t.indexOf("pf_p_") || 0 == t.indexOf("pf_vp_")) &&
                      !t.includes("_exclude_from_value")
                    );
                  })).length &&
                    n.forEach(function (t) {
                      var n = [];
                      Array.isArray(e[t]) &&
                        e[t].forEach(function (t) {
                          var e = t.split(":");
                          (e = e.map(function (t, e) {
                            return 0 == t.length
                              ? ""
                              : s.a.convertPriceBasedOnActiveCurrency(t);
                          })),
                            n.push(e.join(":"));
                        }),
                        (e[t] = n);
                    }),
                  e)
                : l.a.setShopifyMultiCurrencyParams(i)),
            (o.a.queryParams = i);
        },
        setParam: function (t, e) {
          null == e || (Array.isArray(e) && 0 == e.length)
            ? delete o.a.queryParams[t]
            : Array.isArray(e)
            ? (o.a.queryParams[t] = h(new Set(e)))
            : (o.a.queryParams[t] = e);
          var n = t.startsWith(o.a.prefix + "_c_"),
            i = t.startsWith(o.a.prefix + "_ct_"),
            r = RegExp(o.a.prefix + "_v?li_[a-z_]+?_ibsl$").test(t),
            a = o.a.queryParams[t];
          if (
            (n || "collection_scope" == t) &&
            ((o.a.queryParams.collection_scope = a), (o.a.collectionId = a), !a)
          ) {
            var s = t.replace(o.a.prefix + "_c_", o.a.prefix + "_ct_");
            delete o.a.queryParams[s],
              (o.a.queryParams.tag = null),
              (o.a.collectionTags = null);
          }
          i && ((o.a.queryParams.tag = a), (o.a.collectionTags = a)),
            r && (o.a.inventoryBaseSelectedLocations = a);
        },
        setDefaultValueForExcludedFields: function (t) {
          if (Array.isArray(t.products)) {
            var e = new Date().toISOString();
            t.products.forEach(function (t) {
              t.hasOwnProperty("variants") || (t.variants = []),
                t.hasOwnProperty("images_info") || (t.images_info = []),
                t.hasOwnProperty("collections") || (t.collections = []),
                t.hasOwnProperty("tags") || (t.tags = []),
                t.hasOwnProperty("skus") || (t.skus = []),
                t.hasOwnProperty("options_with_values") ||
                  (t.options_with_values = []),
                t.hasOwnProperty("barcodes") || (t.barcodes = []),
                t.hasOwnProperty("created_at") || (t.created_at = e),
                t.hasOwnProperty("updated_at") || (t.updated_at = e),
                t.hasOwnProperty("published_at") || (t.published_at = e);
            });
          }
        },
        addBeforeApplyFilter: function (t) {
          b.push(t);
        },
        addAfterApplyFilter: function (t) {
          S.push(t);
        },
        applyFilter: function (t, e) {
          (g.eventType = t),
            (g.eventInfo = e),
            u.default.instance.filter.filterLoadingIcon.setShow(!0),
            y(
              t,
              u.default.instance.filter.setData.bind(u.default.instance.filter),
              u.default.instance.filter.errorFilterCallback.bind(
                u.default.instance.filter
              )
            ),
            c.a.updateAddressBar();
        },
        callFilterApi: m,
        callbackFilterApi: v,
        beforeCall: null,
        afterCall: null,
        beforeCallAsync: null,
        afterCallAsync: null,
      };
    e.default = C;
  },
  84: function (t, e, n) {
    "use strict";
    n.r(e),
      n(11),
      n(9),
      n(12),
      n(98),
      n(47),
      n(81),
      n(211),
      n(151),
      n(24),
      n(25);
    var i = n(1),
      r = n.n(i),
      o = n(3),
      a = n(2),
      s = n(0),
      l = n(39),
      c = n(69),
      u = n(42),
      p = function t(e, n, i, o) {
        (n = void 0 !== n ? n : 0), (o = void 0 !== o ? o : "");
        var a = h(e, i);
        a.q && ((e = a.q), delete a.q), "" != o && (a.prev_query = o);
        var s = document.createElement("script");
        (s.type = "text/javascript"),
          (s.src =
            l.a.getApiUrl("suggestion") + "?q=" + e + "&" + r.a.param(a)),
          (s.async = !0),
          s.addEventListener("error", function (e) {
            r()(this).remove(),
              n < 3 ? (n++, t(a.q, i, o, n)) : u.a.disableInstantSearch();
          }),
          document.getElementsByTagName("head")[0].appendChild(s),
          s.addEventListener("load", function (t) {
            r()(this).remove();
          });
      },
      f = function (t) {
        var e = o.a.suggestionCache;
        if (t.hasOwnProperty("prev_query")) {
          var n = t.prev_query;
          if (e.hasOwnProperty(n)) {
            var i,
              r = e[n],
              a = ["collections", "did_you_mean", "pages", "suggest_query"],
              l = a.length;
            for (i = 0; i < l; i++)
              t[a[i]] = s.a.getValueInObjectArray(a[i], r);
            (t.prev_total_product = s.a.getValueInObjectArray(
              "total_product",
              r
            )),
              (r[s.a.findIndexArray("products", r, "key")].values = t.products),
              (r[s.a.findIndexArray("suggestions", r, "key")].values =
                t.suggestions),
              r.push({ key: "local_cache", values: !0 }),
              r.push({ key: "suggest_total_product", values: t.total_product }),
              (o.a.suggestionCache[n] = r);
          }
        }
        window.suggestionCallback(
          Object.keys(t).map(function (e) {
            return { key: e, values: t[e] };
          })
        );
      },
      h = function (t, e) {
        var n = {};
        (n.shop = o.a.shopDomain),
          (n.t = new Date().getTime()),
          a.a.getSettingValue("search.enableDefaultResult") ||
            (n.enable_default_result = !1);
        var i = a.a.getSettingValue("search.enableFuzzy");
        !0 !== i && (n.fuzzy = i),
          a.a.getSettingValue("search.fullMinMatch") && (n.full_min_match = !0),
          !1 !== a.a.getSettingValue("search.reduceMinMatch") &&
            (n.reduce_min_match = a.a.getSettingValue("search.reduceMinMatch")),
          a.a.getSettingValue("general.showVariantsAsProduct") &&
            (n.variants_as_products = !0),
          a.a.getSettingValue("search.enablePlusCharacterSearch") &&
            (n.enable_plus_character_search = !0),
          1 == a.a.getSettingValue("search.productAvailable") &&
            (n.product_available = !0);
        var r,
          s = a.a.getSettingValue("search.suggestionBlocks"),
          u = s.length;
        for (r = 0; r < u; r++)
          n[s[r].type.slice(0, -1) + "_limit"] = s[r].number;
        n.dym_limit = a.a.getSettingValue("search.suggestionDymLimit");
        var p = a.a.getSettingValue("search.skipFields");
        p.length > 0 && (param.skipFields = p),
          (n.callback = "BoostPFSInstantSearchCallback"),
          (n.event_type = e);
        var f = "suggest_dym" == e ? ["products", "suggestions"] : [];
        return (
          (n.suggest_types = f),
          (n = l.a.setApiLocaleParams(n)),
          ((n = l.a.setShopifyMultiCurrencyParams(n)).sid = c.a.getSessionId()),
          Object.assign(n, o.a.instantSearchQueryParams)
        );
      },
      d = {
        BoostPFSInstantSearchCallback: function (t) {
          d.setDefaultValueForExcludedFields(t),
            "function" == typeof d.afterCall && d.afterCall(t),
            "function" != typeof d.afterCallAsync
              ? f(t)
              : d.afterCallAsync(t, f);
        },
        getSuggestionData: function (t, e, n, i) {
          ("function" == typeof d.beforeCall && d.beforeCall(t),
          "function" != typeof d.beforeCallAsync)
            ? p(t, 0, n, i)
            : d.beforeCallAsync(t, function () {
                p(t, 0, n, i);
              });
        },
        prepareSuggestionParams: h,
        setDefaultValueForExcludedFields: function (t) {
          if (Array.isArray(t.products)) {
            var e = new Date().toISOString();
            t.products.forEach(function (t) {
              t.hasOwnProperty("variants") || (t.variant = []),
                t.hasOwnProperty("images_info") || (t.images_info = []),
                t.hasOwnProperty("collections") || (t.collections = []),
                t.hasOwnProperty("tags") || (t.tags = []),
                t.hasOwnProperty("skus") || (t.skus = []),
                t.hasOwnProperty("options_with_values") ||
                  (t.options_with_values = []),
                t.hasOwnProperty("barcodes") || (t.barcodes = []),
                t.hasOwnProperty("created_at") || (t.created_at = e),
                t.hasOwnProperty("updated_at") || (t.updated_at = e),
                t.hasOwnProperty("published_at") || (t.published_at = e);
            });
          }
        },
        callInstantSearchApi: p,
        callbackInstantSearchApi: f,
        beforeCall: null,
        afterCall: null,
        beforeCallAsync: null,
        afterCallAsync: null,
      };
    e.default = d;
  },
  85: function (t, e, n) {
    "use strict";
    n(80),
      n(24),
      n(9),
      n(25),
      n(21),
      n(22),
      n(23),
      n(27),
      n(45),
      n(34),
      n(41),
      n(17),
      n(18),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(2),
      a = n(0),
      s = n(4),
      l = n(20),
      c = n(70),
      u = n(43),
      p = n(10),
      f = n(121),
      h = n(126),
      d = n(127),
      g = n(128);
    function y(t) {
      return (y =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function m(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function v(t, e) {
      return (v =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function b(t, e) {
      return e && ("object" === y(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function S(t) {
      return (S = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var $ = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && v(t, e);
      })(y, t);
      var e,
        n,
        i,
        p = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = S(t);
            if (e()) {
              var r = S(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return b(this, n);
          };
        })(y);
      function y(t, e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw TypeError("Cannot call a class as a function");
        })(this, y),
          ((n = p.call(this)).searchInputId = t),
          (n.isLoading = !1),
          (n.isFirstLoad = !0),
          (n.blocks = []),
          (n.onClickBlocks = []),
          (n.loadingBlock = null);
        var n,
          i =
            "." +
            s.a.searchSuggestionWrapper +
            '[data-search-box-id="' +
            n.searchInputId +
            '"]';
        return (
          (n.selector = {
            wrapper: i,
            popover: i + " ." + s.a.searchSuggestion + "-popover",
            loading: i + " ." + s.a.searchSuggestion + "-loading",
          }),
          (n.$searchInputElement = e),
          (n.$instantSearchResult = null),
          (n.$wrapper = null),
          (n.$popoverElement = null),
          (n.$loadingElement = null),
          (n.suggestionDirection = n._getSuggestionDirection()),
          (n.position = ""),
          n
        );
      }
      return (
        (e = y),
        (i = [
          {
            key: "isActive",
            value: function () {
              return !0;
            },
          },
        ]),
        (n = [
          {
            key: "init",
            value: function () {
              var t = this;
              (this.loadingBlock = new d.a()),
                this.addComponent(this.loadingBlock),
                (this.blockSettings = o.a.getSettingValue(
                  "search.suggestionBlocks"
                )),
                (this.onClickBlocks = u.a.getOnClickBlockSettings()),
                (this.blockSettings = this.onClickBlocks.concat(
                  this.blockSettings
                )),
                (this.noResultBlocks = c.a.getNoResultBlockSettings()),
                (this.blockSettings = this.blockSettings.concat(
                  this.noResultBlocks
                )),
                this._applyFilterBlockSettings(),
                (this.hasProductBlock = !1),
                this.blockSettings.forEach(function (e) {
                  var n = new f.a(e);
                  t.addComponent(n),
                    t.blocks.push(n),
                    e.type == l.a.ResultType.PRODUCTS &&
                      "active" == e.status &&
                      (t.hasProductBlock = !0);
                });
              var e = new h.a();
              this.addComponent(e), (this.blockViewAll = e);
              var n = new g.a();
              this.addComponent(n),
                (this.blockEmpty = n),
                c.a.getNoResultData(),
                u.a.getOnClickData();
            },
          },
          {
            key: "getTemplate",
            value: function () {
              return '\n			<div class="{{class.searchSuggestionWrapper}}" id="{{searchSuggestionId}}" data-search-box-id="{{searchInputId}}" role="listbox">\n				<div class="{{class.searchSuggestion}}-popover" data-direction="{{suggestionDirection}}"></div>\n			</div>\n		'.trim();
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              var t = this._getSuggestionWrapperClass();
              return this.getTemplate()
                .replace(
                  /{{searchSuggestionId}}/g,
                  this.searchInputId.replace(
                    s.a.searchBox,
                    s.a.searchSuggestion
                  )
                )
                .replace(/{{searchInputId}}/g, this.searchInputId)
                .replace(/{{suggestionDirection}}/g, this.suggestionDirection)
                .replace(/{{class.searchSuggestionWrapper}}/g, t)
                .replace(/{{class.searchSuggestion}}/g, s.a.searchSuggestion);
            },
          },
          {
            key: "_getSuggestionWrapperClass",
            value: function () {
              var t = "",
                e =
                  s.a.searchSuggestion +
                  "-mobile-" +
                  o.a.getSettingValue("search.suggestionMobileStyle");
              switch (o.a.getSettingValue("search.suggestionStyle")) {
                case "style1":
                  var n =
                    "grid" ===
                    o.a.getSettingValue(
                      "search.suggestionStyle1ProductItemType"
                    )
                      ? 3
                      : 1;
                  t =
                    s.a.searchSuggestionWrapper +
                    " " +
                    e +
                    " " +
                    s.a.searchSuggestion +
                    "-column-1 " +
                    s.a.searchSuggestion +
                    "-product-position-none " +
                    s.a.searchSuggestion +
                    "-product-item-type-" +
                    o.a.getSettingValue(
                      "search.suggestionStyle1ProductItemType"
                    ) +
                    " " +
                    s.a.searchSuggestion +
                    "-products-per-row-" +
                    n;
                  break;
                case "style2":
                  var i =
                    "grid" ===
                    o.a.getSettingValue(
                      "search.suggestionStyle2ProductItemType"
                    )
                      ? 3
                      : o.a.getSettingValue(
                          "search.suggestionStyle2ProductPerRow"
                        );
                  t =
                    s.a.searchSuggestionWrapper +
                    " " +
                    e +
                    " " +
                    s.a.searchSuggestion +
                    "-column-2-non-fullwidth " +
                    s.a.searchSuggestion +
                    "-product-position-" +
                    o.a.getSettingValue(
                      "search.suggestionStyle2ProductPosition"
                    ) +
                    " " +
                    s.a.searchSuggestion +
                    "-product-item-type-" +
                    o.a.getSettingValue(
                      "search.suggestionStyle2ProductItemType"
                    ) +
                    " " +
                    s.a.searchSuggestion +
                    "-products-per-row-" +
                    i;
                  break;
                case "style3":
                  var r =
                    "grid" ===
                    o.a.getSettingValue(
                      "search.suggestionStyle3ProductItemType"
                    )
                      ? 4
                      : o.a.getSettingValue(
                          "search.suggestionStyle3ProductPerRow"
                        );
                  t =
                    s.a.searchSuggestionWrapper +
                    " " +
                    e +
                    " " +
                    s.a.searchSuggestion +
                    "-column-2-overlay-fullwidth " +
                    s.a.searchSuggestion +
                    "-product-position-" +
                    o.a.getSettingValue(
                      "search.suggestionStyle3ProductPosition"
                    ) +
                    " " +
                    s.a.searchSuggestion +
                    "-product-item-type-" +
                    o.a.getSettingValue(
                      "search.suggestionStyle3ProductItemType"
                    ) +
                    " " +
                    s.a.searchSuggestion +
                    "-products-per-row-" +
                    r;
                  break;
                default:
                  var a = o.a.getSettingValue(
                    "search.suggestionProductItemPerRow"
                  );
                  t =
                    s.a.searchSuggestionWrapper +
                    " " +
                    e +
                    " " +
                    s.a.searchSuggestion +
                    "-column-" +
                    o.a.getSettingValue("search.suggestionColumn") +
                    " " +
                    s.a.searchSuggestion +
                    "-product-position-" +
                    o.a.getSettingValue("search.suggestionProductPosition") +
                    " " +
                    s.a.searchSuggestion +
                    "-product-item-type-" +
                    o.a.getSettingValue("search.suggestionProductItemType") +
                    " " +
                    s.a.searchSuggestion +
                    "-products-per-row-" +
                    a;
              }
              return t;
            },
          },
          { key: "_applyFilterBlockSettings", value: function () {} },
          {
            key: "render",
            value: function () {
              if (this.isFirstLoad) {
                var t = this.compileTemplate();
                (this.appendToSelector = "body"),
                  this._applyFilterAutocompleteAppendElement(),
                  r()(this.appendToSelector).append(t),
                  (this.$wrapper = r()(this.selector.wrapper)),
                  (this.$popoverElement = r()(this.selector.popover)),
                  (this.isFirstLoad = !1);
              } else
                this.$instantSearchResult.show(),
                  this.$instantSearchResult.siblings().show(),
                  this.isLoading
                    ? (this._renderSuggestionLoading(), this._renderWrapper())
                    : (this._renderWrapper(), this._renderSuggestion());
            },
          },
          {
            key: "isBindEvents",
            value: function () {
              return !this.isBoundEvent;
            },
          },
          {
            key: "bindEvents",
            value: function () {
              window.addEventListener(
                "resize",
                this._setSuggestionPosition.bind(this)
              );
              for (var t = 0; t < this.$searchInputElement.length; t++)
                this.$searchInputElement[t].addEventListener(
                  "click",
                  this._setSuggestionPosition.bind(this)
                );
            },
          },
          {
            key: "_applyFilterAutocompleteAppendElement",
            value: function () {},
          },
          {
            key: "_renderWrapper",
            value: function () {
              var t = a.a.InstantSearch.isFullWidthMobile()
                ? s.a.searchSuggestionMobile
                : "";
              "" !== t && this.$wrapper.addClass(t);
              var e = this._setSuggestionPosition();
              e.setSuggetionPosition(), e.setSuggetionPopoverPosition();
              var n = "";
              (n =
                "auto" == o.a.getSettingValue("search.suggestionWidth") ||
                a.a.isMobile()
                  ? this.$searchInputElement[0].getBoundingClientRect().width
                  : o.a.getSettingValue("search.suggestionWidth")),
                this.$wrapper.css({ width: n });
            },
          },
          {
            key: "_setSuggestionPosition",
            value: function () {
              var t = this,
                e = this,
                n = this.$searchInputElement[0].getBoundingClientRect(),
                i = a.a.InstantSearch.isFullWidthMobile()
                  ? n.bottom
                  : n.bottom + 12,
                o = e._getSuggestionDirection(),
                s = e._maxWidth();
              window.addEventListener("scroll", function () {
                if (!a.a.isMobile()) {
                  var t = e.$searchInputElement[0].getBoundingClientRect();
                  (i = a.a.InstantSearch.isFullWidthMobile()
                    ? t.bottom
                    : t.bottom + 12),
                    "left" == o
                      ? e.$wrapper.css({ top: i + "px", left: t.left + "px" })
                      : e.$wrapper.css({
                          top: i + "px",
                          right: window.innerWidth - t.right + "px",
                        });
                }
              });
              var l = "",
                c = "",
                u = "";
              if ("left" == o) {
                (l = i + "px"), (c = n.left + "px");
                var p = r()(window).width() - n.left,
                  f = s;
                a.a.isMobile()
                  ? this.$wrapper.css({ top: l, right: "10px", left: "10px" })
                  : this.$wrapper.css({ top: l, left: c });
                var h = function () {
                    p < f
                      ? t.$instantSearchResult.css({
                          top: "0px",
                          left: "-" + (f - p + 20) + "px",
                        })
                      : t.$instantSearchResult.css({ top: "0px", left: "0px" });
                  },
                  d = function () {
                    t.$popoverElement.css({ top: "-20px", left: "20px" });
                  };
              } else
                (l = i + "px"),
                  (u = window.innerWidth - n.right + "px"),
                  a.a.isMobile()
                    ? this.$wrapper.css({ top: l, right: "10px", left: "10px" })
                    : this.$wrapper.css({ top: l, right: u }),
                  (h = function () {
                    t.$instantSearchResult.css({ top: "0px", right: "0px" });
                  }),
                  (d = function () {
                    t.$popoverElement.css({ top: "-20px", right: "20px" });
                  });
              return {
                setSuggetionPosition: h,
                setSuggetionPopoverPosition: d,
              };
            },
          },
          {
            key: "_renderSuggestion",
            value: function () {
              if (
                (this.$instantSearchResult &&
                  this.$instantSearchResult.attr(
                    "data-search-box",
                    a.a.stripHtml(this.id)
                  ),
                this.data)
              ) {
                var t = this._getSuggestionBlockElements(),
                  e = this._isTwoColumn();
                e
                  ? this._renderSuggestionTwoColumn(t)
                  : this._renderSuggestionOneColumn(t);
                var n =
                  a.a.getValueInObjectArray(
                    l.a.ResultType.ALL_EMPTY,
                    this.data
                  ) && !this.hasRedirectData;
                if ((this.$wrapper.show(), n)) {
                  if (this.blockEmpty.$element) {
                    if (
                      this.blockEmpty.isEmptyWithSuggestion &&
                      !a.a.isMobile() &&
                      e
                    ) {
                      var i = this.$instantSearchResult.find(
                          "[data-group=no_result_products]"
                        ),
                        r = this.$instantSearchResult.find(
                          "[data-group=no_result_suggestions]"
                        );
                      i.length > 0
                        ? i
                            .find("." + s.a.searchSuggestionHeader)
                            .before(this.blockEmpty.$element)
                        : r.length > 0
                        ? r
                            .find("." + s.a.searchSuggestionHeader)
                            .before(this.blockEmpty.$element)
                        : this.$instantSearchResult.prepend(
                            this.blockEmpty.$element
                          );
                    } else
                      this.$instantSearchResult.prepend(
                        this.blockEmpty.$element
                      );
                  } else this.$wrapper.hide();
                }
              }
            },
          },
          {
            key: "_getSuggestionBlockElements",
            value: function () {
              var t = [],
                e =
                  a.a.getValueInObjectArray(
                    l.a.ResultType.ALL_EMPTY,
                    this.data
                  ) && !this.hasRedirectData,
                n = a.a.getValueInObjectArray(
                  l.a.ResultType.SUGGEST_QUERY,
                  this.data
                ),
                i = a.a.getValueInObjectArray(
                  l.a.ResultType.DID_YOU_MEAN,
                  this.data
                );
              return (
                !e || n || (i && 0 != i.length)
                  ? (this.blocks.forEach(function (e) {
                      t.push(e.$element);
                    }),
                    this.hasProductBlock && t.push(this.blockViewAll.$element))
                  : this.blockEmpty.$element &&
                    ((!a.a.isMobile() &&
                      this.blockEmpty.isEmptyWithSuggestion) ||
                      t.push(this.blockEmpty.$element),
                    this.blocks.forEach(function (e) {
                      t.push(e.$element);
                    })),
                t
              );
            },
          },
          {
            key: "_isTwoColumn",
            value: function () {
              var t = !1;
              if (!a.a.isMobile() && this.hasProductBlock)
                switch (o.a.getSettingValue("search.suggestionStyle")) {
                  case "style1":
                    t = !1;
                    break;
                  case "style2":
                  case "style3":
                    t = !0;
                    break;
                  default:
                    o.a
                      .getSettingValue("search.suggestionColumn")
                      .startsWith("1") || (t = !0);
                }
              else t = !1;
              return t;
            },
          },
          {
            key: "_maxHeight",
            value: function () {
              var t = "",
                e = o.a.getSettingValue("search.suggestionMaxHeight"),
                n = o.a.getSettingValue("search.suggestionStyle"),
                i = o.a.getSettingValue(
                  "search.suggestionStyle2ProductItemType"
                ),
                r = this.$searchInputElement[0].getBoundingClientRect(),
                s = a.a.InstantSearch.isFullWidthMobile()
                  ? r.bottom
                  : r.bottom + 12;
              return (
                (t = "" == e ? ("style2" == n && "list" == i ? 564 : 640) : e) +
                  s >
                  window.innerHeight - 30 && (t = window.innerHeight - s - 30),
                t
              );
            },
          },
          {
            key: "_maxWidth",
            value: function () {
              var t = o.a.getSettingValue("search.suggestionMaxWidth"),
                e = o.a.getSettingValue("search.suggestionStyle"),
                n = o.a.getSettingValue(
                  "search.suggestionStyle2ProductItemType"
                ),
                i = o.a.getSettingValue("search.suggestionStyle2ProductPerRow");
              return "" == t
                ? "style2" == e && "grid" == n
                  ? 850
                  : "style2" == e && "list" == n && "2" == i
                  ? 800
                  : "style2" == e && "list" == n && "1" == i
                  ? 526
                  : ""
                : t;
            },
          },
          {
            key: "_renderSuggestionOneColumn",
            value: function (t) {
              var e = this._maxHeight() + "px";
              this.$instantSearchResult.css("maxHeight", e);
              var n = r()(
                '<div class="boost-pfs-search-suggestion-scroll-groups-element-wrapper"></div>'
              );
              t.forEach(function (t) {
                n.append(t);
              }),
                this.$instantSearchResult.append(n),
                this.$instantSearchResult.append(this.blockViewAll.$element);
            },
          },
          {
            key: "_renderSuggestionTwoColumn",
            value: function (t) {
              var e = this,
                n = this._maxHeight() + "px";
              this.$instantSearchResult.css("maxHeight", n);
              var i = r()(
                  '<div class="' + s.a.searchSuggestion + '-groups-pro"></div>'
                ),
                o = r()(
                  '<div class="' +
                    s.a.searchSuggestion +
                    '-groups-others"></div>'
                );
              t.forEach(function (t) {
                e.$instantSearchResult.append(o).append(i);
                var n = void 0 !== t.data ? t.data("group") : "";
                void 0 === n && (n = ""),
                  n.includes("products") || "view-all" == n || "empty" == n
                    ? i.append(t)
                    : o.append(t);
              }),
                "" == i.html().trim()
                  ? o.addClass(s.a.searchSuggestion + "-no-products")
                  : o.removeClass(s.a.searchSuggestion + "-no-products"),
                "" == o.html().trim()
                  ? (i.addClass(s.a.searchSuggestion + "-no-others"),
                    this.$instantSearchResult
                      .parent()
                      .addClass(s.a.searchSuggestion + "-no-others-wrapper"))
                  : (i.removeClass(s.a.searchSuggestion + "-no-others"),
                    this.$instantSearchResult
                      .parent()
                      .removeClass(
                        s.a.searchSuggestion + "-no-others-wrapper"
                      )),
                this.$instantSearchResult.append(o).append(i);
            },
          },
          {
            key: "_renderSuggestionLoading",
            value: function () {
              this.loadingBlock.$element &&
                !r()(this.selector.loading).length &&
                (this.$instantSearchResult.children().hide(),
                this.$instantSearchResult.prepend(this.loadingBlock.$element),
                (this.$loadingElement = r()(this.selector.loading)),
                this.$wrapper.addClass(s.a.searchSuggestionOpen),
                r()("body").addClass(s.a.searchSuggestionOpenBody),
                this.$instantSearchResult.show(),
                this.$loadingElement.show());
            },
          },
          {
            key: "_getSuggestionDirection",
            value: function () {
              var t = o.a.getSettingValue("search.suggestionPosition");
              if ("" != t) return t;
              var e = r()(window).width() / 2;
              return this.$searchInputElement.offset().left < e
                ? "left"
                : "right";
            },
          },
          {
            key: "setData",
            value: function (t, e, n) {
              var i = this;
              if (
                ((this.$instantSearchResult = t),
                (this.data = e),
                (this.isLoading = n),
                this.data)
              ) {
                this.setRedirectData();
                var r =
                    a.a.getValueInObjectArray(
                      l.a.ResultType.ALL_EMPTY,
                      this.data
                    ) && !this.hasRedirectData,
                  o = a.a.getValueInObjectArray(
                    l.a.ResultType.SUGGEST_QUERY,
                    this.data
                  ),
                  s = a.a.getValueInObjectArray(
                    l.a.ResultType.DID_YOU_MEAN,
                    this.data
                  );
                this.blocks.forEach(function (t) {
                  var e = a.a.getValueInObjectArray(t.type, i.data);
                  if (r && !o && (!s || 0 == s.length)) {
                    var n = c.a.getNoResultData()[t.type];
                    n && (e = n);
                  }
                  t.setData(e, r);
                }),
                  this.blockEmpty.setData(this.data),
                  this.blockViewAll.setData(this.data);
              }
            },
          },
          {
            key: "setRedirectData",
            value: function () {
              if (
                ((this.redirectData = a.a.getValueInObjectArray(
                  l.a.ResultType.REDIRECT,
                  this.data
                )),
                (this.searchQuery = a.a.getValueInObjectArray(
                  l.a.ResultType.QUERY,
                  this.data
                )),
                (this.hasRedirectData = !1),
                this.redirectData && this.searchQuery)
              ) {
                var t = a.a.getValueInObjectArray(
                  l.a.ResultType.SUGGESTIONS,
                  this.data
                );
                Array.isArray(t) &&
                  (t.includes(this.searchQuery) || t.unshift(this.searchQuery),
                  (this.hasRedirectData = !0));
              }
            },
          },
        ]),
        m(e.prototype, n),
        i && m(e, i),
        y
      );
    })(p.a);
    e.a = $;
  },
  86: function (t, e, n) {
    "use strict";
    n(21),
      n(22),
      n(23),
      n(17),
      n(18),
      n(9),
      n(19),
      n(14),
      n(15),
      n(16),
      n(11),
      n(13),
      n(12);
    var i = n(1),
      r = n.n(i),
      o = n(0),
      a = n(4),
      s = n(2),
      l = n(3);
    function c(t) {
      return (c =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function u(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function p(t, e) {
      return (p =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function f(t, e) {
      return e && ("object" === c(e) || "function" == typeof e)
        ? e
        : (function (t) {
            if (void 0 === t)
              throw ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return t;
          })(t);
    }
    function h(t) {
      return (h = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    var d = (function (t) {
      !(function (t, e) {
        if ("function" != typeof e && null !== e)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(e && e.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          e && p(t, e);
      })(d, t);
      var e,
        n,
        i,
        c = (function (t) {
          function e() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Date.prototype.toString.call(
                  Reflect.construct(Date, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          }
          return function () {
            var n,
              i = h(t);
            if (e()) {
              var r = h(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return f(this, n);
          };
        })(d);
      function d() {
        var t;
        return (
          (function (t, e) {
            if (!(t instanceof e))
              throw TypeError("Cannot call a class as a function");
          })(this, d),
          ((t = c.call(this)).id = ""),
          (t.title = ""),
          (t.imageUrl = ""),
          (t.url = ""),
          (t.sku = ""),
          (t.label = ""),
          (t.vendor = ""),
          (t.isShow = !1),
          t
        );
      }
      return (
        (e = d),
        (i = [
          {
            key: "tempType",
            get: function () {
              return {
                SKU: "sku",
                VENDOR: "vendor",
                IMAGE: "thumb",
                PRICE: "regular_price",
                PRICE_SALE: "sale_price",
              };
            },
          },
        ]),
        (n = [
          {
            key: "getTemplate",
            value: function (t) {
              switch (t) {
                case d.tempType.IMAGE:
                  return '\n					<div class="{{class.searchSuggestion}}-left">\n						<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">\n					</div>\n				'.trim();
                case d.tempType.SKU:
                  return '\n					<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>\n				'.trim();
                case d.tempType.VENDOR:
                  return '\n					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>\n				'.trim();
                case d.tempType.PRICE:
                  return '\n					<p class="{{class.searchSuggestion}}-product-price">\n						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>\n					</p>\n				'.trim();
                case d.tempType.PRICE_SALE:
                  return '\n					<p class="{{class.searchSuggestion}}-product-price">\n            <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;\n						<s>{{compareAtPrice}}</s>\n						\n					</p>\n				'.trim();
                default:
                  return '\n					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">\n						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>\n							{{itemProductImage}}\n							<div class="{{class.searchSuggestion}}-right">\n								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>\n								{{itemProductSku}}\n								{{itemProductVendor}}\n								{{itemProductPrice}}\n							</div>\n						</a>\n					</li>\n				'.trim();
              }
            },
          },
          {
            key: "compileTemplate",
            value: function () {
              if (this.isShow) {
                var t = o.a.stripHtml(l.a.currentTerm),
                  e = "";
                s.a.getSettingValue("search.showSuggestionProductImage") &&
                  this.imageUrl.length &&
                  (e = (e = this.getTemplate(d.tempType.IMAGE)).replace(
                    /{{imageUrl}}/g,
                    this.imageUrl
                  ));
                var n = this.customizeProductTitle();
                n = this._highlightSuggestionResult(n, t);
                var i = "";
                s.a.getSettingValue("search.showSuggestionProductSku") &&
                  this.sku.length &&
                  (i = (i = this.getTemplate(d.tempType.SKU)).replace(
                    /{{sku}}/g,
                    this.sku
                  ));
                var r = "";
                s.a.getSettingValue("search.showSuggestionProductVendor") &&
                  this.vendor.length &&
                  (r = (r = this.getTemplate(d.tempType.VENDOR)).replace(
                    /{{vendor}}/g,
                    this.vendor
                  ));
                var c = this.compileSuggestionProductPrice(),
                  u = s.a.getSettingValue("search.openProductNewTab")
                    ? 'target="_blank"'
                    : "";
                return this.getTemplate()
                  .replace(/{{id}}/g, this.id)
                  .replace(
                    /{{escapedBlockType}}/g,
                    o.a.stripHtml(this.parent.type)
                  )
                  .replace(/{{url}}/g, this.url)
                  .replace(/{{newTabAttribute}}/g, u)
                  .replace(/{{itemProductImage}}/g, e)
                  .replace(/{{title}}/g, n)
                  .replace(/{{escapedTitle}}/g, o.a.stripHtml(n))
                  .replace(/{{itemProductSku}}/g, i)
                  .replace(/{{itemProductVendor}}/g, r)
                  .replace(/{{itemProductPrice}}/, c)
                  .replace(/{{class.searchSuggestion}}/g, a.a.searchSuggestion)
                  .replace(
                    /{{class.searchSuggestionItem}}/g,
                    a.a.searchSuggestionItem
                  )
                  .replace(
                    /{{class.searchUiAutocompleteItem}}/g,
                    a.a.searchUiAutocompleteItem
                  );
              }
              return "";
            },
          },
          {
            key: "render",
            value: function () {
              this.isShow
                ? ((this.$element = r()(this.compileTemplate())),
                  this.$element.attr("data-title", o.a.stripHtml(this.title)))
                : (this.$element = null);
            },
          },
          {
            key: "setData",
            value: function (t) {
              t
                ? ((this.data = t),
                  (this.id = t.id),
                  (this.title = o.a.stripHtml(t.title)),
                  (this.imageUrl =
                    t.images_info.length > 0
                      ? o.a.optimizeImage(t.images_info[0].src, "200x")
                      : boostPFSConfig.general.no_image_url),
                  (this.url = o.a.buildProductItemUrl(t, !1)),
                  (this.sku = o.a.stripHtml(
                    t.skus && t.skus.length > 0 ? t.skus[0] : ""
                  )),
                  (this.label = o.a.stripHtml(t.label)),
                  (this.vendor = o.a.stripHtml(t.vendor)),
                  (this.isShow = !0))
                : ((this.data = null),
                  (this.id = ""),
                  (this.title = ""),
                  (this.imageUrl = ""),
                  (this.url = ""),
                  (this.sku = ""),
                  (this.label = ""),
                  (this.vendor = ""),
                  (this.isShow = !1));
            },
          },
          {
            key: "compileSuggestionProductPrice",
            value: function () {
              this.prepareSuggestionProductPriceData();
              var t = this.data.compare_at_price_min > this.data.price_min,
                e = o.a.formatMoney(this.data.price_min),
                n = "";
              this.data &&
                this.data.compare_at_price_min &&
                ((n = o.a.formatMoney(this.data.compare_at_price_min)),
                s.a.getSettingValue("search.removePriceDecimal") &&
                  ((e = o.a.removeDecimal(e)), (n = o.a.removeDecimal(n))));
              var i = "";
              return (
                s.a.getSettingValue("search.showSuggestionProductPrice") &&
                  (i =
                    t &&
                    s.a.getSettingValue("search.showSuggestionProductSalePrice")
                      ? this.getTemplate(d.tempType.PRICE_SALE)
                      : this.getTemplate(d.tempType.PRICE)),
                i
                  .replace(/{{regularPrice}}/g, e)
                  .replace(/{{compareAtPrice}}/g, n)
              );
            },
          },
          {
            key: "customizeProductTitle",
            value: function () {
              return this.title;
            },
          },
          {
            key: "prepareSuggestionProductPriceData",
            value: function () {
              var t = this.data;
              o.a.isEnableShopifyMultipleCurrencies() &&
                (!t.isConvertedPrice && o.a.isConvertCurrenciesOnFrontEnd()
                  ? ((t.price_min = o.a.convertPriceBasedOnActiveCurrency(
                      t.price_min,
                      !0
                    )),
                    (t.price_max = o.a.convertPriceBasedOnActiveCurrency(
                      t.price_max,
                      !0
                    )),
                    (t.compare_at_price_min =
                      o.a.convertPriceBasedOnActiveCurrency(
                        t.compare_at_price_min,
                        !0
                      )),
                    (t.compare_at_price_max =
                      o.a.convertPriceBasedOnActiveCurrency(
                        t.compare_at_price_max,
                        !0
                      )),
                    (t.isConvertedPrice = !0))
                  : o.a.convertPriceBasedOnPresentmentPrice(t));
            },
          },
        ]),
        u(e.prototype, n),
        i && u(e, i),
        d
      );
    })(n(59).a);
    e.a = d;
  },
});
